/*! @charter/helix 4.38.0 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Helix", [], factory);
	else if(typeof exports === 'object')
		exports["Helix"] = factory();
	else
		root["Helix"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayLikeToArray.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/arrayWithHoles.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithHoles.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/assertThisInitialized.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/asyncToGenerator.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/classCallCheck.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/classCallCheck.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/createClass.js":
/*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/createClass.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/@babel/runtime/helpers/toPropertyKey.js");
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/defineProperty.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/@babel/runtime/helpers/toPropertyKey.js");
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/getPrototypeOf.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/inherits.js":
/*!*********************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/inherits.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(/*! ./setPrototypeOf.js */ "./node_modules/@babel/runtime/helpers/setPrototypeOf.js");
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/iterableToArray.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArray.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/nonIterableRest.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableRest.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableSpread.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js":
/*!************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutProperties.js ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(/*! ./objectWithoutPropertiesLoose.js */ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js");
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js":
/*!**************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];
var assertThisInitialized = __webpack_require__(/*! ./assertThisInitialized.js */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/regeneratorRuntime.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/regeneratorRuntime.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/setPrototypeOf.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/setPrototypeOf.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/slicedToArray.js":
/*!**************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/slicedToArray.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(/*! ./arrayWithHoles.js */ "./node_modules/@babel/runtime/helpers/arrayWithHoles.js");
var iterableToArrayLimit = __webpack_require__(/*! ./iterableToArrayLimit.js */ "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js");
var unsupportedIterableToArray = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");
var nonIterableRest = __webpack_require__(/*! ./nonIterableRest.js */ "./node_modules/@babel/runtime/helpers/nonIterableRest.js");
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toConsumableArray.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toConsumableArray.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(/*! ./arrayWithoutHoles.js */ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");
var iterableToArray = __webpack_require__(/*! ./iterableToArray.js */ "./node_modules/@babel/runtime/helpers/iterableToArray.js");
var unsupportedIterableToArray = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");
var nonIterableSpread = __webpack_require__(/*! ./nonIterableSpread.js */ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js");
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toPrimitive.js":
/*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toPrimitive.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toPropertyKey.js":
/*!**************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toPropertyKey.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];
var toPrimitive = __webpack_require__(/*! ./toPrimitive.js */ "./node_modules/@babel/runtime/helpers/toPrimitive.js");
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/typeof.js":
/*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/regenerator/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(/*! ../helpers/regeneratorRuntime */ "./node_modules/@babel/runtime/helpers/regeneratorRuntime.js")();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/app/Assignment.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/app/Assignment.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Assignment = void 0;
var Index_1 = __webpack_require__(/*! ./Index */ "./node_modules/@charter/helix-extensions/dist/app/Index.js");
var Operand_1 = __webpack_require__(/*! ./Operand */ "./node_modules/@charter/helix-extensions/dist/app/Operand.js");
var OperandType_1 = __webpack_require__(/*! ./OperandType */ "./node_modules/@charter/helix-extensions/dist/app/OperandType.js");
var OperatorType_1 = __webpack_require__(/*! ./OperatorType */ "./node_modules/@charter/helix-extensions/dist/app/OperatorType.js");
var Utils_1 = __webpack_require__(/*! ./Utils */ "./node_modules/@charter/helix-extensions/dist/app/Utils.js");
var Assignment = (function () {
    function Assignment(leftOperand, rightOperand) {
        if (leftOperand) {
            this.leftOperandVar = leftOperand;
        }
        if (rightOperand) {
            this.rightOperandVar = rightOperand;
        }
    }
    Assignment.parse = function (expr) {
        var idx = new Index_1.Index(0);
        var leftOperand;
        var rightOperand;
        var token;
        var quote = false;
        var operatorType;
        if (!Utils_1.Utils.eatSpaces(expr, idx)) {
            throw new Error("Unable to parse due to spacing issues!");
        }
        leftOperand = Assignment.readOperand(expr, idx);
        Utils_1.Utils.eatSpaces(expr, idx);
        token = Assignment.readToken(expr, idx, quote);
        operatorType = Utils_1.Utils.stringToOperatorType(token);
        if (operatorType !== OperatorType_1.OperatorType.EQ) {
            throw new Error("Invalid operator in assignment expression!");
        }
        Utils_1.Utils.eatSpaces(expr, idx);
        rightOperand = Assignment.readOperand(expr, idx);
        return new Assignment(leftOperand, rightOperand);
    };
    Assignment.readOperand = function (expression, idx) {
        var operand;
        var token;
        try {
            token = Assignment.readToken(expression, idx);
            operand = Operand_1.Operand.parse(token);
        }
        catch (err) {
            throw new Error("Unable to parse operand: " + err);
        }
        return operand;
    };
    Assignment.readToken = function (expression, idx, quote) {
        var token = "";
        quote = false;
        Utils_1.Utils.eatSpaces(expression, idx);
        if (expression[idx.valueOf()] === "'") {
            quote = true;
            idx.increment();
        }
        while (idx.valueOf() < expression.length) {
            if (quote && expression[idx.valueOf()] === "'") {
                idx.increment();
                return token;
            }
            if (!quote && (Utils_1.Utils.isWhiteSpace(expression[idx.valueOf()]) || expression[idx.valueOf()] === ")")) {
                return token;
            }
            token += expression[idx.valueOf()];
            idx.increment();
        }
        if (quote) {
            throw new Error("Unterminated token. Expected single quote");
        }
        if (token === "") {
            throw new Error("Unexpected empty token");
        }
        return token;
    };
    Assignment.prototype.eval = function (context) {
        var value;
        if (this.leftOperandVar.operandType === OperandType_1.OperandType.Litteral) {
            throw new Error("Invalid assignment to litteral operand");
        }
        if (this.rightOperandVar.operandType === OperandType_1.OperandType.Litteral) {
            value = this.rightOperandVar.value;
        }
        else if (this.rightOperandVar.operandType === OperandType_1.OperandType.Data) {
            value = context.getValue(this.rightOperandVar);
        }
        else {
            value = context.getValue(this.leftOperandVar);
        }
        context.setValue(this.leftOperandVar, value);
    };
    Object.defineProperty(Assignment.prototype, "rightOperand", {
        get: function () {
            return this.rightOperandVar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Assignment.prototype, "leftOperand", {
        get: function () {
            return this.leftOperandVar;
        },
        enumerable: false,
        configurable: true
    });
    return Assignment;
}());
exports.Assignment = Assignment;
//# sourceMappingURL=Assignment.js.map

/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/app/Context.js":
/*!********************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/app/Context.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
var OperandType_1 = __webpack_require__(/*! ./OperandType */ "./node_modules/@charter/helix-extensions/dist/app/OperandType.js");
var Context = (function () {
    function Context() {
        this.dataVar = {};
    }
    Context.prototype.setValue = function (operand, value) {
        switch (operand.operandType) {
            case OperandType_1.OperandType.Data:
                this.dataVar[operand.value.toString()] = value;
                break;
            case OperandType_1.OperandType.LocalStorage:
                throw new Error("LocalStorage is not a currently supported assignment");
            case OperandType_1.OperandType.Cookies:
                throw new Error("Cookies is not a currently supported assignment");
            default:
                throw new Error("Invalid or unsupported assignment");
        }
    };
    Context.prototype.getValue = function (operand) {
        switch (operand.operandType) {
            case OperandType_1.OperandType.Data:
                return this.dataVar[operand.value.toString()];
            case OperandType_1.OperandType.LocalStorage:
                throw new Error("LocalStorage is not a currently supported assignment");
            case OperandType_1.OperandType.Cookies:
                throw new Error("Cookies is not a currently supported assignment");
            default:
                throw new Error("Invalid or unsupported assignment");
        }
    };
    Object.defineProperty(Context.prototype, "data", {
        get: function () {
            return this.dataVar;
        },
        enumerable: false,
        configurable: true
    });
    return Context;
}());
exports.Context = Context;
//# sourceMappingURL=Context.js.map

/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/app/Expression.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/app/Expression.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Expression = void 0;
var Assignment_1 = __webpack_require__(/*! ./Assignment */ "./node_modules/@charter/helix-extensions/dist/app/Assignment.js");
var ExpressionType_1 = __webpack_require__(/*! ./ExpressionType */ "./node_modules/@charter/helix-extensions/dist/app/ExpressionType.js");
var Index_1 = __webpack_require__(/*! ./Index */ "./node_modules/@charter/helix-extensions/dist/app/Index.js");
var Parser_1 = __webpack_require__(/*! ./Parser */ "./node_modules/@charter/helix-extensions/dist/app/Parser.js");
var Utils_1 = __webpack_require__(/*! ./Utils */ "./node_modules/@charter/helix-extensions/dist/app/Utils.js");
var Expression = (function () {
    function Expression() {
        this.commandTypeVar = ExpressionType_1.ExpressionType.Unknown;
    }
    Expression.prototype.parse = function (exprIn) {
        var s;
        var i = new Index_1.Index(0);
        var token;
        var idx;
        var expr = exprIn.trim();
        if (!Utils_1.Utils.eatSpaces(expr, i)) {
            throw new Error("Unexpected end of statement");
        }
        idx = expr.indexOf("WHEN");
        if (idx < 0) {
            throw new Error("WHEN keyword was not detected");
        }
        token = Utils_1.Utils.readToken(expr, i).toUpperCase();
        switch (token) {
            case "SET":
                s = expr.substr(0, idx);
                s = s.substr("SET".length);
                this.assignmentVar = Assignment_1.Assignment.parse(s);
                this.commandTypeVar = ExpressionType_1.ExpressionType.Set;
                break;
            case "BLOCK":
                this.commandTypeVar = ExpressionType_1.ExpressionType.Block;
                break;
            default:
                throw new Error("Unknown command type!");
        }
        s = expr.substr(idx + "WHEN".length);
        i.setValue(0);
        this.operationVar = Parser_1.Parser.parse(s, i);
    };
    Expression.prototype.eval = function (context) {
        var result = true;
        switch (this.commandTypeVar) {
            case ExpressionType_1.ExpressionType.Set:
                if (this.operationVar.eval(context)) {
                    this.assignmentVar.eval(context);
                }
                break;
            case ExpressionType_1.ExpressionType.Block:
                if (this.operationVar.eval(context)) {
                    result = false;
                }
        }
        return result;
    };
    Object.defineProperty(Expression.prototype, "commandType", {
        get: function () {
            return this.commandTypeVar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Expression.prototype, "assignment", {
        get: function () {
            return this.assignmentVar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Expression.prototype, "operation", {
        get: function () {
            return this.operationVar;
        },
        enumerable: false,
        configurable: true
    });
    return Expression;
}());
exports.Expression = Expression;
//# sourceMappingURL=Expression.js.map

/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/app/ExpressionType.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/app/ExpressionType.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionType = void 0;
var ExpressionType;
(function (ExpressionType) {
    ExpressionType[ExpressionType["Unknown"] = 0] = "Unknown";
    ExpressionType[ExpressionType["Set"] = 1] = "Set";
    ExpressionType[ExpressionType["Block"] = 2] = "Block";
})(ExpressionType = exports.ExpressionType || (exports.ExpressionType = {}));
//# sourceMappingURL=ExpressionType.js.map

/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/app/Index.js":
/*!******************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/app/Index.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Index = void 0;
var Index = (function () {
    function Index(i) {
        this.idx = i || 0;
    }
    Index.prototype.setValue = function (i) {
        this.idx = i;
    };
    Index.prototype.increment = function () {
        ++this.idx;
    };
    Index.prototype.decrement = function () {
        --this.idx;
    };
    Index.prototype.valueOf = function () {
        return this.idx;
    };
    return Index;
}());
exports.Index = Index;
//# sourceMappingURL=Index.js.map

/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/app/Operand.js":
/*!********************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/app/Operand.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Operand = void 0;
var OperandType_1 = __webpack_require__(/*! ./OperandType */ "./node_modules/@charter/helix-extensions/dist/app/OperandType.js");
var Utils_1 = __webpack_require__(/*! ./Utils */ "./node_modules/@charter/helix-extensions/dist/app/Utils.js");
var Operand = (function () {
    function Operand(value, operandType) {
        this.valueVar = value;
        this.operandTypeVar = operandType ? operandType : OperandType_1.OperandType.Unknown;
    }
    Operand.parse = function (expr) {
        var list;
        var operandType = OperandType_1.OperandType.Unknown;
        var value;
        if (Utils_1.Utils.nullOrEmpty(expr)) {
            throw new Error("Invalid operand");
        }
        if (expr.indexOf(".") > -1 && expr[0] !== "'") {
            list = expr.split(".");
            switch (list[0].toUpperCase()) {
                case "DATA":
                    operandType = OperandType_1.OperandType.Data;
                    break;
                case "COOKIES":
                    operandType = OperandType_1.OperandType.Cookies;
                    break;
                case "LOCALSTORAGE":
                    operandType = OperandType_1.OperandType.LocalStorage;
                    break;
                default:
                    return new Operand(Operand.unbox(expr), OperandType_1.OperandType.Litteral);
            }
            value = list[1].trim();
            return new Operand(value, operandType);
        }
        return new Operand(Operand.unbox(expr), OperandType_1.OperandType.Litteral);
    };
    Operand.unbox = function (value) {
        if (Utils_1.Utils.nullOrEmpty(value)) {
            return null;
        }
        if (value[0] === "'") {
            if (value.length === 1 || value[value.length - 1] !== "\'") {
                throw new Error("Unterminated String");
            }
            return value.substr(1, value.length - 2);
        }
        if (value.toUpperCase() === "TRUE") {
            return true;
        }
        if (value.toUpperCase() === "FALSE") {
            return false;
        }
        if (value.indexOf(".") > -1 && !isNaN(Number(value))) {
            return parseFloat(value);
        }
        var result = parseInt(value, 10);
        return Number.isNaN(result) ? value : result;
    };
    Operand.readOperand = function (expression, idx) {
        var operand;
        var token;
        try {
            token = Utils_1.Utils.readToken(expression, idx);
            if (token[0] === "\'") {
                token = token.substr(1, token.length - 2);
                operand = Operand.parse(token);
            }
            else {
                operand = Operand.parse(token);
            }
        }
        catch (err) {
            throw new Error("Unable to parse operand: " + err);
        }
        return operand;
    };
    Object.defineProperty(Operand.prototype, "operandType", {
        get: function () {
            return this.operandTypeVar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Operand.prototype, "value", {
        get: function () {
            return this.valueVar;
        },
        enumerable: false,
        configurable: true
    });
    return Operand;
}());
exports.Operand = Operand;
//# sourceMappingURL=Operand.js.map

/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/app/OperandType.js":
/*!************************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/app/OperandType.js ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OperandType = void 0;
var OperandType;
(function (OperandType) {
    OperandType[OperandType["Unknown"] = 0] = "Unknown";
    OperandType[OperandType["Litteral"] = 1] = "Litteral";
    OperandType[OperandType["Data"] = 2] = "Data";
    OperandType[OperandType["Cookies"] = 3] = "Cookies";
    OperandType[OperandType["LocalStorage"] = 4] = "LocalStorage";
})(OperandType = exports.OperandType || (exports.OperandType = {}));
//# sourceMappingURL=OperandType.js.map

/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/app/Operation.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/app/Operation.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Operation = void 0;
var Operand_1 = __webpack_require__(/*! ./Operand */ "./node_modules/@charter/helix-extensions/dist/app/Operand.js");
var OperandType_1 = __webpack_require__(/*! ./OperandType */ "./node_modules/@charter/helix-extensions/dist/app/OperandType.js");
var OperatorType_1 = __webpack_require__(/*! ./OperatorType */ "./node_modules/@charter/helix-extensions/dist/app/OperatorType.js");
var Utils_1 = __webpack_require__(/*! ./Utils */ "./node_modules/@charter/helix-extensions/dist/app/Utils.js");
var Operation = (function () {
    function Operation(operand1, operatorType, operand2) {
        this.op1Var = operand1;
        this.operatorTypeVar = operatorType ? operatorType : OperatorType_1.OperatorType.Unknown;
        this.op2Var = operand2;
    }
    Operation.readOperation = function (expr, i) {
        var operation;
        var operation1;
        var operation2;
        var op1;
        expr = expr.trim();
        var token;
        var operatorType = OperatorType_1.OperatorType.Unknown;
        var c;
        if (!Utils_1.Utils.eatSpaces(expr, i)) {
            throw new Error("Unexpected EOL");
        }
        while (true) {
            if (!Utils_1.Utils.eatSpaces(expr, i)) {
                break;
            }
            if (expr[i.valueOf()] === "(") {
                i.increment();
                operation1 = Operation.readOperation(expr, i);
                c = expr[i.valueOf()];
                if (c !== ")") {
                    throw new Error("Expected ')'");
                }
                if (operation1.operatorType === OperatorType_1.OperatorType.NOOP) {
                    throw new Error("Invalid operation: will always return true");
                }
                i.increment();
                if (!operation) {
                    operation = operation1;
                }
                else {
                    operation.add(operation1, operatorType);
                }
            }
            else {
                if (expr[i.valueOf()] === ")") {
                    break;
                }
                op1 = Operand_1.Operand.readOperand(expr, i);
                operation1 = new Operation(op1, OperatorType_1.OperatorType.NOOP, null);
                if (!operation) {
                    operation = operation1;
                }
                else {
                    operation.add(operation1, operatorType);
                }
            }
            if (!Utils_1.Utils.eatSpaces(expr, i)) {
                return operation;
            }
            if (expr[i.valueOf()] === ")") {
                if (operation == null) {
                    throw new Error("Unexpected end of expression at index: " + i);
                }
                return operation;
            }
            token = Utils_1.Utils.readToken(expr, i);
            operatorType = Utils_1.Utils.stringToOperatorType(token);
            if (!Utils_1.Utils.eatSpaces(expr, i)) {
                throw new Error("Missing operand at index " + i);
            }
            if (expr[i.valueOf()] === "(") {
                operation2 = Operation.readOperation(expr, i);
            }
            else {
                op1 = Operand_1.Operand.readOperand(expr, i);
                operation2 = new Operation(op1, OperatorType_1.OperatorType.NOOP, null);
            }
            operation.add(operation2, operatorType);
            if (!Utils_1.Utils.eatSpaces(expr, i)) {
                break;
            }
            if (expr[i.valueOf()] === ")") {
                return operation;
            }
            token = Utils_1.Utils.readToken(expr, i);
            if (!Utils_1.Utils.eatSpaces(expr, i)) {
                throw new Error("Missing operand at index " + i);
            }
            operatorType = Utils_1.Utils.stringToOperatorType(token);
            if (Utils_1.Utils.isLogicalOperator(operatorType)) {
                operation2 = Operation.readOperation(expr, i);
                operation = new Operation(operation, operatorType, operation2);
            }
        }
        return operation;
    };
    Operation.convertToObject = function (operand, context) {
        var o;
        if (operand.operandType === OperandType_1.OperandType.Litteral) {
            if (typeof operand.value === "string" &&
                operand.value.toLowerCase() === "null") {
                o = null;
            }
            else if (typeof operand.value === "string" &&
                operand.value.toLowerCase() === "undefined") {
                o = undefined;
            }
            else if (typeof operand.value === "string" &&
                operand.value.toLowerCase() === "true") {
                o = true;
            }
            else if (typeof operand.value === "string" &&
                operand.value.toLowerCase() === "false") {
                o = false;
            }
            else {
                o = operand.value;
            }
        }
        else {
            switch (operand.operandType) {
                case OperandType_1.OperandType.Cookies:
                    throw new Error("Cookies is not a currently supported assignment");
                case OperandType_1.OperandType.Data:
                    o = context.data[operand.value]
                        ? context.data[operand.value.toString()]
                        : null;
                    break;
                case OperandType_1.OperandType.LocalStorage:
                    throw new Error("LocalStorage is not a currently supported assignment");
                default:
                    throw new Error("Invalid operand type");
            }
        }
        if (typeof o !== typeof "" && typeof o !== typeof true && o !== null) {
            o = parseFloat(o);
        }
        return o;
    };
    Operation.calculate = function (op1, operatorType, op2) {
        if ((typeof op1 === typeof true && typeof op2 !== typeof true) ||
            (typeof op1 !== typeof true && op2 === typeof true)) {
            throw new Error("Invalid operation on boolean value");
        }
        switch (operatorType) {
            case OperatorType_1.OperatorType.AND:
                return op1 && op2;
            case OperatorType_1.OperatorType.OR:
                return op1 || op2;
            case OperatorType_1.OperatorType.EQ:
                return op1 === op2;
            case OperatorType_1.OperatorType.NEQ:
                return op1 !== op2;
            case OperatorType_1.OperatorType.GT:
                return op1 > op2;
            case OperatorType_1.OperatorType.GTE:
                return op1 >= op2;
            case OperatorType_1.OperatorType.LT:
                return op1 < op2;
            case OperatorType_1.OperatorType.LTE:
                return op1 <= op2;
            case OperatorType_1.OperatorType.LIKE:
                return Operation.processLike(op1, op2);
            case OperatorType_1.OperatorType.ADD:
            case OperatorType_1.OperatorType.MINUS:
            case OperatorType_1.OperatorType.MULTIPLY:
            case OperatorType_1.OperatorType.DIVIDE:
                return Operation.processMathOperation(op1, operatorType, op2);
            default:
                throw new Error("Unknown or invalid operator!");
        }
    };
    Operation.processLike = function (op1, op2) {
        var regex = RegExp(op2);
        return regex.test(op1);
    };
    Operation.processMathOperation = function (op1, operatorType, op2) {
        if (Utils_1.Utils.isFloat(op1)) {
            return Operation.processFloatOperation(op1, operatorType, op2);
        }
        else {
            return Operation.processIntegerOperation(op1, operatorType, op2);
        }
    };
    Operation.processIntegerOperation = function (op1, operatorType, op2) {
        var result;
        switch (operatorType) {
            case OperatorType_1.OperatorType.ADD:
                result = op1 + op2;
                break;
            case OperatorType_1.OperatorType.MINUS:
                result = op1 - op2;
                break;
            case OperatorType_1.OperatorType.MULTIPLY:
                result = op1 * op2;
                break;
            case OperatorType_1.OperatorType.DIVIDE:
                result = op1 / op2;
                break;
            default:
                throw new Error("Invalid math operation");
        }
        if (Number.isNaN(result) || !Number.isFinite(result)) {
            throw new Error("Result is NaN or Infinite");
        }
        return result;
    };
    Operation.processFloatOperation = function (op1, operatorType, op2) {
        var result;
        var scale = 2;
        switch (operatorType) {
            case OperatorType_1.OperatorType.ADD:
                result = parseFloat(op1.toString()) + parseFloat(op2.toString());
                break;
            case OperatorType_1.OperatorType.MINUS:
                result = parseFloat(op1.toString()) - parseFloat(op2.toString());
                break;
            case OperatorType_1.OperatorType.MULTIPLY:
                result = parseFloat(op1.toString()) * parseFloat(op2.toString());
                break;
            case OperatorType_1.OperatorType.DIVIDE:
                result = parseFloat(op1.toString()) / parseFloat(op2.toString());
                break;
            default:
                throw new Error("Invalid math operation");
        }
        if (Number.isNaN(result) || !Number.isFinite(result)) {
            throw new Error("Result is NaN or Infinite");
        }
        return parseFloat(result.toFixed(scale));
    };
    Operation.prototype.add = function (operation, operatorType) {
        if (this.operatorTypeVar === OperatorType_1.OperatorType.NOOP) {
            this.operatorTypeVar = operatorType;
            this.op2Var =
                operation.operatorType === OperatorType_1.OperatorType.NOOP
                    ? operation.op1
                    : operation;
        }
        else {
            this.op1Var = new Operation(this.op1Var, this.operatorTypeVar, this.op2Var);
            this.operatorTypeVar = operatorType;
            this.op2Var = operation;
        }
    };
    Operation.prototype.eval = function (context) {
        var result;
        result = this.process(this, context);
        if (!(typeof result === typeof true)) {
            throw new Error("Top-level operation must return a boolean");
        }
        return result;
    };
    Operation.prototype.process = function (operation, context) {
        var op1;
        var op2;
        var o1;
        var o2;
        if (operation.op1 instanceof Operation) {
            op1 = new Operand_1.Operand(this.process(operation.op1, context), OperandType_1.OperandType.Litteral);
        }
        else {
            op1 = operation.op1;
        }
        if (operation.op2 instanceof Operation) {
            op2 = new Operand_1.Operand(this.process(operation.op2, context), OperandType_1.OperandType.Litteral);
        }
        else {
            op2 = operation.op2;
        }
        o1 = Operation.convertToObject(op1, context);
        o2 = Operation.convertToObject(op2, context);
        return Operation.calculate(o1, operation.operatorType, o2);
    };
    Object.defineProperty(Operation.prototype, "op1", {
        get: function () {
            return this.op1Var;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Operation.prototype, "op2", {
        get: function () {
            return this.op2Var;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Operation.prototype, "operatorType", {
        get: function () {
            return this.operatorTypeVar;
        },
        enumerable: false,
        configurable: true
    });
    return Operation;
}());
exports.Operation = Operation;
//# sourceMappingURL=Operation.js.map

/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/app/OperatorType.js":
/*!*************************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/app/OperatorType.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorType = void 0;
var OperatorType;
(function (OperatorType) {
    OperatorType[OperatorType["Unknown"] = 0] = "Unknown";
    OperatorType[OperatorType["LT"] = 1] = "LT";
    OperatorType[OperatorType["GT"] = 2] = "GT";
    OperatorType[OperatorType["LTE"] = 3] = "LTE";
    OperatorType[OperatorType["GTE"] = 4] = "GTE";
    OperatorType[OperatorType["EQ"] = 5] = "EQ";
    OperatorType[OperatorType["NEQ"] = 6] = "NEQ";
    OperatorType[OperatorType["LIKE"] = 7] = "LIKE";
    OperatorType[OperatorType["AND"] = 8] = "AND";
    OperatorType[OperatorType["OR"] = 9] = "OR";
    OperatorType[OperatorType["ADD"] = 10] = "ADD";
    OperatorType[OperatorType["MINUS"] = 11] = "MINUS";
    OperatorType[OperatorType["DIVIDE"] = 12] = "DIVIDE";
    OperatorType[OperatorType["MULTIPLY"] = 13] = "MULTIPLY";
    OperatorType[OperatorType["NOOP"] = 14] = "NOOP";
})(OperatorType = exports.OperatorType || (exports.OperatorType = {}));
//# sourceMappingURL=OperatorType.js.map

/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/app/Parser.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/app/Parser.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
var Operation_1 = __webpack_require__(/*! ./Operation */ "./node_modules/@charter/helix-extensions/dist/app/Operation.js");
var Parser = (function () {
    function Parser() {
    }
    Parser.parse = function (expression, i) {
        var operation;
        operation = Operation_1.Operation.readOperation(expression, i);
        return operation;
    };
    return Parser;
}());
exports.Parser = Parser;
//# sourceMappingURL=Parser.js.map

/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/app/Utils.js":
/*!******************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/app/Utils.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var OperatorType_1 = __webpack_require__(/*! ./OperatorType */ "./node_modules/@charter/helix-extensions/dist/app/OperatorType.js");
var Utils = (function () {
    function Utils() {
    }
    Utils.nullOrEmpty = function (value) {
        return !value || value === '';
    };
    Utils.isWhiteSpace = function (value) {
        return /^\s*$/.test(value);
    };
    Utils.eatSpaces = function (expression, idx) {
        while (idx.valueOf() < expression.length) {
            if (Utils.isWhiteSpace(expression[idx.valueOf()])) {
                idx.increment();
            }
            else {
                return true;
            }
        }
        return false;
    };
    Utils.readToken = function (expression, idx) {
        var token = '';
        var quote = false;
        Utils.eatSpaces(expression, idx);
        if (expression[idx.valueOf()] === "'") {
            quote = true;
            token += "'";
            idx.increment();
        }
        while (idx.valueOf() < expression.length) {
            if (quote && expression[idx.valueOf()] === "'") {
                idx.increment();
                token += "'";
                return token;
            }
            if (!quote &&
                (Utils.isWhiteSpace(expression[idx.valueOf()]) ||
                    expression[idx.valueOf()] === ')')) {
                return token;
            }
            token += expression[idx.valueOf()];
            idx.increment();
        }
        if (quote) {
            throw new Error('Unterminated token. Expected single quote');
        }
        if (token === '') {
            throw new Error('Unexpected empty token');
        }
        return token;
    };
    Utils.isLogicalOperator = function (operatorType) {
        return (operatorType === OperatorType_1.OperatorType.AND ||
            operatorType === OperatorType_1.OperatorType.OR);
    };
    Utils.stringToOperatorType = function (value) {
        value = value.toUpperCase().trim();
        switch (value) {
            case '=':
                return OperatorType_1.OperatorType.EQ;
            case '!=':
            case '<>':
                return OperatorType_1.OperatorType.NEQ;
            case '<':
                return OperatorType_1.OperatorType.LT;
            case '<=':
                return OperatorType_1.OperatorType.LTE;
            case '>':
                return OperatorType_1.OperatorType.GT;
            case '>=':
                return OperatorType_1.OperatorType.GTE;
            case 'AND':
                return OperatorType_1.OperatorType.AND;
            case 'OR':
                return OperatorType_1.OperatorType.OR;
            case '+':
                return OperatorType_1.OperatorType.ADD;
            case '-':
                return OperatorType_1.OperatorType.MINUS;
            case '*':
                return OperatorType_1.OperatorType.MULTIPLY;
            case '/':
                return OperatorType_1.OperatorType.DIVIDE;
            case 'LIKE':
                return OperatorType_1.OperatorType.LIKE;
            default:
                throw new Error('Invalid operator: ' + value);
        }
    };
    Utils.isInt = function (n) {
        return Number(n) === n && n % 1 === 0;
    };
    Utils.isFloat = function (n) {
        return Number(n) === n && n % 1 !== 0;
    };
    return Utils;
}());
exports.Utils = Utils;
//# sourceMappingURL=Utils.js.map

/***/ }),

/***/ "./node_modules/@charter/helix-extensions/dist/index.js":
/*!**************************************************************!*\
  !*** ./node_modules/@charter/helix-extensions/dist/index.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Expression_1 = __webpack_require__(/*! ./app/Expression */ "./node_modules/@charter/helix-extensions/dist/app/Expression.js");
Object.defineProperty(exports, "Expression", { enumerable: true, get: function () { return Expression_1.Expression; } });
var Context_1 = __webpack_require__(/*! ./app/Context */ "./node_modules/@charter/helix-extensions/dist/app/Context.js");
Object.defineProperty(exports, "Context", { enumerable: true, get: function () { return Context_1.Context; } });
var Operand_1 = __webpack_require__(/*! ./app/Operand */ "./node_modules/@charter/helix-extensions/dist/app/Operand.js");
Object.defineProperty(exports, "Operand", { enumerable: true, get: function () { return Operand_1.Operand; } });
var OperandType_1 = __webpack_require__(/*! ./app/OperandType */ "./node_modules/@charter/helix-extensions/dist/app/OperandType.js");
Object.defineProperty(exports, "OperandType", { enumerable: true, get: function () { return OperandType_1.OperandType; } });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/@charter/quantum/build/video/analytics.js":
/*!****************************************************************!*\
  !*** ./node_modules/@charter/quantum/build/video/analytics.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*! @charter/quantum 8.28.0 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayLikeToArray.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/arrayWithHoles.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithHoles.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/assertThisInitialized.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/asyncToGenerator.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/classCallCheck.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/classCallCheck.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/createClass.js":
/*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/createClass.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/@babel/runtime/helpers/toPropertyKey.js");
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/defineProperty.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/@babel/runtime/helpers/toPropertyKey.js");
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/getPrototypeOf.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/inherits.js":
/*!*********************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/inherits.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(/*! ./setPrototypeOf.js */ "./node_modules/@babel/runtime/helpers/setPrototypeOf.js");
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/nonIterableRest.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableRest.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js":
/*!**************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];
var assertThisInitialized = __webpack_require__(/*! ./assertThisInitialized.js */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/regeneratorRuntime.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/regeneratorRuntime.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/setPrototypeOf.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/setPrototypeOf.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/slicedToArray.js":
/*!**************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/slicedToArray.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(/*! ./arrayWithHoles.js */ "./node_modules/@babel/runtime/helpers/arrayWithHoles.js");
var iterableToArrayLimit = __webpack_require__(/*! ./iterableToArrayLimit.js */ "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js");
var unsupportedIterableToArray = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");
var nonIterableRest = __webpack_require__(/*! ./nonIterableRest.js */ "./node_modules/@babel/runtime/helpers/nonIterableRest.js");
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toPrimitive.js":
/*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toPrimitive.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toPropertyKey.js":
/*!**************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toPropertyKey.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];
var toPrimitive = __webpack_require__(/*! ./toPrimitive.js */ "./node_modules/@babel/runtime/helpers/toPrimitive.js");
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/typeof.js":
/*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/regenerator/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(/*! ../helpers/regeneratorRuntime */ "./node_modules/@babel/runtime/helpers/regeneratorRuntime.js")();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "./node_modules/lodash/_DataView.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_DataView.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "./node_modules/lodash/_Hash.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/_Hash.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(/*! ./_hashClear */ "./node_modules/lodash/_hashClear.js"),
    hashDelete = __webpack_require__(/*! ./_hashDelete */ "./node_modules/lodash/_hashDelete.js"),
    hashGet = __webpack_require__(/*! ./_hashGet */ "./node_modules/lodash/_hashGet.js"),
    hashHas = __webpack_require__(/*! ./_hashHas */ "./node_modules/lodash/_hashHas.js"),
    hashSet = __webpack_require__(/*! ./_hashSet */ "./node_modules/lodash/_hashSet.js");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "./node_modules/lodash/_ListCache.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_ListCache.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(/*! ./_listCacheClear */ "./node_modules/lodash/_listCacheClear.js"),
    listCacheDelete = __webpack_require__(/*! ./_listCacheDelete */ "./node_modules/lodash/_listCacheDelete.js"),
    listCacheGet = __webpack_require__(/*! ./_listCacheGet */ "./node_modules/lodash/_listCacheGet.js"),
    listCacheHas = __webpack_require__(/*! ./_listCacheHas */ "./node_modules/lodash/_listCacheHas.js"),
    listCacheSet = __webpack_require__(/*! ./_listCacheSet */ "./node_modules/lodash/_listCacheSet.js");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "./node_modules/lodash/_Map.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/_Map.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "./node_modules/lodash/_MapCache.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_MapCache.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(/*! ./_mapCacheClear */ "./node_modules/lodash/_mapCacheClear.js"),
    mapCacheDelete = __webpack_require__(/*! ./_mapCacheDelete */ "./node_modules/lodash/_mapCacheDelete.js"),
    mapCacheGet = __webpack_require__(/*! ./_mapCacheGet */ "./node_modules/lodash/_mapCacheGet.js"),
    mapCacheHas = __webpack_require__(/*! ./_mapCacheHas */ "./node_modules/lodash/_mapCacheHas.js"),
    mapCacheSet = __webpack_require__(/*! ./_mapCacheSet */ "./node_modules/lodash/_mapCacheSet.js");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "./node_modules/lodash/_Promise.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_Promise.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "./node_modules/lodash/_Set.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/_Set.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "./node_modules/lodash/_SetCache.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_SetCache.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(/*! ./_MapCache */ "./node_modules/lodash/_MapCache.js"),
    setCacheAdd = __webpack_require__(/*! ./_setCacheAdd */ "./node_modules/lodash/_setCacheAdd.js"),
    setCacheHas = __webpack_require__(/*! ./_setCacheHas */ "./node_modules/lodash/_setCacheHas.js");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "./node_modules/lodash/_Stack.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/_Stack.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(/*! ./_ListCache */ "./node_modules/lodash/_ListCache.js"),
    stackClear = __webpack_require__(/*! ./_stackClear */ "./node_modules/lodash/_stackClear.js"),
    stackDelete = __webpack_require__(/*! ./_stackDelete */ "./node_modules/lodash/_stackDelete.js"),
    stackGet = __webpack_require__(/*! ./_stackGet */ "./node_modules/lodash/_stackGet.js"),
    stackHas = __webpack_require__(/*! ./_stackHas */ "./node_modules/lodash/_stackHas.js"),
    stackSet = __webpack_require__(/*! ./_stackSet */ "./node_modules/lodash/_stackSet.js");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "./node_modules/lodash/_Symbol.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/_Symbol.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "./node_modules/lodash/_Uint8Array.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_Uint8Array.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "./node_modules/lodash/_WeakMap.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_WeakMap.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "./node_modules/lodash/_apply.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/_apply.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "./node_modules/lodash/_arrayEach.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_arrayEach.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ "./node_modules/lodash/_arrayFilter.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_arrayFilter.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "./node_modules/lodash/_arrayIncludes.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_arrayIncludes.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(/*! ./_baseIndexOf */ "./node_modules/lodash/_baseIndexOf.js");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "./node_modules/lodash/_arrayIncludesWith.js":
/*!***************************************************!*\
  !*** ./node_modules/lodash/_arrayIncludesWith.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ "./node_modules/lodash/_arrayLikeKeys.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_arrayLikeKeys.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(/*! ./_baseTimes */ "./node_modules/lodash/_baseTimes.js"),
    isArguments = __webpack_require__(/*! ./isArguments */ "./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__(/*! ./isBuffer */ "./node_modules/lodash/isBuffer.js"),
    isIndex = __webpack_require__(/*! ./_isIndex */ "./node_modules/lodash/_isIndex.js"),
    isTypedArray = __webpack_require__(/*! ./isTypedArray */ "./node_modules/lodash/isTypedArray.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "./node_modules/lodash/_arrayMap.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_arrayMap.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "./node_modules/lodash/_arrayPush.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_arrayPush.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "./node_modules/lodash/_arraySome.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_arraySome.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "./node_modules/lodash/_assignMergeValue.js":
/*!**************************************************!*\
  !*** ./node_modules/lodash/_assignMergeValue.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ "./node_modules/lodash/_baseAssignValue.js"),
    eq = __webpack_require__(/*! ./eq */ "./node_modules/lodash/eq.js");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "./node_modules/lodash/_assignValue.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_assignValue.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ "./node_modules/lodash/_baseAssignValue.js"),
    eq = __webpack_require__(/*! ./eq */ "./node_modules/lodash/eq.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "./node_modules/lodash/_assocIndexOf.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_assocIndexOf.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(/*! ./eq */ "./node_modules/lodash/eq.js");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_baseAssign.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseAssign.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ "./node_modules/lodash/_copyObject.js"),
    keys = __webpack_require__(/*! ./keys */ "./node_modules/lodash/keys.js");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ "./node_modules/lodash/_baseAssignIn.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseAssignIn.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ "./node_modules/lodash/_copyObject.js"),
    keysIn = __webpack_require__(/*! ./keysIn */ "./node_modules/lodash/keysIn.js");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ "./node_modules/lodash/_baseAssignValue.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_baseAssignValue.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(/*! ./_defineProperty */ "./node_modules/lodash/_defineProperty.js");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "./node_modules/lodash/_baseClone.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseClone.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(/*! ./_Stack */ "./node_modules/lodash/_Stack.js"),
    arrayEach = __webpack_require__(/*! ./_arrayEach */ "./node_modules/lodash/_arrayEach.js"),
    assignValue = __webpack_require__(/*! ./_assignValue */ "./node_modules/lodash/_assignValue.js"),
    baseAssign = __webpack_require__(/*! ./_baseAssign */ "./node_modules/lodash/_baseAssign.js"),
    baseAssignIn = __webpack_require__(/*! ./_baseAssignIn */ "./node_modules/lodash/_baseAssignIn.js"),
    cloneBuffer = __webpack_require__(/*! ./_cloneBuffer */ "./node_modules/lodash/_cloneBuffer.js"),
    copyArray = __webpack_require__(/*! ./_copyArray */ "./node_modules/lodash/_copyArray.js"),
    copySymbols = __webpack_require__(/*! ./_copySymbols */ "./node_modules/lodash/_copySymbols.js"),
    copySymbolsIn = __webpack_require__(/*! ./_copySymbolsIn */ "./node_modules/lodash/_copySymbolsIn.js"),
    getAllKeys = __webpack_require__(/*! ./_getAllKeys */ "./node_modules/lodash/_getAllKeys.js"),
    getAllKeysIn = __webpack_require__(/*! ./_getAllKeysIn */ "./node_modules/lodash/_getAllKeysIn.js"),
    getTag = __webpack_require__(/*! ./_getTag */ "./node_modules/lodash/_getTag.js"),
    initCloneArray = __webpack_require__(/*! ./_initCloneArray */ "./node_modules/lodash/_initCloneArray.js"),
    initCloneByTag = __webpack_require__(/*! ./_initCloneByTag */ "./node_modules/lodash/_initCloneByTag.js"),
    initCloneObject = __webpack_require__(/*! ./_initCloneObject */ "./node_modules/lodash/_initCloneObject.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__(/*! ./isBuffer */ "./node_modules/lodash/isBuffer.js"),
    isMap = __webpack_require__(/*! ./isMap */ "./node_modules/lodash/isMap.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js"),
    isSet = __webpack_require__(/*! ./isSet */ "./node_modules/lodash/isSet.js"),
    keys = __webpack_require__(/*! ./keys */ "./node_modules/lodash/keys.js"),
    keysIn = __webpack_require__(/*! ./keysIn */ "./node_modules/lodash/keysIn.js");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ "./node_modules/lodash/_baseCreate.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseCreate.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "./node_modules/lodash/_baseDifference.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_baseDifference.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(/*! ./_SetCache */ "./node_modules/lodash/_SetCache.js"),
    arrayIncludes = __webpack_require__(/*! ./_arrayIncludes */ "./node_modules/lodash/_arrayIncludes.js"),
    arrayIncludesWith = __webpack_require__(/*! ./_arrayIncludesWith */ "./node_modules/lodash/_arrayIncludesWith.js"),
    arrayMap = __webpack_require__(/*! ./_arrayMap */ "./node_modules/lodash/_arrayMap.js"),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ "./node_modules/lodash/_baseUnary.js"),
    cacheHas = __webpack_require__(/*! ./_cacheHas */ "./node_modules/lodash/_cacheHas.js");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),

/***/ "./node_modules/lodash/_baseFindIndex.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_baseFindIndex.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "./node_modules/lodash/_baseFlatten.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseFlatten.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(/*! ./_arrayPush */ "./node_modules/lodash/_arrayPush.js"),
    isFlattenable = __webpack_require__(/*! ./_isFlattenable */ "./node_modules/lodash/_isFlattenable.js");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ "./node_modules/lodash/_baseFor.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_baseFor.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(/*! ./_createBaseFor */ "./node_modules/lodash/_createBaseFor.js");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "./node_modules/lodash/_baseGet.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_baseGet.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(/*! ./_castPath */ "./node_modules/lodash/_castPath.js"),
    toKey = __webpack_require__(/*! ./_toKey */ "./node_modules/lodash/_toKey.js");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ "./node_modules/lodash/_baseGetAllKeys.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_baseGetAllKeys.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(/*! ./_arrayPush */ "./node_modules/lodash/_arrayPush.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseGetTag.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseGetTag.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__(/*! ./_getRawTag */ "./node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__(/*! ./_objectToString */ "./node_modules/lodash/_objectToString.js");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "./node_modules/lodash/_baseHasIn.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseHasIn.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "./node_modules/lodash/_baseIndexOf.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseIndexOf.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(/*! ./_baseFindIndex */ "./node_modules/lodash/_baseFindIndex.js"),
    baseIsNaN = __webpack_require__(/*! ./_baseIsNaN */ "./node_modules/lodash/_baseIsNaN.js"),
    strictIndexOf = __webpack_require__(/*! ./_strictIndexOf */ "./node_modules/lodash/_strictIndexOf.js");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_baseIndexOfWith.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_baseIndexOfWith.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOfWith;


/***/ }),

/***/ "./node_modules/lodash/_baseIsArguments.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_baseIsArguments.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqual.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseIsEqual.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(/*! ./_baseIsEqualDeep */ "./node_modules/lodash/_baseIsEqualDeep.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqualDeep.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_baseIsEqualDeep.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(/*! ./_Stack */ "./node_modules/lodash/_Stack.js"),
    equalArrays = __webpack_require__(/*! ./_equalArrays */ "./node_modules/lodash/_equalArrays.js"),
    equalByTag = __webpack_require__(/*! ./_equalByTag */ "./node_modules/lodash/_equalByTag.js"),
    equalObjects = __webpack_require__(/*! ./_equalObjects */ "./node_modules/lodash/_equalObjects.js"),
    getTag = __webpack_require__(/*! ./_getTag */ "./node_modules/lodash/_getTag.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__(/*! ./isBuffer */ "./node_modules/lodash/isBuffer.js"),
    isTypedArray = __webpack_require__(/*! ./isTypedArray */ "./node_modules/lodash/isTypedArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "./node_modules/lodash/_baseIsMap.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseIsMap.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(/*! ./_getTag */ "./node_modules/lodash/_getTag.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ "./node_modules/lodash/_baseIsMatch.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseIsMatch.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(/*! ./_Stack */ "./node_modules/lodash/_Stack.js"),
    baseIsEqual = __webpack_require__(/*! ./_baseIsEqual */ "./node_modules/lodash/_baseIsEqual.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "./node_modules/lodash/_baseIsNaN.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseIsNaN.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "./node_modules/lodash/_baseIsNative.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseIsNative.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(/*! ./isFunction */ "./node_modules/lodash/isFunction.js"),
    isMasked = __webpack_require__(/*! ./_isMasked */ "./node_modules/lodash/_isMasked.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js"),
    toSource = __webpack_require__(/*! ./_toSource */ "./node_modules/lodash/_toSource.js");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "./node_modules/lodash/_baseIsSet.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseIsSet.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(/*! ./_getTag */ "./node_modules/lodash/_getTag.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ "./node_modules/lodash/_baseIsTypedArray.js":
/*!**************************************************!*\
  !*** ./node_modules/lodash/_baseIsTypedArray.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isLength = __webpack_require__(/*! ./isLength */ "./node_modules/lodash/isLength.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "./node_modules/lodash/_baseIteratee.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseIteratee.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(/*! ./_baseMatches */ "./node_modules/lodash/_baseMatches.js"),
    baseMatchesProperty = __webpack_require__(/*! ./_baseMatchesProperty */ "./node_modules/lodash/_baseMatchesProperty.js"),
    identity = __webpack_require__(/*! ./identity */ "./node_modules/lodash/identity.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    property = __webpack_require__(/*! ./property */ "./node_modules/lodash/property.js");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "./node_modules/lodash/_baseKeys.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseKeys.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(/*! ./_isPrototype */ "./node_modules/lodash/_isPrototype.js"),
    nativeKeys = __webpack_require__(/*! ./_nativeKeys */ "./node_modules/lodash/_nativeKeys.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseKeysIn.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseKeysIn.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js"),
    isPrototype = __webpack_require__(/*! ./_isPrototype */ "./node_modules/lodash/_isPrototype.js"),
    nativeKeysIn = __webpack_require__(/*! ./_nativeKeysIn */ "./node_modules/lodash/_nativeKeysIn.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ "./node_modules/lodash/_baseMatches.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseMatches.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(/*! ./_baseIsMatch */ "./node_modules/lodash/_baseIsMatch.js"),
    getMatchData = __webpack_require__(/*! ./_getMatchData */ "./node_modules/lodash/_getMatchData.js"),
    matchesStrictComparable = __webpack_require__(/*! ./_matchesStrictComparable */ "./node_modules/lodash/_matchesStrictComparable.js");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "./node_modules/lodash/_baseMatchesProperty.js":
/*!*****************************************************!*\
  !*** ./node_modules/lodash/_baseMatchesProperty.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(/*! ./_baseIsEqual */ "./node_modules/lodash/_baseIsEqual.js"),
    get = __webpack_require__(/*! ./get */ "./node_modules/lodash/get.js"),
    hasIn = __webpack_require__(/*! ./hasIn */ "./node_modules/lodash/hasIn.js"),
    isKey = __webpack_require__(/*! ./_isKey */ "./node_modules/lodash/_isKey.js"),
    isStrictComparable = __webpack_require__(/*! ./_isStrictComparable */ "./node_modules/lodash/_isStrictComparable.js"),
    matchesStrictComparable = __webpack_require__(/*! ./_matchesStrictComparable */ "./node_modules/lodash/_matchesStrictComparable.js"),
    toKey = __webpack_require__(/*! ./_toKey */ "./node_modules/lodash/_toKey.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "./node_modules/lodash/_baseMerge.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseMerge.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(/*! ./_Stack */ "./node_modules/lodash/_Stack.js"),
    assignMergeValue = __webpack_require__(/*! ./_assignMergeValue */ "./node_modules/lodash/_assignMergeValue.js"),
    baseFor = __webpack_require__(/*! ./_baseFor */ "./node_modules/lodash/_baseFor.js"),
    baseMergeDeep = __webpack_require__(/*! ./_baseMergeDeep */ "./node_modules/lodash/_baseMergeDeep.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js"),
    keysIn = __webpack_require__(/*! ./keysIn */ "./node_modules/lodash/keysIn.js"),
    safeGet = __webpack_require__(/*! ./_safeGet */ "./node_modules/lodash/_safeGet.js");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "./node_modules/lodash/_baseMergeDeep.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_baseMergeDeep.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(/*! ./_assignMergeValue */ "./node_modules/lodash/_assignMergeValue.js"),
    cloneBuffer = __webpack_require__(/*! ./_cloneBuffer */ "./node_modules/lodash/_cloneBuffer.js"),
    cloneTypedArray = __webpack_require__(/*! ./_cloneTypedArray */ "./node_modules/lodash/_cloneTypedArray.js"),
    copyArray = __webpack_require__(/*! ./_copyArray */ "./node_modules/lodash/_copyArray.js"),
    initCloneObject = __webpack_require__(/*! ./_initCloneObject */ "./node_modules/lodash/_initCloneObject.js"),
    isArguments = __webpack_require__(/*! ./isArguments */ "./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isArrayLikeObject = __webpack_require__(/*! ./isArrayLikeObject */ "./node_modules/lodash/isArrayLikeObject.js"),
    isBuffer = __webpack_require__(/*! ./isBuffer */ "./node_modules/lodash/isBuffer.js"),
    isFunction = __webpack_require__(/*! ./isFunction */ "./node_modules/lodash/isFunction.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js"),
    isPlainObject = __webpack_require__(/*! ./isPlainObject */ "./node_modules/lodash/isPlainObject.js"),
    isTypedArray = __webpack_require__(/*! ./isTypedArray */ "./node_modules/lodash/isTypedArray.js"),
    safeGet = __webpack_require__(/*! ./_safeGet */ "./node_modules/lodash/_safeGet.js"),
    toPlainObject = __webpack_require__(/*! ./toPlainObject */ "./node_modules/lodash/toPlainObject.js");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "./node_modules/lodash/_basePick.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_basePick.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(/*! ./_basePickBy */ "./node_modules/lodash/_basePickBy.js"),
    hasIn = __webpack_require__(/*! ./hasIn */ "./node_modules/lodash/hasIn.js");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),

/***/ "./node_modules/lodash/_basePickBy.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_basePickBy.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(/*! ./_baseGet */ "./node_modules/lodash/_baseGet.js"),
    baseSet = __webpack_require__(/*! ./_baseSet */ "./node_modules/lodash/_baseSet.js"),
    castPath = __webpack_require__(/*! ./_castPath */ "./node_modules/lodash/_castPath.js");

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ "./node_modules/lodash/_baseProperty.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseProperty.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "./node_modules/lodash/_basePropertyDeep.js":
/*!**************************************************!*\
  !*** ./node_modules/lodash/_basePropertyDeep.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(/*! ./_baseGet */ "./node_modules/lodash/_baseGet.js");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "./node_modules/lodash/_basePullAll.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_basePullAll.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(/*! ./_arrayMap */ "./node_modules/lodash/_arrayMap.js"),
    baseIndexOf = __webpack_require__(/*! ./_baseIndexOf */ "./node_modules/lodash/_baseIndexOf.js"),
    baseIndexOfWith = __webpack_require__(/*! ./_baseIndexOfWith */ "./node_modules/lodash/_baseIndexOfWith.js"),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ "./node_modules/lodash/_baseUnary.js"),
    copyArray = __webpack_require__(/*! ./_copyArray */ "./node_modules/lodash/_copyArray.js");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = copyArray(values);
  }
  if (iteratee) {
    seen = arrayMap(array, baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

module.exports = basePullAll;


/***/ }),

/***/ "./node_modules/lodash/_baseRest.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseRest.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(/*! ./identity */ "./node_modules/lodash/identity.js"),
    overRest = __webpack_require__(/*! ./_overRest */ "./node_modules/lodash/_overRest.js"),
    setToString = __webpack_require__(/*! ./_setToString */ "./node_modules/lodash/_setToString.js");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "./node_modules/lodash/_baseSet.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_baseSet.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(/*! ./_assignValue */ "./node_modules/lodash/_assignValue.js"),
    castPath = __webpack_require__(/*! ./_castPath */ "./node_modules/lodash/_castPath.js"),
    isIndex = __webpack_require__(/*! ./_isIndex */ "./node_modules/lodash/_isIndex.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js"),
    toKey = __webpack_require__(/*! ./_toKey */ "./node_modules/lodash/_toKey.js");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ "./node_modules/lodash/_baseSetToString.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_baseSetToString.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(/*! ./constant */ "./node_modules/lodash/constant.js"),
    defineProperty = __webpack_require__(/*! ./_defineProperty */ "./node_modules/lodash/_defineProperty.js"),
    identity = __webpack_require__(/*! ./identity */ "./node_modules/lodash/identity.js");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "./node_modules/lodash/_baseTimes.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseTimes.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "./node_modules/lodash/_baseToString.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseToString.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js"),
    arrayMap = __webpack_require__(/*! ./_arrayMap */ "./node_modules/lodash/_arrayMap.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__(/*! ./isSymbol */ "./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ "./node_modules/lodash/_baseUnary.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseUnary.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "./node_modules/lodash/_cacheHas.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_cacheHas.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "./node_modules/lodash/_castPath.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_castPath.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isKey = __webpack_require__(/*! ./_isKey */ "./node_modules/lodash/_isKey.js"),
    stringToPath = __webpack_require__(/*! ./_stringToPath */ "./node_modules/lodash/_stringToPath.js"),
    toString = __webpack_require__(/*! ./toString */ "./node_modules/lodash/toString.js");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ "./node_modules/lodash/_cloneArrayBuffer.js":
/*!**************************************************!*\
  !*** ./node_modules/lodash/_cloneArrayBuffer.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(/*! ./_Uint8Array */ "./node_modules/lodash/_Uint8Array.js");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "./node_modules/lodash/_cloneBuffer.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_cloneBuffer.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/** Detect free variable `exports`. */
var freeExports =   true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/_cloneDataView.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_cloneDataView.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ "./node_modules/lodash/_cloneArrayBuffer.js");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ "./node_modules/lodash/_cloneRegExp.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_cloneRegExp.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ "./node_modules/lodash/_cloneSymbol.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_cloneSymbol.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js");

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ "./node_modules/lodash/_cloneTypedArray.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_cloneTypedArray.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ "./node_modules/lodash/_cloneArrayBuffer.js");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "./node_modules/lodash/_copyArray.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_copyArray.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "./node_modules/lodash/_copyObject.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_copyObject.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(/*! ./_assignValue */ "./node_modules/lodash/_assignValue.js"),
    baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ "./node_modules/lodash/_baseAssignValue.js");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "./node_modules/lodash/_copySymbols.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_copySymbols.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ "./node_modules/lodash/_copyObject.js"),
    getSymbols = __webpack_require__(/*! ./_getSymbols */ "./node_modules/lodash/_getSymbols.js");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ "./node_modules/lodash/_copySymbolsIn.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_copySymbolsIn.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ "./node_modules/lodash/_copyObject.js"),
    getSymbolsIn = __webpack_require__(/*! ./_getSymbolsIn */ "./node_modules/lodash/_getSymbolsIn.js");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ "./node_modules/lodash/_coreJsData.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_coreJsData.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "./node_modules/lodash/_createAssigner.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_createAssigner.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(/*! ./_baseRest */ "./node_modules/lodash/_baseRest.js"),
    isIterateeCall = __webpack_require__(/*! ./_isIterateeCall */ "./node_modules/lodash/_isIterateeCall.js");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "./node_modules/lodash/_createBaseFor.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_createBaseFor.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "./node_modules/lodash/_defineProperty.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_defineProperty.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "./node_modules/lodash/_equalArrays.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_equalArrays.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(/*! ./_SetCache */ "./node_modules/lodash/_SetCache.js"),
    arraySome = __webpack_require__(/*! ./_arraySome */ "./node_modules/lodash/_arraySome.js"),
    cacheHas = __webpack_require__(/*! ./_cacheHas */ "./node_modules/lodash/_cacheHas.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "./node_modules/lodash/_equalByTag.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_equalByTag.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js"),
    Uint8Array = __webpack_require__(/*! ./_Uint8Array */ "./node_modules/lodash/_Uint8Array.js"),
    eq = __webpack_require__(/*! ./eq */ "./node_modules/lodash/eq.js"),
    equalArrays = __webpack_require__(/*! ./_equalArrays */ "./node_modules/lodash/_equalArrays.js"),
    mapToArray = __webpack_require__(/*! ./_mapToArray */ "./node_modules/lodash/_mapToArray.js"),
    setToArray = __webpack_require__(/*! ./_setToArray */ "./node_modules/lodash/_setToArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "./node_modules/lodash/_equalObjects.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_equalObjects.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(/*! ./_getAllKeys */ "./node_modules/lodash/_getAllKeys.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "./node_modules/lodash/_flatRest.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_flatRest.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(/*! ./flatten */ "./node_modules/lodash/flatten.js"),
    overRest = __webpack_require__(/*! ./_overRest */ "./node_modules/lodash/_overRest.js"),
    setToString = __webpack_require__(/*! ./_setToString */ "./node_modules/lodash/_setToString.js");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ "./node_modules/lodash/_freeGlobal.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_freeGlobal.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash/_getAllKeys.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_getAllKeys.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(/*! ./_baseGetAllKeys */ "./node_modules/lodash/_baseGetAllKeys.js"),
    getSymbols = __webpack_require__(/*! ./_getSymbols */ "./node_modules/lodash/_getSymbols.js"),
    keys = __webpack_require__(/*! ./keys */ "./node_modules/lodash/keys.js");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_getAllKeysIn.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_getAllKeysIn.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(/*! ./_baseGetAllKeys */ "./node_modules/lodash/_baseGetAllKeys.js"),
    getSymbolsIn = __webpack_require__(/*! ./_getSymbolsIn */ "./node_modules/lodash/_getSymbolsIn.js"),
    keysIn = __webpack_require__(/*! ./keysIn */ "./node_modules/lodash/keysIn.js");

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ "./node_modules/lodash/_getMapData.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_getMapData.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(/*! ./_isKeyable */ "./node_modules/lodash/_isKeyable.js");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "./node_modules/lodash/_getMatchData.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_getMatchData.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(/*! ./_isStrictComparable */ "./node_modules/lodash/_isStrictComparable.js"),
    keys = __webpack_require__(/*! ./keys */ "./node_modules/lodash/keys.js");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "./node_modules/lodash/_getNative.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_getNative.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(/*! ./_baseIsNative */ "./node_modules/lodash/_baseIsNative.js"),
    getValue = __webpack_require__(/*! ./_getValue */ "./node_modules/lodash/_getValue.js");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "./node_modules/lodash/_getPrototype.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_getPrototype.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(/*! ./_overArg */ "./node_modules/lodash/_overArg.js");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "./node_modules/lodash/_getRawTag.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_getRawTag.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "./node_modules/lodash/_getSymbols.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_getSymbols.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(/*! ./_arrayFilter */ "./node_modules/lodash/_arrayFilter.js"),
    stubArray = __webpack_require__(/*! ./stubArray */ "./node_modules/lodash/stubArray.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "./node_modules/lodash/_getSymbolsIn.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_getSymbolsIn.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(/*! ./_arrayPush */ "./node_modules/lodash/_arrayPush.js"),
    getPrototype = __webpack_require__(/*! ./_getPrototype */ "./node_modules/lodash/_getPrototype.js"),
    getSymbols = __webpack_require__(/*! ./_getSymbols */ "./node_modules/lodash/_getSymbols.js"),
    stubArray = __webpack_require__(/*! ./stubArray */ "./node_modules/lodash/stubArray.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ "./node_modules/lodash/_getTag.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/_getTag.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(/*! ./_DataView */ "./node_modules/lodash/_DataView.js"),
    Map = __webpack_require__(/*! ./_Map */ "./node_modules/lodash/_Map.js"),
    Promise = __webpack_require__(/*! ./_Promise */ "./node_modules/lodash/_Promise.js"),
    Set = __webpack_require__(/*! ./_Set */ "./node_modules/lodash/_Set.js"),
    WeakMap = __webpack_require__(/*! ./_WeakMap */ "./node_modules/lodash/_WeakMap.js"),
    baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    toSource = __webpack_require__(/*! ./_toSource */ "./node_modules/lodash/_toSource.js");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "./node_modules/lodash/_getValue.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_getValue.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "./node_modules/lodash/_hasPath.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_hasPath.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(/*! ./_castPath */ "./node_modules/lodash/_castPath.js"),
    isArguments = __webpack_require__(/*! ./isArguments */ "./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isIndex = __webpack_require__(/*! ./_isIndex */ "./node_modules/lodash/_isIndex.js"),
    isLength = __webpack_require__(/*! ./isLength */ "./node_modules/lodash/isLength.js"),
    toKey = __webpack_require__(/*! ./_toKey */ "./node_modules/lodash/_toKey.js");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "./node_modules/lodash/_hashClear.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_hashClear.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "./node_modules/lodash/_nativeCreate.js");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "./node_modules/lodash/_hashDelete.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_hashDelete.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "./node_modules/lodash/_hashGet.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_hashGet.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "./node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "./node_modules/lodash/_hashHas.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_hashHas.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "./node_modules/lodash/_nativeCreate.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "./node_modules/lodash/_hashSet.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_hashSet.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "./node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "./node_modules/lodash/_initCloneArray.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_initCloneArray.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ "./node_modules/lodash/_initCloneByTag.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_initCloneByTag.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ "./node_modules/lodash/_cloneArrayBuffer.js"),
    cloneDataView = __webpack_require__(/*! ./_cloneDataView */ "./node_modules/lodash/_cloneDataView.js"),
    cloneRegExp = __webpack_require__(/*! ./_cloneRegExp */ "./node_modules/lodash/_cloneRegExp.js"),
    cloneSymbol = __webpack_require__(/*! ./_cloneSymbol */ "./node_modules/lodash/_cloneSymbol.js"),
    cloneTypedArray = __webpack_require__(/*! ./_cloneTypedArray */ "./node_modules/lodash/_cloneTypedArray.js");

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ "./node_modules/lodash/_initCloneObject.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_initCloneObject.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(/*! ./_baseCreate */ "./node_modules/lodash/_baseCreate.js"),
    getPrototype = __webpack_require__(/*! ./_getPrototype */ "./node_modules/lodash/_getPrototype.js"),
    isPrototype = __webpack_require__(/*! ./_isPrototype */ "./node_modules/lodash/_isPrototype.js");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "./node_modules/lodash/_isFlattenable.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_isFlattenable.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js"),
    isArguments = __webpack_require__(/*! ./isArguments */ "./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js");

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ "./node_modules/lodash/_isIndex.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_isIndex.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "./node_modules/lodash/_isIterateeCall.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_isIterateeCall.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(/*! ./eq */ "./node_modules/lodash/eq.js"),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ "./node_modules/lodash/isArrayLike.js"),
    isIndex = __webpack_require__(/*! ./_isIndex */ "./node_modules/lodash/_isIndex.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "./node_modules/lodash/_isKey.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/_isKey.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__(/*! ./isSymbol */ "./node_modules/lodash/isSymbol.js");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ "./node_modules/lodash/_isKeyable.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_isKeyable.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "./node_modules/lodash/_isMasked.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_isMasked.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(/*! ./_coreJsData */ "./node_modules/lodash/_coreJsData.js");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "./node_modules/lodash/_isPrototype.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_isPrototype.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "./node_modules/lodash/_isStrictComparable.js":
/*!****************************************************!*\
  !*** ./node_modules/lodash/_isStrictComparable.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_listCacheClear.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_listCacheClear.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_listCacheDelete.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_listCacheDelete.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "./node_modules/lodash/_assocIndexOf.js");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_listCacheGet.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_listCacheGet.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "./node_modules/lodash/_assocIndexOf.js");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_listCacheHas.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_listCacheHas.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "./node_modules/lodash/_assocIndexOf.js");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_listCacheSet.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_listCacheSet.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "./node_modules/lodash/_assocIndexOf.js");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheClear.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_mapCacheClear.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(/*! ./_Hash */ "./node_modules/lodash/_Hash.js"),
    ListCache = __webpack_require__(/*! ./_ListCache */ "./node_modules/lodash/_ListCache.js"),
    Map = __webpack_require__(/*! ./_Map */ "./node_modules/lodash/_Map.js");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheDelete.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_mapCacheDelete.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "./node_modules/lodash/_getMapData.js");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheGet.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_mapCacheGet.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "./node_modules/lodash/_getMapData.js");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheHas.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_mapCacheHas.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "./node_modules/lodash/_getMapData.js");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheSet.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_mapCacheSet.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "./node_modules/lodash/_getMapData.js");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapToArray.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_mapToArray.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "./node_modules/lodash/_matchesStrictComparable.js":
/*!*********************************************************!*\
  !*** ./node_modules/lodash/_matchesStrictComparable.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_memoizeCapped.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_memoizeCapped.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(/*! ./memoize */ "./node_modules/lodash/memoize.js");

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ "./node_modules/lodash/_nativeCreate.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_nativeCreate.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "./node_modules/lodash/_nativeKeys.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_nativeKeys.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(/*! ./_overArg */ "./node_modules/lodash/_overArg.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "./node_modules/lodash/_nativeKeysIn.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_nativeKeysIn.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "./node_modules/lodash/_nodeUtil.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_nodeUtil.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(/*! ./_freeGlobal */ "./node_modules/lodash/_freeGlobal.js");

/** Detect free variable `exports`. */
var freeExports =   true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/_objectToString.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_objectToString.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "./node_modules/lodash/_overArg.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_overArg.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "./node_modules/lodash/_overRest.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_overRest.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(/*! ./_apply */ "./node_modules/lodash/_apply.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "./node_modules/lodash/_root.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/_root.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(/*! ./_freeGlobal */ "./node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "./node_modules/lodash/_safeGet.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_safeGet.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ "./node_modules/lodash/_setCacheAdd.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_setCacheAdd.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "./node_modules/lodash/_setCacheHas.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_setCacheHas.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_setToArray.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_setToArray.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "./node_modules/lodash/_setToString.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_setToString.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(/*! ./_baseSetToString */ "./node_modules/lodash/_baseSetToString.js"),
    shortOut = __webpack_require__(/*! ./_shortOut */ "./node_modules/lodash/_shortOut.js");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "./node_modules/lodash/_shortOut.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_shortOut.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "./node_modules/lodash/_stackClear.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_stackClear.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(/*! ./_ListCache */ "./node_modules/lodash/_ListCache.js");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "./node_modules/lodash/_stackDelete.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_stackDelete.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "./node_modules/lodash/_stackGet.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_stackGet.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "./node_modules/lodash/_stackHas.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_stackHas.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "./node_modules/lodash/_stackSet.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_stackSet.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(/*! ./_ListCache */ "./node_modules/lodash/_ListCache.js"),
    Map = __webpack_require__(/*! ./_Map */ "./node_modules/lodash/_Map.js"),
    MapCache = __webpack_require__(/*! ./_MapCache */ "./node_modules/lodash/_MapCache.js");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "./node_modules/lodash/_strictIndexOf.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_strictIndexOf.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_stringToPath.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_stringToPath.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(/*! ./_memoizeCapped */ "./node_modules/lodash/_memoizeCapped.js");

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ "./node_modules/lodash/_toKey.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/_toKey.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(/*! ./isSymbol */ "./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ "./node_modules/lodash/_toSource.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_toSource.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "./node_modules/lodash/cloneDeep.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/cloneDeep.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(/*! ./_baseClone */ "./node_modules/lodash/_baseClone.js");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ "./node_modules/lodash/constant.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/constant.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "./node_modules/lodash/difference.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/difference.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(/*! ./_baseDifference */ "./node_modules/lodash/_baseDifference.js"),
    baseFlatten = __webpack_require__(/*! ./_baseFlatten */ "./node_modules/lodash/_baseFlatten.js"),
    baseRest = __webpack_require__(/*! ./_baseRest */ "./node_modules/lodash/_baseRest.js"),
    isArrayLikeObject = __webpack_require__(/*! ./isArrayLikeObject */ "./node_modules/lodash/isArrayLikeObject.js");

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),

/***/ "./node_modules/lodash/eq.js":
/*!***********************************!*\
  !*** ./node_modules/lodash/eq.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "./node_modules/lodash/flatten.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/flatten.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(/*! ./_baseFlatten */ "./node_modules/lodash/_baseFlatten.js");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ "./node_modules/lodash/get.js":
/*!************************************!*\
  !*** ./node_modules/lodash/get.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(/*! ./_baseGet */ "./node_modules/lodash/_baseGet.js");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ "./node_modules/lodash/hasIn.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/hasIn.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(/*! ./_baseHasIn */ "./node_modules/lodash/_baseHasIn.js"),
    hasPath = __webpack_require__(/*! ./_hasPath */ "./node_modules/lodash/_hasPath.js");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "./node_modules/lodash/identity.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/identity.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "./node_modules/lodash/isArguments.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/isArguments.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(/*! ./_baseIsArguments */ "./node_modules/lodash/_baseIsArguments.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "./node_modules/lodash/isArray.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/isArray.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "./node_modules/lodash/isArrayLike.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/isArrayLike.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(/*! ./isFunction */ "./node_modules/lodash/isFunction.js"),
    isLength = __webpack_require__(/*! ./isLength */ "./node_modules/lodash/isLength.js");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "./node_modules/lodash/isArrayLikeObject.js":
/*!**************************************************!*\
  !*** ./node_modules/lodash/isArrayLikeObject.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(/*! ./isArrayLike */ "./node_modules/lodash/isArrayLike.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "./node_modules/lodash/isBuffer.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isBuffer.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js"),
    stubFalse = __webpack_require__(/*! ./stubFalse */ "./node_modules/lodash/stubFalse.js");

/** Detect free variable `exports`. */
var freeExports =   true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/isFunction.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/isFunction.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "./node_modules/lodash/isLength.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isLength.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "./node_modules/lodash/isMap.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/isMap.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(/*! ./_baseIsMap */ "./node_modules/lodash/_baseIsMap.js"),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ "./node_modules/lodash/_baseUnary.js"),
    nodeUtil = __webpack_require__(/*! ./_nodeUtil */ "./node_modules/lodash/_nodeUtil.js");

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ "./node_modules/lodash/isObject.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isObject.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "./node_modules/lodash/isObjectLike.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/isObjectLike.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "./node_modules/lodash/isPlainObject.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/isPlainObject.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    getPrototype = __webpack_require__(/*! ./_getPrototype */ "./node_modules/lodash/_getPrototype.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "./node_modules/lodash/isSet.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/isSet.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(/*! ./_baseIsSet */ "./node_modules/lodash/_baseIsSet.js"),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ "./node_modules/lodash/_baseUnary.js"),
    nodeUtil = __webpack_require__(/*! ./_nodeUtil */ "./node_modules/lodash/_nodeUtil.js");

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ "./node_modules/lodash/isSymbol.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isSymbol.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "./node_modules/lodash/isTypedArray.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/isTypedArray.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(/*! ./_baseIsTypedArray */ "./node_modules/lodash/_baseIsTypedArray.js"),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ "./node_modules/lodash/_baseUnary.js"),
    nodeUtil = __webpack_require__(/*! ./_nodeUtil */ "./node_modules/lodash/_nodeUtil.js");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "./node_modules/lodash/keys.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/keys.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(/*! ./_arrayLikeKeys */ "./node_modules/lodash/_arrayLikeKeys.js"),
    baseKeys = __webpack_require__(/*! ./_baseKeys */ "./node_modules/lodash/_baseKeys.js"),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ "./node_modules/lodash/isArrayLike.js");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "./node_modules/lodash/keysIn.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/keysIn.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(/*! ./_arrayLikeKeys */ "./node_modules/lodash/_arrayLikeKeys.js"),
    baseKeysIn = __webpack_require__(/*! ./_baseKeysIn */ "./node_modules/lodash/_baseKeysIn.js"),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ "./node_modules/lodash/isArrayLike.js");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ "./node_modules/lodash/memoize.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/memoize.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(/*! ./_MapCache */ "./node_modules/lodash/_MapCache.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ "./node_modules/lodash/merge.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/merge.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(/*! ./_baseMerge */ "./node_modules/lodash/_baseMerge.js"),
    createAssigner = __webpack_require__(/*! ./_createAssigner */ "./node_modules/lodash/_createAssigner.js");

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ "./node_modules/lodash/pick.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/pick.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(/*! ./_basePick */ "./node_modules/lodash/_basePick.js"),
    flatRest = __webpack_require__(/*! ./_flatRest */ "./node_modules/lodash/_flatRest.js");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),

/***/ "./node_modules/lodash/pickBy.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/pickBy.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(/*! ./_arrayMap */ "./node_modules/lodash/_arrayMap.js"),
    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ "./node_modules/lodash/_baseIteratee.js"),
    basePickBy = __webpack_require__(/*! ./_basePickBy */ "./node_modules/lodash/_basePickBy.js"),
    getAllKeysIn = __webpack_require__(/*! ./_getAllKeysIn */ "./node_modules/lodash/_getAllKeysIn.js");

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),

/***/ "./node_modules/lodash/property.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/property.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(/*! ./_baseProperty */ "./node_modules/lodash/_baseProperty.js"),
    basePropertyDeep = __webpack_require__(/*! ./_basePropertyDeep */ "./node_modules/lodash/_basePropertyDeep.js"),
    isKey = __webpack_require__(/*! ./_isKey */ "./node_modules/lodash/_isKey.js"),
    toKey = __webpack_require__(/*! ./_toKey */ "./node_modules/lodash/_toKey.js");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "./node_modules/lodash/pull.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/pull.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(/*! ./_baseRest */ "./node_modules/lodash/_baseRest.js"),
    pullAll = __webpack_require__(/*! ./pullAll */ "./node_modules/lodash/pullAll.js");

/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = baseRest(pullAll);

module.exports = pull;


/***/ }),

/***/ "./node_modules/lodash/pullAll.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/pullAll.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var basePullAll = __webpack_require__(/*! ./_basePullAll */ "./node_modules/lodash/_basePullAll.js");

/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values)
    : array;
}

module.exports = pullAll;


/***/ }),

/***/ "./node_modules/lodash/set.js":
/*!************************************!*\
  !*** ./node_modules/lodash/set.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(/*! ./_baseSet */ "./node_modules/lodash/_baseSet.js");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ "./node_modules/lodash/stubArray.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/stubArray.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "./node_modules/lodash/stubFalse.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/stubFalse.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "./node_modules/lodash/toPlainObject.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/toPlainObject.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ "./node_modules/lodash/_copyObject.js"),
    keysIn = __webpack_require__(/*! ./keysIn */ "./node_modules/lodash/keysIn.js");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "./node_modules/lodash/toString.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/toString.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(/*! ./_baseToString */ "./node_modules/lodash/_baseToString.js");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ "./node_modules/web-vitals/dist/web-vitals.js":
/*!****************************************************!*\
  !*** ./node_modules/web-vitals/dist/web-vitals.js ***!
  \****************************************************/
/*! exports provided: CLSThresholds, FCPThresholds, INPThresholds, LCPThresholds, TTFBThresholds, onCLS, onFCP, onINP, onLCP, onTTFB */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLSThresholds", function() { return T; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FCPThresholds", function() { return b; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPThresholds", function() { return N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LCPThresholds", function() { return x; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TTFBThresholds", function() { return $; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onCLS", function() { return E; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onFCP", function() { return P; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onINP", function() { return S; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onLCP", function() { return O; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onTTFB", function() { return H; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);



function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e4) { throw _e4; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e5) { didErr = true; err = _e5; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var e = -1;
var t = function t(_t) {
    addEventListener("pageshow", function (n) {
      n.persisted && (e = n.timeStamp, _t(n));
    }, !0);
  },
  n = function n(e, t, _n, i) {
    var o, s;
    return function (r) {
      var _o;
      t.value >= 0 && (r || i) && (s = t.value - ((_o = o) !== null && _o !== void 0 ? _o : 0), (s || void 0 === o) && (o = t.value, t.delta = s, t.rating = function (e, t) {
        return e > t[1] ? "poor" : e > t[0] ? "needs-improvement" : "good";
      }(t.value, _n), e(t)));
    };
  },
  i = function i(e) {
    requestAnimationFrame(function () {
      return requestAnimationFrame(function () {
        return e();
      });
    });
  },
  o = function o() {
    var e = performance.getEntriesByType("navigation")[0];
    if (e && e.responseStart > 0 && e.responseStart < performance.now()) return e;
  },
  s = function s() {
    var _e$activationStart;
    var e = o();
    return (_e$activationStart = e === null || e === void 0 ? void 0 : e.activationStart) !== null && _e$activationStart !== void 0 ? _e$activationStart : 0;
  },
  r = function r(t) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    var i = o();
    var r = "navigate";
    e >= 0 ? r = "back-forward-cache" : i && (document.prerendering || s() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : i.type && (r = i.type.replace(/_/g, "-")));
    return {
      name: t,
      value: n,
      rating: "good",
      delta: 0,
      entries: [],
      id: "v5-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
      navigationType: r
    };
  },
  c = new WeakMap();
function a(e, t) {
  return c.get(e) || c.set(e, new t()), c.get(e);
}
var d = /*#__PURE__*/function () {
  function d() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, d);
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "t", void 0);
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "i", 0);
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "o", []);
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(d, [{
    key: "h",
    value: function h(e) {
      var _this$t;
      if (e.hadRecentInput) return;
      var t = this.o[0],
        n = this.o.at(-1);
      this.i && t && n && e.startTime - n.startTime < 1e3 && e.startTime - t.startTime < 5e3 ? (this.i += e.value, this.o.push(e)) : (this.i = e.value, this.o = [e]), (_this$t = this.t) === null || _this$t === void 0 ? void 0 : _this$t.call(this, e);
    }
  }]);
  return d;
}();
var h = function h(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    try {
      if (PerformanceObserver.supportedEntryTypes.includes(e)) {
        var _i = new PerformanceObserver(function (e) {
          Promise.resolve().then(function () {
            t(e.getEntries());
          });
        });
        return _i.observe(_objectSpread({
          type: e,
          buffered: !0
        }, n)), _i;
      }
    } catch (_unused) {}
  },
  f = function f(e) {
    var t = !1;
    return function () {
      t || (e(), t = !0);
    };
  };
var u = -1;
var l = function l() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
  },
  m = function m(e) {
    "hidden" === document.visibilityState && u > -1 && (u = "visibilitychange" === e.type ? e.timeStamp : 0, v());
  },
  g = function g() {
    addEventListener("visibilitychange", m, !0), addEventListener("prerenderingchange", m, !0);
  },
  v = function v() {
    removeEventListener("visibilitychange", m, !0), removeEventListener("prerenderingchange", m, !0);
  },
  p = function p() {
    if (u < 0) {
      var _globalThis$performan;
      var _e = s(),
        _n2 = document.prerendering ? void 0 : (_globalThis$performan = globalThis.performance.getEntriesByType("visibility-state").filter(function (t) {
          return "hidden" === t.name && t.startTime > _e;
        })[0]) === null || _globalThis$performan === void 0 ? void 0 : _globalThis$performan.startTime;
      u = _n2 !== null && _n2 !== void 0 ? _n2 : l(), g(), t(function () {
        setTimeout(function () {
          u = l(), g();
        });
      });
    }
    return {
      get firstHiddenTime() {
        return u;
      }
    };
  },
  y = function y(e) {
    document.prerendering ? addEventListener("prerenderingchange", function () {
      return e();
    }, !0) : e();
  },
  b = [1800, 3e3],
  P = function P(e) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    y(function () {
      var c = p();
      var a,
        d = r("FCP");
      var f = h("paint", function (e) {
        var _iterator = _createForOfIteratorHelper(e),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _t2 = _step.value;
            "first-contentful-paint" === _t2.name && (f.disconnect(), _t2.startTime < c.firstHiddenTime && (d.value = Math.max(_t2.startTime - s(), 0), d.entries.push(_t2), a(!0)));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      f && (a = n(e, d, b, o.reportAllChanges), t(function (t) {
        d = r("FCP"), a = n(e, d, b, o.reportAllChanges), i(function () {
          d.value = performance.now() - t.timeStamp, a(!0);
        });
      }));
    });
  },
  T = [.1, .25],
  E = function E(e) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    P(f(function () {
      var s,
        c = r("CLS", 0);
      var f = a(o, d),
        u = function u(e) {
          var _iterator2 = _createForOfIteratorHelper(e),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _t3 = _step2.value;
              f.h(_t3);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          f.i > c.value && (c.value = f.i, c.entries = f.o, s());
        },
        l = h("layout-shift", u);
      l && (s = n(e, c, T, o.reportAllChanges), document.addEventListener("visibilitychange", function () {
        "hidden" === document.visibilityState && (u(l.takeRecords()), s(!0));
      }), t(function () {
        f.i = 0, c = r("CLS", 0), s = n(e, c, T, o.reportAllChanges), i(function () {
          return s();
        });
      }), setTimeout(s));
    }));
  };
var _ = 0,
  L = 1 / 0,
  M = 0;
var C = function C(e) {
  var _iterator3 = _createForOfIteratorHelper(e),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _t4 = _step3.value;
      _t4.interactionId && (L = Math.min(L, _t4.interactionId), M = Math.max(M, _t4.interactionId), _ = M ? (M - L) / 7 + 1 : 0);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
};
var I;
var w = function w() {
    var _performance$interact;
    return I ? _ : (_performance$interact = performance.interactionCount) !== null && _performance$interact !== void 0 ? _performance$interact : 0;
  },
  F = function F() {
    "interactionCount" in performance || I || (I = h("event", C, {
      type: "event",
      buffered: !0,
      durationThreshold: 0
    }));
  };
var k = 0;
var A = /*#__PURE__*/function () {
  function A() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, A);
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "u", []);
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "l", new Map());
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "m", void 0);
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "v", void 0);
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(A, [{
    key: "p",
    value: function p() {
      k = w(), this.u.length = 0, this.l.clear();
    }
  }, {
    key: "P",
    value: function P() {
      var e = Math.min(this.u.length - 1, Math.floor((w() - k) / 50));
      return this.u[e];
    }
  }, {
    key: "h",
    value: function h(e) {
      var _this$m;
      if ((_this$m = this.m) !== null && _this$m !== void 0 && _this$m.call(this, e), !e.interactionId && "first-input" !== e.entryType) return;
      var t = this.u.at(-1);
      var n = this.l.get(e.interactionId);
      if (n || this.u.length < 10 || e.duration > t.T) {
        var _this$v;
        if (n ? e.duration > n.T ? (n.entries = [e], n.T = e.duration) : e.duration === n.T && e.startTime === n.entries[0].startTime && n.entries.push(e) : (n = {
          id: e.interactionId,
          entries: [e],
          T: e.duration
        }, this.l.set(n.id, n), this.u.push(n)), this.u.sort(function (e, t) {
          return t.T - e.T;
        }), this.u.length > 10) {
          var _e2 = this.u.splice(10);
          var _iterator4 = _createForOfIteratorHelper(_e2),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _t5 = _step4.value;
              this.l["delete"](_t5.id);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
        (_this$v = this.v) === null || _this$v === void 0 || _this$v.call(this, n);
      }
    }
  }]);
  return A;
}();
var B = function B(e) {
    var t = globalThis.requestIdleCallback || setTimeout;
    "hidden" === document.visibilityState ? e() : (e = f(e), document.addEventListener("visibilitychange", e, {
      once: !0
    }), t(function () {
      e(), document.removeEventListener("visibilitychange", e);
    }));
  },
  N = [200, 500],
  S = function S(e) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype && y(function () {
      var _i$durationThreshold;
      F();
      var o,
        s = r("INP");
      var c = a(i, A),
        d = function d(e) {
          B(function () {
            var _iterator5 = _createForOfIteratorHelper(e),
              _step5;
            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _t6 = _step5.value;
                c.h(_t6);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
            var t = c.P();
            t && t.T !== s.value && (s.value = t.T, s.entries = t.entries, o());
          });
        },
        f = h("event", d, {
          durationThreshold: (_i$durationThreshold = i.durationThreshold) !== null && _i$durationThreshold !== void 0 ? _i$durationThreshold : 40
        });
      o = n(e, s, N, i.reportAllChanges), f && (f.observe({
        type: "first-input",
        buffered: !0
      }), document.addEventListener("visibilitychange", function () {
        "hidden" === document.visibilityState && (d(f.takeRecords()), o(!0));
      }), t(function () {
        c.p(), s = r("INP"), o = n(e, s, N, i.reportAllChanges);
      }));
    });
  };
var q = /*#__PURE__*/function () {
  function q() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, q);
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "m", void 0);
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(q, [{
    key: "h",
    value: function h(e) {
      var _this$m2;
      (_this$m2 = this.m) === null || _this$m2 === void 0 || _this$m2.call(this, e);
    }
  }]);
  return q;
}();
var x = [2500, 4e3],
  O = function O(e) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    y(function () {
      var c = p();
      var d,
        u = r("LCP");
      var l = a(o, q),
        m = function m(e) {
          o.reportAllChanges || (e = e.slice(-1));
          var _iterator6 = _createForOfIteratorHelper(e),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _t7 = _step6.value;
              l.h(_t7), _t7.startTime < c.firstHiddenTime && (u.value = Math.max(_t7.startTime - s(), 0), u.entries = [_t7], d());
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        },
        g = h("largest-contentful-paint", m);
      if (g) {
        d = n(e, u, x, o.reportAllChanges);
        var _s = f(function () {
          m(g.takeRecords()), g.disconnect(), d(!0);
        });
        for (var _i2 = 0, _arr = ["keydown", "click", "visibilitychange"]; _i2 < _arr.length; _i2++) {
          var _e3 = _arr[_i2];
          addEventListener(_e3, function () {
            return B(_s);
          }, {
            capture: !0,
            once: !0
          });
        }
        t(function (t) {
          u = r("LCP"), d = n(e, u, x, o.reportAllChanges), i(function () {
            u.value = performance.now() - t.timeStamp, d(!0);
          });
        });
      }
    });
  },
  $ = [800, 1800],
  D = function D(e) {
    document.prerendering ? y(function () {
      return D(e);
    }) : "complete" !== document.readyState ? addEventListener("load", function () {
      return D(e);
    }, !0) : setTimeout(e);
  },
  H = function H(e) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var c = r("TTFB"),
      a = n(e, c, $, i.reportAllChanges);
    D(function () {
      var d = o();
      d && (c.value = Math.max(d.responseStart - s(), 0), c.entries = [d], a(!0), t(function () {
        c = r("TTFB", 0), a = n(e, c, $, i.reportAllChanges), a(!0);
      }));
    });
  };


/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./src/common/callbacks/api.js":
/*!*************************************!*\
  !*** ./src/common/callbacks/api.js ***!
  \*************************************/
/*! exports provided: onBeforeApiCall, onBeforeBatchApiCall, onAfterBatchApiCall, onBeforeSystemMessage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeApiCall", function() { return onBeforeApiCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeBatchApiCall", function() { return onBeforeBatchApiCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterBatchApiCall", function() { return onAfterBatchApiCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeSystemMessage", function() { return onBeforeSystemMessage; });
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");

function onBeforeApiCall(event, from, into, args) {
  var data = args.data;
  data['message.triggeredBy'] = 'application';
  if (true) {
    core_utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].info("Callbacks::onBeforeApiCall(): API response code: ".concat(data['application.api.responseCode']));
    core_utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].info("Callbacks::onBeforeApiCall(): API host: ".concat(data['application.api.host']));
    core_utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].info("Callbacks::onBeforeApiCall(): API path: ".concat(data['application.api.path']));
    core_utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].info("Callbacks::onBeforeApiCall(): API query parameters: ".concat(data['application.api.queryParameters']));
  }
}
function onBeforeBatchApiCall(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.triggeredBy'] = 'analytics';
  data['message.category'] = 'api';
  data['message.eventCaseId'] = "generic_batchApiCall_".concat(analytics.model.get('domain'));

  // If we have the special batch - use state content from it's start
  if (data['operation.operationType'] === 'contentBatchApi') {
    analytics.storage.internal.batchApiOriginalStateContent = analytics.model.get('state.content');
    analytics.model.set('state.content', analytics.storage.internal.stateContentAtBatchStart);
    delete analytics.storage.internal.stateContentAtBatchStart;
  }
  // Else set no content
  else {
    analytics.storage.internal.batchApiOriginalStateContent = analytics.model.get('state.content');
    analytics.model.reset('state.content');
  }
}
function onAfterBatchApiCall(event, from, into, args) {
  var analytics = args.analytics;
  // Don't forget to restore content after
  analytics.model.set('state.content', analytics.storage.internal.batchApiOriginalStateContent);
  delete analytics.storage.internal.batchApiOriginalStateContent;
}
function onBeforeSystemMessage(event, from, into, args) {
  var data = args.data;
  data['message.triggeredBy'] = 'application';
  data['message.category'] = 'systemMessage';
}

/***/ }),

/***/ "./src/common/callbacks/error.js":
/*!***************************************!*\
  !*** ./src/common/callbacks/error.js ***!
  \***************************************/
/*! exports provided: onBeforeError, onBeforeApplicationCrash */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeError", function() { return onBeforeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeApplicationCrash", function() { return onBeforeApplicationCrash; });
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");

function onBeforeError(event, from, into, args) {
  var data = args.data;
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'application'; // for analytics error
  data['message.category'] = 'error';
  data['operation.success'] = false;
  if (!data['application.error.errorCode']) {
    data['application.error.errorCode'] = 'unknown';
  }
  if (true) {
    core_utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].info("Callbacks::onBeforeError(): Error code: ".concat(data['application.error.errorCode']));
  }
}
function onBeforeApplicationCrash(event, from, into, args) {
  var data = args.data;
  data['message.triggeredBy'] = 'application';
  data['message.category'] = 'error';
  data['application.error.errorType'] = 'applicationCrash';
}

/***/ }),

/***/ "./src/common/callbacks/general.js":
/*!*****************************************!*\
  !*** ./src/common/callbacks/general.js ***!
  \*****************************************/
/*! exports provided: onBeforeEvent, onChangeState, onAfterEvent, onBeforeCustomEvent, onInvalidEvent, onEventBeforeInit */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeEvent", function() { return onBeforeEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onChangeState", function() { return onChangeState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterEvent", function() { return onAfterEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeCustomEvent", function() { return onBeforeCustomEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onInvalidEvent", function() { return onInvalidEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onEventBeforeInit", function() { return onEventBeforeInit; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/get */ "./node_modules/lodash/get.js");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_utils_messages__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core/utils/messages */ "./src/core/utils/messages.js");
/* harmony import */ var core_utils_uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core/utils/uuid */ "./src/core/utils/uuid.js");
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");
/* harmony import */ var core_utils_errors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core/utils/errors */ "./src/core/utils/errors.js");


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




function onBeforeEvent(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;
  if (analytics.flushedEvents.before[event] && analytics.checkFlushCondition(analytics.flushedEvents.before[event], data)) {
    analytics.queue.flush();
  }
  // Flush if any visit keys are set
  else if (event !== 'startSession' && Object.keys(data).some(function (key) {
    return key.includes('visit');
  })) {
    analytics.queue.flush();
  }
  analytics.previousTimestamp = analytics.timestamp;
  if (options && options.timestamp !== undefined) {
    analytics.timestamp = options.timestamp;
  } else {
    analytics.timestamp = Date.now();
  }

  // If both feature flags are set only use persistFeature
  if (data['message.feature.ignoreContext'] !== undefined && data['message.persistFeature'] !== undefined) {
    delete data['message.feature.ignoreContext'];
    var message = 'Both ignoreContext and persistFeature set, discarding ignoreContext';
      true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].warning(message);
    if (data['message.qa.issues']) {
      data['message.qa.issues'].push(message);
    } else data['message.qa.issues'] = [message];
  }

  // reset feature object if event can have context, but message.context is empty (wrong event for flow, exiting it)
  // and its not an exception (ignoreContext or persistFeature)
  if (analytics.currentFlow && analytics.isFeatureFlowEvent(event) && !data['message.context'] && data['message.feature.ignoreContext'] !== true && data['message.persistFeature'] !== true) {
      true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info("Exiting feature flow on event ".concat(event, " as we expected a [message.context] value but none was provided"));
    analytics.model.reset('message.feature');
    delete analytics.currentFlow; // end of flow
  }

  if (data['message.context'] || analytics.currentFlow && data['message.persistFeature']) {
    if (analytics.currentFlow !== data['message.context'] && data['message.persistFeature'] !== true) {
      if (analytics.currentFlow) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info("Exiting feature flow on event ".concat(event, " - context changed from ").concat(analytics.currentFlow, " to ").concat(data['message.context']));
        analytics.model.reset('message.feature');
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info("Entering new feature flow - ".concat(data['message.context']));
      }
      analytics.currentFlow = data['message.context']; // begin new flow

      // generate new transactionId
      var transactionId = "".concat(analytics.model.get('visit.visitId'), "|").concat(analytics.timestamp);
      data['message.feature.transactionId'] = transactionId;
    }
    var newFeatureStepName = data['message.feature.featureStepName'];
    if (newFeatureStepName) {
      // set flag to true if feature step name changed
      var oldFeatureStepName = analytics.model.get('message.feature.featureStepName');
      if (oldFeatureStepName !== newFeatureStepName) {
        data['message.feature.featureStepChanged'] = true;
      }

      // append latest step name to array
      var completedSteps = analytics.model.get('message.feature.completedSteps') || [];
      completedSteps.push(newFeatureStepName);
      analytics.model.set('message.feature.completedSteps', completedSteps);
    }
    if (data['operation.userPreferencesSelections']) {
      var currentSelections = analytics.model.get('message.feature.featureSelections') || [];
      data['message.feature.featureSelections'] = currentSelections.concat(data['operation.userPreferencesSelections']);
    }
  }
  if (data['state.userJourney.featureFlagged'] === true) {
    var currentFeatureName = analytics.model.get('state.userJourney.currentFeature.name');
    var isJourneyNameFromClient = data['state.userJourney.currentFeature.name'] !== undefined;
    // Feature name is either newly passed page name (on pageView) or existing current page name
    var newFeatureName = data['state.userJourney.currentFeature.name'] || data['state.view.currentPage.pageName'] || analytics.model.get('state.view.currentPage.pageName');

    // Only handle new feature name if value comes as data from client directly or if it's in the included list
    if (isJourneyNameFromClient || analytics.settings.includedFeatureNameList.includes(newFeatureName)) {
      // The currentFeature.name and the previousFeature.name should never be the same.
      // For example, if the user opens up the app and navigates to home → productPage → home we would not want the currentFeaute.name and previousFeature.name to both be home.
      // In this scenario, we would leave the currentFeautre.Name as "home" and previousFeature.name would remain NULL.
      if (currentFeatureName !== newFeatureName) {
        var currentSequenceNumber = analytics.model.get('state.userJourney.currentFeature.sequenceNumber');
        data['state.userJourney.currentFeature.sequenceNumber'] = currentSequenceNumber !== undefined ? currentSequenceNumber + 1 : 0;
        data['state.userJourney.previousFeature.name'] = currentFeatureName;
        data['state.userJourney.currentFeature.name'] = newFeatureName;
      }
    } else {
      delete data['state.userJourney.featureFlagged'];
    }
  }
  if (data['visit.accessibility']) {
    // Remove from data to avoid writing to model
    var newAccessibility = data['visit.accessibility'];
    delete data['visit.accessibility'];
    if (!Array.isArray(newAccessibility)) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].warning('Ignoring visit.accessibility field that is not an array!');
    } else {
      var _analytics$model$get;
      var currentAccessibility = (_analytics$model$get = analytics.model.get('visit.accessibility')) !== null && _analytics$model$get !== void 0 ? _analytics$model$get : [];
      newAccessibility.forEach(function (newSetting) {
        if (newSetting.name === undefined) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].warning('Ignoring accessibility object with missing name');
        } else {
          var found = currentAccessibility.find(function (oldSetting, i) {
            if (oldSetting.name === newSetting.name && oldSetting.setLevel === newSetting.setLevel) {
                true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info("Updating existing accessibility setting ".concat(newSetting.name, ":").concat(newSetting.level));
              currentAccessibility[i] = newSetting;
              return true;
            }
            return false;
          });
          if (!found) {
              true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info("Adding new accessibility setting ".concat(newSetting.name, ":").concat(newSetting.level));
            currentAccessibility.push(newSetting);
          }
        }
      });
      analytics.model.set('visit.accessibility', currentAccessibility);
    }
  }
}

// actual transition
function onChangeState(event, from, into, args) {
  var analytics = args.analytics;
  var previousState = analytics.model.get('state.name');
  if (previousState) {
    analytics.model.set('state.previousState.name', previousState);
    analytics.model.set('state.previousState.entryTimestamp', analytics.model.get('state.entryTimestamp'));
    analytics.model.set('state.previousState.exitTimestamp', analytics.timestamp);
  }
  analytics.model.set('state.name', analytics.sm.current);
  analytics.model.set('state.entryTimestamp', analytics.timestamp);
}
function onAfterEvent(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;
  analytics.model.batchSet(data); // save prepared data into the model

  // Handle only real events
  if (!options.noMessage) {
    var message = Object(core_utils_messages__WEBPACK_IMPORTED_MODULE_2__["compose"])(event, args.data, analytics.model.getData(), analytics); // create a JSON string from one event

    // Capture performance fields, for JS sdk we depend on options passed from JS helix
    message.message.performance = {
      timeInRules: options.helixTimeInRules
    };
    if (options.helixTrackStartTimestamp !== undefined) {
      message.message.performance.timeInSDK = Date.now() - options.helixTrackStartTimestamp;
    }
    analytics.queue.push(message);
    if (analytics.flushedEvents.after[event] && analytics.checkFlushCondition(analytics.flushedEvents.after[event], data, event) ||
    // buyFlow events should always be flushed
    analytics.currentFlow === 'buyFlow' || analytics.currentFlow === 'buyFlow2' || analytics.currentFlow === 'preBuyFlow' || analytics.currentFlow === 'postBuyFlow') {
      analytics.queue.flush();
    }

    // Save feature object because we might need it later
    var feature = analytics.model.get('message.feature');

    // Reset fields based on persistence config for any event
    var fieldsToResetForAny = analytics.persistenceRules.after.any;
    fieldsToResetForAny.forEach(function (path) {
      return analytics.model.reset(path);
    });

    // Reset fields based on persistence config for specific event
    if (analytics.persistenceRules.after[event]) {
      var fieldsToResetForEvent = analytics.persistenceRules.after[event];
      fieldsToResetForEvent.forEach(function (path) {
        return analytics.model.reset(path);
      });
    }
    if (analytics.currentFlow) {
      if (!analytics.isFeatureFlowEvent(event) || data['message.feature.ignoreContext'] === true || data['message.persistFeature'] === true || data['message.context'] && analytics.currentFlow === data['message.context']) {
        analytics.model.set('message.feature', feature); // restore feature
        analytics.model.set('message.feature.featureStepChanged', false);
      }
    }
  }
  analytics.saveState();
}
function onBeforeCustomEvent(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'custom';
  data['message.triggeredBy'] = 'application';
}
function onInvalidEvent(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;
  var errorCode = Object(core_utils_errors__WEBPACK_IMPORTED_MODULE_5__["getStateMachineErrorCode"])(analytics.errorCodes.state, event, from);
  var errorFields = {
    // TODO: maybe do something about paths here
    'message.eventCaseId': "generic_error_".concat("video"),
    'application.error.errorType': 'analytics',
    'application.error.errorCode': errorCode,
    'application.error.errorMessage': "Unexpected event ".concat(event, " received in state ").concat(from, ". Analytics partially disabled until the next tune"),
    'application.error.clientErrorCode': "".concat(from, ":").concat(event)
  };
  Object(core_utils_errors__WEBPACK_IMPORTED_MODULE_5__["addInputDataToError"])(analytics, errorFields, data);
  errorFields['message.triggeredBy'] = 'analytics';
  analytics.heartBeatTimer.stop();
  analytics.track('error', errorFields, options);
}
function onEventBeforeInit(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;
  var errorCode = analytics.errorCodes.internal.eventBeforeInit;
  var errorEventFields = {
    'application.error.errorType': 'analytics',
    'application.error.errorCode': errorCode,
    'application.error.errorMessage': "Unexpected event ".concat(event, " received before library initialization.")
  };
  Object(core_utils_errors__WEBPACK_IMPORTED_MODULE_5__["addInputDataToError"])(analytics, errorEventFields, data);

  // If we end up getting a startSession after use this to connect the messages to the visitId
    true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].warning('Generating visit ID for error event due to missing startSession');
  analytics.visitIdFromInitError = Object(core_utils_uuid__WEBPACK_IMPORTED_MODULE_3__["generateVisitId"])("video"); // We don't have data.domain here, so fall back to what we can

  // We do not want a fake appName/appType so we don't pollute data. This will still go into error topic but will be easier to idenfity
  var fullErrorFields = _objectSpread(_objectSpread({}, errorEventFields), {}, {
    'message.eventCaseId': "generic_error_".concat("video"),
    'message.triggeredBy': 'analytics',
    'visit.applicationDetails.venonaVersion': analytics.libraryVersion,
    'visit.device.uuid': Object(core_utils_uuid__WEBPACK_IMPORTED_MODULE_3__["default"])(),
    'visit.visitId': analytics.visitIdFromInitError
  });

  // Try to capture at least some platform data, url should accurately idenfity the app at least.
  // This would be specific for each library version
  if (typeof window !== 'undefined') {
    fullErrorFields['application.error.errorExtras'].userAgent = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(window, 'navigator.userAgent');
    fullErrorFields['application.error.errorExtras'].url = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(window, 'location.href');
    fullErrorFields['application.error.errorExtras'].pageTitle = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(window, 'document.title');
  }

  // Workaround for being able to push through the event regardless of transition rules
  analytics.track('error', fullErrorFields, _objectSpread(_objectSpread({}, options), {}, {
    forceTransitionTo: from
  }));
}

/***/ }),

/***/ "./src/common/callbacks/index.js":
/*!***************************************!*\
  !*** ./src/common/callbacks/index.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./api */ "./src/common/callbacks/api.js");
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./error */ "./src/common/callbacks/error.js");
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./general */ "./src/common/callbacks/general.js");
/* harmony import */ var _login__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./login */ "./src/common/callbacks/login.js");
/* harmony import */ var _navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./navigation */ "./src/common/callbacks/navigation.js");
/* harmony import */ var _search__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./search */ "./src/common/callbacks/search.js");
/* harmony import */ var _select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./select */ "./src/common/callbacks/select.js");
/* harmony import */ var _session__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./session */ "./src/common/callbacks/session.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








/* harmony default export */ __webpack_exports__["default"] = (_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _api__WEBPACK_IMPORTED_MODULE_1__), _error__WEBPACK_IMPORTED_MODULE_2__), _general__WEBPACK_IMPORTED_MODULE_3__), _login__WEBPACK_IMPORTED_MODULE_4__), _navigation__WEBPACK_IMPORTED_MODULE_5__), _search__WEBPACK_IMPORTED_MODULE_6__), _select__WEBPACK_IMPORTED_MODULE_7__), _session__WEBPACK_IMPORTED_MODULE_8__));

/***/ }),

/***/ "./src/common/callbacks/login.js":
/*!***************************************!*\
  !*** ./src/common/callbacks/login.js ***!
  \***************************************/
/*! exports provided: onBeforeLoginStart, onBeforeLoginStop, onAfterLoginStop, onBeforeInVisitOauthRefresh, onBeforeLogout, onAfterLogout */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeLoginStart", function() { return onBeforeLoginStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeLoginStop", function() { return onBeforeLoginStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterLoginStop", function() { return onAfterLoginStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeInVisitOauthRefresh", function() { return onBeforeInVisitOauthRefresh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeLogout", function() { return onBeforeLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterLogout", function() { return onAfterLogout; });
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/merge */ "./node_modules/lodash/merge.js");
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);

function onBeforeLoginStart(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'authentication';
  if (data['operation.operationType'] === 'manualAuth') {
    data['message.triggeredBy'] = 'user';
    data['operation.userEntry.entryType'] = 'username';
  } else {
    data['message.triggeredBy'] = 'application';
  }
  var failedAttempts = analytics.model.get('visit.login.failedAttempts');
  data['visit.login.failedAttempts'] = failedAttempts || 0;

  // TODO: deal with storage.internal
  analytics.storage.internal.loginStartTimestamp = analytics.timestamp;

  // TODO maybe find a way not to save fields 1 by 1
  analytics.storage.internal.operation = {
    'operation.operationType': data['operation.operationType'],
    'operation.userEntry.text': data['operation.userEntry.text'],
    'operation.userEntry.entryType': data['operation.userEntry.entryType'],
    'operation.userPreferencesSelections': data['operation.userPreferencesSelections']
  };
}
function onBeforeLoginStop(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'authentication';
  data['message.triggeredBy'] = 'application';
  analytics.storage.internal.oAuthToken = data.oAuthToken;
  delete data.oAuthToken; // TODO: improve

  analytics.storage.internal.tokenType = data.tokenType;
  delete data.tokenType;
  data['visit.login.loginCompletedTimestamp'] = analytics.timestamp;
  var loginStartTimestamp = analytics.storage.internal.loginStartTimestamp;
  var loginDurationMs = data['visit.login.loginCompletedTimestamp'] - loginStartTimestamp;
  data['visit.login.loginDurationMs'] = loginDurationMs;
  if (analytics.storage.internal.operation) {
    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(data, analytics.storage.internal.operation);
  }
  if (data['operation.success'] === false) {
    var failedAttempts = analytics.model.get('visit.login.failedAttempts');
    data['visit.login.failedAttempts'] = failedAttempts + 1;
  }
}
function onAfterLoginStop(event, from, into, args) {
  var analytics = args.analytics;
  delete analytics.storage.internal.operation;
}
function onBeforeInVisitOauthRefresh(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'authentication';
  data['message.triggeredBy'] = 'application';
  data['operation.operationType'] = 'refreshAuth';
  analytics.storage.internal.oAuthToken = data.oAuthToken;
  delete data.oAuthToken; // TODO: improve

  analytics.storage.internal.tokenType = data.tokenType;
  delete data.tokenType;
  if (data['operation.success'] === false) {
    data['application.error.errorType'] = 'authentication';
  }
}
function onBeforeLogout(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'authentication';
  data['message.triggeredBy'] = 'user';
  data['operation.operationType'] = 'logout';
}
function onAfterLogout(event, from, into, args) {
  var analytics = args.analytics;
  analytics.model.set('visit.login.failedAttempts', 0);
  delete analytics.storage.internal.loginStartTimestamp;
  delete analytics.storage.internal.oAuthToken;
  delete analytics.storage.internal.tokenType;
}

/***/ }),

/***/ "./src/common/callbacks/navigation.js":
/*!********************************************!*\
  !*** ./src/common/callbacks/navigation.js ***!
  \********************************************/
/*! exports provided: onBeforePageViewInit, onBeforePageViewCompleteAwaitingAction, onBeforeTemporaryView, onBeforePageViewPartiallyRendered, onBeforePageView, onAfterPageView, onBeforeModalView, onBeforePurchaseStart, onBeforePurchaseStop, onAfterPurchaseStop, onBeforeFeatureStart, onBeforeFeatureStop, onAfterFeatureStop, onBeforeApplicationActivity, onAfterApplicationActivity, onBeforeModalClose, onBeforePageViewPerformance, onBeforeUserFeedback, onBeforeDeeplinkStart, onBeforeDeeplinkStop, onBeforeAssetDisplayed, onBeforeImpressionStart, onBeforeImpressionStop, onBeforeSubModalView, onBeforeSubModalClose, onAfterSubModalClose */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePageViewInit", function() { return onBeforePageViewInit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePageViewCompleteAwaitingAction", function() { return onBeforePageViewCompleteAwaitingAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeTemporaryView", function() { return onBeforeTemporaryView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePageViewPartiallyRendered", function() { return onBeforePageViewPartiallyRendered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePageView", function() { return onBeforePageView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterPageView", function() { return onAfterPageView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeModalView", function() { return onBeforeModalView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePurchaseStart", function() { return onBeforePurchaseStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePurchaseStop", function() { return onBeforePurchaseStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterPurchaseStop", function() { return onAfterPurchaseStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeFeatureStart", function() { return onBeforeFeatureStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeFeatureStop", function() { return onBeforeFeatureStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterFeatureStop", function() { return onAfterFeatureStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeApplicationActivity", function() { return onBeforeApplicationActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterApplicationActivity", function() { return onAfterApplicationActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeModalClose", function() { return onBeforeModalClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePageViewPerformance", function() { return onBeforePageViewPerformance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeUserFeedback", function() { return onBeforeUserFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeDeeplinkStart", function() { return onBeforeDeeplinkStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeDeeplinkStop", function() { return onBeforeDeeplinkStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeAssetDisplayed", function() { return onBeforeAssetDisplayed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeImpressionStart", function() { return onBeforeImpressionStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeImpressionStop", function() { return onBeforeImpressionStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeSubModalView", function() { return onBeforeSubModalView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeSubModalClose", function() { return onBeforeSubModalClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterSubModalClose", function() { return onAfterSubModalClose; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/cloneDeep */ "./node_modules/lodash/cloneDeep.js");
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_pickBy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash/pickBy */ "./node_modules/lodash/pickBy.js");
/* harmony import */ var lodash_pickBy__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_pickBy__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lodash/merge */ "./node_modules/lodash/merge.js");
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");




function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function onBeforePageViewInit(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;
  data['message.category'] = 'navigation';
  if (options.supressImpressionStopCleanup !== true && analytics.storage.internal.impression) {
      true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].warning('Callbacks::onBeforePageViewInit(): have impression events that were not closed');
    Object.keys(analytics.storage.internal.impression).forEach(function (key) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].warning("Callbacks::onBeforePageViewInit(): injecting impressionStop for ".concat(key));
      var savedData = analytics.storage.internal.impression[key].data;
      var fields = _objectSpread({
        'message.eventCaseId': "generic_impressionStop_".concat("video"),
        'message.triggeredBy': 'analytics',
        'state.impression.interaction': 'none'
      }, savedData);
      analytics.track('impressionStop', fields, {
        timestamp: analytics.timestamp
      });
    });
    delete analytics.storage.internal.impression;
  }
  analytics.storage.internal.onPage = true;
  analytics.storage.internal.pageViewContext = data['message.context'];
  analytics.storage.internal.pageViewTriggeredBy = data['message.triggeredBy'];

  // TODO: handle these better (same for searchObject)
  analytics.storage.internal.pageViewSection = {
    'state.view.currentPage.pageSection.name': data['state.view.currentPage.pageSection.name'],
    'state.view.currentPage.pageSection.index': data['state.view.currentPage.pageSection.index'],
    'state.view.currentPage.pageSection.numberOfItems': data['state.view.currentPage.pageSection.numberOfItems'],
    'state.view.currentPage.pageSection.allDisplayed': data['state.view.currentPage.pageSection.allDisplayed'],
    'state.view.currentPage.pageSection.onSiteCampaignId': data['state.view.currentPage.pageSection.onSiteCampaignId']
  };
  analytics.storage.internal.pageViewSubsection = {
    'state.view.currentPage.pageSubSection.name': data['state.view.currentPage.pageSubSection.name'],
    'state.view.currentPage.pageSubSection.index': data['state.view.currentPage.pageSubSection.index'],
    'state.view.currentPage.pageSubSection.numberOfItems': data['state.view.currentPage.pageSubSection.numberOfItems'],
    'state.view.currentPage.pageSubSection.allDisplayed': data['state.view.currentPage.pageSubSection.allDisplayed'],
    'state.view.currentPage.pageSubSection.displayType': data['state.view.currentPage.pageSubSection.displayType']
  };
  var currentSequenceNumber = analytics.model.get('state.view.currentPage.pageSequenceNumber');
  var nextSequenceNumber = typeof currentSequenceNumber !== 'undefined' ? currentSequenceNumber + 1 : 0;
  data['state.view.currentPage.pageSequenceNumber'] = nextSequenceNumber;
  data['state.view.currentPage.renderDetails.renderInitTimestamp'] = analytics.timestamp;
  data['state.view.currentPage.renderDetails.viewRenderedStatus'] = 'noRender';

  // TODO: improve this
  var pageViewedTime;
  var renderInitTimestamp = analytics.model.get('state.view.currentPage.renderDetails.renderInitTimestamp');
  if (renderInitTimestamp !== undefined) {
    pageViewedTime = analytics.timestamp - renderInitTimestamp;
  }

  // Transition between pages

  // reset modal in case it's still open
  analytics.model.reset('state.view.modal');
  analytics.model.reset('state.view.subModal');

  // Reset viewed device fields
  analytics.model.reset('state.view.device');
  var previousRenderedStatus = analytics.model.get('state.view.currentPage.renderDetails.viewRenderedStatus');
  if (previousRenderedStatus !== 'temporary') {
    // reset first in case we're missing some fields and some fields might not get overwritten
    analytics.model.reset('state.view.previousPage');

    // set currentPage to previousPage and remove fields that are not present in the specs
    analytics.model.set('state.view.previousPage', analytics.model.get('state.view.currentPage'));
    analytics.model.reset('state.view.previousPage.channelLineup');
    analytics.model.reset('state.view.previousPage.elements');
    analytics.model.reset('state.view.previousPage.navigation');
    analytics.model.reset('state.view.previousPage.renderDetails');
  }
  analytics.model.reset('state.view.currentPage');

  // Persist identifiers throughout a productPage or any flow
  if (!analytics.currentFlow && data['state.view.currentPage.pageName'] !== 'productPage') {
    analytics.model.reset('state.view.content');
  }
  pageViewedTime !== undefined && analytics.model.set('state.view.previousPage.pageViewedTimeMs', pageViewedTime);
  if (true) {
    core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info("Callbacks::onBeforePageViewInit(): Current page name: ".concat(data['state.view.currentPage.pageName']));
    core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info("Callbacks::onBeforePageViewInit(): Application section: ".concat(data['state.view.currentPage.appSection']));
  }
}
function onBeforePageViewCompleteAwaitingAction(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['state.view.currentPage.renderDetails.viewRenderedStatus'] = 'completeAwaitingAction';
  var duration = analytics.timestamp - analytics.model.get('state.view.currentPage.renderDetails.renderInitTimestamp');
  data['state.view.currentPage.renderDetails.fullyRenderedMs'] = duration;
  data['state.view.currentPage.renderDetails.fullyRenderedTimestamp'] = analytics.timestamp;
}
function onBeforeTemporaryView(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'navigation';
  data['message.triggeredBy'] = 'user';
  data['state.view.currentPage.renderDetails.viewRenderedStatus'] = 'temporary';
  var duration = analytics.timestamp - analytics.model.get('state.view.currentPage.renderDetails.renderInitTimestamp');
  data['state.view.currentPage.temporaryViewedTimeMs'] = duration;
}
function onBeforePageViewPartiallyRendered(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  var duration = analytics.timestamp - analytics.model.get('state.view.currentPage.renderDetails.renderInitTimestamp');
  data['state.view.currentPage.renderDetails.partialRenderedMs'] = duration;
  data['state.view.currentPage.renderDetails.partialRenderedTimestamp'] = analytics.timestamp;
  data['state.view.currentPage.renderDetails.viewRenderedStatus'] = 'partial';
}
function onBeforePageView(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;
  data['message.category'] = 'navigation';
  // TODO: ideally this should be 'application', but we're keeping this behavior for backwards compatibility
  data['message.triggeredBy'] = data['message.triggeredBy'] || analytics.storage.internal.pageViewTriggeredBy;
  data['message.eventCaseId'] = data['message.eventCaseId'] || "generic_pageView_missingEID_".concat("video");
  if (options.pageViewStatus) {
    data['state.view.currentPage.renderDetails.viewRenderedStatus'] = options.pageViewStatus;
  }
  var _analytics$storage$in = analytics.storage.internal,
    pageViewSection = _analytics$storage$in.pageViewSection,
    pageViewSubsection = _analytics$storage$in.pageViewSubsection;
  lodash_merge__WEBPACK_IMPORTED_MODULE_3___default()(data, pageViewSection);
  lodash_merge__WEBPACK_IMPORTED_MODULE_3___default()(data, pageViewSubsection);
  delete analytics.storage.internal.pageViewSection;
  delete analytics.storage.internal.pageViewSubsection;
  delete analytics.storage.internal.pageViewTriggeredBy;
  var incomingViewRenderedStatus = data['state.view.currentPage.renderDetails.viewRenderedStatus'];
  if (incomingViewRenderedStatus === 'complete') {
    var currentViewRenderedStatus = analytics.model.get('state.view.currentPage.renderDetails.viewRenderedStatus');
    var duration = analytics.timestamp - analytics.model.get('state.view.currentPage.renderDetails.renderInitTimestamp');
    if (currentViewRenderedStatus !== 'completeAwaitingAction') {
      data['state.view.currentPage.renderDetails.fullyRenderedTimestamp'] = analytics.timestamp;
      data['state.view.currentPage.renderDetails.fullyRenderedMs'] = duration;
    }
    var isLazyLoad = analytics.model.get('state.view.currentPage.renderDetails.isLazyLoad');
    var hasPartial = analytics.model.get('state.view.currentPage.renderDetails.partialRenderedTimestamp') || analytics.model.get('state.view.currentPage.renderDetails.partialRenderedMs');
    if (!isLazyLoad || !hasPartial) {
      data['state.view.currentPage.renderDetails.partialRenderedTimestamp'] = analytics.timestamp;
      data['state.view.currentPage.renderDetails.partialRenderedMs'] = duration;
    }
  }

  // TODO: re-work this for more generic use
  var currentPageName = analytics.model.get('state.view.currentPage.pageName'); // Search Flow: to get currentPage name
  // 'Search Flow: check for current page, if user returns to search page after curated result page, use saved search object from local storage
  if (currentPageName === 'search' && analytics.storage.internal.searchObject) {
    var searchObject = analytics.storage.internal.searchObject;
    lodash_merge__WEBPACK_IMPORTED_MODULE_3___default()(data, searchObject);
  }
}
function onAfterPageView(event, from, into, args) {
  var analytics = args.analytics;
  var timing = analytics.storage.internal.performanceTiming;
  if (timing) {
      true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info('Callbacks::onAfterPageView(): have performance timing object, reporting performance event');
    var fields = {
      'message.eventCaseId': "generic_pageViewPerformance_".concat("video"),
      'message.triggeredBy': 'analytics',
      'state.view.currentPage.performanceTiming': lodash_pickBy__WEBPACK_IMPORTED_MODULE_2___default()(timing, function (value) {
        return value && typeof value === 'number';
      }),
      'operation.operationType': 'domContentLoaded'
    };
    analytics.track('pageViewPerformance', fields);
    delete analytics.storage.internal.performanceTiming;
  }
}
function onBeforeModalView(event, from, into, args) {
  var data = args.data,
    analytics = args.analytics;
  data['message.category'] = 'navigation';

  // reset previous modal in case it's still open
  analytics.model.reset('state.view.modal');
  analytics.model.reset('state.view.subModal');
  if (true) {
    core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info("Callbacks::onBeforeModalView(): Modal name: ".concat(data['state.view.modal.name']));
  }
}
function onBeforePurchaseStart(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'contentDiscovery';
  data['message.triggeredBy'] = 'user';
}
function onBeforePurchaseStop(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'contentDiscovery';
  if (analytics.storage.internal.preferences) {
    lodash_merge__WEBPACK_IMPORTED_MODULE_3___default()(data, analytics.storage.internal.preferences);
  }
}
function onAfterPurchaseStop(event, from, into, args) {
  var analytics = args.analytics;
  delete analytics.storage.internal.preferences;
}
function onBeforeFeatureStart(event, from, into, args) {
  var data = args.data;
  data['message.triggeredBy'] = 'user';
}
function onBeforeFeatureStop(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  if (analytics.storage.internal.preferences) {
    lodash_merge__WEBPACK_IMPORTED_MODULE_3___default()(data, analytics.storage.internal.preferences);
  }
}
function onAfterFeatureStop(event, from, into, args) {
  var analytics = args.analytics;
  delete analytics.storage.internal.preferences;
}
function onBeforeApplicationActivity(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'navigation';
  if (data['operation.operationType'] === 'backgrounded') {
    // TODO: should get field moved
    analytics.model.set('visit.applicationDetails.appBackgroundedTimestamp', analytics.timestamp);
    analytics.model.set('visit.inFocus', false);
  } else if (data['operation.operationType'] === 'foregrounded') {
    var appBackgroundedTimestamp = analytics.model.get('visit.applicationDetails.appBackgroundedTimestamp');
    if (analytics.settings.backgroundedVisitTTL && appBackgroundedTimestamp && analytics.timestamp - appBackgroundedTimestamp >= analytics.settings.backgroundedVisitTTL) {
      var domain = analytics.model.get('domain') || "video";
      analytics.track('startSession', {
        'message.eventCaseId': "generic_startSession_".concat(domain),
        'visit.connection.connectionType': analytics.model.get('visit.connection.connectionType'),
        // otherwise we will fall back to the default value
        'visit.previousVisitId': analytics.model.get('visit.visitId')
      }, {
        forceTransitionTo: analytics.settings.resetStateOnResume ? 'appInitializing' : analytics.sm.current,
        timestamp: analytics.timestamp
      });
    }
    analytics.model.set('visit.inFocus', true);
  }
  if (data['state.lifecycleState.name']) {
    var oldLifecycleState = analytics.model.get('state.lifecycleState.name');
    if (oldLifecycleState) {
      data['state.previousLifecycleState.name'] = oldLifecycleState;
      var timeInStateMs = analytics.timestamp - analytics.storage.internal.lifecycleChangeTimestamp;
      data['state.previousLifecycleState.timeInStateMs'] = timeInStateMs;

      // If we were in a state for 30 minutes and we changed from inactive to active state - generate new visit
      if (analytics.settings.backgroundedVisitTTL && timeInStateMs >= analytics.settings.backgroundedVisitTTL && ['initializing', 'suspended', 'inactive', 'unloading', 'unknown'].includes(oldLifecycleState) && ['inactive', 'backgroundActive', 'foregroundActive'].includes(data['state.lifecycleState.name'])) {
        // Since this is a more complex condition we can't handle this with flushedEvents.json config
        analytics.queue.flush();
        var _domain = analytics.model.get('domain') || "video";
        analytics.track('startSession', {
          'message.eventCaseId': "generic_startSession_".concat(_domain),
          'visit.connection.connectionType': analytics.model.get('visit.connection.connectionType'),
          // otherwise we will fall back to the default value
          'visit.previousVisitId': analytics.model.get('visit.visitId')
        }, {
          forceTransitionTo: analytics.settings.resetStateOnResume ? 'appInitializing' : analytics.sm.current,
          timestamp: analytics.timestamp
        });
      }
    }
    analytics.storage.internal.lifecycleChangeTimestamp = analytics.timestamp;
  }
}
function onAfterApplicationActivity(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  if (data['operation.operationType'] === 'foregrounded') {
    analytics.model.reset('visit.applicationDetails.appBackgroundedTimestamp');
  }
}
function onBeforeModalClose(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'navigation';

  // reset any open submodals
  analytics.model.reset('state.view.subModal');
}
function onBeforePageViewPerformance(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'navigation';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'application'; // for generated performance event
}

function onBeforeUserFeedback(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'navigation';
}
function onBeforeDeeplinkStart(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'navigation';
  data['message.triggeredBy'] = 'user';
  analytics.model.reset('state.referrer.instanceCampaignId');
}
function onBeforeDeeplinkStop(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'navigation';
}
function onBeforeAssetDisplayed(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'navigation';
}
function onBeforeImpressionStart(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  if (!analytics.storage.internal.impression) {
    analytics.storage.internal.impression = {};
  }
  var impressionId = [data['state.impression.location'], data['state.impression.id'], data['state.impression.locationTmsGuideId']].filter(function (val) {
    return val;
  }).join('|');
  if (impressionId) {
    var fieldsToSave = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default()(data); // clone so it's not a reference
    delete fieldsToSave['message.eventCaseId']; // Don't save eventCaseId

    analytics.storage.internal.impression[impressionId] = {
      timestamp: analytics.timestamp,
      data: fieldsToSave
    };
  } else {
      true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].warning('API: no valid impression id');
  }
  data['message.category'] = 'navigation';
  data['message.triggeredBy'] = 'application';
}
function onBeforeImpressionStop(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'navigation';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'application'; // default value for analytics and backwards compatibility

  var impressionId = [data['state.impression.location'], data['state.impression.id'], data['state.impression.locationTmsGuideId']].filter(function (val) {
    return val;
  }).join('|');
  if (analytics.storage.internal.impression && analytics.storage.internal.impression[impressionId]) {
    data['state.impression.viewedTime'] = analytics.timestamp - analytics.storage.internal.impression[impressionId].timestamp;
    Object.assign(data, analytics.storage.internal.impression[impressionId].data); // shallow merge is enough
    delete analytics.storage.internal.impression[impressionId];
  }
}
function onBeforeSubModalView(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'navigation';
  if (!analytics.storage.internal.subModals) {
    analytics.storage.internal.subModals = {};
  }
  var newSubModalName = data['state.view.subModal.currentModalName'];
  analytics.storage.internal.subModals[newSubModalName] = {
    currentModalText: data['state.view.subModal.currentModalText'],
    currentModalType: data['state.view.subModal.currentModalType'],
    currentModalLoadTimeMs: data['state.view.subModal.currentModalLoadTimeMs']
  };
  var currentSubModals = analytics.model.get('state.view.subModal.openModalNames') || [];
  currentSubModals.push(newSubModalName);
  data['state.view.subModal.openModalNames'] = currentSubModals;
}
function onBeforeSubModalClose(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;
  data['message.category'] = 'navigation';
  var currentSubModals = analytics.model.get('state.view.subModal.openModalNames') || [];
  var closingSubModalName = data['state.view.subModal.currentModalName'];
  // if we got a name close that one
  if (closingSubModalName) {
    data['state.view.subModal.openModalNames'] = currentSubModals.filter(function (name) {
      return name !== closingSubModalName;
    });
  } else {
    // current name is last one, remove it
    closingSubModalName = currentSubModals.pop();
    data['state.view.subModal.currentModalName'] = closingSubModalName;
    data['state.view.subModal.openModalNames'] = currentSubModals;
  }

  // for close events submodal fields are ones from closing modal
  options.closingSubModalName = closingSubModalName;
  var _analytics$storage$in2 = analytics.storage.internal.subModals[closingSubModalName],
    currentModalLoadTimeMs = _analytics$storage$in2.currentModalLoadTimeMs,
    currentModalText = _analytics$storage$in2.currentModalText,
    currentModalType = _analytics$storage$in2.currentModalType;
  data['state.view.subModal.currentModalText'] = currentModalText;
  data['state.view.subModal.currentModalType'] = currentModalType;
  data['state.view.subModal.currentModalLoadTimeMs'] = currentModalLoadTimeMs;
}
function onAfterSubModalClose(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;

  // clean up internal state for closed submodal
  var closingSubModalName = options.closingSubModalName;
  delete analytics.storage.internal.subModals[closingSubModalName];

  // set fields back to value from last submodal
  var currentSubModals = data['state.view.subModal.openModalNames'];
  var lastSubModalName = currentSubModals[currentSubModals.length - 1];
  // if there's any more left
  if (lastSubModalName) {
    var _analytics$storage$in3 = analytics.storage.internal.subModals[lastSubModalName],
      currentModalLoadTimeMs = _analytics$storage$in3.currentModalLoadTimeMs,
      currentModalText = _analytics$storage$in3.currentModalText,
      currentModalType = _analytics$storage$in3.currentModalType;
    // note: has to be model.set, too late to edit data object here
    analytics.model.set('state.view.subModal.currentModalName', lastSubModalName);
    analytics.model.set('state.view.subModal.currentModalText', currentModalText);
    analytics.model.set('state.view.subModal.currentModalType', currentModalType);
    analytics.model.set('state.view.subModal.currentModalLoadTimeMs', currentModalLoadTimeMs);
  }
  // If none left clean up all object
  else {
    analytics.model.reset('state.view.subModal');
  }
}

/***/ }),

/***/ "./src/common/callbacks/search.js":
/*!****************************************!*\
  !*** ./src/common/callbacks/search.js ***!
  \****************************************/
/*! exports provided: onBeforeSearched, onBeforeSearchClosed */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeSearched", function() { return onBeforeSearched; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeSearchClosed", function() { return onBeforeSearchClosed; });
function onBeforeSearched(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'search';
  data['operation.operationType'] = 'searchEntered';
  var currentPageName = analytics.model.get('state.view.currentPage.pageName');
  // Search Flow: save the search data in the local storage from search page.
  // TODO: re-work this to more generic use, e.g. pageStorage[model.currentPage].data
  if (currentPageName === 'search') {
    analytics.storage.internal.searchObject = {
      // TODO: improve so we don't do this 1 by 1
      'state.search.numberOfSearchResults': data['state.search.numberOfSearchResults'],
      'state.search.selectedResultName': data['state.search.selectedResultName'],
      'state.search.selectedResultFacet': data['state.search.selectedResultFacet'],
      'state.search.text': data['state.search.text'],
      'state.search.searchType': data['state.search.searchType'],
      'state.search.results': data['state.search.results'],
      'state.search.searchResults': data['state.search.searchResults'],
      'state.search.resultsMs': data['state.search.resultsMs'],
      'state.search.queryId': data['state.search.queryId'],
      'state.search.searchId': data['state.search.searchId']
    };
  }
}
function onBeforeSearchClosed(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'search';
  data['message.triggeredBy'] = 'user';
  delete analytics.storage.internal.searchObject; // User exits Search Flow, clearing out local storage

  analytics.model.set('operation.operationType', 'searchClosed');
}

/***/ }),

/***/ "./src/common/callbacks/select.js":
/*!****************************************!*\
  !*** ./src/common/callbacks/select.js ***!
  \****************************************/
/*! exports provided: onBeforeSelectAction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeSelectAction", function() { return onBeforeSelectAction; });
function onBeforeSelectAction(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  if (data['operation.userPreferencesSelections'] || data['operation.userPreferenceCategory']) {
    analytics.storage.internal.preferences = {
      'operation.userPreferencesSelections': data['operation.userPreferencesSelections'],
      'operation.userPreferenceCategory': data['operation.userPreferenceCategory']
    };
  }
}

/***/ }),

/***/ "./src/common/callbacks/session.js":
/*!*****************************************!*\
  !*** ./src/common/callbacks/session.js ***!
  \*****************************************/
/*! exports provided: onBeforeStartSession, onBeforeUserConfigSet, onBeforeConnectionChange, onBeforeApplicationPerformance */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeStartSession", function() { return onBeforeStartSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeUserConfigSet", function() { return onBeforeUserConfigSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeConnectionChange", function() { return onBeforeConnectionChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeApplicationPerformance", function() { return onBeforeApplicationPerformance; });
/* harmony import */ var core_utils_uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core/utils/uuid */ "./src/core/utils/uuid.js");
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");
/* harmony import */ var core_utils_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core/utils/cookie */ "./src/core/utils/cookie.js");
/* harmony import */ var core_utils_domain__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core/utils/domain */ "./src/core/utils/domain.js");




function onBeforeStartSession(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'application';
  data['message.triggeredBy'] = 'user';

  // In order of priority - previously generated visitId from init error, passed in ID or new uuid;
  var domain = data.domain || "video";
  data['visit.visitId'] = analytics.visitIdFromInitError || data['visit.visitId'] || Object(core_utils_uuid__WEBPACK_IMPORTED_MODULE_0__["generateVisitId"])(domain);
  delete analytics.visitIdFromInitError;
  if (typeof window !== 'undefined' && window.document) {
    var browserEvent = new CustomEvent('quantumVisitIdSet', {
      detail: data['visit.visitId']
    });
    document.dispatchEvent(browserEvent);
  }
  !data['visit.connection.connectionType'] && analytics.model.set('visit.connection.connectionType', 'unknown');
  if (data['visit.inFocus'] === undefined) {
    data['visit.inFocus'] = true;
  }

  // Only generate new one if we don't have it
  analytics.model.set('visit.appSessionId', analytics.model.get('visit.appSessionId') || Object(core_utils_uuid__WEBPACK_IMPORTED_MODULE_0__["default"])());
  analytics.model.set('visit.visitStartTimestamp', analytics.timestamp);
  analytics.model.set('visit.applicationDetails.venonaVersion', analytics.libraryVersion);
  analytics.model.set('visit.applicationDetails.venonaRequirementsVersion', analytics.venonaRequirementsVersion);
  analytics.model.set('visit.analytics.libraryType', 'JavaScript');
  var hasToken = analytics.storage.permanent.get('library-first-launch');
  if (hasToken) {
    data['visit.firstLaunch'] = false;
  } else {
    core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].info('Callbacks::onBeforeStartSession(): First launch, saving token to storage');
    analytics.storage.permanent.set('library-first-launch', true);
    data['visit.firstLaunch'] = true;
  }
  if (typeof window !== 'undefined' && window.location && window.document) {
    var browserSessionId = Object(core_utils_cookie__WEBPACK_IMPORTED_MODULE_2__["default"])('qBrowserSessionId');
    if (browserSessionId) {
      core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].info("Callbacks::onBeforeStartSession(): Have existing browser session ID: ".concat(browserSessionId));
    } else {
      browserSessionId = Object(core_utils_uuid__WEBPACK_IMPORTED_MODULE_0__["default"])();
      core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].info("Callbacks::onBeforeStartSession(): New browser session ID: ".concat(browserSessionId));
      document.cookie = "qBrowserSessionId=".concat(browserSessionId, ";domain=.").concat(Object(core_utils_domain__WEBPACK_IMPORTED_MODULE_3__["default"])(), ";SameSite=Strict");
    }
    data['visit.device.browser.sessionId'] = browserSessionId;
  }
  if (true) {
    var visitId = analytics.model.get('visit.visitId') || data['visit.visitId'];
    core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].info("Callbacks::onBeforeStartSession(): Current visit ID: ".concat(visitId));
  }
}
function onBeforeUserConfigSet(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'application';
  data['message.triggeredBy'] = 'application';
}
function onBeforeConnectionChange(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'application';
  data['message.triggeredBy'] = 'application';
}
function onBeforeApplicationPerformance(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'application';
}

/***/ }),

/***/ "./src/common/json/Categories.json":
/*!*****************************************!*\
  !*** ./src/common/json/Categories.json ***!
  \*****************************************/
/*! exports provided: startSession, userConfigSet, playbackSelect, playbackStreamUriAcquired, playbackExitBeforeStart, playbackStart, playbackStartAfterRetry, playbackStop, bufferingStart, bufferingStop, playbackPause, playbackUnpause, playbackFailure, playbackFailureBeforeRetry, attemptRestart, playbackTrickPlayStart, playbackTrickPlayRateChange, playbackTrickPlayStop, playbackBitRateUpshift, playbackBitRateDownshift, playbackHeartbeat, loginStart, loginStop, logout, inVisitOauthRefresh, pageView, modalView, selectAction, selectContent, searched, searchClosed, adBreakStart, adBreakStop, adStart, adStop, error, apiCall, pinEntry, requestToRecord, requestToDeleteRecording, requestToEditRecording, requestToCancelRecording, setVideoZone, setAccountFeatures, setNetworkStatus, setDeviceLocation, setAutoAccessEnabled, setExperimentConfigurations, setSegment, pageViewInit, pageViewPartiallyRendered, purchaseStart, purchaseStop, applicationActivity, checkAvailableChannels, forcedLogin, switchScreen, setApplicationName, displayChange, setTimeZone, featureStart, featureStop, deviceConfigSet, modalClose, setBulkMduClass, setPageAdditionalInfo, setOtaChannels, connectionChange, setPictureInPicture, setEntitlements, pageViewPerformance, userFeedback, externalAppStateChange, applicationCrash, customEvent, impressionStart, impressionStop, assetDisplayed, applicationPerformance, deeplinkStart, deeplinkStop, concurrencyChange, setTrafficOriginId, pushNotification, setAccessibilitySettings, setMaxVideoDetails, setResolution, setDevicePerformance, setPlaybackPerformance, setAudioBitRate, setPackageInformation, setLocationStatus, webSocketActivity, webSocketHeartbeat, webSocketOpen, webSocketClose, webSocketError, temporaryView, pageViewCompleteAwaitingAction, setSpeedBoost, setApplePrivateRelayIp, batchApiCall, additionalAppStart, additionalAppStop, subModalView, subModalClose, playbackTrackChange, systemMessage, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"startSession\":\"session\",\"userConfigSet\":\"session\",\"playbackSelect\":\"playback\",\"playbackStreamUriAcquired\":\"playback\",\"playbackExitBeforeStart\":\"playback\",\"playbackStart\":\"playback\",\"playbackStartAfterRetry\":\"playback\",\"playbackStop\":\"playback\",\"bufferingStart\":\"playback\",\"bufferingStop\":\"playback\",\"playbackPause\":\"playback\",\"playbackUnpause\":\"playback\",\"playbackFailure\":\"playback\",\"playbackFailureBeforeRetry\":\"playback\",\"attemptRestart\":\"playback\",\"playbackTrickPlayStart\":\"playback\",\"playbackTrickPlayRateChange\":\"playback\",\"playbackTrickPlayStop\":\"playback\",\"playbackBitRateUpshift\":\"playback\",\"playbackBitRateDownshift\":\"playback\",\"playbackHeartbeat\":\"playback\",\"loginStart\":\"login\",\"loginStop\":\"login\",\"logout\":\"login\",\"inVisitOauthRefresh\":\"login\",\"pageView\":\"navigation\",\"modalView\":\"navigation\",\"selectAction\":\"select\",\"selectContent\":\"select\",\"searched\":\"search\",\"searchClosed\":\"search\",\"adBreakStart\":\"ads\",\"adBreakStop\":\"ads\",\"adStart\":\"ads\",\"adStop\":\"ads\",\"error\":\"error\",\"apiCall\":\"apiCall\",\"pinEntry\":\"navigation\",\"requestToRecord\":\"navigation\",\"requestToDeleteRecording\":\"navigation\",\"requestToEditRecording\":\"navigation\",\"requestToCancelRecording\":\"navigation\",\"setVideoZone\":\"session\",\"setAccountFeatures\":\"session\",\"setNetworkStatus\":\"session\",\"setDeviceLocation\":\"session\",\"setAutoAccessEnabled\":\"session\",\"setExperimentConfigurations\":\"session\",\"setSegment\":\"playback\",\"pageViewInit\":\"navigation\",\"pageViewPartiallyRendered\":\"navigation\",\"purchaseStart\":\"navigation\",\"purchaseStop\":\"navigation\",\"applicationActivity\":\"navigation\",\"checkAvailableChannels\":\"navigation\",\"forcedLogin\":\"login\",\"switchScreen\":\"navigation\",\"setApplicationName\":\"session\",\"displayChange\":\"navigation\",\"setTimeZone\":\"session\",\"featureStart\":\"navigation\",\"featureStop\":\"navigation\",\"deviceConfigSet\":\"session\",\"modalClose\":\"navigation\",\"setBulkMduClass\":\"session\",\"setPageAdditionalInfo\":\"navigation\",\"setOtaChannels\":\"session\",\"connectionChange\":\"session\",\"setPictureInPicture\":\"navigation\",\"setEntitlements\":\"session\",\"pageViewPerformance\":\"navigation\",\"userFeedback\":\"navigation\",\"externalAppStateChange\":\"navigation\",\"applicationCrash\":\"error\",\"customEvent\":\"custom\",\"impressionStart\":\"navigation\",\"impressionStop\":\"navigation\",\"assetDisplayed\":\"navigation\",\"applicationPerformance\":\"session\",\"deeplinkStart\":\"navigation\",\"deeplinkStop\":\"navigation\",\"concurrencyChange\":\"playback\",\"setTrafficOriginId\":\"session\",\"pushNotification\":\"navigation\",\"setAccessibilitySettings\":\"session\",\"setMaxVideoDetails\":\"playback\",\"setResolution\":\"playback\",\"setDevicePerformance\":\"session\",\"setPlaybackPerformance\":\"playback\",\"setAudioBitRate\":\"playback\",\"setPackageInformation\":\"session\",\"setLocationStatus\":\"session\",\"webSocketActivity\":\"apiCall\",\"webSocketHeartbeat\":\"apiCall\",\"webSocketOpen\":\"apiCall\",\"webSocketClose\":\"apiCall\",\"webSocketError\":\"apiCall\",\"temporaryView\":\"navigation\",\"pageViewCompleteAwaitingAction\":\"navigation\",\"setSpeedBoost\":\"session\",\"setApplePrivateRelayIp\":\"session\",\"batchApiCall\":\"apiCall\",\"additionalAppStart\":\"navigation\",\"additionalAppStop\":\"navigation\",\"subModalView\":\"navigation\",\"subModalClose\":\"navigation\",\"playbackTrackChange\":\"playback\",\"systemMessage\":\"apiCall\"}");

/***/ }),

/***/ "./src/common/json/FlushedEvents.json":
/*!********************************************!*\
  !*** ./src/common/json/FlushedEvents.json ***!
  \********************************************/
/*! exports provided: before, after, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"before\":{\"applicationActivity\":[{\"operation.operationType\":[\"backgrounded\",\"foregrounded\",\"sectionView\"]}],\"switchScreen\":[],\"connectionChange\":[]},\"after\":{\"loginStart\":[],\"loginStop\":[],\"logout\":[],\"error\":[],\"playbackFailure\":[],\"userConfigSet\":[],\"deviceConfigSet\":[],\"switchScreen\":[{\"operation.switchScreenDirection\":[\"referrerDisconnect\"]}],\"applicationActivity\":[{\"operation.operationType\":[\"foregrounded\"]}],\"featureStop\":[],\"purchaseStop\":[],\"apiCall\":[{\"operation.success\":[false]}],\"pageViewPerformance\":[{\"operation.operationType\":[\"cwvEvent\"]}]}}");

/***/ }),

/***/ "./src/core/AnalyticsCore.js":
/*!***********************************!*\
  !*** ./src/core/AnalyticsCore.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash/cloneDeep */ "./node_modules/lodash/cloneDeep.js");
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_set__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lodash/set */ "./node_modules/lodash/set.js");
/* harmony import */ var lodash_set__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_set__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lodash/get */ "./node_modules/lodash/get.js");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lodash/isPlainObject */ "./node_modules/lodash/isPlainObject.js");
/* harmony import */ var lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_pickBy__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lodash/pickBy */ "./node_modules/lodash/pickBy.js");
/* harmony import */ var lodash_pickBy__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_pickBy__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lodash/pick */ "./node_modules/lodash/pick.js");
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_pick__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var web_vitals__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! web-vitals */ "./node_modules/web-vitals/dist/web-vitals.js");
/* harmony import */ var core_utils_StateMachine__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core/utils/StateMachine */ "./src/core/utils/StateMachine.js");
/* harmony import */ var core_model__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core/model */ "./src/core/model.js");
/* harmony import */ var core_utils_MessageQueue__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core/utils/MessageQueue */ "./src/core/utils/MessageQueue.js");
/* harmony import */ var core_utils_messages__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core/utils/messages */ "./src/core/utils/messages.js");
/* harmony import */ var core_utils_Timer__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core/utils/Timer */ "./src/core/utils/Timer.js");
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");
/* harmony import */ var common_json_Categories_json__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! common/json/Categories.json */ "./src/common/json/Categories.json");
var common_json_Categories_json__WEBPACK_IMPORTED_MODULE_18___namespace = /*#__PURE__*/__webpack_require__.t(/*! common/json/Categories.json */ "./src/common/json/Categories.json", 1);
/* harmony import */ var common_json_FlushedEvents_json__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! common/json/FlushedEvents.json */ "./src/common/json/FlushedEvents.json");
var common_json_FlushedEvents_json__WEBPACK_IMPORTED_MODULE_19___namespace = /*#__PURE__*/__webpack_require__.t(/*! common/json/FlushedEvents.json */ "./src/common/json/FlushedEvents.json", 1);
/* harmony import */ var core_utils_CollectorRequest__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core/utils/CollectorRequest */ "./src/core/utils/CollectorRequest.js");
/* harmony import */ var core_utils_post__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core/utils/post */ "./src/core/utils/post.js");
/* harmony import */ var core_utils_rateLimit__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core/utils/rateLimit */ "./src/core/utils/rateLimit.js");
/* harmony import */ var core_utils_uuid__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core/utils/uuid */ "./src/core/utils/uuid.js");
/* harmony import */ var core_utils_prune__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core/utils/prune */ "./src/core/utils/prune.js");
/* harmony import */ var core_utils_platform__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core/utils/platform */ "./src/core/utils/platform.js");
/* harmony import */ var _AnalyticsStorage__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./AnalyticsStorage */ "./src/core/AnalyticsStorage.js");



























var AnalyticsCore = /*#__PURE__*/function () {
  function AnalyticsCore(callbacks, specs) {
    var _this = this;
    var onSetHandlers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, AnalyticsCore);
    this.eventInput = specs.input;
    this.eventOutput = specs.output;
    this.venonaRequirementsVersion = specs.version;
    this.blacklists = specs.blacklists;
    this.flushedEvents = common_json_FlushedEvents_json__WEBPACK_IMPORTED_MODULE_19__;
    this.errorCodes = specs.errorCodes;
    this.persistenceRules = specs.persistenceRules;
    this.transitions = specs.legacyTransitions;
    this.onSetHandlers = onSetHandlers;
    this.currentFlow = undefined;
    this.isUnloading = false;
    this.eventFilters = {};
    this.settings = {
      endpoint: 'https://collector-dev.pi-charter.net/api/collector',
      // collector endpoint
      sendInterval: 10000,
      // timer for periodically sending messages
      maxMessageSize: 5000,
      // maximum message size
      heartBeatInterval: 60000,
      // heartBeat timer // TODO: extract heartbeat stuff somehow
      maxBulkQueueSize: 50,
      // max unsent bulk messages
      bulkMessageTTL: 1800000,
      // time to live for messages in bulk queue
      filterFields: true,
      // filter out fields from messages
      storageDuration: 1800000,
      // TTL of data saved in storage
      backgroundedVisitTTL: 1800000,
      // Time after which restoring a foregrounded app will create a new visit ID
      isOnline: true,
      // is application currently online
      sendRetryInterval: 60000,
      // Interval at which to retry sending bulk messages if retry is on
      sendRetryCount: 3,
      // Count of retries for sending bulk messages (max 5)
      sendTimeout: 10000,
      // Timeout value for post requests
      resetStateOnResume: true,
      // When tracking startSession on a resume - reset state to appInitializing or not
      maxEventsPerSecond: 20,
      // Max count of events that can be processed per second, further events are discarded
      verifyAppNameOnResume: true,
      // Check if application name when resuming a saved session
      renamePlaybackStartDuringRetry: false,
      // Rename playbackStart to playbackStartAfterRetry (both ways) depending on active playback state
      batchApiInterval: 30000,
      // Interval for sending batch API call messages
      maxSingleFieldSize: 10000,
      // Limit after which a field will be handled as an oversized value
      includedFeatureNameList: [],
      // Page names to include in the userJourney flow
      forceXHR: false,
      // Force XHR instead of fetch for posting to the collector
      // 0 so we always force client to set value
      playbackCacheMaxLengthMs: 0,
      // Pause live cache length, must be set if using pause in live TV
      cwvEnabled: false,
      // Is reporting Core Web Vitals enabled
      cwvVerbose: false // Is every Core Web Vitals event reported
    };

    this.onSetCallbacks = {
      maxMessageSize: function maxMessageSize(value) {
        return _this.queue.setMaxSize(value);
      },
      isOnline: function isOnline(value, oldValue) {
        return _this.connectionChanged(value, oldValue);
      },
      sendInterval: function sendInterval(value) {
        return _this.sendTimer.changeInterval(value);
      },
      heartBeatInterval: function heartBeatInterval(value) {
        return _this.heartBeatTimer.changeInterval(value);
      },
      batchApiInterval: function batchApiInterval(value) {
        return _this.batchApiTimer.changeInterval(value);
      },
      maxEventsPerSecond: function maxEventsPerSecond(value) {
        return _this.rateLimiter.changeRate(value);
      },
      sendRetryInterval: function sendRetryInterval() {
        return core_utils_CollectorRequest__WEBPACK_IMPORTED_MODULE_20__["default"].config(_this.settings);
      },
      sendTimeout: function sendTimeout() {
        return core_utils_CollectorRequest__WEBPACK_IMPORTED_MODULE_20__["default"].config(_this.settings);
      },
      forceXHR: function forceXHR() {
        return core_utils_CollectorRequest__WEBPACK_IMPORTED_MODULE_20__["default"].config(_this.settings);
      }
    };
    this.libraryVersion = "8.28.0";
    this.sm = new core_utils_StateMachine__WEBPACK_IMPORTED_MODULE_12__["default"]({
      initial: 'blank',
      callbacks: callbacks,
      transitions: this.transitions,
      name: 'Core'
    });
    this.queue = new core_utils_MessageQueue__WEBPACK_IMPORTED_MODULE_14__["default"](this.settings.maxMessageSize, this.sendMessages.bind(this));
    this.bulkQueue = [];
    this.model = new core_model__WEBPACK_IMPORTED_MODULE_13__["default"]();
    this.storage = new _AnalyticsStorage__WEBPACK_IMPORTED_MODULE_26__["default"]();
    this.timestamp = undefined;
    this.messageId = 0;
    this.sendTimer = new core_utils_Timer__WEBPACK_IMPORTED_MODULE_16__["default"](function () {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].debug('Core: triggering flush timer');
      _this.queue.flush();
    }, this.settings.sendInterval);
    this.heartBeatTimer = new core_utils_Timer__WEBPACK_IMPORTED_MODULE_16__["default"](function () {
      // TODO: maybe extract this?
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].debug('Core: triggering heartbeat timer');
      _this.track('playbackHeartbeat');
    }, this.settings.heartBeatInterval);
    this.batchApiTimer = new core_utils_Timer__WEBPACK_IMPORTED_MODULE_16__["default"](function () {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].debug('Core: triggering batch API call timer');
      _this.reportBatchApiCalls();
    }, this.settings.batchApiInterval);
    this.features = {
      playback: true,
      login: true,
      navigation: true,
      select: true,
      search: true,
      ads: true,
      error: true,
      apiCall: true
    };
    this.rateLimiter = new core_utils_rateLimit__WEBPACK_IMPORTED_MODULE_22__["default"](this.settings.maxEventsPerSecond, {
      exceptions: ['customEvent'],
      onError: function onError() {
        var errorFields = {
          'message.eventCaseId': "generic_error_".concat("video"),
          'message.triggeredBy': 'analytics',
          'application.error.errorType': 'analytics',
          'application.error.errorCode': _this.errorCodes.internal.rateLimit,
          'application.error.errorMessage': "Total event rate limit (".concat(_this.settings.maxEventsPerSecond, " events per second) is reached")
        };
        _this.track('error', errorFields);
      }
    });
    this.handleEvent = this.rateLimiter.wrap(this.handleEvent.bind(this));
    this.pendingRequests = [];
    if (!Promise.allSettled) {
      Promise.allSettled = function allSettled(promises) {
        return Promise.all(promises.map(function (p) {
          return p.then(function (value) {
            return {
              status: 'fulfilled',
              value: value
            };
          })["catch"](function (reason) {
            return {
              status: 'rejected',
              reason: reason
            };
          });
        }));
      };
    }
    core_utils_CollectorRequest__WEBPACK_IMPORTED_MODULE_20__["default"].init(this.settings);
    this.handleWebVitals = this.handleWebVitals.bind(this);
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(AnalyticsCore, [{
    key: "get",
    value: function get(param) {
      return this.settings[param];
    }
  }, {
    key: "set",
    value: function set(param, value) {
      var oldValue = this.settings[param];
      this.settings[param] = value;
      this.onSetCallbacks[param] && this.onSetCallbacks[param](value, oldValue);
      this.saveState();
    }
  }, {
    key: "setFeatures",
    value: function setFeatures(conf) {
      var _this2 = this;
      Object.keys(conf).forEach(function (key) {
        typeof _this2.features[key] !== 'undefined' && (_this2.features[key] = conf[key]);
      });
      this.saveState();
    }
  }, {
    key: "setEventFilters",
    value: function setEventFilters(conf) {
      // TODO add validation
      this.eventFilters = conf;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(event) {
      var category = common_json_Categories_json__WEBPACK_IMPORTED_MODULE_18__[event];
      return this.features[category] === false;
    }
  }, {
    key: "connectionChanged",
    value: function connectionChanged(isOnline, wasOnline) {
      if (!wasOnline && isOnline) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: connection restored, triggering send');
        this.sendBulkMessages();
      }
    }

    // Common entry point for set methods
  }, {
    key: "handleSet",
    value: function handleSet(event, fields) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info("Core: saving data for set method ".concat(event));
      this.filterOversizedFields(event, fields);
      var data = this.prepareData(event, lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_4___default()(fields));

      // Flush if any visit keys are set
      if (Object.keys(data).some(function (key) {
        return key.includes('visit');
      })) {
        this.queue.flush();
      }
      if (this.onSetHandlers[event]) {
        this.onSetHandlers[event](data);
      } else {
        this.model.batchSet(data); // save prepared data into the model directly
      }
    }

    // Common entry point of events
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info("Core:: event ".concat(event));
      this.filterOversizedFields(event, fields, options);
      var data = this.prepareData(event, lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_4___default()(fields), options);
      if (data) {
        this.track(event, data, options);
      }
    }
  }, {
    key: "filterOversizedFields",
    value: function filterOversizedFields(event, fields, options) {
      var _this3 = this;
      var inputDataSize = JSON.stringify(fields).length;
      if (inputDataSize > this.settings.maxSingleFieldSize) {
        var sizePerField = {};
        Object.keys(fields).forEach(function (fieldName) {
          // Skip empty fields
          // eslint-disable-next-line eqeqeq
          if (fields[fieldName] == undefined) {
            return;
          }
          var isString = typeof fields[fieldName] === 'string';
          var fieldSize = isString ? fields[fieldName].length : JSON.stringify(fields[fieldName]).length;
          if (fieldSize > _this3.settings.maxSingleFieldSize) {
            sizePerField[fieldName] = fieldSize;
            // Substring string fields and erase other values
            if (isString) {
              // eslint-disable-next-line no-param-reassign
              fields[fieldName] = fields[fieldName].substring(0, _this3.settings.maxSingleFieldSize);
            } else {
              // eslint-disable-next-line no-param-reassign
              fields[fieldName] = undefined;
            }
          }
        });
        var errorFields = {
          'message.eventCaseId': "generic_error_".concat("video"),
          'message.triggeredBy': 'analytics',
          'application.error.errorType': 'analytics',
          'application.error.errorCode': this.errorCodes.internal.maxFieldSize,
          'application.error.errorMessage': "Event ".concat(event, " data over the size limit (").concat(this.settings.maxSingleFieldSize, " characters), long string fields will be truncated and non string fields will be discarded"),
          'application.error.errorExtras': {
            sizePerField: JSON.stringify(sizePerField),
            originalEventCaseId: fields.eventCaseId
          }
        };
        this.track('error', errorFields, options);
      }
    }

    // Direct event track without handling fields
  }, {
    key: "track",
    value: function track(event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!this.isDisabled(event)) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info("Core: tracking event ".concat(event));
        this.sm.trigger(event, {
          data: data,
          options: options,
          analytics: this
        });
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core: feature ".concat(common_json_Categories_json__WEBPACK_IMPORTED_MODULE_18__[event], " is disabled"));
      }
    }
  }, {
    key: "prepareData",
    value: function prepareData(event, data) {
      var _this4 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].debug("Core: received data:\n".concat(JSON.stringify(data, null, 2)));
      var fields;
      var eventSpec = this.eventInput[event];
      if (eventSpec) {
        // check if event can actually have data
        fields = this.mapFields(event, data);
        var issuesList = options.messageQaIssues || [];
        Object.keys(fields).forEach(function (key) {
          var fieldRules = _this4.eventInput[event][key];
          // Force convert keys to string if field is type:string and value is not a string
          if (fieldRules.type === 'string' && typeof fields[key] !== 'string') {
            if (lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_7___default()(fields[key])) {
              fields[key] = JSON.stringify(fields[key]);
            } else {
              fields[key] = String(fields[key]);
            }
          }
          // Force convert object fields field is type:map and elementType:string and object fields are not strings
          else if (fieldRules.type === 'map' && fieldRules.elementType === 'string') {
            Object.keys(fields[key]).forEach(function (mapKey) {
              if (typeof fields[key][mapKey] !== 'string') {
                if (lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_7___default()(fields[key][mapKey])) {
                  fields[key][mapKey] = JSON.stringify(fields[key][mapKey]);
                } else {
                  fields[key][mapKey] = String(fields[key][mapKey]);
                }
              }
            });
          }

          // Remove all unknown subfields from maps
          // TEMP: errorExtras and custom as exceptions
          if (fieldRules.type === 'map' && !(key === 'application.error.errorExtras' || key === 'custom.message')) {
            Object.keys(fields[key]).forEach(function (subkey) {
              var subFieldPath = "".concat(key, ".").concat(subkey);
              if (!eventSpec[subFieldPath]) {
                issuesList.push("Invalid MAP field: ".concat(subFieldPath));
                  true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core:: Deleting unknown map field on event ".concat(event, ": ").concat(subFieldPath));
                delete fields[key][subkey];
              }
            });
          }
        });
        if (issuesList.length > 0) {
          fields['message.qa.issues'] = issuesList;
        }
      } else {
        fields = {};
      }
      if (Object.keys(this.eventFilters) && this.eventFilters[event]) {
        if (!this.checkEventFilterCondition(event, data)) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core:: Data for event ".concat(event, " did not pass filter rules, discarding event"));
          return undefined;
        }
      }
      this.applyBlacklists(event, fields);
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].debug("Core: prepared data:\n".concat(JSON.stringify(fields, null, 2)));
      return fields;
    }
  }, {
    key: "applyBlacklists",
    value: function applyBlacklists(event, fields) {
      var _this5 = this;
      Object.keys(fields).forEach(function (path) {
        var fieldBlacklists = _this5.eventInput[event][path] && _this5.eventInput[event][path].blacklists;
        if (fieldBlacklists) {
          fieldBlacklists.forEach(function (blacklistName) {
            return _this5.blacklists[blacklistName].forEach(function (blacklistValue) {
              var regexp = new RegExp(blacklistValue, 'i');

              // if field is an array -> check each item and replace individually
              if (Array.isArray(fields[path])) {
                fields[path] = fields[path].map(function (value) {
                  // eslint-disable-line no-param-reassign
                  if (regexp.test(JSON.stringify(value))) {
                    return '[REDACTED]';
                  }
                  return value;
                });
              }

              // if field is a map -> check key:value pairs and replace values
              else if (lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_7___default()(fields[path])) {
                Object.keys(fields[path]).forEach(function (key) {
                  if (regexp.test("".concat(key, ":").concat(JSON.stringify(fields[path][key])))) {
                      true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core:: Removing blacklisted value on ".concat(event, " for ").concat(path));
                    fields[path][key] = '[REDACTED]'; // eslint-disable-line no-param-reassign
                  }
                });
              }

              // else just replace the whole value
              else if (regexp.test(fields[path])) {
                  true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core:: Removing blacklisted value on ".concat(event, " for ").concat(path));
                fields[path] = '[REDACTED]'; // eslint-disable-line no-param-reassign
              }
            });
          });
        }
      });
    }
  }, {
    key: "mapFields",
    value: function mapFields(event, inputData) {
      var eventFields = this.eventInput[event];
      var paths = Object.keys(eventFields);
      /* eslint-disable no-param-reassign */
      var data = paths.reduce(function (result, path) {
        if (inputData[eventFields[path].quantumKey] !== undefined) {
          result[path] = inputData[eventFields[path].quantumKey];
        }
        return result;
      }, {});
      return data;
    }
  }, {
    key: "sendMessages",
    value: function sendMessages(messages) {
      // reset timer
      this.sendTimer.start();
      if (messages.length === 0) {
        // Nothing to send, just resolve instantly
        return;
      }
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: preparing bulk message to send');
      // generate a new bulk message
      var bulkMessage = Object(core_utils_messages__WEBPACK_IMPORTED_MODULE_15__["pack"])(messages, this.model.getData());
      if (this.bulkQueue.length > this.settings.maxBulkQueueSize - 1) {
        this.bulkQueue.shift();
      }
      this.bulkQueue.push({
        data: bulkMessage,
        id: Object(core_utils_uuid__WEBPACK_IMPORTED_MODULE_23__["default"])(),
        timestamp: Date.now()
      });
      this.saveState();
      this.sendBulkMessages();
    }
  }, {
    key: "sendBulkMessages",
    value: function sendBulkMessages() {
      var _this6 = this;
      if (this.settings.isOnline) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info("Core: ".concat(this.bulkQueue.length, " bulk messages in queue"));
        var now = Date.now();
        this.bulkQueue.forEach(function (msg) {
          if (now - msg.timestamp <= _this6.settings.bulkMessageTTL) {
              true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info("Core: sending bulk message to ".concat(_this6.settings.endpoint));
            _this6.handlePost(_this6.settings.endpoint, msg.data, msg.id, _this6.storage.internal.oAuthToken, _this6.storage.internal.tokenType);
          } else {
              true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning('Core: bulk message expired, discarding');
          }
        });
        this.bulkQueue = [];
        this.saveState();
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning('Core: Connection state set to false, skipping send');
      }
    }
  }, {
    key: "handlePost",
    value: function handlePost(url, data, id, token, tokenType) {
      var msg = {
        url: url,
        data: data,
        token: token,
        tokenType: tokenType
      };
      return core_utils_CollectorRequest__WEBPACK_IMPORTED_MODULE_20__["default"].send(msg, id, this.isUnloading);
    }
  }, {
    key: "flush",
    value: function () {
      var _flush = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.queue.flush();
                true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: Waiting for all pending requests to finish');
              _context.next = 4;
              return core_utils_CollectorRequest__WEBPACK_IMPORTED_MODULE_20__["default"].finishRequests();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function flush() {
        return _flush.apply(this, arguments);
      }
      return flush;
    }()
  }, {
    key: "isPlayback",
    value: function isPlayback(event) {
      return common_json_Categories_json__WEBPACK_IMPORTED_MODULE_18__[event] && (common_json_Categories_json__WEBPACK_IMPORTED_MODULE_18__[event] === 'playback' || common_json_Categories_json__WEBPACK_IMPORTED_MODULE_18__[event] === 'ads');
    }
  }, {
    key: "isFeatureFlowEvent",
    value: function isFeatureFlowEvent(event) {
      return event === 'pageViewInit' || lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(this.eventInput, [event, 'message.context']);
    }
  }, {
    key: "getStateToPersist",
    value: function getStateToPersist() {
      var allModelData = this.model.getData();
      var filteredModel = lodash_pick__WEBPACK_IMPORTED_MODULE_9___default()(allModelData, [
      // keep only relevant fields for persisting
      'domain', 'customer', 'visit', 'state.previousState', 'state.view', 'state.name', 'state.entryTimestamp']);
      filteredModel.state.name = 'navigating'; // reset state

      var appName = this.model.get('visit.applicationDetails.applicationName');
      var appType = this.model.get('visit.applicationDetails.applicationType');
      var stateToSave = {
        previousTabId: this.currentTabId,
        model: Object(core_utils_prune__WEBPACK_IMPORTED_MODULE_24__["default"])(filteredModel),
        settings: this.settings,
        features: this.features,
        sm: {
          current: 'navigating',
          ignored: this.sm.ignored
        },
        messageQueue: {
          buffer: Object(core_utils_prune__WEBPACK_IMPORTED_MODULE_24__["default"])(this.queue.buffer),
          currentSize: this.queue.currentSize
        },
        bulkQueue: this.bulkQueue,
        internalStorage: Object(core_utils_prune__WEBPACK_IMPORTED_MODULE_24__["default"])(this.storage.internal),
        messageId: this.messageId,
        platform: Object(core_utils_platform__WEBPACK_IMPORTED_MODULE_25__["default"])(appName, appType)
      };
      return stateToSave;
    }
  }, {
    key: "saveState",
    value: function saveState() {
      if (this.sm.current !== 'blank' && this.storage.persistenceEnabled) {
        // don't try to save before we initialized library
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: saving library state to storage');
        var persistedState = this.getStateToPersist();
        var platform = persistedState.platform;
        this.storage.session.set('library-state', JSON.stringify(persistedState));

        // get seed data
        var seedFields = ['visit.account', 'visit.device', 'visit.applicationDetails.appVersion', 'visit.applicationDetails.venonaVersion'];
        var seedData = lodash_pick__WEBPACK_IMPORTED_MODULE_9___default()(persistedState.model, seedFields);

        // Seed will have previous visit id from current visit id
        lodash_set__WEBPACK_IMPORTED_MODULE_5___default()(seedData, 'visit.previousVisitId', lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(persistedState.model, 'visit.visitId'));
        this.storage.permanent.set("library-state-".concat(platform), JSON.stringify(seedData), this.settings.storageDuration);
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].debug("Core: persisted data:\n".concat(JSON.stringify(persistedState, null, 2)));
      }
    }
  }, {
    key: "removeStoredState",
    value: function removeStoredState() {
      this.storage.session.reset('library-state');
      var appName = this.model.get('visit.applicationDetails.applicationName');
      var appType = this.model.get('visit.applicationDetails.applicationType');
      var platform = Object(core_utils_platform__WEBPACK_IMPORTED_MODULE_25__["default"])(appName, appType);
      this.storage.permanent.reset("library-state-".concat(platform));
    }
  }, {
    key: "getStoredState",
    value: function getStoredState(_ref) {
      var applicationName = _ref.applicationName,
        applicationType = _ref.applicationType;
      if (this.storage.persistenceEnabled) {
        var platform = Object(core_utils_platform__WEBPACK_IMPORTED_MODULE_25__["default"])(applicationName, applicationType);
        return {
          state: this.storage.session.get('library-state'),
          seed: this.storage.permanent.get("library-state-".concat(platform))
        };
      }
      return null;
    }

    // Load whole library state based on data from sessionStorage
  }, {
    key: "loadPersistedState",
    value: function loadPersistedState(rawState, newInitData, loadStateError) {
      var _this7 = this;
      var state = JSON.parse(rawState);
      var resumeAppVisitId = newInitData.resumeAppVisitId;

      // Check tabs only if there's no resumeAppVisitId
      if (resumeAppVisitId === undefined) {
        if (this.isDuplicateTab(state)) {
          loadStateError.message = "Unable to load state, mismatched tab ID. Old: ".concat(state.previousTabId, ", new: ").concat(this.currentTabId);
          loadStateError.type = 'tabId';
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core: ".concat(loadStateError.message));
          return false;
        }
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info("Core: tab ID matched, can resume ".concat(state.previousTabId, ", new: ").concat(this.currentTabId));
      } else {
        if (resumeAppVisitId !== state.model.visit.visitId) {
          loadStateError.message = "Unable to load state, resumeAppVisitId ".concat(resumeAppVisitId, " does not match saved visit ID ").concat(state.model.visit.visitId);
          loadStateError.type = 'resumeAppVisitId';
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core: ".concat(loadStateError.message));
          return false;
        }
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: resumeAppVisitId ID matched, can resume');
      }
      var savedAppVersion = state.model.visit.applicationDetails.appVersion;
      var savedAppName = state.model.visit.applicationDetails.applicationName;
      var savedLibraryVersion = state.model.visit.applicationDetails.venonaVersion;

      // TODO not sure if these are needed for sessionstorage
      if (
      // Check if library or app version changed on restoring state - if it did state is probably not valid anymore so discard it
      savedAppVersion === newInitData.appVersion && savedLibraryVersion === this.libraryVersion && (this.settings.verifyAppNameOnResume ? savedAppName === newInitData.applicationName : true)) {
        this.settings = state.settings;
        Object.entries(this.settings).forEach(function (_ref2) {
          var _ref3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, 2),
            name = _ref3[0],
            value = _ref3[1];
          if (_this7.onSetCallbacks[name]) {
            _this7.onSetCallbacks[name](value, value);
          }
        });
        this.features = state.features;
        this.sm.current = state.sm.current;
        this.sm.setIgnored(state.sm.ignored);
        this.queue.maxSize = state.settings.maxMessageSize;
        this.queue.buffer = state.messageQueue.buffer || [];
        this.queue.currentSize = state.messageQueue.currentSize;
        this.bulkQueue = state.bulkQueue;
        this.storage.setInternal(state.internalStorage);
        this.messageId = state.messageId;
        this.model.data = state.model;
        return true;
      }
      loadStateError.message = 'Unable to load state, application or analytics version changed';
      loadStateError.type = 'version';
      if (true) {
        core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core: ".concat(loadStateError.message));
        core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core: new application version [".concat(savedAppVersion, "] -> [").concat(newInitData.appVersion, "]"));
        core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core: new application name [".concat(savedAppName, "] -> [").concat(newInitData.applicationName, "]"));
        core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core: new analytics version [".concat(savedLibraryVersion, "] -> [").concat(this.libraryVersion, "]"));
      }
      return false;
    }

    // Load some seed values to model based on data from session storage
  }, {
    key: "loadSeedData",
    value: function loadSeedData(rawSeed, newInitData) {
      var seed = JSON.parse(rawSeed);
      var savedAppVersion = seed.visit.applicationDetails.appVersion;
      var savedLibraryVersion = seed.visit.applicationDetails.venonaVersion;
      if (
      // Check if library or app version changed on restoring state - if it did state is probably not valid anymore so discard it
      savedAppVersion === newInitData.appVersion && savedLibraryVersion === this.libraryVersion) {
        if (this.isReferrerValid()) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: referrer matches current domain, loading seed data');
          // app details was just for some metadata, not needed to seed
          delete seed.visit.applicationDetails;

          // delete passed previous visit ID from input data, we will use ours
          delete newInitData.previousVisitId;

          // Seed initial data values in model
          this.model.data = seed;
          return true;
        }
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: not loading seed data as referrer is different from current domain');
      } else if (true) {
        core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning('Core: discarding seed data because of mismatched versions');
        core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core: new application version [".concat(savedAppVersion, "] -> [").concat(newInitData.appVersion, "]"));
        core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].warning("Core: new analytics version [".concat(savedLibraryVersion, "] -> [").concat(this.libraryVersion, "]"));
      }
      return false;
    }
  }, {
    key: "isReferrerValid",
    value: function isReferrerValid() {
      // We only want to load seed data when we're reloading from the same app instance, so check if we have referrer
      if (typeof window === 'undefined' || typeof document === 'undefined' || !document.referrer) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: not loading seed data as there is no referrer');
        return false;
      }
      var refererDomain = document.referrer.split('/')[2];
      var activeDomain = window.location.href.split('/')[2];

      // Referrer must be the same as current domain, so don't reload if we navigated e.g. from SpecNet to IDM for auth
      if (refererDomain === activeDomain) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].debug("Core: referrer ".concat(refererDomain, " matches current domain ").concat(activeDomain));
        return true;
      }
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].debug("Core: referrer ".concat(refererDomain, " does not match current domain ").concat(activeDomain));
      return false;
    }

    // Chrome will copy sessionStorage for a duplicate tab, breaking the seed logic
    // We generate unique ID's per tab which should help distinguish between a refresh or a duplicate
  }, {
    key: "isDuplicateTab",
    value: function isDuplicateTab(state) {
      return this.currentTabId !== state.previousTabId;
    }
  }, {
    key: "checkFlushCondition",
    value: function checkFlushCondition(allRules, data) {
      // If no conditions provided it's always a match
      return allRules.length > 0 ?
      // Check if at least one rule matches
      allRules.some(function (rule) {
        return Object.keys(rule).every(function (rulePath) {
          // One rule can have multiple conditions, all should match
          var isInverted = rulePath[0] === '!';
          var path = isInverted ? rulePath.slice(1) : rulePath;
          var value = data[path];

          // !field: [A, B] => !A && !B
          if (isInverted) {
            return rule[rulePath].every(function (ruleValue) {
              return value !== ruleValue;
            });
          }
          // field: [A, B] => A || B
          return rule[rulePath].some(function (ruleValue) {
            return value === ruleValue;
          });
        });
      }) : true;
    }
  }, {
    key: "checkEventFilterCondition",
    value: function checkEventFilterCondition(event, data) {
      var _this8 = this;
      var allRules = this.eventFilters[event];
      // Check if at least one rule matches
      return !allRules.some(function (rule) {
        return Object.keys(rule).every(function (path) {
          // One rule can have multiple conditions, all should match
          var key = _this8.eventInput[event][path].quantumKey;
          var value = data[key];
          return rule[path].some(function (ruleValue) {
            return value === ruleValue;
          });
        });
      });
    }
  }, {
    key: "setupListeners",
    value: function setupListeners() {
      var _this9 = this;
      if (typeof window !== 'undefined') {
        if (window.performance) {
          if (document.readyState === 'complete') {
              true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: page already loaded, saving page performance timing');
            this.reportPageLoadPerformance();
          } else {
              true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: waiting for page to load to save performance timing');
            window.addEventListener('load', this.reportPageLoadPerformance.bind(this));
          }
        }
        // If we support fetch we can make use of keepalive for sending data on unloading pages
        if (core_utils_post__WEBPACK_IMPORTED_MODULE_21__["canUseFetch"]) {
          // Seems to work more reliably depending on browser
          var isChrome = typeof navigator !== 'undefined' && navigator.userAgent.match(/Chrom(e|ium)/);
          window.addEventListener(isChrome ? 'pagehide' : 'beforeunload', function () {
              true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: flushing messages before page unload');
            _this9.isUnloading = true;
            _this9.flush();
          });
        }
        Object(web_vitals__WEBPACK_IMPORTED_MODULE_11__["onLCP"])(this.handleWebVitals, {
          reportAllChanges: this.cwvVerbose
        });
        Object(web_vitals__WEBPACK_IMPORTED_MODULE_11__["onINP"])(this.handleWebVitals, {
          reportAllChanges: this.cwvVerbose
        });
        Object(web_vitals__WEBPACK_IMPORTED_MODULE_11__["onCLS"])(this.handleWebVitals, {
          reportAllChanges: this.cwvVerbose
        });
      }
    }
  }, {
    key: "reportPageLoadPerformance",
    value: function reportPageLoadPerformance() {
      var timing = window.performance.timing;
      if (timing) {
        if (this.storage.internal.onPage) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info('Core: initial pageView tracked and have performance timing object, reporting performance event');
          var fields = {
            'message.eventCaseId': "generic_pageViewPerformance_".concat("video"),
            'message.triggeredBy': 'analytics',
            'state.view.currentPage.performanceTiming': lodash_pickBy__WEBPACK_IMPORTED_MODULE_8___default()(timing, function (value) {
              return value && typeof value === 'number';
            }),
            'operation.operationType': 'domComplete'
          };
          this.track('pageViewPerformance', fields);
        } else {
          this.storage.internal.performanceTiming = timing;
        }
      }
    }
  }, {
    key: "reportBatchApiCalls",
    value: function reportBatchApiCalls() {
      var _this10 = this;
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info("Core: tracking ".concat(Object.keys(this.storage.internal.batchApiCalls).length, " batchApiCalls"));
      Object.values(this.storage.internal.batchApiCalls).forEach(function (batchItem) {
        var fields = batchItem.fields,
          apis = batchItem.apis,
          count = batchItem.count;
        var data = _this10.prepareData('batchApiCall', fields);
        if (data) {
          data['operation.intValue'] = count;
          data['application.api.apis'] = apis;
          _this10.track('batchApiCall', data);
        }
      });
      this.storage.internal.batchApiCalls = {};
      this.batchApiTimer.stop();
    }
  }, {
    key: "handleWebVitals",
    value: function handleWebVitals(data) {
      if (this.settings.cwvEnabled) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_17__["default"].info("Core: tracking Core Web Vitals event ".concat(data.name));
        var fields = {
          'message.eventCaseId': "generic_pageViewPerformance_".concat("video"),
          'message.triggeredBy': 'analytics',
          'operation.operationType': 'cwvEvent',
          'message.event.eventLabel': data.name,
          'operation.additionalInformation': String(data.value)
        };
        this.track('pageViewPerformance', fields);
      }
    }
  }]);
  return AnalyticsCore;
}();
/* harmony default export */ __webpack_exports__["default"] = (AnalyticsCore);

/***/ }),

/***/ "./src/core/AnalyticsStorage.js":
/*!**************************************!*\
  !*** ./src/core/AnalyticsStorage.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lodash/isPlainObject */ "./node_modules/lodash/isPlainObject.js");
/* harmony import */ var lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");
/* harmony import */ var core_utils_storage_PersistedStorage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core/utils/storage/PersistedStorage */ "./src/core/utils/storage/PersistedStorage.js");






var AnalyticsStorage = /*#__PURE__*/function () {
  function AnalyticsStorage() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, AnalyticsStorage);
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "internal", {});
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "persistenceEnabled", false);
    this.useDefaultPersisted();
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(AnalyticsStorage, [{
    key: "useDefaultPersisted",
    value: function useDefaultPersisted() {
      this.session = new core_utils_storage_PersistedStorage__WEBPACK_IMPORTED_MODULE_5__["default"](true);
      this.permanent = new core_utils_storage_PersistedStorage__WEBPACK_IMPORTED_MODULE_5__["default"]();
    }
  }, {
    key: "setCustomPersisted",
    value: function setCustomPersisted(storageObj) {
        true && this.checkStorage(storageObj);
      this.session = storageObj;
      this.permanent = storageObj;
    }
  }, {
    key: "enablePersistence",
    value: function enablePersistence() {
      this.persistenceEnabled = true;
    }
  }, {
    key: "disablePersistence",
    value: function disablePersistence() {
      this.persistenceEnabled = false;
    }
  }, {
    key: "checkStorage",
    value: function checkStorage(storageObj) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info('Storage: checking provided storage object');
      var testKey = "key-".concat(Date.now());
      var testValue = "value-".concat(Date.now());
      storageObj.set(testKey, testValue);
      if (storageObj.get(testKey) !== testValue) {
        throw new Error('Storage: provided storage object API not working');
      }
      storageObj.reset(testKey);
      if (storageObj.get(testKey) !== null) {
        throw new Error('Storage: provided storage object API not working');
      }
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info('Storage: provided storage object is valid');
    }
  }, {
    key: "setInternal",
    value: function setInternal(data) {
      if (lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_3___default()(data)) {
        this.internal = data;
      }
    }
  }]);
  return AnalyticsStorage;
}();
/* harmony default export */ __webpack_exports__["default"] = (AnalyticsStorage);

/***/ }),

/***/ "./src/core/BaseAnalytics.js":
/*!***********************************!*\
  !*** ./src/core/BaseAnalytics.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lodash/cloneDeep */ "./node_modules/lodash/cloneDeep.js");
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_difference__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lodash/difference */ "./node_modules/lodash/difference.js");
/* harmony import */ var lodash_difference__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_difference__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lodash/isPlainObject */ "./node_modules/lodash/isPlainObject.js");
/* harmony import */ var lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_AnalyticsCore__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core/AnalyticsCore */ "./src/core/AnalyticsCore.js");
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");
/* harmony import */ var core_utils_uuid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core/utils/uuid */ "./src/core/utils/uuid.js");








function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





/**
 * Common analytics API's
 * @typicalname analytics
*/
var BaseAnalytics = /*#__PURE__*/function () {
  function BaseAnalytics(callbacks, specs, onSetHandlers) {
    var _this = this;
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, BaseAnalytics);
    this.callbacks = callbacks;
    this.specs = specs;
    this.onSetHandlers = onSetHandlers;
    this.core = new core_AnalyticsCore__WEBPACK_IMPORTED_MODULE_9__["default"](callbacks, specs, onSetHandlers);
    this.log = core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"];

    // export app related error codes
    this.errorCodes = this.core.errorCodes.application;

    // event API
    var inputEvents = Object.keys(specs.input);
    var outputEvents = Object.keys(specs.output);

    // Events that are handled differently
    var eventsExceptionList = ['pageView'];
    var setterExceptionList = [];
    var eventNames = lodash_difference__WEBPACK_IMPORTED_MODULE_6___default()(outputEvents, eventsExceptionList);
    this.setterNames = lodash_difference__WEBPACK_IMPORTED_MODULE_6___default()(inputEvents, outputEvents, setterExceptionList);

    // Add events to analytics API
    eventNames.forEach(function (eventName) {
      if (!_this[eventName]) {
        // don't overwrite
        _this[eventName] = function (fields, options) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info("API: ".concat(eventName));
          _this.core.handleEvent(eventName, fields, options);
        };
      }
    });

    // Add setters to analytics API
    this.setterNames.forEach(function (setterName) {
      if (!_this[setterName]) {
        // don't overwrite
        _this[setterName] = function (fields) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info("API: ".concat(setterName));
          _this.core.handleSet(setterName, fields);
        };
      }
    });
  }

  /**
  * Fetch parameter value from library settings
  * @param {string} param - parameter name
  * @returns {string|int} parameter value
  */
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(BaseAnalytics, [{
    key: "get",
    value: function get(param) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: get');
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: ".concat(param, " is equal to ").concat(this.core.get(param)));
      return this.core.get(param);
    }

    /**
    * Fetch model value by full path
    * @param {string} path - full Quantum path
    * @returns {any} field value
    */
  }, {
    key: "getValueForPath",
    value: function getValueForPath(path) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: getValueForPath');
      var value = this.core.model.get(path);
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: model ".concat(path, " value is ").concat(value));
      return value;
    }

    /**
    * Find full field path for Quantum key
    * @param {string} key - Quantum key
    * @param {string} event - Event name
    * @returns {string} Full path
    */
  }, {
    key: "getPathFromQuantumKey",
    value: function getPathFromQuantumKey(key, event) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: getPathFromQuantumKey');
      var eventFields = this.core.eventInput[event];
      if (!eventFields) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("API: Unknown event ".concat(event));
        return undefined;
      }
      var found = Object.entries(eventFields).find(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref, 2),
          field = _ref2[1];
        return field.quantumKey === key;
      });
      if (found) {
        var path = found[0];
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: path for key ".concat(key, " is ").concat(path));
        return path;
      }
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("API: Unknown key ".concat(key));
      return undefined;
    }

    /**
    * Find full field path for Unified key
    * @param {string} key - Unified key
    * @param {string} event - Event name
    * @returns {string} Full path
    */
  }, {
    key: "getPathFromUnifiedKey",
    value: function getPathFromUnifiedKey(key, event) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: getPathFromUnifiedKey');
      var eventFields = this.core.eventInput[event];
      if (!eventFields) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("API: Unknown event ".concat(event));
        return undefined;
      }
      var found = Object.entries(eventFields).find(function (_ref3) {
        var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref3, 2),
          field = _ref4[1];
        return field.unifiedKey === key;
      });
      if (found) {
        var path = found[0];
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: path for key ".concat(key, " is ").concat(path));
        return path;
      }
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("API: Unknown key ".concat(key));
      return undefined;
    }

    /**
    * Find Quantum key based on full path
    * @param {string} path - Full Quantum path
    * @param {string} event - Event name
    * @returns {string} Quantum key
    */
  }, {
    key: "getQuantumKeyForPath",
    value: function getQuantumKeyForPath(path, event) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: getQuantumKeyForPath');
      var eventFields = this.core.eventInput[event];
      if (!eventFields) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("API: Unknown event ".concat(event));
        return undefined;
      }
      var fieldData = eventFields[path];
      if (fieldData) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: key for path ".concat(path, " is ").concat(fieldData.quantumKey));
        return fieldData.quantumKey;
      }
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("API: Unknown path ".concat(path));
      return undefined;
    }

    /**
    * Find Unified key based on full path
    * @param {string} path - Full Unified path
    * @param {string} event - Event name
    * @returns {string} Unified key
    */
  }, {
    key: "getUnifiedKeyForPath",
    value: function getUnifiedKeyForPath(path, event) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: getUnifiedKeyForPath');
      var eventFields = this.core.eventInput[event];
      if (!eventFields) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("API: Unknown event ".concat(event));
        return undefined;
      }
      var fieldData = eventFields[path];
      if (fieldData) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: key for path ".concat(path, " is ").concat(fieldData.unifiedKey));
        return fieldData.unifiedKey;
      }
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("API: Unknown path ".concat(path));
      return undefined;
    }

    /**
    * Set parameter value to library settings
    * @param {string} param - parameter name
    * @param {string} value - parameter value
    */
  }, {
    key: "set",
    value: function set(param, value) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: set');
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: setting ".concat(param, " to ").concat(value));
      this.core.set(param, value);
    }

    /**
    * Enable or disable certain analytics features
    * @deprecated
    * @param {object.<string, bool>} config
    * @example setFeatures({ playback: true, login: true, navigation: true, select: false, search: false, ad: true, error: true, api: true })
    */
  }, {
    key: "setFeatures",
    value: function setFeatures(config) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: setFeatures');
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: setting features ".concat(JSON.stringify(config)));
      this.core.setFeatures(config);
    }

    /**
    * Set rules for ignoring events in certain states
    * @deprecated
    * @param {object.<string, string[]>} rules
    * @example addIgnoredEvents({ scrubbing: ['playbackPause'] })
    * @returns {bool} shows if rules were successfuly set
    */
  }, {
    key: "addIgnoredEvents",
    value: function addIgnoredEvents(rules) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: addIgnoredEvents');
      if (lodash_isPlainObject__WEBPACK_IMPORTED_MODULE_7___default()(rules) && Object.keys(rules).every(function (stateName) {
        return Array.isArray(rules[stateName]) && rules[stateName].every(function (event) {
          return typeof event === 'string';
        });
      })) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: adding ignore rules ".concat(JSON.stringify(rules)));
        this.core.sm.setIgnored(rules);
        return true;
      }
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("API: Invalid config for ignored events - ".concat(JSON.stringify(rules)));
      return false;
    }

    /**
    * Set rules for ignoring events with certain values
    * @deprecated
    * @param {object.<string, object[]>} rules
    * @example
    *  setEventFilters({
    *    'apiCall': [
    *      {
    *        'application.api.path': ['/api/services/oauth'],
    *        'application.api.responseCode': [200, 201, 202],
    *      },
    *      {
    *        'application.api.path': ['/api/services/timezone'],
    *        'application.api.responseCode': [404],
    *      }
    *    ]
    *  )
    */
  }, {
    key: "setEventFilters",
    value: function setEventFilters(conf) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: setEventFilters');
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: setting event filter rules ".concat(JSON.stringify(conf)));
      this.core.setEventFilters(conf);
    }

    /**
    * Get the current state from the state machine
    * @returns {string} current state
    */
  }, {
    key: "getCurrentLibraryState",
    value: function getCurrentLibraryState() {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: getCurrentLibraryState');
      return this.core.sm.current;
    }

    /**
    * Get the list of events that could be tracked in current state
    * @returns {string} current state
    */
  }, {
    key: "getNextEvents",
    value: function getNextEvents() {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: getNextEvents');
      return this.core.sm.getNextEvents();
    }

    /**
    * Check if event can be tracked in current state
    * @returns {bool}
    */
  }, {
    key: "isValidEventForCurrentState",
    value: function isValidEventForCurrentState(eventName) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: isValidEventForCurrentState');
      return this.core.sm.can(eventName);
    }

    /**
    * Get the current visitId
    * @returns {string} visitId
    */
  }, {
    key: "getVisitId",
    value: function getVisitId() {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: getVisitId');
      return this.core.model.get('visit.visitId');
    }

    /**
    * Generate visitID in SDK format
    * @param {string} domain - domain for the visit, will default to value from internal state if present or the SDK type if not
    * @returns {string} visitId
    */
  }, {
    key: "generateVisitId",
    value: function generateVisitId(domain) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: generateVisitId');
      return Object(core_utils_uuid__WEBPACK_IMPORTED_MODULE_11__["generateVisitId"])(domain || this.core.model.get('domain') || "video");
    }

    /**
    * Get the currently active experiments
    * @returns {object} list of experiment and variant ID's
    */
  }, {
    key: "getExperimentConfigurations",
    value: function getExperimentConfigurations() {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: getExperimentConfigurations');
      return {
        experimentUuids: lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5___default()(this.core.model.get('visit.experimentUuids')),
        variantUuids: lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5___default()(this.core.model.get('visit.variantUuids'))
      };
    }

    /**
    * Get list of available set methods
    * @returns {string[]} setter names
    */
  }, {
    key: "getSetterNames",
    value: function getSetterNames() {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: getSetterNames');
      return this.setterNames;
    }

    /**
    * Force flush the message queue
    * Returns a promise which resolves after all the events are sent out, regardless of success/fail state
    * NOTE: avoid waiting for promise in blocking scenarios such as 'oneRetry'
    */
  }, {
    key: "flush",
    value: function () {
      var _flush = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
                true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: flush');
              if (this.core.storage.internal.batchApiCalls && Object.keys(this.core.storage.internal.batchApiCalls).length > 0) {
                  true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: also flushing all stored batchApiCall events');
                this.core.reportBatchApiCalls();
              }
              _context.next = 4;
              return this.core.flush();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function flush() {
        return _flush.apply(this, arguments);
      }
      return flush;
    }()
    /**
    * Enable library state persistence (local storage by default)
    */
  }, {
    key: "enablePersistence",
    value: function enablePersistence() {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: enablePersistence');
      this.core.storage.enablePersistence();
    }

    /**
    * Disable library state persistence and remove the stored state
    */
  }, {
    key: "disablePersistence",
    value: function disablePersistence() {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: disablePersistence');
      this.core.removeStoredState();
      this.core.storage.disablePersistence();
    }

    /**
    * Add custom persistent storage object to library
    * @param {object} storage object that provides persistence API
    * @throws {Error} Will throw an error in development mode if storage API's are not working
    */
  }, {
    key: "setCustomStorage",
    value: function setCustomStorage(storageObj) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: setCustomStorage');
      this.core.storage.setCustomPersisted(storageObj);
    }

    /**
    * Remove custom persistent storage object from library and revert to local storage
    */
  }, {
    key: "removeCustomStorage",
    value: function removeCustomStorage() {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: removeStorage');
      this.core.storage.useDefaultPersisted();
    }

    /**
    * Restart any in progress flow (e.g. tvod, stream2, etc).
    */
  }, {
    key: "restartFlow",
    value: function restartFlow() {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: restartFlow');
      delete this.core.currentFlow;
      this.core.model.reset('message.feature');
    }

    /**
    * Turn off the library
    */
  }, {
    key: "stop",
    value: function stop() {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: stop');
      this.core.sendTimer.stop();
      this.core.heartBeatTimer.stop();
      this.core.batchApiTimer.stop();
      this.core.removeStoredState();
      this.core = new core_AnalyticsCore__WEBPACK_IMPORTED_MODULE_9__["default"](this.callbacks, this.specs, this.onSetHandlers);
    }

    /**
    * Initialize library and track startSession event. Alias for init
    * @param {object} fields
    * @param {long} [options.timestamp]
    */
  }, {
    key: "startSession",
    value: function startSession(fields, options) {
      this.init(fields, options);
    }

    /**
    * Initialize library and track startSession event
    * @param {object} fields
    * @param {long} [options.timestamp]
    */
  }, {
    key: "init",
    value: function init(fields) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: init');
      if (this.getCurrentLibraryState() !== this.core.sm.initial) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].error('API: tried to initialize already running analytics');
        throw new Error('Tried to initialize already running analytics');
      }
      var savedState = this.core.getStoredState(fields);
      this.core.currentTabId = options.currentTabId;
      var loadStateError = {};
      var shouldTrackStartSession = false;
      if (savedState && (savedState.state || savedState.seed)) {
        // Resume session
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: resumeSession');
        // Try to load state first
        if (savedState.state && this.core.loadPersistedState(savedState.state, fields, loadStateError)) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: restored saved session');
          // If we resumed session we still want a visit ID notification even if it didn't change
          if (typeof window !== 'undefined' && window.document) {
            var visitId = this.core.model.get('visit.visitId');
            var browserEvent = new CustomEvent('quantumVisitIdSet', {
              detail: visitId
            });
            document.dispatchEvent(browserEvent);
          }
        }
        // If not successful try seed data
        else {
          shouldTrackStartSession = true;
          if (savedState.seed && this.core.loadSeedData(savedState.seed, fields)) {
              true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: seeding new session with saved data');
          } else {
              true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning('API: could not resume, tracking fresh session');
          }
          if (fields.resumeAppVisitId && !savedState.state) {
            loadStateError.message = "resumeAppVisitId ".concat(fields.resumeAppVisitId, " provided but no saved state found");
            loadStateError.type = 'noState';
              true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("Core: ".concat(loadStateError));
          }
        }
      } else {
        shouldTrackStartSession = true;
      }
      if (shouldTrackStartSession) {
        if (loadStateError.message) {
          var messageQaIssues = ["".concat(loadStateError.type, "|").concat(loadStateError.message)];
          // eslint-disable-next-line no-param-reassign
          options = _objectSpread(_objectSpread({}, options), {}, {
            messageQaIssues: messageQaIssues
          });
        }
        this.core.handleEvent('startSession', fields, options);
      }
      this.core.setupListeners();
      this.core.sendTimer.start();
    }

    /**
    * Track pageViewInit event
    * @ignore
    * @param {object} fields
    * @param {long} [options.timestamp]
    */
  }, {
    key: "pageViewInit",
    value: function pageViewInit(fields) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: pageViewInit');
      var renderDetails = this.core.model.get('state.view.currentPage.renderDetails');
      if (renderDetails) {
        var currentViewRenderedStatus = renderDetails.viewRenderedStatus;
        var finishedRenderStatuses = ['complete', 'timeout', 'completeWithError', 'temporary'];
        var isPageLoading = !finishedRenderStatuses.includes(renderDetails.viewRenderedStatus);
        if (renderDetails.renderInitTimestamp !== undefined && currentViewRenderedStatus === 'completeAwaitingAction') {
          this.core.track('temporaryView', {
            'message.eventCaseId': "generic_temporaryView_".concat("video")
          }, options);
        } else if (renderDetails.renderInitTimestamp !== undefined && isPageLoading) {
          // NOTE: both error and recovery pageView need persistFeature:true not to break feature flow!
          var errorFields = {
            'message.triggeredBy': 'analytics',
            'message.eventCaseId': "generic_error_".concat("video"),
            'application.error.errorType': 'analytics',
            'application.error.errorCode': this.core.errorCodes.internal.duplicatePageViewInit,
            'application.error.errorMessage': 'Received consecutive pageViewInit events. The SDK is injecting a pageView event to maintain the correct state. Please review the event flow to ensure proper event sequencing.',
            'message.persistFeature': true
          };
          this.core.track('error', errorFields, options);
          this.core.track('pageView', {
            'message.triggeredBy': 'analytics',
            'message.category': 'navigation',
            'message.eventCaseId': "generic_pageView_recovery_".concat("video"),
            'message.persistFeature': true
          }, options);
        }
      }
      this.core.handleEvent('pageViewInit', fields, options);
    }

    /**
    * Track pageViewPartiallyRendered event
    * @ignore
    * @param {long} [options.timestamp]
    */
  }, {
    key: "pageViewPartiallyRendered",
    value: function pageViewPartiallyRendered() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: pageViewPartiallyRendered');
      var renderStatus = this.core.model.get('state.view.currentPage.renderDetails.viewRenderedStatus');
      if (renderStatus === 'noRender') {
        this.core.track('pageViewPartiallyRendered', {}, _objectSpread(_objectSpread({}, options), {}, {
          noMessage: true
        }));
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("API: discarding pageViewPartiallyRendered received in invalid render state '".concat(renderStatus, "'"));
      }
    }

    /**
    * Track pageViewCompleteAwaitingAction event
    * @ignore
    * @param {long} [options.timestamp]
    */
  }, {
    key: "pageViewCompleteAwaitingAction",
    value: function pageViewCompleteAwaitingAction(fields) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: pageViewCompleteAwaitingAction');
      this.core.track('pageViewCompleteAwaitingAction', {}, _objectSpread(_objectSpread({}, options), {}, {
        noMessage: true
      }));
    }

    /**
    * Track pageViewCompleted event
    * @ignore
    * @param {object} fields
    * @param {long} [options.timestamp]
    */
  }, {
    key: "pageViewCompleted",
    value: function pageViewCompleted() {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: pageViewCompleted');

      // Context has to be set here, too late to set it in callback
      var context = fields.context || this.core.storage.internal.pageViewContext;
      this.core.handleEvent('pageView', _objectSpread(_objectSpread({}, fields), {}, {
        context: context
      }), _objectSpread(_objectSpread({}, options), {}, {
        pageViewStatus: 'complete'
      }));
    }

    /**
    * Track pageViewTimeout event
    * @ignore
    * @param {object} fields
    * @param {long} [options.timestamp]
    */
  }, {
    key: "pageViewTimeout",
    value: function pageViewTimeout(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: pageViewTimeout');

      // Context has to be set here, too late to set it in callback
      var context = fields.context || this.core.storage.internal.pageViewContext;
      this.core.handleEvent('pageView', _objectSpread(_objectSpread({}, fields), {}, {
        context: context
      }), _objectSpread(_objectSpread({}, options), {}, {
        pageViewStatus: 'timeout'
      }));
    }
  }, {
    key: "impressionStop",
    value: function impressionStop(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: impressionStop');
      var impressionId = [fields.impressionLocation, fields.impressionId, fields.impressionLocationTmsGuideId].filter(function (val) {
        return val;
      }).join('|');
      if (!impressionId) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning('API: no valid impression id');
        return;
      }
      if (this.core.storage.internal.impression && this.core.storage.internal.impression[impressionId]) {
        this.core.handleEvent('impressionStop', fields, options);
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].warning("API: impressionStop for id [".concat(impressionId, "] already triggered or no matching impressionStart found"));
      }
    }
  }, {
    key: "batchApiCall",
    value: function batchApiCall(fields) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: batchApiCall');
      var batchApiCallId = [fields.host, fields.path, fields.responseCode, fields.httpVerb].filter(function (val) {
        return val;
      }).join('|');
      if (!batchApiCallId) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].error('API: no valid batch API call id');
        return;
      }

      // TODO: maybe default to {} on setup
      if (!this.core.storage.internal.batchApiCalls) {
        this.core.storage.internal.batchApiCalls = {};
      }
      var batchEntry = {
        timestamp: Date.now(),
        queryParameters: fields.queryParameters,
        responseTimeMs: fields.responseTimeMs,
        traceId: fields.traceId,
        apiCached: fields.apiCached
      };
      if (this.core.storage.internal.batchApiCalls && this.core.storage.internal.batchApiCalls[batchApiCallId]) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: incrementing batch API count for ID ".concat(batchApiCallId));
        this.core.storage.internal.batchApiCalls[batchApiCallId].apis.push(batchEntry);
        this.core.storage.internal.batchApiCalls[batchApiCallId].count = this.core.storage.internal.batchApiCalls[batchApiCallId].apis.length;
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].debug("API: new batch API for ID ".concat(batchApiCallId));
        var filteredFields = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5___default()(fields);
        delete filteredFields.queryParameters;
        delete filteredFields.queryparameters;
        this.core.storage.internal.batchApiCalls[batchApiCallId] = {
          fields: filteredFields,
          apis: [batchEntry],
          count: 1
        };
      }

      // If handling special video batch api - save initial values for state.content
      if (fields.operationType === 'contentBatchApi' && this.core.storage.internal.stateContentAtBatchStart === undefined) {
        this.core.storage.internal.stateContentAtBatchStart = this.core.model.get('state.content');
      }
      if (!this.core.batchApiTimer.isRunning()) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: starting batch API call timer');
        this.core.batchApiTimer.start();
      }
    }
  }, {
    key: "subModalView",
    value: function subModalView(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: subModalView');
      var openSubModals = this.core.model.get('state.view.subModal.openModalNames') || [];
      if (!openSubModals.includes(fields.subModalName)) {
        this.core.handleEvent('subModalView', fields, options);
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].error("API: submodal with name ".concat(fields.subModalName, " already opened"));
      }
    }
  }, {
    key: "subModalClose",
    value: function subModalClose(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].info('API: subModalClose');
      var openSubModals = this.core.model.get('state.view.subModal.openModalNames') || [];
      // If no name passed just check for empty list
      // Otherwise check if current list includes closing modal
      if (fields.subModalName === undefined && openSubModals.length > 0 || openSubModals.includes(fields.subModalName)) {
        this.core.handleEvent('subModalClose', fields, options);
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_10__["default"].error("API: submodal with name ".concat(fields.subModalName, " already closed or was never opened"));
      }
    }
  }]);
  return BaseAnalytics;
}();
/* harmony default export */ __webpack_exports__["default"] = (BaseAnalytics);

/***/ }),

/***/ "./src/core/model.js":
/*!***************************!*\
  !*** ./src/core/model.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Model; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lodash/get */ "./node_modules/lodash/get.js");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash/set */ "./node_modules/lodash/set.js");
/* harmony import */ var lodash_set__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_set__WEBPACK_IMPORTED_MODULE_4__);





var Model = /*#__PURE__*/function () {
  function Model() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Model);
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "data", {});
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Model, [{
    key: "set",
    value: function set(path, value) {
      lodash_set__WEBPACK_IMPORTED_MODULE_4___default()(this.data, path, value);
    }
  }, {
    key: "get",
    value: function get(path) {
      return lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(this.data, path);
    }
  }, {
    key: "reset",
    value: function reset(path) {
      lodash_set__WEBPACK_IMPORTED_MODULE_4___default()(this.data, path, undefined);
    }
  }, {
    key: "batchSet",
    value: function batchSet(data) {
      var _this = this;
      var fullPaths = Object.keys(data);
      fullPaths.forEach(function (path) {
        _this.set(path, data[path]);
      });
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }]);
  return Model;
}();


/***/ }),

/***/ "./src/core/utils/CollectorRequest.js":
/*!********************************************!*\
  !*** ./src/core/utils/CollectorRequest.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_utils_post__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core/utils/post */ "./src/core/utils/post.js");
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");






var CollectorRequest = /*#__PURE__*/function () {
  function CollectorRequest() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, CollectorRequest);
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(CollectorRequest, [{
    key: "init",
    value: function init(settings) {
      this.pendingRequests = {};
      this.config(settings);
    }
  }, {
    key: "config",
    value: function config(settings) {
      this.sendRetryInterval = settings.sendRetryInterval;
      // Cap to 5
      this.sendRetryCount = Math.min(settings.sendRetryCount, 5);
      this.sendTimeout = settings.sendTimeout;
      this.forceXHR = settings.forceXHR;
    }
  }, {
    key: "send",
    value: function send(msg, messageId, isUnloading) {
      var _this = this;
      var retryAttempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_5__["default"].debug("CollectorRequest: posting data: id ".concat(messageId, "\n").concat(JSON.stringify(msg, null, 2)));
      var promise = Object(core_utils_post__WEBPACK_IMPORTED_MODULE_4__["default"])(msg, this.sendTimeout, isUnloading, this.forceXHR);
      var postId = retryAttempt > 0 ? "".concat(messageId, "_retry_").concat(retryAttempt) : messageId;
      // save to list of active requests
      this.pendingRequests[postId] = promise;
      promise["catch"](function (responseCode) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_5__["default"].warning("CollectorRequest: Posting data for message id ".concat(messageId, " failed. Response code:\n ").concat(responseCode));
        // Assume anything 0 is a network error or timeout, since we don't know more
        // https://bugs.chromium.org/p/chromium/issues/detail?id=718447
        // https://jira.charter.com/browse/PICA-5143

        // Don't retry is page is unloading, that won't work anyway
        if (isUnloading) {
          return;
        }
        if (responseCode === 0 || responseCode === 460 || responseCode === 408 || responseCode >= 500) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_5__["default"].info("CollectorRequest: Retrying to post data for message id ".concat(messageId, " in ").concat(_this.sendRetryInterval / 1000, " seconds"));

          // eslint-disable-next-line no-param-reassign
          retryAttempt++;
          if (retryAttempt <= _this.sendRetryCount) {
            setTimeout(function () {
              _this.send(msg, messageId, isUnloading, retryAttempt);
            }, _this.sendRetryInterval);
          }
        }
      })["finally"](function () {
        // after request fails or succeeds remove it from list of active requests
        delete _this.pendingRequests[postId];
      });
    }
  }, {
    key: "finishRequests",
    value: function () {
      var _finishRequests = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.allSettled(Object.values(this.pendingRequests));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function finishRequests() {
        return _finishRequests.apply(this, arguments);
      }
      return finishRequests;
    }()
  }]);
  return CollectorRequest;
}();
/* harmony default export */ __webpack_exports__["default"] = (new CollectorRequest());

/***/ }),

/***/ "./src/core/utils/Logger.js":
/*!**********************************!*\
  !*** ./src/core/utils/Logger.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);



/* eslint-disable no-console */

var levels = {
  debug: 0,
  info: 10,
  warning: 20,
  error: 30,
  critical: 40
};
var levelNames = {
  debug: 'DEBUG',
  info: 'INFO',
  warning: 'WARNING',
  error: 'ERROR',
  critical: 'CRITICAL'
};
var consoleFunctions = {
  debug: console.log.bind(console),
  info: console.log.bind(console),
  warning: console.warn ? console.warn.bind(console) : console.log.bind(console),
  error: console.error ? console.error.bind(console) : console.log.bind(console),
  critical: console.error ? console.error.bind(console) : console.log.bind(console)
};
var Logger = /*#__PURE__*/function () {
  function Logger() {
    var _this = this;
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Logger);
    this._level = levels.info;
    Object.entries(levels).forEach(function (_ref) {
      var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref, 1),
        key = _ref2[0];
      _this[key] = function (message) {
        return _this.write(key, message);
      };
    });
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Logger, [{
    key: "setLevel",
    value: function setLevel(level) {
      if (level in levels) {
        this._level = levels[level];
      }
    }
  }, {
    key: "setCustomHandler",
    value: function setCustomHandler(callback) {
      this.logHandler = callback;
    }
  }, {
    key: "clearCustomHandler",
    value: function clearCustomHandler() {
      this.logHandler = undefined;
    }
  }, {
    key: "write",
    value: function write(level, message) {
      if (levels[level] >= this._level) {
        var timestamp = new Date().toISOString();
        var levelName = levelNames[level];
        if (this.logHandler) {
          this.logHandler(timestamp, levelName, message);
        } else {
          consoleFunctions[level]("[".concat(timestamp, "] (").concat(levelName, ") Analytics::").concat(message));
        }
      }
    }
  }]);
  return Logger;
}();
/* harmony default export */ __webpack_exports__["default"] = (new Logger());

/***/ }),

/***/ "./src/core/utils/MessageQueue.js":
/*!****************************************!*\
  !*** ./src/core/utils/MessageQueue.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");



var Queue = /*#__PURE__*/function () {
  function Queue(maxSize, onFlushCallback) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Queue);
    this.onFlush = onFlushCallback;
    this.buffer = [];
    this.currentSize = 0;
    this.maxSize = maxSize;
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Queue, [{
    key: "push",
    value: function push(message) {
      var messageSize = JSON.stringify(message).length;
      this.buffer.push(message);
      this.currentSize += messageSize;
      if (this.currentSize >= this.maxSize) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_2__["default"].debug("MessageQueue: queue size exceeds maximum (".concat(this.maxSize, ") - flushing"));
        this.flush();
      }
    }
  }, {
    key: "setMaxSize",
    value: function setMaxSize(maxSize) {
      this.maxSize = maxSize;
    }
  }, {
    key: "flush",
    value: function flush() {
      var messages = this.buffer;
      this.buffer = [];
      this.currentSize = 0;
      this.onFlush(messages);
    }
  }]);
  return Queue;
}();
/* harmony default export */ __webpack_exports__["default"] = (Queue);

/***/ }),

/***/ "./src/core/utils/StateMachine.js":
/*!****************************************!*\
  !*** ./src/core/utils/StateMachine.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_utils_capitalize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core/utils/capitalize */ "./src/core/utils/capitalize.js");
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");





var StateMachine = /*#__PURE__*/function () {
  function StateMachine(config) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, StateMachine);
    this.initial = config.initial;
    this.current = config.initial;
    this.transitions = config.transitions;
    this.states = this.convertTransitions(this.transitions);
    this.ignored = {};
    this.callbacks = config.callbacks;
    this.name = config.name || 'default';
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(StateMachine, [{
    key: "trigger",
    value: function trigger(event, args) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info("StateMachine(".concat(this.name, "): Triggering event ").concat(event, " in state ").concat(this.current));
      var forceTransitionTo = args.options && args.options.forceTransitionTo;
        true && forceTransitionTo && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].warning("StateMachine(".concat(this.name, "): Performing forced transition to ").concat(forceTransitionTo));
      if (!this.transitions[event]) {
        if (true) {
          core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].error("StateMachine(".concat(this.name, "): No event ").concat(event, " in configuration"));
          core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].debug("StateMachine(".concat(this.name, "): Valid events are: ").concat(JSON.stringify(Object.keys(this.transitions))));
          throw new Error("Unknown event: ".concat(event));
        } else {}
      }
      if (this.isIgnored(event)) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].warning("StateMachine(".concat(this.name, "): event ").concat(event, " is ignored in the current state ").concat(this.current));
        return;
      }
      if (this.cannot(event) && !forceTransitionTo) {
        if (this.current === this.initial) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].error("StateMachine(".concat(this.name, "): Unexpected event ").concat(event, " received before initialization"));
          // TODO handle this check better?
          if (!this.hadInitError) {
            this.eventBeforeInit(event, this.current, into, args);
            this.hadInitError = true;
          }
        } else {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].error("StateMachine(".concat(this.name, "): Unexpected event ").concat(event, " received in state ").concat(this.current));
          if (this.current !== 'DISABLED') {
              true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].error("StateMachine(".concat(this.name, "): Analytics partially disabled until the next tune"));
            this.invalidEvent(event, this.current, into, args);
            this.current = 'DISABLED';
          }
        }
        if (true) {
          throw new Error("Invalid event: ".concat(event, " in state ").concat(this.current));
        }
        return;
      }
      var from = this.current;
      var into = forceTransitionTo || this.transitions[event][from] || this.transitions[event]['*'];
      if (into === '*') {
        // Didn't transition
        into = this.current;
      }
        true && from !== into && core_utils_Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info("StateMachine(".concat(this.name, "): Transitioning from ").concat(from, " state into ").concat(into, " state"));
      if (from !== into) {
        this.beforeLeaveState(event, from, into, args);
      }
      this.beforeEvent(event, from, into, args);
      if (from !== into) {
        this.current = into;
        this.changeState(event, from, into, args);
      }
      this.afterEvent(event, from, into, args);
      if (from !== into) {
        this.afterEnterState(event, from, into, args);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.current = this.initial;
      this.hadInitError = false;
    }
  }, {
    key: "is",
    value: function is(state) {
      return state === this.current;
    }
  }, {
    key: "can",
    value: function can(event) {
      // Check if we have such an event
      if (this.transitions[event]) {
        // If we're in initial state - only accept events that move us out of initial state
        if (this.current === this.initial) {
          return this.transitions[event][this.current] && this.transitions[event][this.current] !== '*' || this.transitions[event]['*'] && this.transitions[event]['*'] !== '*';
        }
        // Otherwise accept any valid event
        return Boolean(this.transitions[event][this.current] || this.transitions[event]['*']);
      }
      return false;
    }
  }, {
    key: "cannot",
    value: function cannot(event) {
      return !this.can(event);
    }
  }, {
    key: "isIgnored",
    value: function isIgnored(event) {
      return this.ignored[this.current] && this.ignored[this.current].indexOf(event) !== -1;
    }
  }, {
    key: "setIgnored",
    value: function setIgnored() {
      var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.ignored = rules;
    }
  }, {
    key: "getNextEvents",
    value: function getNextEvents() {
      var statefulEvents = this.states[this.current].reduce(function (all, rule) {
        return all.concat(rule.events);
      }, []);
      if (this.current === this.initial) {
        return statefulEvents;
      }
      var statelessEvents = this.states['*'].reduce(function (all, rule) {
        return all.concat(rule.events);
      }, []);
      return Array.from(new Set(statefulEvents.concat(statelessEvents)));
    }
  }, {
    key: "invalidEvent",
    value: function invalidEvent(event, from, into, args) {
      this.callbacks.onInvalidEvent && this.callbacks.onInvalidEvent(event, from, into, args);
    }
  }, {
    key: "eventBeforeInit",
    value: function eventBeforeInit(event, from, into, args) {
      this.callbacks.onEventBeforeInit && this.callbacks.onEventBeforeInit(event, from, into, args);
    }
  }, {
    key: "beforeEvent",
    value: function beforeEvent(event, from, into, args) {
      this.beforeAnyEvent(event, from, into, args);
      this.beforeThisEvent(event, from, into, args);
    }
  }, {
    key: "beforeAnyEvent",
    value: function beforeAnyEvent(event, from, into, args) {
      this.callbacks.onBeforeEvent && this.callbacks.onBeforeEvent(event, from, into, args);
    }
  }, {
    key: "beforeThisEvent",
    value: function beforeThisEvent(event, from, into, args) {
      var callbackName = "onBefore".concat(Object(core_utils_capitalize__WEBPACK_IMPORTED_MODULE_3__["capitalizeFirstLetter"])(event));
      this.callbacks[callbackName] && this.callbacks[callbackName](event, from, into, args);
    }
  }, {
    key: "afterEvent",
    value: function afterEvent(event, from, into, args) {
      this.afterAnyEvent(event, from, into, args);
      this.afterThisEvent(event, from, into, args);
    }
  }, {
    key: "afterAnyEvent",
    value: function afterAnyEvent(event, from, into, args) {
      this.callbacks.onAfterEvent && this.callbacks.onAfterEvent(event, from, into, args);
    }
  }, {
    key: "afterThisEvent",
    value: function afterThisEvent(event, from, into, args) {
      var callbackName = "onAfter".concat(Object(core_utils_capitalize__WEBPACK_IMPORTED_MODULE_3__["capitalizeFirstLetter"])(event));
      this.callbacks[callbackName] && this.callbacks[callbackName](event, from, into, args);
    }
  }, {
    key: "beforeLeaveState",
    value: function beforeLeaveState(event, from, into, args) {
      var callbackName = "onBeforeLeave".concat(Object(core_utils_capitalize__WEBPACK_IMPORTED_MODULE_3__["capitalizeFirstLetter"])(from));
      this.callbacks[callbackName] && this.callbacks[callbackName](event, from, into, args);
    }
  }, {
    key: "changeState",
    value: function changeState(event, from, into, args) {
      this.callbacks.onChangeState && this.callbacks.onChangeState(event, from, into, args);
    }
  }, {
    key: "afterEnterState",
    value: function afterEnterState(event, from, into, args) {
      var callbackName = "onAfterEnter".concat(Object(core_utils_capitalize__WEBPACK_IMPORTED_MODULE_3__["capitalizeFirstLetter"])(into));
      this.callbacks[callbackName] && this.callbacks[callbackName](event, from, into, args);
    }

    /*
      Input data:
      {
        "startSession": {
          "blank": "appInitializing"
        },
        "pageViewInit": {
          "appInitializing": "navigating",
          "*": "*"
        },
      }
       Output data:
      {
        "blank": [{ "events": ["startSession"], "nextState": "appInitializing" }],
        "appInitializing": [{ "events": ["pageViewInit"], "nextState": "navigating" }]
      }
    */
  }, {
    key: "convertTransitions",
    value: function convertTransitions() {
      var result = {};
      Object.entries(this.transitions).forEach(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref, 2),
          eventName = _ref2[0],
          transitionRules = _ref2[1];
        Object.entries(transitionRules).forEach(function (_ref3) {
          var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, 2),
            currentState = _ref4[0],
            nextState = _ref4[1];
          if (!result[currentState]) {
            result[currentState] = [];
          }
          var existingRule = result[currentState].find(function (rule) {
            return rule.nextState === nextState;
          });
          if (existingRule) {
            existingRule.events.push(eventName);
          } else {
            result[currentState].push({
              events: [eventName],
              nextState: nextState
            });
          }
        });
      });
      return result;
    }
  }]);
  return StateMachine;
}();
/* harmony default export */ __webpack_exports__["default"] = (StateMachine);

/***/ }),

/***/ "./src/core/utils/Timer.js":
/*!*********************************!*\
  !*** ./src/core/utils/Timer.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);


var Timer = /*#__PURE__*/function () {
  function Timer(callback, interval) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Timer);
    this.id = null;
    this.callback = callback;
    this.interval = interval;
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Timer, [{
    key: "start",
    value: function start(delay) {
      this.delay = this.delay || delay;
      this.clear();
      this.run();
    }
  }, {
    key: "pause",
    value: function pause() {
      this.clear();
      // calculate remaining time
      this.delay = this.interval - (Date.now() - this.startTime);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.clear();
      this.delay = null;
      this.startTime = null;
    }
  }, {
    key: "changeInterval",
    value: function changeInterval(interval) {
      this.interval = interval;
    }
  }, {
    key: "run",
    value: function run() {
      var _this = this;
      var interval = this.delay || this.interval;
      this.id = setTimeout(function () {
        _this.delay = null;
        // restart recursive timer
        _this.run();
        // execute callback function
        _this.callback();
      }, interval);

      // store timeout start time
      this.startTime = Date.now();
    }
  }, {
    key: "clear",
    value: function clear() {
      clearTimeout(this.id);
      this.id = null;
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return Boolean(this.startTime);
    }
  }]);
  return Timer;
}();
/* harmony default export */ __webpack_exports__["default"] = (Timer);

/***/ }),

/***/ "./src/core/utils/capitalize.js":
/*!**************************************!*\
  !*** ./src/core/utils/capitalize.js ***!
  \**************************************/
/*! exports provided: capitalizeFirstLetter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capitalizeFirstLetter", function() { return capitalizeFirstLetter; });
function capitalizeFirstLetter(string) {
  return string[0].toUpperCase() + string.slice(1);
}

/***/ }),

/***/ "./src/core/utils/cookie.js":
/*!**********************************!*\
  !*** ./src/core/utils/cookie.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return getCookie; });
function getCookie(name) {
  var _document$cookie$spli;
  return (_document$cookie$spli = document.cookie.split('; ')
  // TODO: template crashes eslint... fix after updating version
  // https://github.com/babel/babel-eslint/issues/530
  // eslint-disable-next-line prefer-template
  .find(function (row) {
    return row.startsWith(name + '=');
  })) === null || _document$cookie$spli === void 0 ? void 0 : _document$cookie$spli.split('=')[1];
}

/***/ }),

/***/ "./src/core/utils/domain.js":
/*!**********************************!*\
  !*** ./src/core/utils/domain.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return getDomain; });
function getDomain() {
  try {
    var cookieDomain = window.location.hostname.match(/[^.]*\.[^.]*$/)[0];
    return cookieDomain;
  } catch (err) {
    return window.location.hostname;
  }
}

/***/ }),

/***/ "./src/core/utils/errors.js":
/*!**********************************!*\
  !*** ./src/core/utils/errors.js ***!
  \**********************************/
/*! exports provided: getStateMachineErrorCode, addInputDataToError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStateMachineErrorCode", function() { return getStateMachineErrorCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addInputDataToError", function() { return addInputDataToError; });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/get */ "./node_modules/lodash/get.js");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var common_json_Categories_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! common/json/Categories.json */ "./src/common/json/Categories.json");
var common_json_Categories_json__WEBPACK_IMPORTED_MODULE_1___namespace = /*#__PURE__*/__webpack_require__.t(/*! common/json/Categories.json */ "./src/common/json/Categories.json", 1);


function getStateMachineErrorCode(errorCodes, event, from) {
  var category = common_json_Categories_json__WEBPACK_IMPORTED_MODULE_1__[event];
  var forEvent = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(errorCodes, [category, from, event]);
  if (forEvent) {
    return forEvent;
  }
  var forState = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(errorCodes, [category, from, 'default']);
  if (forState) {
    return forState;
  }
  var forCategory = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(errorCodes, [category, 'default']);
  if (forCategory) {
    return forCategory;
  }
  return errorCodes["default"];
}
function addInputDataToError(analytics, errorData, inputData) {
  /* eslint-disable no-param-reassign */
  // pass as object for cleanup through blacklist, re-format later
  errorData['application.error.errorExtras'] = inputData;
  analytics.applyBlacklists('error', errorData);
  // re-format input data to string
  errorData['application.error.errorExtras'] = {
    inputData: JSON.stringify(errorData['application.error.errorExtras'])
  };
}

/***/ }),

/***/ "./src/core/utils/messages.js":
/*!************************************!*\
  !*** ./src/core/utils/messages.js ***!
  \************************************/
/*! exports provided: compose, pack */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pack", function() { return pack; });
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/pick */ "./node_modules/lodash/pick.js");
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_pick__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/cloneDeep */ "./node_modules/lodash/cloneDeep.js");
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_utils_prune__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core/utils/prune */ "./src/core/utils/prune.js");
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");





// TODO: don't pass analytics instance
function compose(event, eventData, modelData, analytics) {
  var message = {
    state: modelData.state,
    message: modelData.message,
    operation: modelData.operation,
    application: modelData.application,
    performance: modelData.performance,
    custom: modelData.custom
  };
  message.message.name = event;
  message.message.sequenceNumber = analytics.messageId;
  message.message.timestamp = analytics.timestamp;
  message.message.timeSinceLastEventMs = analytics.previousTimestamp ? analytics.timestamp - analytics.previousTimestamp : 0;
  var preparedMessage = message;
  if (analytics.settings.filterFields) {
    var commonFields = analytics.eventOutput.common;
    var fields = analytics.eventOutput[event];
    if (fields) {
      preparedMessage = lodash_pick__WEBPACK_IMPORTED_MODULE_0___default()(message, commonFields.concat(fields));
    }
  }
  analytics.messageId++; // eslint-disable-line no-param-reassign

  // pack message into json
    true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].debug("Messages: composed message:\n ".concat(JSON.stringify(Object(core_utils_prune__WEBPACK_IMPORTED_MODULE_2__["default"])(message), null, 2)));
  return lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default()(preparedMessage); // clone to get rid of references to model object
}

function pack(messages, modelData) {
  // bulk message with messages from queue
  var bulk = {
    domain: modelData.domain,
    customer: modelData.customer,
    visit: modelData.visit,
    messages: messages
  };

  // clear out empty values
  var cleaned = Object(core_utils_prune__WEBPACK_IMPORTED_MODULE_2__["default"])(bulk);
    true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].debug("Messages: packed bulk message:\n ".concat(JSON.stringify(cleaned, null, 2)));
  return JSON.stringify(cleaned);
}

/***/ }),

/***/ "./src/core/utils/platform.js":
/*!************************************!*\
  !*** ./src/core/utils/platform.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return getStandardizedPlatform; });
function getStandardizedPlatform(appName, appType) {
  // BulkMDU and SpecU are the same app, and names can change in runtime so normalize it to be treated as OneApp
  if (appName && (appName.toLowerCase() === 'BulkMDU' || appName.toLowerCase() === 'SpecU')) {
    // eslint-disable-next-line no-param-reassign
    appName = 'OneApp';
  }
  return "".concat(appName, "@").concat(appType);
}

/***/ }),

/***/ "./src/core/utils/post.js":
/*!********************************!*\
  !*** ./src/core/utils/post.js ***!
  \********************************/
/*! exports provided: canUseFetch, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canUseFetch", function() { return canUseFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return post; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);


var canUseFetch = typeof window !== 'undefined' && window.fetch && window.AbortController;
function post(msg, timeout, isUnloading, forceXHR) {
  if (canUseFetch && forceXHR !== true) {
    return postFetch(msg, timeout, isUnloading);
  }
  return postXHR(msg, timeout);
}
function postFetch(_x, _x2, _x3) {
  return _postFetch.apply(this, arguments);
}
function _postFetch() {
  _postFetch = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee(_ref, timeout, isUnloading) {
    var url, data, token, tokenType, headers, repsonse;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = _ref.url, data = _ref.data, token = _ref.token, tokenType = _ref.tokenType;
          headers = {
            'Content-Type': 'application/json'
          };
          if (token) {
            headers.Authorization = "OAuth oauth_token=".concat(token);
            tokenType && (headers.AuthType = tokenType);
          }
          _context.prev = 3;
          _context.next = 6;
          return fetchWithTimeout(url, {
            method: 'POST',
            headers: headers,
            body: data,
            credentials: 'include',
            keepalive: Boolean(isUnloading)
          }, timeout);
        case 6:
          repsonse = _context.sent;
          if (repsonse.ok) {
            _context.next = 9;
            break;
          }
          throw repsonse.status;
        case 9:
          _context.next = 16;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](3);
          if (!(_context.t0.name === 'AbortError')) {
            _context.next = 15;
            break;
          }
          throw 0;
        case 15:
          throw _context.t0;
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 11]]);
  }));
  return _postFetch.apply(this, arguments);
}
function postXHR(_ref2, timeout) {
  var url = _ref2.url,
    data = _ref2.data,
    token = _ref2.token,
    tokenType = _ref2.tokenType;
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    timeout && (xhr.timeout = timeout);
    xhr.withCredentials = true;
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve();
        } else {
          reject(xhr.status);
        }
      }
    };
    xhr.open('post', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    token && xhr.setRequestHeader('Authorization', "OAuth oauth_token=".concat(token));
    token && tokenType && xhr.setRequestHeader('AuthType', tokenType);
    xhr.send(data);
  });
}

// Because why would fetch support timeouts and abort...
function fetchWithTimeout(url, options, timeout) {
  var controller = new AbortController();
  var signal = controller.signal;

  // eslint-disable-next-line no-param-reassign
  options.signal = signal;
  if (timeout) {
    // Fetch will ignore .abort if it already finished, no need to handle that
    setTimeout(function () {
      return controller.abort();
    }, timeout);
  }
  return fetch(url, options);
}

/***/ }),

/***/ "./src/core/utils/prune.js":
/*!*********************************!*\
  !*** ./src/core/utils/prune.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return pruneObject; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/cloneDeep */ "./node_modules/lodash/cloneDeep.js");
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_pull__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash/pull */ "./node_modules/lodash/pull.js");
/* harmony import */ var lodash_pull__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_pull__WEBPACK_IMPORTED_MODULE_2__);



function pruneObject(obj) {
  var copy = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default()(obj);
  return prune(copy);
}
function prune(obj) {
  Object.keys(obj).forEach(function (key) {
    var value = obj[key];
    if (value === undefined || value === null || typeof value === 'number' && Number.isNaN(value) || value === '' || _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value) === 'object' && Object.keys(prune(value)).length === 0) {
      delete obj[key]; // eslint-disable-line no-param-reassign
    }
  });
  // remove any leftover undefined values from the delete operation on an array
  if (Array.isArray(obj)) {
    lodash_pull__WEBPACK_IMPORTED_MODULE_2___default()(obj, undefined);
  }
  return obj;
}

/***/ }),

/***/ "./src/core/utils/rateLimit.js":
/*!*************************************!*\
  !*** ./src/core/utils/rateLimit.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");



var RateLimiter = /*#__PURE__*/function () {
  function RateLimiter(timesPerSecond) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      exceptions: []
    };
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, RateLimiter);
    this.timesPerSecond = timesPerSecond;
    this.exceptions = options.exceptions;
    this.exceptionCount = {};
    this.onError = options.onError;
    this.reset();
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(RateLimiter, [{
    key: "changeRate",
    value: function changeRate(timesPerSecond) {
      this.timesPerSecond = timesPerSecond;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;
      this.count = 0;
      this.exceptions.forEach(function (key) {
        return _this.exceptionCount[key] = 0;
      });
      this.sentError = false;
    }
  }, {
    key: "wrap",
    value: function wrap(func) {
      var _this2 = this;
      setInterval(function () {
        _this2.reset();
      }, 1000);
      return function (key) {
        var isException = _this2.exceptions.includes(key);
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        if (isException && _this2.exceptionCount[key] < _this2.timesPerSecond) {
          _this2.exceptionCount[key]++;
          return func.apply(void 0, [key].concat(args));
        }
        if (!isException && _this2.count < _this2.timesPerSecond) {
          _this2.count++;
          return func.apply(void 0, [key].concat(args));
        }
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_2__["default"].warning("Event ".concat(key, " called more than ").concat(_this2.timesPerSecond, " times per second, discarding"));
        if (!_this2.sentError) {
          _this2.sentError = true;
          _this2.onError();
        }
        return false;
      };
    }
  }]);
  return RateLimiter;
}();
/* harmony default export */ __webpack_exports__["default"] = (RateLimiter);

/***/ }),

/***/ "./src/core/utils/storage/PersistedStorage.js":
/*!****************************************************!*\
  !*** ./src/core/utils/storage/PersistedStorage.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");



/**
* Example storage object implementation
* Uses two key approach for storing data and TTL separately to avoid parsing large data objects when checking fir expiration
*/

var Storage = /*#__PURE__*/function () {
  function Storage(isSession) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Storage);
    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "expirationSuffix", 'expkey');
    this.isSession = isSession;
    this.storageType = isSession ? 'sessionStorage' : 'localStorage';
    this.storage = this.getStorage();
  }

  /**
  * Set value to storage
  * @param {string} key - storage key
  * @param {string} data - serialized data to save
  * @param {string} [storageDuration] - saved data lifetime
  */
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Storage, [{
    key: "set",
    value: function set(key, data, storageDuration) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].debug("Storage: setting value to key ".concat(key));
      if (this.storage) {
        this.storage.setItem(key, data);
        if (storageDuration && !this.isSession) {
          // Doesn't make sense to have TTL for session storage
          var storeUntil = Date.now() + storageDuration;
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].debug("Storage: setting expiration for key ".concat(key, " until ").concat(storeUntil, " (").concat(storageDuration, "ms)"));
          this.storage.setItem(this.getExpirationKeyName(key), storeUntil);
        }
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].warning("Storage: ".concat(this.storageType, " not available"));
      }
    }

    /**
    * Get value from storage
    * @param {string} key - storage key
    * @returns {string|null} stored serialized data
    */
  }, {
    key: "get",
    value: function get(key) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].debug("Storage: getting value at key ".concat(key));
      if (this.storage) {
        // No TTL for session storage
        if (this.isSession) {
          return this.storage.getItem(key);
        }
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].debug("Storage: checking expiration for key ".concat(key));
        var storeUntil = this.storage.getItem(this.getExpirationKeyName(key));
        if (storeUntil && Date.now() > storeUntil) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].warning("Storage: Data for key ".concat(key, " has expired"));
          this.storage.removeItem(key);
          this.storage.removeItem(this.getExpirationKeyName(key));
          return null;
        }
        return this.storage.getItem(key);
      }
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].warning("Storage: ".concat(this.storageType, " not available"));
      return null;
    }

    /**
    * Remove value from storage
    * @param {string} key - storage key
    */
  }, {
    key: "reset",
    value: function reset(key) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].debug("Storage: resetting value at key ".concat(key));
      if (this.storage) {
        this.storage.removeItem(key);
        this.storage.removeItem(this.getExpirationKeyName(key));
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].warning("Storage: ".concat(this.storageType, " not available"));
      }
    }

    /**
    * Gets storage if it is available
    * @returns {object}
    */
  }, {
    key: "getStorage",
    value: function getStorage() {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].debug("Storage: checking ".concat(this.storageType, " availability"));
      try {
        if (typeof window === 'undefined' || !window[this.storageType]) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].warning("Storage: ".concat(this.storageType, " not available"));
          return false;
        }
        var key = "test-".concat(Date.now());
        window[this.storageType].setItem(key, 'test');
        window[this.storageType].removeItem(key);
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].debug("Storage: ".concat(this.storageType, " is available"));
        return window[this.storageType];
      } catch (e) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_3__["default"].warning("Storage: ".concat(this.storageType, " not available"));
        return null;
      }
    }

    /**
    * Get expiration key name for provided data key
    * @param {string} key - storage key
    * @returns {string} expiration key
    */
  }, {
    key: "getExpirationKeyName",
    value: function getExpirationKeyName(key) {
      return "".concat(key, "-").concat(this.expirationSuffix);
    }
  }]);
  return Storage;
}();
/* harmony default export */ __webpack_exports__["default"] = (Storage);

/***/ }),

/***/ "./src/core/utils/uuid.js":
/*!********************************!*\
  !*** ./src/core/utils/uuid.js ***!
  \********************************/
/*! exports provided: default, generateVisitId */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return uuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateVisitId", function() { return generateVisitId; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);

/* eslint-disable no-bitwise */
function uuid() {
  var d = new Date().getTime();
  var id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return id;
}
var domainKey = {
  video: 'V',
  internal_apps: 'I',
  portals: 'P'
};

// {YYYYMMDDHHMM}{DOMAIN}-{UUID}
// 202207121129I-296a4548-6eff-4bb6-be53-b3a7a61c49
function generateVisitId(domain) {
  var _Date$toISOString$mat = new Date().toISOString().match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/),
    _Date$toISOString$mat2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_Date$toISOString$mat, 6),
    year = _Date$toISOString$mat2[1],
    month = _Date$toISOString$mat2[2],
    day = _Date$toISOString$mat2[3],
    hour = _Date$toISOString$mat2[4],
    minute = _Date$toISOString$mat2[5];
  var timestamp = "".concat(year).concat(month).concat(day).concat(hour).concat(minute);
  return "".concat(timestamp).concat(domainKey[domain] || 'X', "-").concat(uuid());
}

/***/ }),

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var analytics = __webpack_require__(/*! ./video/analytics */ "./src/video/analytics.js")["default"]; // eslint-disable-line import/no-dynamic-require

module.exports = analytics;

/***/ }),

/***/ "./src/video/analytics.js":
/*!********************************!*\
  !*** ./src/video/analytics.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_BaseAnalytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core/BaseAnalytics */ "./src/core/BaseAnalytics.js");
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");
/* harmony import */ var video_callbacks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! video/callbacks */ "./src/video/callbacks/index.js");
/* harmony import */ var video_json_QuantumSpecTools_json__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! video/json/QuantumSpecTools.json */ "./src/video/json/QuantumSpecTools.json");
var video_json_QuantumSpecTools_json__WEBPACK_IMPORTED_MODULE_8___namespace = /*#__PURE__*/__webpack_require__.t(/*! video/json/QuantumSpecTools.json */ "./src/video/json/QuantumSpecTools.json", 1);
/* harmony import */ var video_videoplayer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! video/videoplayer */ "./src/video/videoplayer/index.js");
/* harmony import */ var core_utils_errors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core/utils/errors */ "./src/core/utils/errors.js");





function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Analytics JS SDK.
 */








/**
 * Video analytics API
 * @typicalname analytics
 * @extends BaseAnalytics
*/
var Analytics = /*#__PURE__*/function (_BaseAnalytics) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_2___default()(Analytics, _BaseAnalytics);
  var _super = _createSuper(Analytics);
  function Analytics() {
    var _this;
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Analytics);
    var onSetHandlers = {
      setSegment: function setSegment(data) {
        if (!_this.core.storage.internal.segmentStorage) {
          _this.core.storage.internal.segmentStorage = [];
        }
        _this.core.storage.internal.segmentStorage.push(data);
      },
      setAudioBitRate: function setAudioBitRate(data) {
        // Previous bitrate fields are only relevant for actual bitrate shift events, so we don't have to deal with that here
        video_videoplayer__WEBPACK_IMPORTED_MODULE_9__["default"].model.currentAudioBitRateBps = data['state.playback.bitRate.currentAudioBitRateBps'];
      }
    };
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _this = _super.call.apply(_super, [this].concat(args, [onSetHandlers]));
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Analytics, [{
    key: "playbackStreamUriAcquired",
    value: function playbackStreamUriAcquired(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].info('API: playbackStreamUriAcquired');
      if (!video_videoplayer__WEBPACK_IMPORTED_MODULE_9__["default"].isActive()) {
        // only accept if we're not in active playback
        this.core.handleEvent('playbackStreamUriAcquired', fields, options);
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].info('API: playbackStreamUriAcquired ignored - already in active playback.');
      }
    }
  }, {
    key: "playbackStart",
    value: function playbackStart(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].info('API: playbackStart');
      var contentClass = this.core.model.get('state.content.contentClass');
      if (contentClass === 'shiftedLinear' && fields.playPointTimestamp) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].warning('API: received new playPointTimestamp on shiftedLinear playbackStart, overriding stored value');
      }
      if (!video_videoplayer__WEBPACK_IMPORTED_MODULE_9__["default"].isActive()) {
        // only accept if we're not in active playback
        this.core.handleEvent('playbackStart', fields, options);
      } else if (this.core.settings.renamePlaybackStartDuringRetry) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].warning('API: playbackStart called during active playback, replacing with playbackStartAfterRetry');
        this.core.handleEvent('playbackStartAfterRetry', fields, options);
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].error('API: cannot track playbackStart after starting playback, did you mean to use playbackStartAfterRetry?');
      }
    }
  }, {
    key: "playbackStartAfterRetry",
    value: function playbackStartAfterRetry(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].info('API: playbackStartAfterRetry');
      if (video_videoplayer__WEBPACK_IMPORTED_MODULE_9__["default"].isActive()) {
        // only accept if we're in active playback
        this.core.handleEvent('playbackStartAfterRetry', fields, options);
      } else if (this.core.settings.renamePlaybackStartDuringRetry) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].warning('API: playbackStartAfterRetry called before active playback, replacing with playbackStart');
        this.core.handleEvent('playbackStart', fields, options);
      } else {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].error('API: cannot track playbackStartAfterRetry before starting playback, did you mean to use playbackStart?');
      }
    }
  }, {
    key: "playbackBitRateUpshift",
    value: function playbackBitRateUpshift(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].info('API: playbackBitRateUpshift');
      if (fields.currentBitRateBps === undefined || fields.currentBitRateBps === video_videoplayer__WEBPACK_IMPORTED_MODULE_9__["default"].model.currentBitRate) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].error('API: cannot track playbackBitRateUpshift without a new bitrate');
        var errorFields = {
          'message.eventCaseId': "generic_error_".concat("video"),
          'application.error.errorType': 'analytics',
          'application.error.errorCode': this.core.errorCodes.internal.badBitrate,
          'application.error.errorMessage': 'Received playbackBitRateUpshift with no new bitrate value',
          'application.error.clientErrorCode': 'playbackBitRateUpshift'
        };
        Object(core_utils_errors__WEBPACK_IMPORTED_MODULE_10__["addInputDataToError"])(this.core, errorFields, fields);
        this.core.track('error', errorFields, options);
      } else {
        this.core.handleEvent('playbackBitRateUpshift', fields, options);
      }
    }
  }, {
    key: "playbackBitRateDownshift",
    value: function playbackBitRateDownshift(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].info('API: playbackBitRateDownshift');
      if (fields.currentBitRateBps === undefined || fields.currentBitRateBps === video_videoplayer__WEBPACK_IMPORTED_MODULE_9__["default"].model.currentBitRate) {
          true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].error('API: cannot track playbackBitRateDownshift without a new bitrate');
        var errorFields = {
          'message.eventCaseId': "generic_error_".concat("video"),
          'application.error.errorType': 'analytics',
          'application.error.errorCode': this.core.errorCodes.internal.badBitrate,
          'application.error.errorMessage': 'Received playbackBitRateDownshift with no new bitrate value',
          'application.error.clientErrorCode': 'playbackBitRateDownshift'
        };
        Object(core_utils_errors__WEBPACK_IMPORTED_MODULE_10__["addInputDataToError"])(this.core, errorFields, fields);
        this.core.track('error', errorFields, options);
      } else {
        this.core.handleEvent('playbackBitRateDownshift', fields, options);
      }
    }
  }, {
    key: "playbackSelect",
    value: function playbackSelect(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].info('API: playbackSelect');
      if (fields.pauseLiveTvIsEnabled !== undefined) {
        var maxPauseCacheLength = this.core.settings.playbackCacheMaxLengthMs;
        if (fields.pauseLiveTvIsEnabled === true && (maxPauseCacheLength === 0 || maxPauseCacheLength === undefined)) {
          var errorFields = {
            'application.error.errorType': 'analytics',
            'application.error.errorCode': this.core.errorCodes.internal.missingMaxCacheLengthSetting,
            'application.error.errorMessage': 'playbackCacheMaxLengthMs setting was not set to perform cache length calculations. In further calculations 90min (in ms) will be used as a fallback value',
            'application.error.clientErrorCode': "".concat(this.core.sm.current, ":playbackSelect")
          };
          Object(core_utils_errors__WEBPACK_IMPORTED_MODULE_10__["addInputDataToError"])(this.core, errorFields, fields);
          errorFields['message.triggeredBy'] = 'analytics';
          this.core.track('error', errorFields, options);
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].warning('API: No playbackCacheMaxLengthMs setting provided. Using 90min as a default value');
          var DEFAULT_MAX_PAUSE_CACHE_LENGTH = 5400000; // 90 min
          video_videoplayer__WEBPACK_IMPORTED_MODULE_9__["default"].model.playbackCacheMaxLength = DEFAULT_MAX_PAUSE_CACHE_LENGTH;
          this.core.settings.playbackCacheMaxLengthMs = DEFAULT_MAX_PAUSE_CACHE_LENGTH;
        } else if (fields.pauseLiveTvIsEnabled === true) {
          video_videoplayer__WEBPACK_IMPORTED_MODULE_9__["default"].model.playbackCacheMaxLength = maxPauseCacheLength;
        }
      }
      this.core.handleEvent('playbackSelect', fields, options);
    }
  }, {
    key: "playbackPause",
    value: function playbackPause(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].info('API: playbackPause');
      var playbackType = this.core.model.get('state.content.stream.playbackType');
      if (playbackType === 'linear') {
        var pauseLiveTvIsEnabled = this.core.model.get('state.playback.pauseLiveTvIsEnabled');
        var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_9__["default"].getVideoPlayerState();
        var isPauseLinearInitiated = playerState.cache.isPauseLinearInitiated;
        if (pauseLiveTvIsEnabled !== true || isPauseLinearInitiated !== true) {
          var errorFields = {
            'message.eventCaseId': "generic_error_".concat("video"),
            'application.error.errorType': 'analytics',
            'application.error.errorCode': this.core.errorCodes.internal.unsupportedPauseDuringLinear,
            'application.error.errorMessage': 'Unexpected event playbackPause received during linear playback - pauseLiveTvIsEnabled is false or missing recording playbackTrackChange.',
            'application.error.clientErrorCode': "".concat(this.core.sm.current, ":playbackPause")
          };
          Object(core_utils_errors__WEBPACK_IMPORTED_MODULE_10__["addInputDataToError"])(this.core, errorFields, fields);
          errorFields['message.triggeredBy'] = 'analytics';
          this.core.track('error', errorFields, options);
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].error('API: Unexpected event playbackPause received during linear playback. pauseLiveTvIsEnabled is false or missing recording playbackTrackChange');

          // Exit and don't track pause
          return;
        }
      }
      this.core.handleEvent('playbackPause', fields, options);
    }
  }, {
    key: "playbackTrickPlayStart",
    value: function playbackTrickPlayStart(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].info('API: playbackTrickPlayStart');
      var playbackType = this.core.model.get('state.content.stream.playbackType');
      if (playbackType === 'linear') {
        var pauseLiveTvIsEnabled = this.core.model.get('state.playback.pauseLiveTvIsEnabled');
        var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_9__["default"].getVideoPlayerState();
        var isPauseLinearInitiated = playerState.cache.isPauseLinearInitiated;
        if (pauseLiveTvIsEnabled !== true || isPauseLinearInitiated !== true) {
          var errorFields = {
            'message.eventCaseId': "generic_error_".concat("video"),
            'application.error.errorType': 'analytics',
            'application.error.errorCode': this.core.errorCodes.internal.unsupportedPauseDuringLinear,
            'application.error.errorMessage': 'Unexpected event playbackTrickPlayStart received during linear playback - pauseLiveTvIsEnabled is false or missing recording playbackTrackChange.',
            'application.error.clientErrorCode': "".concat(this.core.sm.current, ":playbackTrickPlayStart")
          };
          Object(core_utils_errors__WEBPACK_IMPORTED_MODULE_10__["addInputDataToError"])(this.core, errorFields, fields);
          errorFields['message.triggeredBy'] = 'analytics';
          this.core.track('error', errorFields, options);
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].error('API: Unexpected event playbackTrickPlayStart received during linear playback. pauseLiveTvIsEnabled is false or missing recording playbackTrackChange');

          // Exit and don't track pause
          return;
        }
      }
      this.core.handleEvent('playbackTrickPlayStart', fields, options);
    }
  }, {
    key: "playbackTrickPlayStop",
    value: function playbackTrickPlayStop(fields, options) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].info('API: playbackTrickPlayStop');
      var contentClass = this.core.model.get('state.content.contentClass');
      if (contentClass === 'shiftedLinear') {
        var cacheStartPosition = this.core.model.get('state.playback.cacheStartPosition');
        if (fields.playPointTimestamp === undefined || fields.playPointTimestamp < cacheStartPosition) {
          var errorFields = {
            'application.error.errorType': 'analytics',
            'application.error.errorCode': this.core.errorCodes.internal.brokenPlayPointTimestamp,
            'application.error.errorMessage': 'Missing / incorrect state.playback.heartBeat.playPointTimestamp value from the client side.',
            'application.error.clientErrorCode': "".concat(this.core.sm.current, ":playbackTrickPlayStop")
          };
          Object(core_utils_errors__WEBPACK_IMPORTED_MODULE_10__["addInputDataToError"])(this.core, errorFields, fields);
          errorFields['message.triggeredBy'] = 'analytics';
          this.core.track('error', errorFields, options);
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_6__["default"].warning('API: Missing / incorrect state.playback.heartBeat.playPointTimestamp value from the client side');

          // Exit and don't track trickplay stop
          return;
        }
      }
      this.core.handleEvent('playbackTrickPlayStop', fields, options);
    }
  }]);
  return Analytics;
}(core_BaseAnalytics__WEBPACK_IMPORTED_MODULE_5__["default"]);
/* harmony default export */ __webpack_exports__["default"] = (new Analytics(video_callbacks__WEBPACK_IMPORTED_MODULE_7__["default"], video_json_QuantumSpecTools_json__WEBPACK_IMPORTED_MODULE_8__));

/***/ }),

/***/ "./src/video/callbacks/ad.js":
/*!***********************************!*\
  !*** ./src/video/callbacks/ad.js ***!
  \***********************************/
/*! exports provided: onBeforeAdBreakStart, onBeforeAdBreakStop, onBeforeAdStart, onBeforeAdStop */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeAdBreakStart", function() { return onBeforeAdBreakStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeAdBreakStop", function() { return onBeforeAdBreakStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeAdStart", function() { return onBeforeAdStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeAdStop", function() { return onBeforeAdStop; });
/* harmony import */ var video_videoplayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! video/videoplayer */ "./src/video/videoplayer/index.js");
/* harmony import */ var _playback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./playback */ "./src/video/callbacks/playback.js");


// TODO: don't just import from other file

function onBeforeAdBreakStart(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'ad';
  data['message.triggeredBy'] = 'application';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackHeartbeat(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  Object(_playback__WEBPACK_IMPORTED_MODULE_1__["setActivePlaybackFields"])(playerState, analytics);
  analytics.model.set('state.ad.adBreakStartTimestamp', analytics.timestamp);
  analytics.model.set('state.ad.adBreakStartPositionSec', playerState.currentVideoPosition);
}
function onBeforeAdBreakStop(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'ad';
  data['message.triggeredBy'] = 'application';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackHeartbeat(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  var adBreakElapsedMs = analytics.timestamp - analytics.model.get('state.ad.adBreakStartTimestamp');
  Object(_playback__WEBPACK_IMPORTED_MODULE_1__["setActivePlaybackFields"])(playerState, analytics);
  analytics.model.set('state.ad.adBreakElapsedMs', adBreakElapsedMs);
}
function onBeforeAdStart(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'ad';
  data['message.triggeredBy'] = 'application';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackHeartbeat(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  Object(_playback__WEBPACK_IMPORTED_MODULE_1__["setActivePlaybackFields"])(playerState, analytics);
  analytics.model.set('state.ad.startTimestamp', analytics.timestamp);
}
function onBeforeAdStop(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'ad';
  data['message.triggeredBy'] = 'application';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackHeartbeat(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  var adElapsedMs = analytics.timestamp - analytics.model.get('state.ad.startTimestamp');
  Object(_playback__WEBPACK_IMPORTED_MODULE_1__["setActivePlaybackFields"])(playerState, analytics);
  analytics.model.set('state.ad.adElapsedMs', adElapsedMs);
}

/***/ }),

/***/ "./src/video/callbacks/general.js":
/*!****************************************!*\
  !*** ./src/video/callbacks/general.js ***!
  \****************************************/
/*! exports provided: onBeforeEvent, onChangeState, onAfterEvent, onInvalidEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeEvent", function() { return onBeforeEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onChangeState", function() { return onChangeState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterEvent", function() { return onAfterEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onInvalidEvent", function() { return onInvalidEvent; });
/* harmony import */ var core_utils_messages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core/utils/messages */ "./src/core/utils/messages.js");
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");
/* harmony import */ var core_utils_errors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core/utils/errors */ "./src/core/utils/errors.js");
/* harmony import */ var video_videoplayer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! video/videoplayer */ "./src/video/videoplayer/index.js");




function onBeforeEvent(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;
  if (analytics.flushedEvents.before[event] && analytics.checkFlushCondition(analytics.flushedEvents.before[event], data)) {
    analytics.queue.flush();
  }
  // Flush if any visit keys are set
  else if (event !== 'startSession' && Object.keys(data).some(function (key) {
    return key.includes('visit');
  })) {
    analytics.queue.flush();
  }
  analytics.previousTimestamp = analytics.timestamp;
  if (options && options.timestamp !== undefined) {
    analytics.timestamp = options.timestamp;
  } else {
    analytics.timestamp = Date.now();
  }

  // If both feature flags are set only use persistFeature
  if (data['message.feature.ignoreContext'] !== undefined && data['message.persistFeature'] !== undefined) {
    delete data['message.feature.ignoreContext'];
    var message = 'Both ignoreContext and persistFeature set, discarding ignoreContext';
      true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].warning(message);
    if (data['message.qa.issues']) {
      data['message.qa.issues'].push(message);
    } else data['message.qa.issues'] = [message];
  }

  // reset feature object if event can have context, but message.context is empty (wrong event for flow, exiting it)
  // and its not an exception (ignoreContext or persistFeature)
  if (analytics.currentFlow && analytics.isFeatureFlowEvent(event) && !data['message.context'] && data['message.feature.ignoreContext'] !== true && data['message.persistFeature'] !== true) {
    core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].info("Exiting feature flow on event ".concat(event, " as we expected a [message.context] value but none was provided"));
    analytics.model.reset('message.feature');
    delete analytics.currentFlow; // end of flow
  }

  if (data['message.context'] || analytics.currentFlow && data['message.persistFeature']) {
    if (analytics.currentFlow !== data['message.context'] && data['message.persistFeature'] !== true) {
      if (analytics.currentFlow) {
        core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].info("Exiting feature flow on event ".concat(event, " - context changed from ").concat(analytics.currentFlow, " to ").concat(data['message.context']));
        analytics.model.reset('message.feature');
      } else {
        core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].info("Entering new feature flow - ".concat(data['message.context']));
      }
      analytics.currentFlow = data['message.context']; // begin new flow

      // generate new transactionId
      var transactionId = "".concat(analytics.model.get('visit.visitId'), "|").concat(analytics.timestamp);
      data['message.feature.transactionId'] = transactionId;
    }
    var newFeatureStepName = data['message.feature.featureStepName'];
    if (newFeatureStepName) {
      // set flag to true if feature step name changed
      var oldFeatureStepName = analytics.model.get('message.feature.featureStepName');
      if (oldFeatureStepName !== newFeatureStepName) {
        data['message.feature.featureStepChanged'] = true;
      }

      // append latest step name to array
      var completedSteps = analytics.model.get('message.feature.completedSteps') || [];
      completedSteps.push(newFeatureStepName);
      analytics.model.set('message.feature.completedSteps', completedSteps);
    }
    if (data['operation.userPreferencesSelections']) {
      var currentSelections = analytics.model.get('message.feature.featureSelections') || [];
      data['message.feature.featureSelections'] = currentSelections.concat(data['operation.userPreferencesSelections']);
    }
  }
  if (data['state.userJourney.featureFlagged'] === true) {
    var currentFeatureName = analytics.model.get('state.userJourney.currentFeature.name');
    var isJourneyNameFromClient = data['state.userJourney.currentFeature.name'] !== undefined;
    // Feature name is either newly passed page name (on pageView) or existing current page name
    var newFeatureName = data['state.userJourney.currentFeature.name'] || data['state.view.currentPage.pageName'] || analytics.model.get('state.view.currentPage.pageName');

    // Only handle new feature name if value comes as data from client directly or if it's in the included list
    if (isJourneyNameFromClient || analytics.settings.includedFeatureNameList.includes(newFeatureName)) {
      // The currentFeature.name and the previousFeature.name should never be the same.
      // For example, if the user opens up the app and navigates to home → productPage → home we would not want the currentFeaute.name and previousFeature.name to both be home.
      // In this scenario, we would leave the currentFeautre.Name as "home" and previousFeature.name would remain NULL.
      if (currentFeatureName !== newFeatureName) {
        var currentSequenceNumber = analytics.model.get('state.userJourney.currentFeature.sequenceNumber');
        data['state.userJourney.currentFeature.sequenceNumber'] = currentSequenceNumber !== undefined ? currentSequenceNumber + 1 : 0;
        data['state.userJourney.previousFeature.name'] = currentFeatureName;
        data['state.userJourney.currentFeature.name'] = newFeatureName;
      }
    } else {
      delete data['state.userJourney.featureFlagged'];
    }
  }

  // if playback is active and event is not playback (there is no such interface in the videoplayer)
  if (!options.noMessage && video_videoplayer__WEBPACK_IMPORTED_MODULE_3__["default"].isActive() && !analytics.isPlayback(event)) {
    video_videoplayer__WEBPACK_IMPORTED_MODULE_3__["default"].tick(analytics.timestamp);
    var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_3__["default"].getVideoPlayerState();
    analytics.model.set('state.currentVideoPosition', playerState.currentVideoPosition);
  }
  // Stop heartBeat time on every playback event
  // Except for concurrencyChange events
  if (analytics.isPlayback(event) && event !== 'concurrencyChange') {
    analytics.heartBeatTimer.stop();
  }
  if (data['visit.accessibility']) {
    // Remove from data to avoid writing to model
    var newAccessibility = data['visit.accessibility'];
    delete data['visit.accessibility'];
    if (!Array.isArray(newAccessibility)) {
        true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].warning('Ignoring visit.accessibility field that is not an array!');
    } else {
      var _analytics$model$get;
      var currentAccessibility = (_analytics$model$get = analytics.model.get('visit.accessibility')) !== null && _analytics$model$get !== void 0 ? _analytics$model$get : [];
      newAccessibility.forEach(function (newSetting) {
        if (newSetting.name === undefined) {
            true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].warning('Ignoring accessibility object with missing name');
        } else {
          var found = currentAccessibility.find(function (oldSetting, i) {
            if (oldSetting.name === newSetting.name && oldSetting.setLevel === newSetting.setLevel) {
                true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].info("Updating existing accessibility setting ".concat(newSetting.name, ":").concat(newSetting.level));
              currentAccessibility[i] = newSetting;
              return true;
            }
            return false;
          });
          if (!found) {
              true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].info("Adding new accessibility setting ".concat(newSetting.name, ":").concat(newSetting.level));
            currentAccessibility.push(newSetting);
          }
        }
      });
      analytics.model.set('visit.accessibility', currentAccessibility);
    }
  }

  // if playback is not yet active and event is playback and it's shifted linear
  var contentClass = data['state.content.contentClass'] || analytics.model.get('state.content.contentClass');
  if (!options.noMessage && !video_videoplayer__WEBPACK_IMPORTED_MODULE_3__["default"].isActive() && event !== 'playbackStart' && analytics.isPlayback(event) && contentClass === 'shiftedLinear') {
    var _playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_3__["default"].getVideoPlayerState();
    analytics.model.set('state.playback.heartBeat.playPointTimestamp', _playerState.heartBeat.playPointTimestamp);
  }
}

// actual transition (change state name, current content position, etc)
function onChangeState(event, from, into, args) {
  var analytics = args.analytics,
    options = args.options;
  var previousState = analytics.model.get('state.name');
  if (previousState) {
    analytics.model.set('state.previousState.name', previousState);
    if (!options.isRecovery) {
      analytics.model.set('state.previousState.entryTimestamp', analytics.model.get('state.entryTimestamp'));
      analytics.model.set('state.previousState.exitTimestamp', analytics.timestamp);
    } else {
      analytics.model.reset('state.previousState.exitTimestamp');
    }
  }
  if (!options.isRecovery) {
    analytics.model.set('state.name', analytics.sm.current);
    analytics.model.set('state.entryTimestamp', analytics.timestamp);
  }

  // keep tracking previous positions during playback (including stop)
  if (video_videoplayer__WEBPACK_IMPORTED_MODULE_3__["default"].isActive() || event === 'playbackStop') {
    analytics.model.set('state.previousState.entryVideoPosition', analytics.model.get('state.entryVideoPosition'));
    var currentContPos = analytics.model.get('state.currentVideoPosition'); // already calculated in onBeforeEvent callback
    analytics.model.set('state.entryVideoPosition', currentContPos);
    analytics.model.set('state.previousState.exitVideoPosition', currentContPos);
  }
}
function onAfterEvent(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;
  analytics.model.batchSet(data); // save prepared data into the model

  // Handle only real events
  if (!options.noMessage) {
    var message = Object(core_utils_messages__WEBPACK_IMPORTED_MODULE_0__["compose"])(event, args.data, analytics.model.getData(), analytics); // create a JSON string from one event

    // Capture performance fields, for JS sdk we depend on options passed from JS helix
    message.message.performance = {
      timeInRules: options.helixTimeInRules
    };
    if (options.helixTrackStartTimestamp !== undefined) {
      message.message.performance.timeInSDK = Date.now() - options.helixTrackStartTimestamp;
    }
    analytics.queue.push(message);
    if (analytics.flushedEvents.after[event] && analytics.checkFlushCondition(analytics.flushedEvents.after[event], data, event) ||
    // buyFlow events should always be flushed
    analytics.currentFlow === 'buyFlow' || analytics.currentFlow === 'buyFlow2' || analytics.currentFlow === 'preBuyFlow' || analytics.currentFlow === 'postBuyFlow') {
      analytics.queue.flush();
    }

    // Save feature object because we might need it later
    var feature = analytics.model.get('message.feature');

    // Actually restart heartBeat timer after a playback event if we're playing
    // Except for concurrencyChange events
    if (analytics.isPlayback(event)) {
      if (analytics.sm.current === 'playing' && event !== 'concurrencyChange') {
        analytics.heartBeatTimer.start();
      }
      analytics.model.reset('state.playback.frames');
      analytics.model.reset('state.playback.buffer');
    }

    // Reset fields based on persistence config for any event
    var fieldsToResetForAny = analytics.persistenceRules.after.any;
    fieldsToResetForAny.forEach(function (path) {
      return analytics.model.reset(path);
    });

    // Reset fields based on persistence config for specific event
    if (analytics.persistenceRules.after[event]) {
      var fieldsToResetForEvent = analytics.persistenceRules.after[event];
      fieldsToResetForEvent.forEach(function (path) {
        return analytics.model.reset(path);
      });
    }
    if (analytics.currentFlow) {
      if (!analytics.isFeatureFlowEvent(event) || data['message.feature.ignoreContext'] === true || data['message.persistFeature'] === true || data['message.context'] && analytics.currentFlow === data['message.context']) {
        analytics.model.set('message.feature', feature); // restore feature
        analytics.model.set('message.feature.featureStepChanged', false);
      }
    }
  }
  analytics.saveState(); // TODO move save state later?
}

function onInvalidEvent(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;

  // Force videoplayer to DISABLED state to stay in sync with main state
  video_videoplayer__WEBPACK_IMPORTED_MODULE_3__["default"].sm.current = 'DISABLED';
  var errorCode = Object(core_utils_errors__WEBPACK_IMPORTED_MODULE_2__["getStateMachineErrorCode"])(analytics.errorCodes.state, event, from);
  var errorFields = {
    // TODO: maybe do something about paths here
    'message.eventCaseId': "generic_error_".concat("video"),
    'application.error.errorType': 'analytics',
    'application.error.errorCode': errorCode,
    'application.error.errorMessage': "Unexpected event ".concat(event, " received in state ").concat(from, ". Analytics partially disabled until the next tune"),
    'application.error.clientErrorCode': "".concat(from, ":").concat(event)
  };
  Object(core_utils_errors__WEBPACK_IMPORTED_MODULE_2__["addInputDataToError"])(analytics, errorFields, data);
  errorFields['message.triggeredBy'] = 'analytics';
  analytics.heartBeatTimer.stop();
  analytics.track('error', errorFields, options);
}

/***/ }),

/***/ "./src/video/callbacks/index.js":
/*!**************************************!*\
  !*** ./src/video/callbacks/index.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var common_callbacks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! common/callbacks */ "./src/common/callbacks/index.js");
/* harmony import */ var _ad__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ad */ "./src/video/callbacks/ad.js");
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./general */ "./src/video/callbacks/general.js");
/* harmony import */ var _login__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./login */ "./src/video/callbacks/login.js");
/* harmony import */ var _navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./navigation */ "./src/video/callbacks/navigation.js");
/* harmony import */ var _ondemand__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ondemand */ "./src/video/callbacks/ondemand.js");
/* harmony import */ var _playback__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./playback */ "./src/video/callbacks/playback.js");
/* harmony import */ var _recovery__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./recovery */ "./src/video/callbacks/recovery.js");
/* harmony import */ var _select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./select */ "./src/video/callbacks/select.js");
/* harmony import */ var _websocket__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./websocket */ "./src/video/callbacks/websocket.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }










/* harmony default export */ __webpack_exports__["default"] = (_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, common_callbacks__WEBPACK_IMPORTED_MODULE_1__["default"]), _ad__WEBPACK_IMPORTED_MODULE_2__), _general__WEBPACK_IMPORTED_MODULE_3__), _login__WEBPACK_IMPORTED_MODULE_4__), _navigation__WEBPACK_IMPORTED_MODULE_5__), _ondemand__WEBPACK_IMPORTED_MODULE_6__), _playback__WEBPACK_IMPORTED_MODULE_7__), _recovery__WEBPACK_IMPORTED_MODULE_8__), _select__WEBPACK_IMPORTED_MODULE_9__), _websocket__WEBPACK_IMPORTED_MODULE_10__));

/***/ }),

/***/ "./src/video/callbacks/login.js":
/*!**************************************!*\
  !*** ./src/video/callbacks/login.js ***!
  \**************************************/
/*! exports provided: onBeforeForcedLogin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeForcedLogin", function() { return onBeforeForcedLogin; });
function onBeforeForcedLogin(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'authentication';
  data['message.triggeredBy'] = 'application';
}

/***/ }),

/***/ "./src/video/callbacks/navigation.js":
/*!*******************************************!*\
  !*** ./src/video/callbacks/navigation.js ***!
  \*******************************************/
/*! exports provided: onBeforePageView, onBeforePinEntry, onBeforeRequestToRecord, onBeforeRequestToDeleteRecording, onBeforeRequestToEditRecording, onBeforeRequestToCancelRecording, onBeforeCheckAvailableChannels, onBeforeSwitchScreen, onAfterSwitchScreen, onBeforeDisplayChange, onBeforeExternalAppStateChange, onBeforeFeatureStart, onBeforeFeatureStop */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePageView", function() { return onBeforePageView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePinEntry", function() { return onBeforePinEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeRequestToRecord", function() { return onBeforeRequestToRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeRequestToDeleteRecording", function() { return onBeforeRequestToDeleteRecording; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeRequestToEditRecording", function() { return onBeforeRequestToEditRecording; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeRequestToCancelRecording", function() { return onBeforeRequestToCancelRecording; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeCheckAvailableChannels", function() { return onBeforeCheckAvailableChannels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeSwitchScreen", function() { return onBeforeSwitchScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterSwitchScreen", function() { return onAfterSwitchScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeDisplayChange", function() { return onBeforeDisplayChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeExternalAppStateChange", function() { return onBeforeExternalAppStateChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeFeatureStart", function() { return onBeforeFeatureStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeFeatureStop", function() { return onBeforeFeatureStop; });
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/merge */ "./node_modules/lodash/merge.js");
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var video_videoplayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! video/videoplayer */ "./src/video/videoplayer/index.js");


function onBeforePageView(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;
  data['message.category'] = 'navigation';
  // TODO: ideally this should be 'application', but we're keeping this behavior for backwards compatibility
  data['message.triggeredBy'] = data['message.triggeredBy'] || analytics.storage.internal.pageViewTriggeredBy;
  data['message.eventCaseId'] = data['message.eventCaseId'] || "generic_pageView_missingEID_".concat("video");
  if (options.pageViewStatus) {
    data['state.view.currentPage.renderDetails.viewRenderedStatus'] = options.pageViewStatus;
  }
  var _analytics$storage$in = analytics.storage.internal,
    pageViewSection = _analytics$storage$in.pageViewSection,
    pageViewSubsection = _analytics$storage$in.pageViewSubsection;
  lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(data, pageViewSection);
  lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(data, pageViewSubsection);
  delete analytics.storage.internal.pageViewSection;
  delete analytics.storage.internal.pageViewSubsection;
  delete analytics.storage.internal.pageViewTriggeredBy;
  var incomingViewRenderedStatus = data['state.view.currentPage.renderDetails.viewRenderedStatus'];
  if (incomingViewRenderedStatus === 'complete') {
    var currentViewRenderedStatus = analytics.model.get('state.view.currentPage.renderDetails.viewRenderedStatus');
    var duration = analytics.timestamp - analytics.model.get('state.view.currentPage.renderDetails.renderInitTimestamp');
    if (currentViewRenderedStatus !== 'completeAwaitingAction') {
      data['state.view.currentPage.renderDetails.fullyRenderedTimestamp'] = analytics.timestamp;
      data['state.view.currentPage.renderDetails.fullyRenderedMs'] = duration;
    }
    var isLazyLoad = analytics.model.get('state.view.currentPage.renderDetails.isLazyLoad');
    var hasPartial = analytics.model.get('state.view.currentPage.renderDetails.partialRenderedTimestamp') || analytics.model.get('state.view.currentPage.renderDetails.partialRenderedMs');
    if (!isLazyLoad || !hasPartial) {
      data['state.view.currentPage.renderDetails.partialRenderedTimestamp'] = analytics.timestamp;
      data['state.view.currentPage.renderDetails.partialRenderedMs'] = duration;
    }
  }

  // TODO: re-work this for more generic use
  var currentPageName = analytics.model.get('state.view.currentPage.pageName'); // Search Flow: to get currentPage name
  // 'Search Flow: check for current page, if user returns to search page after curated result page, use saved search object from local storage
  if (currentPageName === 'search' && analytics.storage.internal.searchObject) {
    var searchObject = analytics.storage.internal.searchObject;
    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(data, searchObject);
  }

  // Add some playback values to page events. Only static values, no content elapses calcuation, etc
  if (video_videoplayer__WEBPACK_IMPORTED_MODULE_1__["default"].isActive()) {
    var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_1__["default"].getVideoPlayerState();
    analytics.model.set('state.playback.bitRate.currentBitRateBps', playerState.bitRate.currentBitRate);
    analytics.model.set('state.playback.bitRate.previousBitRateBps', playerState.bitRate.previousBitRate);
    analytics.model.set('state.playback.bitRate.currentAudioBitRateBps', playerState.bitRate.currentAudioBitRateBps);
    analytics.model.set('state.playback.bitRate.previousAudioBitRateBps', playerState.bitRate.previousAudioBitRateBps);
  }
}
function onBeforePinEntry(event, from, into, args) {
  var data = args.data;
  data['message.triggeredBy'] = 'user';
}
function onBeforeRequestToRecord(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'contentDiscovery';
  data['message.triggeredBy'] = 'user';
}
function onBeforeRequestToDeleteRecording(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'contentDiscovery';
  data['message.triggeredBy'] = 'user';
}
function onBeforeRequestToEditRecording(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'contentDiscovery';
  data['message.triggeredBy'] = 'user';
}
function onBeforeRequestToCancelRecording(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'contentDiscovery';
  data['message.triggeredBy'] = 'user';
}
function onBeforeCheckAvailableChannels(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'navigation';
  data['message.triggeredBy'] = 'application';
}
function onBeforeSwitchScreen(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'navigation';
  // https://jira.charter.com/browse/PICA-3059
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'user';
  if (!data['application.error.errorType'] && data['operation.success'] === false) {
    data['application.error.errorType'] = 'switchScreen';
  }
}
function onAfterSwitchScreen(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  if (data['operation.switchScreenDirection'] === 'referrerDisconnect') {
    analytics.model.reset('visit.applicationDetails.referrerApp');
  }
}
function onBeforeDisplayChange(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data,
    options = args.options;
  data['message.category'] = 'navigation';
  data['message.triggeredBy'] = 'user';
  if (analytics.sm.current === 'playing') {
    analytics.track('playbackHeartbeat', {}, options);
  }

  // Add some playback values to display change events. Only static values, no content elapses calcuation, etc
  if (video_videoplayer__WEBPACK_IMPORTED_MODULE_1__["default"].isActive()) {
    var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_1__["default"].getVideoPlayerState();
    analytics.model.set('state.playback.bitRate.currentBitRateBps', playerState.bitRate.currentBitRate);
    analytics.model.set('state.playback.bitRate.previousBitRateBps', playerState.bitRate.previousBitRate);
    analytics.model.set('state.playback.bitRate.currentAudioBitRateBps', playerState.bitRate.currentAudioBitRateBps);
    analytics.model.set('state.playback.bitRate.previousAudioBitRateBps', playerState.bitRate.previousAudioBitRateBps);
  }
}
function onBeforeExternalAppStateChange(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'navigation';
  data['message.triggeredBy'] = 'application';
}
function onBeforeFeatureStart(event, from, into, args) {
  var data = args.data;
  data['message.triggeredBy'] = 'user';
  data['message.category'] = 'contentDiscovery';
}
function onBeforeFeatureStop(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'contentDiscovery';
  if (analytics.storage.internal.preferences) {
    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(data, analytics.storage.internal.preferences);
  }
}

/***/ }),

/***/ "./src/video/callbacks/ondemand.js":
/*!*****************************************!*\
  !*** ./src/video/callbacks/ondemand.js ***!
  \*****************************************/
/*! exports provided: onBeforePlaybackPause, onBeforePlaybackUnpause, onBeforePlaybackTrickPlayStart, onBeforePlaybackTrickPlayRateChange, onBeforePlaybackTrickPlayStop */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackPause", function() { return onBeforePlaybackPause; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackUnpause", function() { return onBeforePlaybackUnpause; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackTrickPlayStart", function() { return onBeforePlaybackTrickPlayStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackTrickPlayRateChange", function() { return onBeforePlaybackTrickPlayRateChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackTrickPlayStop", function() { return onBeforePlaybackTrickPlayStop; });
/* harmony import */ var video_videoplayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! video/videoplayer */ "./src/video/videoplayer/index.js");
/* harmony import */ var _playback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./playback */ "./src/video/callbacks/playback.js");


// TODO: don't just import from other file

function onBeforePlaybackPause(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'user';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackPause(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  Object(_playback__WEBPACK_IMPORTED_MODULE_1__["setActivePlaybackFields"])(playerState, analytics);
}
function onBeforePlaybackUnpause(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackUnpause(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  Object(_playback__WEBPACK_IMPORTED_MODULE_1__["setActivePlaybackFields"])(playerState, analytics);
}
function onBeforePlaybackTrickPlayStart(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'user';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackTrickPlayStart(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  var scrubStartValue = data['state.playback.trickPlay.scrubStartPositionSec'];
  var scrubStartPositionSec = scrubStartValue !== undefined ? scrubStartValue : playerState.currentVideoPosition;
  Object(_playback__WEBPACK_IMPORTED_MODULE_1__["setActivePlaybackFields"])(playerState, analytics);
  analytics.model.set('state.playback.trickPlay.scrubStartPositionSec', scrubStartPositionSec);
}
function onBeforePlaybackTrickPlayRateChange(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = 'user';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackTrickPlayRateChange(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  Object(_playback__WEBPACK_IMPORTED_MODULE_1__["setActivePlaybackFields"])(playerState, analytics);
}
function onBeforePlaybackTrickPlayStop(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'user'; // for recovery

  var playbackType = analytics.model.get('state.content.stream.playbackType');
  if (playbackType === 'linear') {
    video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackTrickPlayStop(analytics.timestamp, undefined, data['state.playback.heartBeat.playPointTimestamp']);
  } else {
    var scrubEndPositionSec = data['state.playback.trickPlay.scrubEndPositionSec'];
    analytics.model.set('state.playback.trickPlay.scrubEndPositionSec', scrubEndPositionSec);
    video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackTrickPlayStop(analytics.timestamp, scrubEndPositionSec);
  }
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  Object(_playback__WEBPACK_IMPORTED_MODULE_1__["setActivePlaybackFields"])(playerState, analytics);
}

/***/ }),

/***/ "./src/video/callbacks/playback.js":
/*!*****************************************!*\
  !*** ./src/video/callbacks/playback.js ***!
  \*****************************************/
/*! exports provided: setActivePlaybackFields, onBeforePlaybackSelect, onBeforePlaybackStreamUriAcquired, onBeforePlaybackExitBeforeStart, onBeforePlaybackStart, onBeforePlaybackStartAfterRetry, onBeforePlaybackStop, onBeforePlaybackHeartbeat, onBeforePlaybackBitRateUpshift, onBeforePlaybackBitRateDownshift, onBeforeBufferingStart, onBeforeBufferingStop, onBeforePlaybackFailure, onBeforePlaybackFailureBeforeRetry, onBeforeAttemptRestart, onBeforeConcurrencyChange, onBeforePlaybackTrackChange */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActivePlaybackFields", function() { return setActivePlaybackFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackSelect", function() { return onBeforePlaybackSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackStreamUriAcquired", function() { return onBeforePlaybackStreamUriAcquired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackExitBeforeStart", function() { return onBeforePlaybackExitBeforeStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackStart", function() { return onBeforePlaybackStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackStartAfterRetry", function() { return onBeforePlaybackStartAfterRetry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackStop", function() { return onBeforePlaybackStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackHeartbeat", function() { return onBeforePlaybackHeartbeat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackBitRateUpshift", function() { return onBeforePlaybackBitRateUpshift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackBitRateDownshift", function() { return onBeforePlaybackBitRateDownshift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeBufferingStart", function() { return onBeforeBufferingStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeBufferingStop", function() { return onBeforeBufferingStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackFailure", function() { return onBeforePlaybackFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackFailureBeforeRetry", function() { return onBeforePlaybackFailureBeforeRetry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeAttemptRestart", function() { return onBeforeAttemptRestart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeConcurrencyChange", function() { return onBeforeConcurrencyChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackTrackChange", function() { return onBeforePlaybackTrackChange; });
/* harmony import */ var video_videoplayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! video/videoplayer */ "./src/video/videoplayer/index.js");
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");



// TODO - where to put this function
function setActivePlaybackFields(playerState, analytics) {
  // video position
  analytics.model.set('state.currentVideoPosition', playerState.currentVideoPosition);

  // heartBeat
  analytics.model.set('state.playback.heartBeat.contentElapsedMs', playerState.heartBeat.contentElapsedMs);
  analytics.model.set('state.playback.heartBeat.clockTimeElapsedMs', playerState.heartBeat.clockTimeElapsedMs);
  analytics.model.set('state.playback.heartBeat.playPointTimestamp', playerState.heartBeat.playPointTimestamp);
  analytics.model.set('state.playback.heartBeat.runningTotalContentElapsedMs', playerState.heartBeat.runningTotalContentElapsedMs);

  // bitRate
  analytics.model.set('state.playback.bitRate.currentBitRateBps', playerState.bitRate.currentBitRate);
  analytics.model.set('state.playback.bitRate.contentElapsedAtCurrentBitRateMs', playerState.bitRate.contentElapsedAtCurrentBitRate);
  analytics.model.set('state.playback.bitRate.previousBitRateBps', playerState.bitRate.previousBitRate);
  analytics.model.set('state.playback.bitRate.contentElapsedAtPreviousBitRateMs', playerState.bitRate.contentElapsedAtPreviousBitRate);
  // audio bitRate
  analytics.model.set('state.playback.bitRate.currentAudioBitRateBps', playerState.bitRate.currentAudioBitRateBps);
  analytics.model.set('state.playback.bitRate.previousAudioBitRateBps', playerState.bitRate.previousAudioBitRateBps);

  // segment info
  var segmentInfo = analytics.storage.internal.segmentStorage;
  if (segmentInfo) {
    analytics.model.set('state.playback.segmentInfo', segmentInfo);
    delete analytics.storage.internal.segmentStorage; // eslint-disable-line no-param-reassign
  }

  // linear cache buffer
  if (playerState.cache.isPauseLinearInitiated) {
    analytics.model.set('state.playback.cacheStartPosition', playerState.cache.cacheStartPosition);
    analytics.model.set('state.playback.cacheLength', playerState.cache.cacheLength);
  }
}
function onBeforePlaybackSelect(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  var newContentClass = data['state.content.contentClass'];

  // NOTE: Must be done before videoplayer.reset call
  if (newContentClass !== 'shiftedLinear') {
    video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model.isPauseLinearInitiated = false;
  }
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].reset();
  analytics.model.reset('state.content');
  analytics.model.reset('state.playback');
  analytics.model.reset('state.search');
  delete analytics.storage.internal.searchObject; // User exits Search Flow, clearing out local storage
  analytics.storage.internal.playbackSessionCount = 0;
  var playbackType = data['state.content.stream.playbackType'];
  if (playbackType !== 'vod' && playbackType !== 'dvr' && playbackType !== 'sizzle' && playbackType !== 'videoClip') {
    delete data['state.content.details.runtime'];
  }
  var position;
  if (playbackType === 'vod' || playbackType === 'dvr' || playbackType === 'sizzle' || playbackType === 'videoClip') {
    position = data['state.content.stream.bookmarkPositionSec'] || 0;
  }
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackSelect(analytics.timestamp, playbackType, position);
  analytics.model.set('state.playback.playbackSelectedTimestamp', analytics.timestamp);
  // format: visitId|playbackSelectedTimestampHex
  // timestamp = 123456789 decimal
  // timestamp hex = 75bcd15 hexadecimal

  var playbackId = "".concat(analytics.model.get('visit.visitId'), "|").concat(analytics.timestamp.toString(16));
  analytics.model.set('state.content.stream.playbackId', playbackId);
  analytics.model.set('state.playback.playerSessionId', "".concat(playbackId, "|0"));
  if (newContentClass === 'shiftedLinear') {
    var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
    analytics.model.set('state.playback.cacheStartPosition', playerState.cache.cacheStartPosition);
    analytics.model.set('state.playback.cacheLength', playerState.cache.cacheLength);
    analytics.model.set('state.content.stream.secondaryPlaybackId', analytics.storage.internal.previousPlaybackId);
    analytics.model.set('state.content.stream.recordingContentUriAcquired', analytics.storage.internal.previousRecordingUri);
    analytics.model.set('state.playback.heartBeat.playPointTimestamp', playerState.heartBeat.playPointTimestamp);
  }
  delete analytics.storage.internal.previousPlaybackId;
  delete analytics.storage.internal.previousRecordingUri;
}
function onBeforePlaybackStreamUriAcquired(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'application';
  if (data['operation.success'] === true) {
    video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackStreamUriAcquired(analytics.timestamp);
    var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
    data['state.playback.uriObtainedMs'] = playerState.uriObtainedMs;
    if (playerState.cache.isPauseLinearInitiated) {
      analytics.model.set('state.playback.cacheStartPosition', playerState.cache.cacheStartPosition);
      analytics.model.set('state.playback.cacheLength', playerState.cache.cacheLength);
    }
  } else {
    delete data['state.content.stream.contentUri'];
  }
}
function onBeforePlaybackExitBeforeStart(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackExitBeforeStart(analytics.timestamp);
}
function onBeforePlaybackStart(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'application';
  var playbackType = analytics.model.get('state.content.stream.playbackType');

  // Discard if it's not linear
  if (playbackType !== 'linear') {
    delete data['state.playback.heartBeat.playPointTimestamp'];
  }

  // Update cache position if new value passed on shifted linear
  var contentClass = analytics.model.get('state.content.contentClass');
  var newCacheStartPosition;
  if (data['state.playback.cacheStartPosition'] !== undefined) {
    if (contentClass === 'shiftedLinear') {
      newCacheStartPosition = data['state.playback.cacheStartPosition'];
      core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].info("Updating cache start position to ".concat(newCacheStartPosition));
    } else {
      core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].warning("New cacheStartPosition passed for invalid contentClass ".concat(contentClass));
    }
  }
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackStart(analytics.timestamp, data['state.playback.bitRate.currentBitRateBps'], data['state.playback.heartBeat.playPointTimestamp'], data['state.playback.bitRate.currentAudioBitRateBps'], newCacheStartPosition);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  setActivePlaybackFields(playerState, analytics);
  analytics.model.set('state.playback.tuneTimeMs', playerState.tuneTimeMs);
  analytics.model.set('state.playback.playbackStartedTimestamp', analytics.timestamp);
  analytics.model.set('state.playback.retryTimeMs', playerState.retryTimeMs);

  // runtime
  if (playbackType !== 'vod' && playbackType !== 'sizzle' && playbackType !== 'videoClip') {
    delete data['state.content.details.actualRuntime'];
  }
}
function onBeforePlaybackStartAfterRetry(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'application';
  var playbackType = analytics.model.get('state.content.stream.playbackType');

  // Discard if it's not linear
  if (playbackType !== 'linear') {
    delete data['state.playback.heartBeat.playPointTimestamp'];
  }
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackStartAfterRetry(analytics.timestamp, data['state.playback.bitRate.currentBitRateBps'], data['state.playback.heartBeat.playPointTimestamp']);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  setActivePlaybackFields(playerState, analytics);
  analytics.model.set('state.playback.playbackStartedTimestamp', analytics.timestamp);
  analytics.model.set('state.playback.retryTimeMs', playerState.retryTimeMs);
}
function onBeforePlaybackStop(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackStop(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();

  // in middle of ad
  if (analytics.model.get('state.ad.startTimestamp')) {
    var adElapsedMs = analytics.timestamp - analytics.model.get('state.ad.startTimestamp');
    analytics.model.set('state.ad.adElapsedMs', adElapsedMs);
  }

  // in middle of ad break
  if (analytics.model.get('state.ad.adBreakStartTimestamp')) {
    var adBreakElapsedMs = analytics.timestamp - analytics.model.get('state.ad.adBreakStartTimestamp');
    analytics.model.set('state.ad.adBreakElapsedMs', adBreakElapsedMs);
  }
  setActivePlaybackFields(playerState, analytics);
  analytics.storage.internal.previousPlaybackId = analytics.model.get('state.content.stream.playbackId');
  analytics.storage.internal.previousRecordingUri = analytics.model.get('state.content.stream.recordingContentUriAcquired');
}
function onBeforePlaybackHeartbeat(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = 'application';
  data['message.eventCaseId'] = 'generic_playbackHeartbeat_video';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackHeartbeat(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  setActivePlaybackFields(playerState, analytics);
}
function onBeforePlaybackBitRateUpshift(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = 'application';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackBitRateChange(analytics.timestamp, data['state.playback.bitRate.currentBitRateBps'], data['state.playback.bitRate.currentAudioBitRateBps']);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  setActivePlaybackFields(playerState, analytics);
}
function onBeforePlaybackBitRateDownshift(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = 'application';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackBitRateChange(analytics.timestamp, data['state.playback.bitRate.currentBitRateBps'], data['state.playback.bitRate.currentAudioBitRateBps']);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  setActivePlaybackFields(playerState, analytics);
}
function onBeforeBufferingStart(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'application';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].bufferingStart(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  setActivePlaybackFields(playerState, analytics);
}
function onBeforeBufferingStop(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'application'; // for recovery

  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].bufferingStop(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  analytics.model.set('state.playback.bufferingTimeMs', playerState.lastBufferingTime);
  setActivePlaybackFields(playerState, analytics);
}
function onBeforePlaybackFailure(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'application';
  data['operation.success'] = false;
  if (!data['application.error.errorType']) {
    data['application.error.errorType'] = 'playback';
  }
  if (!data['application.error.errorCode']) {
    data['application.error.errorCode'] = 'unknown';
  }

  // Need to take value before playbackFailure because it will always set it to false
  var wasActivePlayback = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].isActive();
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackFailure(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  if (wasActivePlayback) {
    // in middle of ad
    if (analytics.model.get('state.ad.startTimestamp')) {
      var adElapsedMs = analytics.timestamp - analytics.model.get('state.ad.startTimestamp');
      analytics.model.set('state.ad.adElapsedMs', adElapsedMs);
    }

    // in middle of ad break
    if (analytics.model.get('state.ad.adBreakStartTimestamp')) {
      var adBreakElapsedMs = analytics.timestamp - analytics.model.get('state.ad.adBreakStartTimestamp');
      analytics.model.set('state.ad.adBreakElapsedMs', adBreakElapsedMs);
    }
    setActivePlaybackFields(playerState, analytics);
  }
  analytics.model.set('state.playback.retryTimeMs', playerState.retryTimeMs);
}
function onBeforePlaybackFailureBeforeRetry(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'application';
  data['operation.success'] = false;
  if (!data['application.error.errorType']) {
    data['application.error.errorType'] = 'playback';
  }
  if (!data['application.error.errorCode']) {
    data['application.error.errorCode'] = 'unknown';
  }
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackFailureBeforeRetry(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  if (video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].isActive()) {
    setActivePlaybackFields(playerState, analytics);
    analytics.model.set('state.playback.retryCategory', 'brokenStream');
  } else {
    analytics.model.set('state.playback.retryCategory', 'streamInit');
  }
  analytics.model.set('state.playback.retryTimeMs', playerState.retryTimeMs);
  var retriedErrorCode = analytics.model.get('state.playback.retriedErrorCode');
  if (!retriedErrorCode) {
    analytics.model.set('state.playback.retriedErrorCode', data['application.error.errorCode']);
  }
}
function onBeforeAttemptRestart(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = data['message.triggeredBy'] || 'application';
  video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].attemptRestart(analytics.timestamp);
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  if (video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].isActive()) {
    setActivePlaybackFields(playerState, analytics);
  } else {
    analytics.model.set('state.currentVideoPosition', playerState.currentVideoPosition);
  }

  // segment info
  var segmentInfo = analytics.storage.internal.segmentStorage;
  if (segmentInfo) {
    analytics.model.set('state.content.stream.segmentInfo', segmentInfo);
    delete analytics.storage.internal.segmentStorage;
  }
  var retryAttempts = analytics.model.get('state.playback.retryAttempts') || 0;
  analytics.model.set('state.playback.retryAttempts', retryAttempts + 1);

  // if first retry in sequence
  if (retryAttempts === 0) {
    var retryWindows = analytics.model.get('state.playback.totalSessionRetries') || 0;
    analytics.model.set('state.playback.totalSessionRetries', retryWindows + 1);
  }
  var playbackId = analytics.model.get('state.content.stream.playbackId');
  analytics.storage.internal.playbackSessionCount++;
  analytics.model.set('state.playback.playerSessionId', "".concat(playbackId, "|").concat(analytics.storage.internal.playbackSessionCount));
}
function onBeforeConcurrencyChange(event, from, into, args) {
  var data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = 'application';
}
function onBeforePlaybackTrackChange(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  data['message.category'] = 'playback';
  data['message.triggeredBy'] = 'application';
  var isPauseLinearInitiated = data['operation.operationType'] === 'recordingUriAcquired' && analytics.model.get('state.content.stream.playbackType') === 'linear' && analytics.model.get('state.playback.pauseLiveTvIsEnabled') === true;
  if (isPauseLinearInitiated) {
    // We may have a custom cache start passed
    video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackTrackChange(analytics.timestamp, isPauseLinearInitiated, data['state.playback.cacheStartPosition']);
  } else {
    video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].playbackTrackChange(analytics.timestamp, isPauseLinearInitiated);
  }
  var playerState = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].getVideoPlayerState();
  if (video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].isActive()) {
    setActivePlaybackFields(playerState, analytics);
  }
  // An alternative PLTV flow is to have track change before playback start, so we need to handle that
  else if (playerState.cache.isPauseLinearInitiated) {
    analytics.model.set('state.playback.cacheStartPosition', playerState.cache.cacheStartPosition);
    analytics.model.set('state.playback.cacheLength', playerState.cache.cacheLength);
  }
}

/***/ }),

/***/ "./src/video/callbacks/recovery.js":
/*!*****************************************!*\
  !*** ./src/video/callbacks/recovery.js ***!
  \*****************************************/
/*! exports provided: onBeforeLeavePaused, onBeforeLeaveScrubbing, onBeforeLeaveBuffering */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeLeavePaused", function() { return onBeforeLeavePaused; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeLeaveScrubbing", function() { return onBeforeLeaveScrubbing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeLeaveBuffering", function() { return onBeforeLeaveBuffering; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core/utils/Logger */ "./src/core/utils/Logger.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function onBeforeLeavePaused(event, from, into, args) {
  var analytics = args.analytics,
    options = args.options;
  if (event !== 'playbackUnpause') {
      true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].warning("Recovery: inserting missed playbackUnpause before ".concat(event));

    // We will silence error in PLTV for now, to be reviewed later
    var isPauseLive = analytics.model.get('state.content.contentClass') === 'linear' && analytics.model.get('state.playback.pauseLiveTvIsEnabled') === true;
    if (!isPauseLive) {
      var errorFields = {
        'message.triggeredBy': 'analytics',
        'message.eventCaseId': 'generic_error_video',
        'application.error.errorType': 'analytics',
        'application.error.errorCode': analytics.errorCodes.recovery.recoveryPlaybackUnpause,
        'application.error.errorMessage': "Recovery: inserting missed playbackUnpause before ".concat(event, ". Please review the event flow to ensure proper event sequencing.")
      };
      analytics.track('error', errorFields, options);
    }
    analytics.track('playbackUnpause', {
      'message.eventCaseId': 'generic_playbackUnpause_recovery_video',
      'message.triggeredBy': 'analytics',
      'message.recoveryEventTrigger': event,
      'message.category': 'playback'
    }, _objectSpread({
      isRecovery: true
    }, options));
  }
}
function onBeforeLeaveScrubbing(event, from, into, args) {
  var analytics = args.analytics,
    options = args.options;
  if (event !== 'playbackTrickPlayStop') {
      true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].warning("Recovery: inserting missed playbackTrickPlayStop before ".concat(event));
    var errorFields = {
      'message.triggeredBy': 'analytics',
      'message.eventCaseId': 'generic_error_video',
      'application.error.errorType': 'analytics',
      'application.error.errorCode': analytics.errorCodes.recovery.recoveryPlaybackTrickPlayStop,
      'application.error.errorMessage': "Recovery: inserting missed playbackTrickPlayStop before ".concat(event, ". Please review the event flow to ensure proper event sequencing.")
    };
    analytics.track('error', errorFields, options);
    var currentContentPosition = analytics.model.get('state.currentVideoPosition');
    analytics.track('playbackTrickPlayStop', {
      'message.eventCaseId': 'generic_playbackTrickPlayStop_recovery_video',
      'message.triggeredBy': 'analytics',
      'message.recoveryEventTrigger': event,
      'state.playback.trickPlay.scrubEndPositionSec': currentContentPosition
    }, _objectSpread({
      isRecovery: true
    }, options));
  }
}
function onBeforeLeaveBuffering(event, from, into, args) {
  var analytics = args.analytics,
    options = args.options;
  if (event !== 'bufferingStop') {
      true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].warning("Recovery: inserting missed bufferingStop before ".concat(event));
    var errorFields = {
      'message.triggeredBy': 'analytics',
      'message.eventCaseId': 'generic_error_video',
      'application.error.errorType': 'analytics',
      'application.error.errorCode': analytics.errorCodes.recovery.recoveryBufferingStop,
      'application.error.errorMessage': "Recovery: inserting missed bufferingStop before ".concat(event, ". Please review the event flow to ensure proper event sequencing.")
    };
    analytics.track('error', errorFields, options);
    analytics.track('bufferingStop', {
      'message.eventCaseId': 'generic_bufferingStop_recovery_video',
      'message.triggeredBy': 'analytics',
      'message.recoveryEventTrigger': event,
      'message.category': 'playback'
    }, _objectSpread({
      isRecovery: true
    }, options));
  }
  if (into === 'initiating') {
      true && core_utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].warning("Recovery: inserting missed playbackStop before ".concat(event));
    var _errorFields = {
      'message.triggeredBy': 'analytics',
      'message.eventCaseId': 'generic_error_video',
      'application.error.errorType': 'analytics',
      'application.error.errorCode': analytics.errorCodes.recovery.recoveryPlaybackStop,
      'application.error.errorMessage': "Recovery: inserting missed playbackStop before ".concat(event, ". Please review the event flow to ensure proper event sequencing.")
    };
    analytics.track('error', _errorFields, options);
    analytics.track('playbackStop', {
      'message.eventCaseId': 'generic_playbackStop_recovery_video',
      'message.triggeredBy': 'analytics',
      'message.recoveryEventTrigger': event,
      'message.category': 'playback'
    }, _objectSpread({
      isRecovery: true
    }, options));
  }
}

/***/ }),

/***/ "./src/video/callbacks/select.js":
/*!***************************************!*\
  !*** ./src/video/callbacks/select.js ***!
  \***************************************/
/*! exports provided: onBeforeSelectAction, onAfterSelectAction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeSelectAction", function() { return onBeforeSelectAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterSelectAction", function() { return onAfterSelectAction; });
function onBeforeSelectAction(event, from, into, args) {
  var analytics = args.analytics,
    data = args.data;
  if (data['operation.userPreferencesSelections'] || data['operation.userPreferenceCategory']) {
    analytics.storage.internal.preferences = {
      'operation.userPreferencesSelections': data['operation.userPreferencesSelections'],
      'operation.userPreferenceCategory': data['operation.userPreferenceCategory']
    };
  }
  analytics.storage.internal.activeContent = analytics.model.get('state.content');
  analytics.model.reset('state.content');
}
function onAfterSelectAction(event, from, into, args) {
  var analytics = args.analytics;
  analytics.model.set('state.content', analytics.storage.internal.activeContent);
  delete analytics.storage.internal.activeContent;
}

/***/ }),

/***/ "./src/video/callbacks/websocket.js":
/*!******************************************!*\
  !*** ./src/video/callbacks/websocket.js ***!
  \******************************************/
/*! exports provided: onBeforeWebSocketOpen, onBeforeWebSocketActivity, onBeforeWebSocketHeartbeat, onBeforeWebSocketClose, onBeforeWebSocketError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeWebSocketOpen", function() { return onBeforeWebSocketOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeWebSocketActivity", function() { return onBeforeWebSocketActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeWebSocketHeartbeat", function() { return onBeforeWebSocketHeartbeat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeWebSocketClose", function() { return onBeforeWebSocketClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeWebSocketError", function() { return onBeforeWebSocketError; });
/* harmony import */ var core_utils_uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core/utils/uuid */ "./src/core/utils/uuid.js");

function onBeforeWebSocketOpen(event, from, into, args) {
  var data = args.data,
    analytics = args.analytics;
  data['message.triggeredBy'] = 'application';
  data['message.category'] = 'networkTransaction';
  var webSocketGuid = Object(core_utils_uuid__WEBPACK_IMPORTED_MODULE_0__["default"])();
  data['application.api.websocketGuid'] = webSocketGuid;
  analytics.storage.internal.websocketGuid = webSocketGuid;
}
function onBeforeWebSocketActivity(event, from, into, args) {
  var data = args.data,
    analytics = args.analytics;
  data['message.triggeredBy'] = 'application';
  data['message.category'] = 'networkTransaction';
  var webSocketGuid = analytics.storage.internal.websocketGuid;
  data['application.api.websocketGuid'] = webSocketGuid;
}
function onBeforeWebSocketHeartbeat(event, from, into, args) {
  var data = args.data,
    analytics = args.analytics;
  data['message.triggeredBy'] = 'application';
  data['message.category'] = 'networkTransaction';
  data['operation.operationType'] = 'heartbeat';
  var webSocketGuid = analytics.storage.internal.websocketGuid;
  data['application.api.websocketGuid'] = webSocketGuid;
}
function onBeforeWebSocketClose(event, from, into, args) {
  var data = args.data,
    analytics = args.analytics;
  data['message.triggeredBy'] = 'application';
  data['message.category'] = 'networkTransaction';
  var webSocketGuid = analytics.storage.internal.websocketGuid;
  data['application.api.websocketGuid'] = webSocketGuid;
  delete analytics.storage.internal.websocketGuid;
}
function onBeforeWebSocketError(event, from, into, args) {
  var data = args.data,
    analytics = args.analytics;
  data['message.triggeredBy'] = 'application';
  data['message.category'] = 'networkTransaction';
  var webSocketGuid = analytics.storage.internal.websocketGuid;
  data['application.api.websocketGuid'] = webSocketGuid;
  delete analytics.storage.internal.websocketGuid;
}

/***/ }),

/***/ "./src/video/json/QuantumSpecTools.json":
/*!**********************************************!*\
  !*** ./src/video/json/QuantumSpecTools.json ***!
  \**********************************************/
/*! exports provided: version, domain, input, output, blacklists, errorCodes, persistenceRules, transitions, legacyTransitions, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"version\":\"2025-06-13:6542af1eb675ccc2066a5485cc1334b22e58ce37\",\"domain\":\"video\",\"input\":{\"adBreakStart\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.ad.adBreakNumber\":{\"quantumKey\":\"adBreakNumber\",\"unifiedKey\":\"adBreakNumber\",\"type\":\"int\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"adBreakStop\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"adStart\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.ad.campaign\":{\"quantumKey\":\"adCampaign\",\"unifiedKey\":\"adCampaign\",\"type\":\"string\"},\"state.ad.deviceAdId\":{\"quantumKey\":\"deviceAdId\",\"unifiedKey\":\"adDeviceAdId\",\"type\":\"string\"},\"state.ad.id\":{\"quantumKey\":\"adId\",\"unifiedKey\":\"adId\",\"type\":\"string\"},\"state.ad.number\":{\"quantumKey\":\"adNumber\",\"unifiedKey\":\"adNbr\",\"type\":\"int\"},\"state.ad.title\":{\"quantumKey\":\"adTitle\",\"unifiedKey\":\"adTitle\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"adStop\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.ad.adDurationSec\":{\"quantumKey\":\"adDurationSec\",\"unifiedKey\":\"adDurSec\",\"type\":\"int\"},\"state.ad.adStoppedReason\":{\"quantumKey\":\"adStoppedReason\",\"unifiedKey\":\"adStoppedReason\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"apiCall\":{\"application.api.apiCached\":{\"quantumKey\":\"apiCached\",\"unifiedKey\":\"appApiCached\",\"type\":\"boolean\"},\"application.api.apiClusterVersion\":{\"quantumKey\":\"apiClusterVersion\",\"unifiedKey\":\"apiClusterVersion\",\"type\":\"string\"},\"application.api.architecture\":{\"quantumKey\":\"apiArchitecture\",\"unifiedKey\":\"apiArchitecture\",\"type\":\"string\"},\"application.api.clientServiceResult\":{\"quantumKey\":\"clientServiceResult\",\"unifiedKey\":\"clientServiceResult\",\"type\":\"string\"},\"application.api.eventUid\":{\"quantumKey\":\"eventUid\",\"unifiedKey\":\"eventUid\",\"type\":\"string\"},\"application.api.gql.errorCode\":{\"quantumKey\":\"gqlErrorCode\",\"unifiedKey\":\"gqlErrorCode\",\"type\":\"string\"},\"application.api.gql.hashId\":{\"quantumKey\":\"gqlHashId\",\"unifiedKey\":\"gqlHashId\",\"type\":\"string\"},\"application.api.gql.operationName\":{\"quantumKey\":\"gqlOperationName\",\"unifiedKey\":\"gqlOperationName\",\"type\":\"string\"},\"application.api.gql.operationType\":{\"quantumKey\":\"gqlOperationType\",\"unifiedKey\":\"gqlOperationType\",\"type\":\"string\"},\"application.api.host\":{\"quantumKey\":\"host\",\"unifiedKey\":\"appApiHost\",\"type\":\"string\"},\"application.api.httpVerb\":{\"quantumKey\":\"httpVerb\",\"unifiedKey\":\"appApiHttpVerb\",\"type\":\"string\"},\"application.api.maxRetryCount\":{\"quantumKey\":\"maxRetryCount\",\"unifiedKey\":\"appApiMaxRetryCnt\",\"type\":\"int\"},\"application.api.path\":{\"quantumKey\":\"path\",\"unifiedKey\":\"appApiPath\",\"type\":\"string\"},\"application.api.queryParameters\":{\"quantumKey\":\"queryParameters\",\"unifiedKey\":\"appApiQueryParameters\",\"type\":\"string\"},\"application.api.reportedHeaders\":{\"quantumKey\":\"apiReportedHeaders\",\"unifiedKey\":\"apiReportedHeaders\",\"type\":\"string\"},\"application.api.responseCode\":{\"quantumKey\":\"responseCode\",\"unifiedKey\":\"appApiResponseCode\",\"type\":\"string\"},\"application.api.responseSize\":{\"quantumKey\":\"responseSize\",\"unifiedKey\":\"appApiResponseSize\",\"type\":\"int\"},\"application.api.responseText\":{\"quantumKey\":\"responseText\",\"unifiedKey\":\"appApiResponseText\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.api.responseTimeMs\":{\"quantumKey\":\"responseTimeMs\",\"unifiedKey\":\"appApiResponseTimeMs\",\"type\":\"int\"},\"application.api.retry\":{\"quantumKey\":\"retry\",\"unifiedKey\":\"appApiRetry\",\"type\":\"boolean\"},\"application.api.retryCount\":{\"quantumKey\":\"retryCount\",\"unifiedKey\":\"appApiRetryCnt\",\"type\":\"int\"},\"application.api.traceId\":{\"quantumKey\":\"traceId\",\"unifiedKey\":\"appApiTraceId\",\"type\":\"string\"},\"application.api.transactionId\":{\"quantumKey\":\"apiTransactionId\",\"unifiedKey\":\"apiTransactionId\",\"type\":\"string\"},\"application.api.willRetry\":{\"quantumKey\":\"willRetry\",\"unifiedKey\":\"appApiWillRetry\",\"type\":\"boolean\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.intValue\":{\"quantumKey\":\"operationIntValue\",\"unifiedKey\":\"operationIntValue\",\"type\":\"int\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.settings.appliedConfigs\":{\"quantumKey\":\"appliedConfigs\",\"unifiedKey\":\"appliedConfigs\",\"type\":\"string\"},\"visit.settings.privateAppliedConfigs\":{\"quantumKey\":\"privateAppliedConfigs\",\"unifiedKey\":\"privateAppliedConfigs\",\"type\":\"string\"},\"visit.settings.reinitVersion\":{\"quantumKey\":\"reinitVersion\",\"unifiedKey\":\"reinitVersion\",\"type\":\"string\"}},\"applicationActivity\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"message.triggeredUsing\":{\"quantumKey\":\"triggeredUsing\",\"unifiedKey\":\"msgTriggeredUsing\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.intValue\":{\"quantumKey\":\"operationIntValue\",\"unifiedKey\":\"operationIntValue\",\"type\":\"int\"},\"operation.nielsenLoadData\":{\"quantumKey\":\"nielsenLoadData\",\"unifiedKey\":\"nielsenLoadData\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.outage.etr\":{\"quantumKey\":\"outageEtr\",\"unifiedKey\":\"outageEtr\",\"type\":\"boolean\"},\"operation.outage.irisEventId\":{\"quantumKey\":\"irisEventId\",\"unifiedKey\":\"irisEventId\",\"type\":\"array\",\"elementType\":\"string\"},\"operation.outage.pid\":{\"quantumKey\":\"outagePid\",\"unifiedKey\":\"outagePid\",\"type\":\"string\"},\"operation.outage.replacementMessagingUsed\":{\"quantumKey\":\"replacementMessagingUsed\",\"unifiedKey\":\"replacementMessagingUsed\",\"type\":\"boolean\"},\"operation.outage.status\":{\"quantumKey\":\"outageStatus\",\"unifiedKey\":\"outageStatus\",\"type\":\"string\"},\"operation.outage.type\":{\"quantumKey\":\"outageType\",\"unifiedKey\":\"outageType\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"state.lifecycleState.name\":{\"quantumKey\":\"lifecycleStateName\",\"unifiedKey\":\"lifecycleStateName\",\"type\":\"string\"},\"state.view.currentPage.elements.elementStringValue\":{\"quantumKey\":\"elementStringValue\",\"unifiedKey\":\"currPageElemStrValue\",\"type\":\"string\"},\"state.view.currentPage.elements.elementUrl\":{\"quantumKey\":\"elementUrl\",\"unifiedKey\":\"currPageElemUrl\",\"type\":\"string\"},\"state.view.currentPage.pageSection.onSiteCampaignId\":{\"quantumKey\":\"onSiteCampaignId\",\"unifiedKey\":\"onSiteCampaignId\",\"type\":\"string\"},\"state.view.pictureInPicture\":{\"quantumKey\":\"pictureInPicture\",\"unifiedKey\":\"pictureInPicture\",\"type\":\"boolean\"},\"visit.accessibility\":{\"quantumKey\":\"accessibilitySettings\",\"unifiedKey\":\"accessibilitySettings\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.internet.equipment\":{\"quantumKey\":\"accountInternetEquipment\",\"unifiedKey\":\"accountInternetEquipment\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.internet.packageName\":{\"quantumKey\":\"accountInternetPackageName\",\"unifiedKey\":\"accountInternetPackageName\",\"type\":\"string\"},\"visit.account.lineOfBusiness.internet.premiumOrAddOn\":{\"quantumKey\":\"accountInternetPremiumOrAddOn\",\"unifiedKey\":\"accountInternetPremiumOrAddOn\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.internet.productId\":{\"quantumKey\":\"accountInternetProductId\",\"unifiedKey\":\"accountInternetProductId\",\"type\":\"string\"},\"visit.account.lineOfBusiness.phone.equipment\":{\"quantumKey\":\"accountPhoneEquipment\",\"unifiedKey\":\"accountPhoneEquipment\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.phone.packageName\":{\"quantumKey\":\"accountPhonePackageName\",\"unifiedKey\":\"accountPhonePackageName\",\"type\":\"string\"},\"visit.account.lineOfBusiness.phone.premiumOrAddOn\":{\"quantumKey\":\"accountPhonePremiumOrAddOn\",\"unifiedKey\":\"accountPhonePremiumOrAddOn\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.phone.productId\":{\"quantumKey\":\"accountPhoneProductId\",\"unifiedKey\":\"accountPhoneProductId\",\"type\":\"string\"},\"visit.account.lineOfBusiness.tv.equipment\":{\"quantumKey\":\"accountTVEquipment\",\"unifiedKey\":\"accountTVEquipment\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.tv.packageName\":{\"quantumKey\":\"accountTVPackageName\",\"unifiedKey\":\"accountTVPackageName\",\"type\":\"string\"},\"visit.account.lineOfBusiness.tv.premiumOrAddOn\":{\"quantumKey\":\"accountTVPremiumOrAddOn\",\"unifiedKey\":\"accountTVPremiumOrAddOn\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.tv.productId\":{\"quantumKey\":\"accountTVProductId\",\"unifiedKey\":\"accountTVProductId\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.applicationDetails.appMode\":{\"quantumKey\":\"appMode\",\"unifiedKey\":\"appMode\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.commonToken\":{\"quantumKey\":\"referrerAppCommonToken\",\"unifiedKey\":\"referrerAppCommonToken\",\"type\":\"string\"},\"visit.chromecastEnabled\":{\"quantumKey\":\"chromecastEnabled\",\"unifiedKey\":\"chromecastEnabled\",\"type\":\"boolean\"},\"visit.connection.deviceLocation\":{\"quantumKey\":\"connectionDeviceLocation\",\"unifiedKey\":\"connectionDeviceLocation\",\"type\":\"string\"},\"visit.connection.networkStatus\":{\"quantumKey\":\"networkStatus\",\"unifiedKey\":\"networkStatus\",\"type\":\"string\"},\"visit.externalAnalytics.sessionId\":{\"quantumKey\":\"externalAnalyticsSessionId\",\"unifiedKey\":\"externalAnalyticsSessionId\",\"type\":\"string\"},\"visit.externalApps\":{\"quantumKey\":\"externalApps\",\"unifiedKey\":\"externalApps\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.features.callerId\":{\"quantumKey\":\"featuresCallerId\",\"unifiedKey\":\"featuresCallerId\",\"type\":\"string\"},\"visit.features.favorites\":{\"quantumKey\":\"featuresFavorites\",\"unifiedKey\":\"featuresFavorites\",\"type\":\"string\"},\"visit.features.parentalControls\":{\"quantumKey\":\"featuresParentalControls\",\"unifiedKey\":\"featuresParentalControls\",\"type\":\"string\"},\"visit.features.powerOn\":{\"quantumKey\":\"featuresPowerOn\",\"unifiedKey\":\"featuresPowerOn\",\"type\":\"string\"},\"visit.features.titleInGuide\":{\"quantumKey\":\"featuresTitleInGuide\",\"unifiedKey\":\"featuresTitleInGuide\",\"type\":\"string\"},\"visit.kochavaSdk.firstInstall\":{\"quantumKey\":\"kochavaFirstInstall\",\"unifiedKey\":\"kochavaFirstInstall\",\"type\":\"boolean\"},\"visit.kochavaSdk.installDate\":{\"quantumKey\":\"kochavaInstallDate\",\"unifiedKey\":\"kochavaInstallDate\",\"type\":\"string\"},\"visit.kochavaSdk.kochavaDeviceId\":{\"quantumKey\":\"kochavaDeviceId\",\"unifiedKey\":\"kochavaDeviceId\",\"type\":\"string\"},\"visit.kochavaSdk.originalRequest\":{\"quantumKey\":\"kochavaOriginalRequest\",\"unifiedKey\":\"kochavaOriginalRequest\",\"type\":\"string\"},\"visit.kochavaSdk.trackerId\":{\"quantumKey\":\"kochavaTrackerId\",\"unifiedKey\":\"kochavaTrackerId\",\"type\":\"string\"},\"visit.kochavaSdk.waterfallLevel\":{\"quantumKey\":\"kochavaWaterfallLevel\",\"unifiedKey\":\"kochavaWaterfallLevel\",\"type\":\"string\"},\"visit.permissionSettings.limitAdTracking\":{\"quantumKey\":\"limitAdTracking\",\"unifiedKey\":\"limitAdTracking\",\"type\":\"string\"},\"visit.promotion.buyflow.appPromoState\":{\"quantumKey\":\"appPromoState\",\"unifiedKey\":\"appPromoState\",\"type\":\"string\"},\"visit.promotion.buyflow.blacklistedFromFreePreview\":{\"quantumKey\":\"blacklistedFromFreePreview\",\"unifiedKey\":\"blacklistedFromFreePreview\",\"type\":\"boolean\"},\"visit.promotion.buyflow.blacklistedFromFreeTrial\":{\"quantumKey\":\"blacklistedFromFreeTrial\",\"unifiedKey\":\"blacklistedFromFreeTrial\",\"type\":\"boolean\"},\"visit.promotion.buyflow.eligible\":{\"quantumKey\":\"buyflowEligible\",\"unifiedKey\":\"buyflowEligible\",\"type\":\"boolean\"},\"visit.promotion.buyflow.householdFoundInMarketingFile\":{\"quantumKey\":\"householdFoundInMarketingFile\",\"unifiedKey\":\"householdFoundInMarketingFile\",\"type\":\"boolean\"},\"visit.promotion.buyflow.offerPriority\":{\"quantumKey\":\"offerPriority\",\"unifiedKey\":\"offerPriority\",\"type\":\"array\",\"elementType\":\"string\"},\"visit.promotion.buyflow.presentedOffers\":{\"quantumKey\":\"presentedOffers\",\"unifiedKey\":\"presentedOffers\",\"type\":\"array\",\"elementType\":\"string\"},\"visit.promotion.buyflow.requestedFreePreviewDisabled\":{\"quantumKey\":\"requestedFreePreviewDisabled\",\"unifiedKey\":\"requestedFreePreviewDisabled\",\"type\":\"boolean\"},\"visit.promotion.buyflow.requestedOfferId\":{\"quantumKey\":\"requestedOfferId\",\"unifiedKey\":\"requestedOfferId\",\"type\":\"string\"},\"visit.promotion.buyflow.requestedOfferIsReturned\":{\"quantumKey\":\"requestedOfferIsReturned\",\"unifiedKey\":\"requestedOfferIsReturned\",\"type\":\"boolean\"},\"visit.promotion.buyflow.requestedOfferMatchedTargeted\":{\"quantumKey\":\"requestedOfferMatchedTargeted\",\"unifiedKey\":\"requestedOfferMatchedTargeted\",\"type\":\"boolean\"},\"visit.promotion.buyflow.scenarioNumber\":{\"quantumKey\":\"scenarioNumber\",\"unifiedKey\":\"scenarioNumber\",\"type\":\"int\"},\"visit.promotion.buyflow.singleOfferReturned\":{\"quantumKey\":\"singleOfferReturned\",\"unifiedKey\":\"singleOfferReturned\",\"type\":\"string\"},\"visit.promotion.buyflow.targetedOfferFound\":{\"quantumKey\":\"targetedOfferFound\",\"unifiedKey\":\"targetedOfferFound\",\"type\":\"boolean\"},\"visit.promotion.endDate\":{\"quantumKey\":\"promoEndDate\",\"unifiedKey\":\"promoEndDate\",\"type\":\"long\"},\"visit.promotion.offerId\":{\"quantumKey\":\"offerId\",\"unifiedKey\":\"offerId\",\"type\":\"string\"},\"visit.promotion.promoId\":{\"quantumKey\":\"promoId\",\"unifiedKey\":\"promoId\",\"type\":\"string\"},\"visit.promotion.promoType\":{\"quantumKey\":\"promoType\",\"unifiedKey\":\"promoType\",\"type\":\"string\"},\"visit.promotion.startDate\":{\"quantumKey\":\"promoStartDate\",\"unifiedKey\":\"promoStartDate\",\"type\":\"long\"}},\"applicationCrash\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.crashReason\":{\"quantumKey\":\"crashReason\",\"unifiedKey\":\"crashReason\",\"type\":\"string\"},\"application.error.crashThreadID\":{\"quantumKey\":\"crashThreadID\",\"unifiedKey\":\"crashThreadID\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"applicationPerformance\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.intValue\":{\"quantumKey\":\"operationIntValue\",\"unifiedKey\":\"operationIntValue\",\"type\":\"int\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"assetDisplayed\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.device.serialNumber\":{\"quantumKey\":\"opDeviceSerialNumber\",\"unifiedKey\":\"opDeviceSerialNumber\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"state.view.currentPage.components\":{\"quantumKey\":\"components\",\"unifiedKey\":\"currPageComponents\",\"type\":\"array\",\"elementType\":\"object\"},\"state.view.currentPage.elements.elementStringValue\":{\"quantumKey\":\"elementStringValue\",\"unifiedKey\":\"currPageElemStrValue\",\"type\":\"string\"},\"state.view.currentPage.elements.xCoordinate\":{\"quantumKey\":\"elementXCoordinate\",\"unifiedKey\":\"elementXCoordinate\",\"type\":\"string\"},\"state.view.currentPage.elements.yCoordinate\":{\"quantumKey\":\"elementYCoordinate\",\"unifiedKey\":\"elementYCoordinate\",\"type\":\"string\"},\"state.view.currentPage.pageSection.name\":{\"quantumKey\":\"pageSectionName\",\"unifiedKey\":\"currPageSecName\",\"type\":\"string\"},\"state.view.currentPage.pageSection.onSiteCampaignId\":{\"quantumKey\":\"onSiteCampaignId\",\"unifiedKey\":\"onSiteCampaignId\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"attemptRestart\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"batchApiCall\":{\"application.api.host\":{\"quantumKey\":\"host\",\"unifiedKey\":\"appApiHost\",\"type\":\"string\"},\"application.api.httpVerb\":{\"quantumKey\":\"httpVerb\",\"unifiedKey\":\"appApiHttpVerb\",\"type\":\"string\"},\"application.api.path\":{\"quantumKey\":\"path\",\"unifiedKey\":\"appApiPath\",\"type\":\"string\"},\"application.api.queryParameters\":{\"quantumKey\":\"queryParameters\",\"unifiedKey\":\"appApiQueryParameters\",\"type\":\"string\"},\"application.api.responseCode\":{\"quantumKey\":\"responseCode\",\"unifiedKey\":\"appApiResponseCode\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"}},\"bufferingStart\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"bufferingStop\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"checkAvailableChannels\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.view.currentPage.channelLineup.numberAvailableChannels\":{\"quantumKey\":\"numberAvailableChannels\",\"unifiedKey\":\"currPageChnlLineupNbrAvailChnls\",\"type\":\"int\"},\"state.view.currentPage.channelLineup.numberUnavailableChannels\":{\"quantumKey\":\"numberUnavailableChannels\",\"unifiedKey\":\"currPageChnlLineupNbrUnavailChnls\",\"type\":\"int\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"concurrencyChange\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.playback.concurrency.aegisCount\":{\"quantumKey\":\"concurrencyAegisCount\",\"unifiedKey\":\"plbkConcurrencyAegisCount\",\"type\":\"int\"},\"state.playback.concurrency.event\":{\"quantumKey\":\"concurrencyEvent\",\"unifiedKey\":\"plbkConcurrencyEvent\",\"type\":\"string\"},\"state.playback.concurrency.isBlocked\":{\"quantumKey\":\"concurrencyBlocked\",\"unifiedKey\":\"plbkConcurrencyBlocked\",\"type\":\"boolean\"},\"state.playback.concurrency.networkPolicyNetworkIds\":{\"quantumKey\":\"concurrencyPolicyNetworkIds\",\"unifiedKey\":\"plbkConcurrencyPolicyNetworkIds\",\"type\":\"array\",\"elementType\":\"string\"},\"state.playback.concurrency.policyContentTypes\":{\"quantumKey\":\"concurrencyPolicyContentTypes\",\"unifiedKey\":\"plbkConcurrencyPolicyContentTypes\",\"type\":\"array\",\"elementType\":\"string\"},\"state.playback.concurrency.policyMaxAegisLimit\":{\"quantumKey\":\"concurrencyPolicyMaxAegisLimit\",\"unifiedKey\":\"plbkConcurrencyPolicyMaxAegisLimit\",\"type\":\"int\"},\"state.playback.concurrency.policyName\":{\"quantumKey\":\"concurrencyPolicyName\",\"unifiedKey\":\"plbkConcurrencyPolicyName\",\"type\":\"string\"},\"state.playback.concurrency.policyType\":{\"quantumKey\":\"concurrencyPolicyType\",\"unifiedKey\":\"plbkConcurrencyPolicyType\",\"type\":\"string\"},\"state.playback.concurrency.token\":{\"quantumKey\":\"concurrencyToken\",\"unifiedKey\":\"plbkConcurrencyToken\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"connectionChange\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.connection.connectionType\":{\"quantumKey\":\"connectionType\",\"unifiedKey\":\"networkConnectType\",\"type\":\"string\"},\"visit.connection.deviceLocation\":{\"quantumKey\":\"connectionDeviceLocation\",\"unifiedKey\":\"connectionDeviceLocation\",\"type\":\"string\"},\"visit.connection.networkCellCarrier\":{\"quantumKey\":\"networkCellCarrier\",\"unifiedKey\":\"networkCellCarrier\",\"type\":\"string\"},\"visit.connection.networkCellNetworkType\":{\"quantumKey\":\"networkCellNetworkType\",\"unifiedKey\":\"networkCellNetworkType\",\"type\":\"string\"},\"visit.connection.networkStatus\":{\"quantumKey\":\"networkStatus\",\"unifiedKey\":\"networkStatus\",\"type\":\"string\"}},\"customEvent\":{\"custom.domain\":{\"quantumKey\":\"customDomain\",\"unifiedKey\":\"customDomain\",\"type\":\"string\"},\"custom.level\":{\"quantumKey\":\"customLevel\",\"unifiedKey\":\"customLevel\",\"type\":\"string\"},\"custom.message\":{\"quantumKey\":\"customMessage\",\"unifiedKey\":\"customMessage\",\"type\":\"map\",\"elementType\":\"string\"},\"custom.name\":{\"quantumKey\":\"customName\",\"unifiedKey\":\"customName\",\"type\":\"string\"},\"custom.sourceCodeInfo.fileName\":{\"quantumKey\":\"fileName\",\"unifiedKey\":\"codeFileName\",\"type\":\"string\"},\"custom.sourceCodeInfo.functionName\":{\"quantumKey\":\"functionName\",\"unifiedKey\":\"codeFnName\",\"type\":\"string\"},\"custom.sourceCodeInfo.lineNumber\":{\"quantumKey\":\"lineNumber\",\"unifiedKey\":\"codeLineNbr\",\"type\":\"int\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"deeplinkStart\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.referrer.instanceCampaignId\":{\"quantumKey\":\"instanceCampaignId\",\"unifiedKey\":\"instanceCampaignId\",\"type\":\"string\"},\"state.referrer.instanceContext\":{\"quantumKey\":\"instanceContext\",\"unifiedKey\":\"instanceContext\",\"type\":\"string\"},\"state.referrer.instanceLink\":{\"quantumKey\":\"instanceLink\",\"unifiedKey\":\"instanceLink\",\"type\":\"string\"},\"state.referrer.instanceLocation\":{\"quantumKey\":\"instanceLocation\",\"unifiedKey\":\"instanceLocation\",\"type\":\"string\"},\"state.userJourney.currentFeature.name\":{\"quantumKey\":\"userJourneyCurrentFeatureName\",\"unifiedKey\":\"userJourneyCurrentFeatureName\",\"type\":\"string\"},\"state.userJourney.featureFlagged\":{\"quantumKey\":\"userJourneyFeatureFlagged\",\"unifiedKey\":\"userJourneyFeatureFlagged\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.applicationDetails.campaign.campaignId\":{\"quantumKey\":\"campaignId\",\"unifiedKey\":\"campaignId\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.applicationName\":{\"quantumKey\":\"referrerAppName\",\"unifiedKey\":\"referrerAppName\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.applicationType\":{\"quantumKey\":\"referrerAppType\",\"unifiedKey\":\"referrerAppType\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.visitId\":{\"quantumKey\":\"referrerAppVisitId\",\"unifiedKey\":\"referrerAppVisitId\",\"type\":\"string\"},\"visit.applicationDetails.technologyType\":{\"quantumKey\":\"technologyType\",\"unifiedKey\":\"techType\",\"type\":\"string\"}},\"deeplinkStop\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"displayChange\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"state.view.playbackDisplayType\":{\"quantumKey\":\"playbackDisplayType\",\"unifiedKey\":\"playbackDisplayType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.screenResolution\":{\"quantumKey\":\"screenResolution\",\"unifiedKey\":\"screenResolution\",\"type\":\"string\"}},\"error\":{\"application.api.apiCached\":{\"quantumKey\":\"apiCached\",\"unifiedKey\":\"appApiCached\",\"type\":\"boolean\"},\"application.api.architecture\":{\"quantumKey\":\"apiArchitecture\",\"unifiedKey\":\"apiArchitecture\",\"type\":\"string\"},\"application.api.clientServiceResult\":{\"quantumKey\":\"clientServiceResult\",\"unifiedKey\":\"clientServiceResult\",\"type\":\"string\"},\"application.api.gql.errorCode\":{\"quantumKey\":\"gqlErrorCode\",\"unifiedKey\":\"gqlErrorCode\",\"type\":\"string\"},\"application.api.gql.hashId\":{\"quantumKey\":\"gqlHashId\",\"unifiedKey\":\"gqlHashId\",\"type\":\"string\"},\"application.api.gql.operationName\":{\"quantumKey\":\"gqlOperationName\",\"unifiedKey\":\"gqlOperationName\",\"type\":\"string\"},\"application.api.gql.operationType\":{\"quantumKey\":\"gqlOperationType\",\"unifiedKey\":\"gqlOperationType\",\"type\":\"string\"},\"application.api.host\":{\"quantumKey\":\"host\",\"unifiedKey\":\"appApiHost\",\"type\":\"string\"},\"application.api.httpVerb\":{\"quantumKey\":\"httpVerb\",\"unifiedKey\":\"appApiHttpVerb\",\"type\":\"string\"},\"application.api.maxRetryCount\":{\"quantumKey\":\"maxRetryCount\",\"unifiedKey\":\"appApiMaxRetryCnt\",\"type\":\"int\"},\"application.api.path\":{\"quantumKey\":\"path\",\"unifiedKey\":\"appApiPath\",\"type\":\"string\"},\"application.api.queryParameters\":{\"quantumKey\":\"queryParameters\",\"unifiedKey\":\"appApiQueryParameters\",\"type\":\"string\"},\"application.api.reportedHeaders\":{\"quantumKey\":\"apiReportedHeaders\",\"unifiedKey\":\"apiReportedHeaders\",\"type\":\"string\"},\"application.api.responseCode\":{\"quantumKey\":\"responseCode\",\"unifiedKey\":\"appApiResponseCode\",\"type\":\"string\"},\"application.api.responseSize\":{\"quantumKey\":\"responseSize\",\"unifiedKey\":\"appApiResponseSize\",\"type\":\"int\"},\"application.api.responseText\":{\"quantumKey\":\"responseText\",\"unifiedKey\":\"appApiResponseText\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.api.responseTimeMs\":{\"quantumKey\":\"responseTimeMs\",\"unifiedKey\":\"appApiResponseTimeMs\",\"type\":\"int\"},\"application.api.retry\":{\"quantumKey\":\"retry\",\"unifiedKey\":\"appApiRetry\",\"type\":\"boolean\"},\"application.api.retryCount\":{\"quantumKey\":\"retryCount\",\"unifiedKey\":\"appApiRetryCnt\",\"type\":\"int\"},\"application.api.traceId\":{\"quantumKey\":\"traceId\",\"unifiedKey\":\"appApiTraceId\",\"type\":\"string\"},\"application.api.transactionId\":{\"quantumKey\":\"apiTransactionId\",\"unifiedKey\":\"apiTransactionId\",\"type\":\"string\"},\"application.api.willRetry\":{\"quantumKey\":\"willRetry\",\"unifiedKey\":\"appApiWillRetry\",\"type\":\"boolean\"},\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.channelAvailableMemoryMb\":{\"quantumKey\":\"channelAvailableMemory\",\"unifiedKey\":\"channelAvailableMemory\",\"type\":\"string\"},\"application.error.errorExtras.exceptionData\":{\"quantumKey\":\"exceptionData\",\"unifiedKey\":\"exceptionData\",\"type\":\"string\"},\"application.error.errorExtras.lastDownloadedSegment\":{\"quantumKey\":\"lastDownloadedSegment\",\"unifiedKey\":\"lastDownloadedSegment\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorExtras.passedJailbreakChecks\":{\"quantumKey\":\"passedJailbreakChecks\",\"unifiedKey\":\"passedJailbreakChecks\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.outage.etr\":{\"quantumKey\":\"outageEtr\",\"unifiedKey\":\"outageEtr\",\"type\":\"boolean\"},\"operation.outage.pid\":{\"quantumKey\":\"outagePid\",\"unifiedKey\":\"outagePid\",\"type\":\"string\"},\"operation.outage.replacementMessagingUsed\":{\"quantumKey\":\"replacementMessagingUsed\",\"unifiedKey\":\"replacementMessagingUsed\",\"type\":\"boolean\"},\"operation.outage.status\":{\"quantumKey\":\"outageStatus\",\"unifiedKey\":\"outageStatus\",\"type\":\"string\"},\"operation.outage.type\":{\"quantumKey\":\"outageType\",\"unifiedKey\":\"outageType\",\"type\":\"string\"},\"operation.userPreferencesSelections\":{\"quantumKey\":\"userPreferencesSelections\",\"unifiedKey\":\"opUserPrefsSelections\",\"type\":\"array\",\"elementType\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"externalAppStateChange\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"featureStart\":{\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.accountNumber\":{\"quantumKey\":\"featureAccountNumber\",\"unifiedKey\":\"featureAccountNumber\",\"type\":\"string\"},\"message.feature.buyflow.offerId\":{\"quantumKey\":\"buyflowOfferId\",\"unifiedKey\":\"buyflowOfferId\",\"type\":\"string\"},\"message.feature.clientCart\":{\"quantumKey\":\"featureClientCart\",\"unifiedKey\":\"featureClientCart\",\"type\":\"array\",\"elementType\":\"object\"},\"message.feature.currentLineup\":{\"quantumKey\":\"featureCurrentLineup\",\"unifiedKey\":\"featureCurrentLineup\",\"type\":\"array\",\"elementType\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.userPreferencesSelections\":{\"quantumKey\":\"userPreferencesSelections\",\"unifiedKey\":\"opUserPrefsSelections\",\"type\":\"array\",\"elementType\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"featureStop\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.buyflow.offerId\":{\"quantumKey\":\"buyflowOfferId\",\"unifiedKey\":\"buyflowOfferId\",\"type\":\"string\"},\"message.feature.clientCart\":{\"quantumKey\":\"featureClientCart\",\"unifiedKey\":\"featureClientCart\",\"type\":\"array\",\"elementType\":\"object\"},\"message.feature.currentLineup\":{\"quantumKey\":\"featureCurrentLineup\",\"unifiedKey\":\"featureCurrentLineup\",\"type\":\"array\",\"elementType\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.billing.paymentAmountUsd\":{\"quantumKey\":\"paymentAmountUsd\",\"unifiedKey\":\"pmtAmount\",\"type\":\"double\"},\"operation.billing.paymentDate\":{\"quantumKey\":\"paymentDate\",\"unifiedKey\":\"pmtDate\",\"type\":\"string\"},\"operation.billing.paymentDueDate\":{\"quantumKey\":\"paymentDueDate\",\"unifiedKey\":\"pmtDueDate\",\"type\":\"string\"},\"operation.billing.paymentMethod\":{\"quantumKey\":\"paymentMethod\",\"unifiedKey\":\"pmtMethod\",\"type\":\"string\"},\"operation.billing.statementAge\":{\"quantumKey\":\"statementAge\",\"unifiedKey\":\"statementDate\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"forcedLogin\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"impressionStart\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.impression.adId\":{\"quantumKey\":\"impressionAdId\",\"unifiedKey\":\"impressionAdId\",\"type\":\"string\"},\"state.impression.campaignId\":{\"quantumKey\":\"impressionCampaignId\",\"unifiedKey\":\"impressionCampaignId\",\"type\":\"string\"},\"state.impression.contentTitle\":{\"quantumKey\":\"impressionContentTitle\",\"unifiedKey\":\"impressionContentTitle\",\"type\":\"string\"},\"state.impression.height\":{\"quantumKey\":\"impressionHeight\",\"unifiedKey\":\"impressionHeight\",\"type\":\"int\"},\"state.impression.id\":{\"quantumKey\":\"impressionId\",\"unifiedKey\":\"impressionId\",\"type\":\"string\"},\"state.impression.impressionType\":{\"quantumKey\":\"impressionType\",\"unifiedKey\":\"impressionType\",\"type\":\"string\"},\"state.impression.location\":{\"quantumKey\":\"impressionLocation\",\"unifiedKey\":\"impressionLocation\",\"type\":\"string\"},\"state.impression.locationTmsGuideId\":{\"quantumKey\":\"impressionLocationTmsGuideId\",\"unifiedKey\":\"impressionLocationTmsGuideId\",\"type\":\"string\"},\"state.impression.scope\":{\"quantumKey\":\"impressionScope\",\"unifiedKey\":\"impressionScope\",\"type\":\"string\"},\"state.impression.scopeId\":{\"quantumKey\":\"impressionScopeId\",\"unifiedKey\":\"impressionScopeId\",\"type\":\"string\"},\"state.impression.subScopeId\":{\"quantumKey\":\"impressionSubScopeId\",\"unifiedKey\":\"impressionSubScopeId\",\"type\":\"string\"},\"state.impression.tmsProgramId\":{\"quantumKey\":\"impressionProgramId\",\"unifiedKey\":\"impressionProgramId\",\"type\":\"string\"},\"state.impression.tmsSeriesId\":{\"quantumKey\":\"impressionSeriesId\",\"unifiedKey\":\"impressionSeriesId\",\"type\":\"string\"},\"state.impression.width\":{\"quantumKey\":\"impressionWidth\",\"unifiedKey\":\"impressionWidth\",\"type\":\"int\"},\"state.view.currentPage.pageSection.onSiteCampaignId\":{\"quantumKey\":\"onSiteCampaignId\",\"unifiedKey\":\"onSiteCampaignId\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"impressionStop\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.impression.id\":{\"quantumKey\":\"impressionId\",\"unifiedKey\":\"impressionId\",\"type\":\"string\"},\"state.impression.interaction\":{\"quantumKey\":\"impressionInteraction\",\"unifiedKey\":\"impressionInteraction\",\"type\":\"string\"},\"state.impression.location\":{\"quantumKey\":\"impressionLocation\",\"unifiedKey\":\"impressionLocation\",\"type\":\"string\"},\"state.impression.locationTmsGuideId\":{\"quantumKey\":\"impressionLocationTmsGuideId\",\"unifiedKey\":\"impressionLocationTmsGuideId\",\"type\":\"string\"},\"state.userJourney.currentFeature.name\":{\"quantumKey\":\"userJourneyCurrentFeatureName\",\"unifiedKey\":\"userJourneyCurrentFeatureName\",\"type\":\"string\"},\"state.userJourney.featureFlagged\":{\"quantumKey\":\"userJourneyFeatureFlagged\",\"unifiedKey\":\"userJourneyFeatureFlagged\",\"type\":\"boolean\"},\"state.view.currentPage.pageSection.onSiteCampaignId\":{\"quantumKey\":\"onSiteCampaignId\",\"unifiedKey\":\"onSiteCampaignId\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"inVisitOauthRefresh\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"oAuthToken\":{\"quantumKey\":\"oAuthToken\",\"unifiedKey\":\"accountOauthToken\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"tokenType\":{\"quantumKey\":\"tokenType\",\"unifiedKey\":\"accountTokenType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.login.oauthExpirationTimestamp\":{\"quantumKey\":\"oAuthExpirationTimestamp\",\"unifiedKey\":\"loginCompletedTs\",\"type\":\"long\"}},\"loginStart\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.userEntry.text\":{\"quantumKey\":\"entryText\",\"unifiedKey\":\"opUserText\",\"type\":\"string\"},\"operation.userPreferencesSelections\":{\"quantumKey\":\"userPreferencesSelections\",\"unifiedKey\":\"opUserPrefsSelections\",\"type\":\"array\",\"elementType\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.appIdentifier\":{\"quantumKey\":\"appIdentifier\",\"unifiedKey\":\"appIdentifier\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.applicationName\":{\"quantumKey\":\"referrerAppName\",\"unifiedKey\":\"referrerAppName\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.applicationType\":{\"quantumKey\":\"referrerAppType\",\"unifiedKey\":\"referrerAppType\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.commonToken\":{\"quantumKey\":\"referrerAppCommonToken\",\"unifiedKey\":\"referrerAppCommonToken\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.visitId\":{\"quantumKey\":\"referrerAppVisitId\",\"unifiedKey\":\"referrerAppVisitId\",\"type\":\"string\"},\"visit.applicationDetails.referrerLink\":{\"quantumKey\":\"referrerLink\",\"unifiedKey\":\"appRefLink\",\"type\":\"string\"},\"visit.applicationDetails.referrerLocation\":{\"quantumKey\":\"referrerLocation\",\"unifiedKey\":\"appRefLocation\",\"type\":\"string\"}},\"loginStop\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"oAuthToken\":{\"quantumKey\":\"oAuthToken\",\"unifiedKey\":\"accountOauthToken\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"tokenType\":{\"quantumKey\":\"tokenType\",\"unifiedKey\":\"accountTokenType\",\"type\":\"string\"},\"visit.account.accountGUID\":{\"quantumKey\":\"accountGUID\",\"unifiedKey\":\"accountGUID\",\"type\":\"string\"},\"visit.account.configurationFactors\":{\"quantumKey\":\"configurationFactors\",\"unifiedKey\":\"configurationFactors\",\"type\":\"string\"},\"visit.account.identityGUID\":{\"quantumKey\":\"identityGUID\",\"unifiedKey\":\"identityGUID\",\"type\":\"string\"},\"visit.account.trustedAuthId\":{\"quantumKey\":\"trustedAuthId\",\"unifiedKey\":\"trustedAuthId\",\"type\":\"string\"},\"visit.account.tvProvider\":{\"quantumKey\":\"tvProvider\",\"unifiedKey\":\"tvProvider\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.applicationName\":{\"quantumKey\":\"referrerAppName\",\"unifiedKey\":\"referrerAppName\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.applicationType\":{\"quantumKey\":\"referrerAppType\",\"unifiedKey\":\"referrerAppType\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.visitId\":{\"quantumKey\":\"referrerAppVisitId\",\"unifiedKey\":\"referrerAppVisitId\",\"type\":\"string\"},\"visit.applicationDetails.referrerLink\":{\"quantumKey\":\"referrerLink\",\"unifiedKey\":\"appRefLink\",\"type\":\"string\"},\"visit.applicationDetails.referrerLocation\":{\"quantumKey\":\"referrerLocation\",\"unifiedKey\":\"appRefLocation\",\"type\":\"string\"},\"visit.device.linkedDevice.id\":{\"quantumKey\":\"linkedDeviceId\",\"unifiedKey\":\"deviceLinkedId\",\"type\":\"string\"},\"visit.device.linkedDevice.name\":{\"quantumKey\":\"linkedDeviceName\",\"unifiedKey\":\"deviceLinkedName\",\"type\":\"string\"},\"visit.login.authAttemptId\":{\"quantumKey\":\"authAttemptId\",\"unifiedKey\":\"loginAttemptId\",\"type\":\"string\"},\"visit.login.oauthExpirationTimestamp\":{\"quantumKey\":\"oAuthExpirationTimestamp\",\"unifiedKey\":\"loginCompletedTs\",\"type\":\"long\"},\"visit.login.userToken\":{\"quantumKey\":\"userToken\",\"unifiedKey\":\"userToken\",\"type\":\"string\"}},\"logout\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"modalClose\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"modalView\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.buyflow.offerId\":{\"quantumKey\":\"buyflowOfferId\",\"unifiedKey\":\"buyflowOfferId\",\"type\":\"string\"},\"message.feature.clientCart\":{\"quantumKey\":\"featureClientCart\",\"unifiedKey\":\"featureClientCart\",\"type\":\"array\",\"elementType\":\"object\"},\"message.feature.currentLineup\":{\"quantumKey\":\"featureCurrentLineup\",\"unifiedKey\":\"featureCurrentLineup\",\"type\":\"array\",\"elementType\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.outage.etr\":{\"quantumKey\":\"outageEtr\",\"unifiedKey\":\"outageEtr\",\"type\":\"boolean\"},\"operation.outage.pid\":{\"quantumKey\":\"outagePid\",\"unifiedKey\":\"outagePid\",\"type\":\"string\"},\"operation.outage.replacementMessagingUsed\":{\"quantumKey\":\"replacementMessagingUsed\",\"unifiedKey\":\"replacementMessagingUsed\",\"type\":\"boolean\"},\"operation.outage.status\":{\"quantumKey\":\"outageStatus\",\"unifiedKey\":\"outageStatus\",\"type\":\"string\"},\"operation.outage.type\":{\"quantumKey\":\"outageType\",\"unifiedKey\":\"outageType\",\"type\":\"string\"},\"state.view.modal.loadTimeMs\":{\"quantumKey\":\"loadTimeMs\",\"unifiedKey\":\"modalLoadTimeMs\",\"type\":\"int\"},\"state.view.modal.modalType\":{\"quantumKey\":\"modalType\",\"unifiedKey\":\"modalType\",\"type\":\"string\"},\"state.view.modal.name\":{\"quantumKey\":\"modalName\",\"unifiedKey\":\"modalName\",\"type\":\"string\"},\"state.view.modal.text\":{\"quantumKey\":\"modalText\",\"unifiedKey\":\"modalText\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"pageView\":{\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.accountNumber\":{\"quantumKey\":\"featureAccountNumber\",\"unifiedKey\":\"featureAccountNumber\",\"type\":\"string\"},\"message.feature.buyflow.offerId\":{\"quantumKey\":\"buyflowOfferId\",\"unifiedKey\":\"buyflowOfferId\",\"type\":\"string\"},\"message.feature.clientCart\":{\"quantumKey\":\"featureClientCart\",\"unifiedKey\":\"featureClientCart\",\"type\":\"array\",\"elementType\":\"object\"},\"message.feature.currentLineup\":{\"quantumKey\":\"featureCurrentLineup\",\"unifiedKey\":\"featureCurrentLineup\",\"type\":\"array\",\"elementType\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.feature.previousStep\":{\"quantumKey\":\"featurePreviousStep\",\"unifiedKey\":\"msgFeaturePrevStep\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.outage.etr\":{\"quantumKey\":\"outageEtr\",\"unifiedKey\":\"outageEtr\",\"type\":\"boolean\"},\"operation.outage.pid\":{\"quantumKey\":\"outagePid\",\"unifiedKey\":\"outagePid\",\"type\":\"string\"},\"state.view.content.identifiers.dvrRecordingId\":{\"quantumKey\":\"dvrRecordingId\",\"unifiedKey\":\"dvrRecordingId\",\"type\":\"string\"},\"state.view.content.identifiers.providerAssetId\":{\"quantumKey\":\"providerAssetId\",\"unifiedKey\":\"providerAssetId\",\"type\":\"string\"},\"state.view.content.identifiers.tmsGuideId\":{\"quantumKey\":\"tmsGuideId\",\"unifiedKey\":\"tmsGuideId\",\"type\":\"string\"},\"state.view.content.identifiers.tmsProgramId\":{\"quantumKey\":\"tmsProgramId\",\"unifiedKey\":\"tmsProgramId\",\"type\":\"string\"},\"state.view.content.identifiers.tmsSeriesId\":{\"quantumKey\":\"tmsSeriesId\",\"unifiedKey\":\"tmsSeriesId\",\"type\":\"string\"},\"state.view.currentPage.appSection\":{\"quantumKey\":\"appSection\",\"unifiedKey\":\"currPageAppSection\",\"type\":\"string\"},\"state.view.currentPage.billing.billDueDate\":{\"quantumKey\":\"billDueDate\",\"unifiedKey\":\"billDueDate\",\"type\":\"long\"},\"state.view.currentPage.billing.billEndDate\":{\"quantumKey\":\"billEndDate\",\"unifiedKey\":\"billEndDate\",\"type\":\"long\"},\"state.view.currentPage.billing.billProgress\":{\"quantumKey\":\"billProgress\",\"unifiedKey\":\"billProgress\",\"type\":\"int\"},\"state.view.currentPage.billing.billStartDate\":{\"quantumKey\":\"billStartDate\",\"unifiedKey\":\"billStartDate\",\"type\":\"long\"},\"state.view.currentPage.billing.ccVendor\":{\"quantumKey\":\"ccVendor\",\"unifiedKey\":\"ccVendor\",\"type\":\"string\"},\"state.view.currentPage.billing.paymentMethod\":{\"quantumKey\":\"paymentMethod\",\"unifiedKey\":\"currPagePmtMethod\",\"type\":\"string\"},\"state.view.currentPage.billing.recentCharges\":{\"quantumKey\":\"recentCharges\",\"unifiedKey\":\"recentCharges\",\"type\":\"double\"},\"state.view.currentPage.components\":{\"quantumKey\":\"components\",\"unifiedKey\":\"currPageComponents\",\"type\":\"array\",\"elementType\":\"object\"},\"state.view.currentPage.currentBalanceAmount\":{\"quantumKey\":\"currentBalanceAmount\",\"unifiedKey\":\"currentBalAmt\",\"type\":\"double\"},\"state.view.currentPage.orders\":{\"quantumKey\":\"currentPageOrders\",\"unifiedKey\":\"currentPageOrders\",\"type\":\"array\",\"elementType\":\"object\"},\"state.view.currentPage.pageSection.allDisplayed\":{\"quantumKey\":\"sectionAllDisplayed\",\"unifiedKey\":\"pageSecAllDisplayed\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.currentPage.pageSection.numberOfItems\":{\"quantumKey\":\"pageSectionNumberOfItems\",\"unifiedKey\":\"currPageSecItemCnt\",\"type\":\"int\"},\"state.view.currentPage.pageSubSection.allDisplayed\":{\"quantumKey\":\"subSectionAllDisplayed\",\"unifiedKey\":\"pageSubSecAllDisplayed\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.currentPage.pastDueAmount\":{\"quantumKey\":\"pastDueAmount\",\"unifiedKey\":\"pastDueAmt\",\"type\":\"double\"},\"state.view.currentPage.settings\":{\"quantumKey\":\"settings\",\"unifiedKey\":\"currPageSettings\",\"type\":\"map\",\"elementType\":\"string\"},\"state.view.currentPage.settings.adultTitles\":{\"quantumKey\":\"currPageSettingsAdultTitles\",\"unifiedKey\":\"currPageSettingsAdultTitles\",\"type\":\"string\"},\"state.view.currentPage.settings.autoplayEnabled\":{\"quantumKey\":\"settingsAutoplayEnabled\",\"unifiedKey\":\"currPageSettingsAutoplayEnabled\",\"type\":\"string\"},\"state.view.currentPage.settings.enabled\":{\"quantumKey\":\"currPageSettingsEnabled\",\"unifiedKey\":\"currPageSettingsEnabled\",\"type\":\"string\"},\"state.view.currentPage.settings.hdAutoTune\":{\"quantumKey\":\"currPageSettingsHdAutoTune\",\"unifiedKey\":\"currPageSettingsHdAutoTune\",\"type\":\"string\"},\"state.view.currentPage.settings.size\":{\"quantumKey\":\"currPageSettingsSize\",\"unifiedKey\":\"currPageSettingsSize\",\"type\":\"string\"},\"state.view.currentPage.settings.theme\":{\"quantumKey\":\"currPageSettingsTheme\",\"unifiedKey\":\"currPageSettingsTheme\",\"type\":\"string\"},\"state.view.currentPage.settings.youtube\":{\"quantumKey\":\"currPageSettingsYoutube\",\"unifiedKey\":\"currPageSettingsYoutube\",\"type\":\"string\"},\"state.view.currentPage.sortAndFilter.appliedFilters\":{\"quantumKey\":\"appliedFilters\",\"unifiedKey\":\"currPageAppliedFilters\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.currentPage.sortAndFilter.appliedSorts\":{\"quantumKey\":\"appliedSorts\",\"unifiedKey\":\"currPageAppliedSorts\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.currentPage.totalAmountDue\":{\"quantumKey\":\"totalAmountDue\",\"unifiedKey\":\"totalAmtDue\",\"type\":\"double\"},\"state.view.currentPage.uiResponsiveBreakpoint\":{\"quantumKey\":\"uiResponsiveBreakpoint\",\"unifiedKey\":\"uiResponsiveBreakpoint\",\"type\":\"int\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.applicationDetails.referrerLink\":{\"quantumKey\":\"referrerLink\",\"unifiedKey\":\"appRefLink\",\"type\":\"string\"},\"visit.applicationDetails.referrerLocation\":{\"quantumKey\":\"referrerLocation\",\"unifiedKey\":\"appRefLocation\",\"type\":\"string\"},\"visit.promotion.buyflow.presentedOffers\":{\"quantumKey\":\"presentedOffers\",\"unifiedKey\":\"presentedOffers\",\"type\":\"array\",\"elementType\":\"string\"}},\"pageViewInit\":{\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.accountNumber\":{\"quantumKey\":\"featureAccountNumber\",\"unifiedKey\":\"featureAccountNumber\",\"type\":\"string\"},\"message.feature.buyflow.offerId\":{\"quantumKey\":\"buyflowOfferId\",\"unifiedKey\":\"buyflowOfferId\",\"type\":\"string\"},\"message.feature.clientCart\":{\"quantumKey\":\"featureClientCart\",\"unifiedKey\":\"featureClientCart\",\"type\":\"array\",\"elementType\":\"object\"},\"message.feature.currentLineup\":{\"quantumKey\":\"featureCurrentLineup\",\"unifiedKey\":\"featureCurrentLineup\",\"type\":\"array\",\"elementType\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.feature.previousStep\":{\"quantumKey\":\"featurePreviousStep\",\"unifiedKey\":\"msgFeaturePrevStep\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.outage.etr\":{\"quantumKey\":\"outageEtr\",\"unifiedKey\":\"outageEtr\",\"type\":\"boolean\"},\"operation.outage.pid\":{\"quantumKey\":\"outagePid\",\"unifiedKey\":\"outagePid\",\"type\":\"string\"},\"state.userJourney.featureFlagged\":{\"quantumKey\":\"userJourneyFeatureFlagged\",\"unifiedKey\":\"userJourneyFeatureFlagged\",\"type\":\"boolean\"},\"state.view.content.identifiers.dvrRecordingId\":{\"quantumKey\":\"dvrRecordingId\",\"unifiedKey\":\"dvrRecordingId\",\"type\":\"string\"},\"state.view.content.identifiers.providerAssetId\":{\"quantumKey\":\"providerAssetId\",\"unifiedKey\":\"providerAssetId\",\"type\":\"string\"},\"state.view.content.identifiers.tmsGuideId\":{\"quantumKey\":\"tmsGuideId\",\"unifiedKey\":\"tmsGuideId\",\"type\":\"string\"},\"state.view.content.identifiers.tmsProgramId\":{\"quantumKey\":\"tmsProgramId\",\"unifiedKey\":\"tmsProgramId\",\"type\":\"string\"},\"state.view.content.identifiers.tmsSeriesId\":{\"quantumKey\":\"tmsSeriesId\",\"unifiedKey\":\"tmsSeriesId\",\"type\":\"string\"},\"state.view.currentPage.appSection\":{\"quantumKey\":\"appSection\",\"unifiedKey\":\"currPageAppSection\",\"type\":\"string\"},\"state.view.currentPage.billing.billDueDate\":{\"quantumKey\":\"billDueDate\",\"unifiedKey\":\"billDueDate\",\"type\":\"long\"},\"state.view.currentPage.billing.billEndDate\":{\"quantumKey\":\"billEndDate\",\"unifiedKey\":\"billEndDate\",\"type\":\"long\"},\"state.view.currentPage.billing.billProgress\":{\"quantumKey\":\"billProgress\",\"unifiedKey\":\"billProgress\",\"type\":\"int\"},\"state.view.currentPage.billing.billStartDate\":{\"quantumKey\":\"billStartDate\",\"unifiedKey\":\"billStartDate\",\"type\":\"long\"},\"state.view.currentPage.billing.ccVendor\":{\"quantumKey\":\"ccVendor\",\"unifiedKey\":\"ccVendor\",\"type\":\"string\"},\"state.view.currentPage.billing.paymentMethod\":{\"quantumKey\":\"paymentMethod\",\"unifiedKey\":\"currPagePmtMethod\",\"type\":\"string\"},\"state.view.currentPage.billing.recentCharges\":{\"quantumKey\":\"recentCharges\",\"unifiedKey\":\"recentCharges\",\"type\":\"double\"},\"state.view.currentPage.campaign.pageViewCampaignId\":{\"quantumKey\":\"pageViewCampaignId\",\"unifiedKey\":\"currPageCampaignId\",\"type\":\"string\"},\"state.view.currentPage.childMarket\":{\"quantumKey\":\"viewChildMarket\",\"unifiedKey\":\"viewChildMarket\",\"type\":\"string\"},\"state.view.currentPage.components\":{\"quantumKey\":\"components\",\"unifiedKey\":\"currPageComponents\",\"type\":\"array\",\"elementType\":\"object\"},\"state.view.currentPage.currentBalanceAmount\":{\"quantumKey\":\"currentBalanceAmount\",\"unifiedKey\":\"currentBalAmt\",\"type\":\"double\"},\"state.view.currentPage.mfeVersion\":{\"quantumKey\":\"currentPageMfeVersion\",\"unifiedKey\":\"currentPageMfeVersion\",\"type\":\"string\"},\"state.view.currentPage.orders\":{\"quantumKey\":\"currentPageOrders\",\"unifiedKey\":\"currentPageOrders\",\"type\":\"array\",\"elementType\":\"object\"},\"state.view.currentPage.pageDisplayType\":{\"quantumKey\":\"pageDisplayType\",\"unifiedKey\":\"currPagePageDisplayType\",\"type\":\"string\"},\"state.view.currentPage.pageId\":{\"quantumKey\":\"pageId\",\"unifiedKey\":\"currPageId\",\"type\":\"string\"},\"state.view.currentPage.pageName\":{\"quantumKey\":\"pageName\",\"unifiedKey\":\"currPageName\",\"type\":\"string\"},\"state.view.currentPage.pageSection.allDisplayed\":{\"quantumKey\":\"sectionAllDisplayed\",\"unifiedKey\":\"pageSecAllDisplayed\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.currentPage.pageSection.numberOfItems\":{\"quantumKey\":\"pageSectionNumberOfItems\",\"unifiedKey\":\"currPageSecItemCnt\",\"type\":\"int\"},\"state.view.currentPage.pageSubSection.allDisplayed\":{\"quantumKey\":\"subSectionAllDisplayed\",\"unifiedKey\":\"pageSubSecAllDisplayed\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.currentPage.pageTitle\":{\"quantumKey\":\"pageTitle\",\"unifiedKey\":\"currPageTitle\",\"type\":\"string\"},\"state.view.currentPage.pageType\":{\"quantumKey\":\"pageType\",\"unifiedKey\":\"currPagePageType\",\"type\":\"string\"},\"state.view.currentPage.pageViewType\":{\"quantumKey\":\"pageViewType\",\"unifiedKey\":\"currPagePageViewType\",\"type\":\"string\"},\"state.view.currentPage.parentMarket\":{\"quantumKey\":\"viewParentMarket\",\"unifiedKey\":\"viewParentMarket\",\"type\":\"string\"},\"state.view.currentPage.pastDueAmount\":{\"quantumKey\":\"pastDueAmount\",\"unifiedKey\":\"pastDueAmt\",\"type\":\"double\"},\"state.view.currentPage.renderDetails.isLazyLoad\":{\"quantumKey\":\"isLazyLoad\",\"unifiedKey\":\"currPageIsLazyLoad\",\"type\":\"boolean\"},\"state.view.currentPage.settings\":{\"quantumKey\":\"settings\",\"unifiedKey\":\"currPageSettings\",\"type\":\"map\",\"elementType\":\"string\"},\"state.view.currentPage.settings.adultTitles\":{\"quantumKey\":\"currPageSettingsAdultTitles\",\"unifiedKey\":\"currPageSettingsAdultTitles\",\"type\":\"string\"},\"state.view.currentPage.settings.autoplayEnabled\":{\"quantumKey\":\"settingsAutoplayEnabled\",\"unifiedKey\":\"currPageSettingsAutoplayEnabled\",\"type\":\"string\"},\"state.view.currentPage.settings.enabled\":{\"quantumKey\":\"currPageSettingsEnabled\",\"unifiedKey\":\"currPageSettingsEnabled\",\"type\":\"string\"},\"state.view.currentPage.settings.hdAutoTune\":{\"quantumKey\":\"currPageSettingsHdAutoTune\",\"unifiedKey\":\"currPageSettingsHdAutoTune\",\"type\":\"string\"},\"state.view.currentPage.settings.size\":{\"quantumKey\":\"currPageSettingsSize\",\"unifiedKey\":\"currPageSettingsSize\",\"type\":\"string\"},\"state.view.currentPage.settings.theme\":{\"quantumKey\":\"currPageSettingsTheme\",\"unifiedKey\":\"currPageSettingsTheme\",\"type\":\"string\"},\"state.view.currentPage.settings.youtube\":{\"quantumKey\":\"currPageSettingsYoutube\",\"unifiedKey\":\"currPageSettingsYoutube\",\"type\":\"string\"},\"state.view.currentPage.sortAndFilter.appliedFilters\":{\"quantumKey\":\"appliedFilters\",\"unifiedKey\":\"currPageAppliedFilters\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.currentPage.sortAndFilter.appliedSorts\":{\"quantumKey\":\"appliedSorts\",\"unifiedKey\":\"currPageAppliedSorts\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.currentPage.totalAmountDue\":{\"quantumKey\":\"totalAmountDue\",\"unifiedKey\":\"totalAmtDue\",\"type\":\"double\"},\"state.view.currentPage.uiResponsiveBreakpoint\":{\"quantumKey\":\"uiResponsiveBreakpoint\",\"unifiedKey\":\"uiResponsiveBreakpoint\",\"type\":\"int\"},\"state.view.currentPage.userJourney\":{\"quantumKey\":\"userJourney\",\"unifiedKey\":\"userJourney\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.currentPage.userSubJourney\":{\"quantumKey\":\"userSubJourney\",\"unifiedKey\":\"userSubJourney\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.userActivity.maxContentClickedOverall\":{\"quantumKey\":\"maxContentClickedOverall\",\"unifiedKey\":\"maxContentClickedOverall\",\"type\":\"int\"},\"state.view.userActivity.maximumXScrollIndex\":{\"quantumKey\":\"maximumXScrollIndex\",\"unifiedKey\":\"maximumXScrollIndex\",\"type\":\"int\"},\"state.view.userActivity.maximumXScrollName\":{\"quantumKey\":\"maximumXScrollName\",\"unifiedKey\":\"maximumXScrollName\",\"type\":\"string\"},\"state.view.userActivity.maximumYScrollIndex\":{\"quantumKey\":\"maximumYScrollIndex\",\"unifiedKey\":\"maximumYScrollIndex\",\"type\":\"int\"},\"state.view.userActivity.maximumYScrollName\":{\"quantumKey\":\"maximumYScrollName\",\"unifiedKey\":\"maximumYScrollName\",\"type\":\"string\"},\"state.view.userActivity.pageContext\":{\"quantumKey\":\"pageContext\",\"unifiedKey\":\"pageContext\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.userActivity.totalSectionsRendered\":{\"quantumKey\":\"totalSectionsRendered\",\"unifiedKey\":\"totalSectionsRendered\",\"type\":\"int\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.promotion.buyflow.presentedOffers\":{\"quantumKey\":\"presentedOffers\",\"unifiedKey\":\"presentedOffers\",\"type\":\"array\",\"elementType\":\"string\"}},\"pageViewPerformance\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"}},\"pinEntry\":{\"message.category\":{\"quantumKey\":\"category\",\"unifiedKey\":\"msgCategory\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"operation.userEntry.pinType\":{\"quantumKey\":\"pinType\",\"unifiedKey\":\"opUserPinType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackBitRateDownshift\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.playback.bitRate.currentAudioBitRateBps\":{\"quantumKey\":\"currentAudioBitRateBps\",\"unifiedKey\":\"currentAudioBitRateBps\",\"type\":\"int\"},\"state.playback.bitRate.currentBitRateBps\":{\"quantumKey\":\"currentBitRateBps\",\"unifiedKey\":\"plbkBtRtCurrBtRtBps\",\"type\":\"int\"},\"state.playback.frames.frameRate\":{\"quantumKey\":\"frameRate\",\"unifiedKey\":\"plbkFrameRate\",\"type\":\"int\"},\"state.playback.maxVideoResolution\":{\"quantumKey\":\"maxVideoResolution\",\"unifiedKey\":\"maxVideoResolution\",\"type\":\"string\"},\"state.playback.videoResolution\":{\"quantumKey\":\"videoResolution\",\"unifiedKey\":\"videoResolution\",\"type\":\"string\"},\"state.playback.viewPortResolution\":{\"quantumKey\":\"viewPortResolution\",\"unifiedKey\":\"viewPortResolution\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackBitRateUpshift\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.playback.bitRate.currentAudioBitRateBps\":{\"quantumKey\":\"currentAudioBitRateBps\",\"unifiedKey\":\"currentAudioBitRateBps\",\"type\":\"int\"},\"state.playback.bitRate.currentBitRateBps\":{\"quantumKey\":\"currentBitRateBps\",\"unifiedKey\":\"plbkBtRtCurrBtRtBps\",\"type\":\"int\"},\"state.playback.frames.frameRate\":{\"quantumKey\":\"frameRate\",\"unifiedKey\":\"plbkFrameRate\",\"type\":\"int\"},\"state.playback.maxVideoResolution\":{\"quantumKey\":\"maxVideoResolution\",\"unifiedKey\":\"maxVideoResolution\",\"type\":\"string\"},\"state.playback.videoResolution\":{\"quantumKey\":\"videoResolution\",\"unifiedKey\":\"videoResolution\",\"type\":\"string\"},\"state.playback.viewPortResolution\":{\"quantumKey\":\"viewPortResolution\",\"unifiedKey\":\"viewPortResolution\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackExitBeforeStart\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.playback.retryAttempts\":{\"quantumKey\":\"playbackRetryAttempts\",\"unifiedKey\":\"plbkRetryAttempts\",\"type\":\"int\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackFailure\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.content.stream.selectedVideoDecoder\":{\"quantumKey\":\"videoDecoder\",\"unifiedKey\":\"videoDecoder\",\"type\":\"string\"},\"state.playback.drmCached\":{\"quantumKey\":\"drmCached\",\"unifiedKey\":\"drmCached\",\"type\":\"boolean\"},\"state.playback.retryMethod\":{\"quantumKey\":\"playbackRetryMethod\",\"unifiedKey\":\"plbkRetryMethod\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackFailureBeforeRetry\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.playback.retryMethod\":{\"quantumKey\":\"playbackRetryMethod\",\"unifiedKey\":\"plbkRetryMethod\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackPause\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"message.triggeredUsing\":{\"quantumKey\":\"triggeredUsing\",\"unifiedKey\":\"msgTriggeredUsing\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackSelect\":{\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"state.content.contentClass\":{\"quantumKey\":\"contentClass\",\"unifiedKey\":\"ctntContentClass\",\"type\":\"string\"},\"state.content.contentFormat\":{\"quantumKey\":\"contentFormat\",\"unifiedKey\":\"ctntContentFormat\",\"type\":\"string\"},\"state.content.details.expirationDate\":{\"quantumKey\":\"expirationDate\",\"unifiedKey\":\"ctntDetailsExpirationDate\",\"type\":\"long\"},\"state.content.details.runtime\":{\"quantumKey\":\"runtime\",\"unifiedKey\":\"ctntDetailsRuntime\",\"type\":\"int\"},\"state.content.details.title\":{\"quantumKey\":\"contentDetailsTitle\",\"unifiedKey\":\"ctntDetailsTitle\",\"type\":\"string\"},\"state.content.identifiers.dvrRecordingId\":{\"quantumKey\":\"dvrRecordingId\",\"unifiedKey\":\"ctntIdDvrRecordingId\",\"type\":\"string\"},\"state.content.identifiers.platformSeriesId\":{\"quantumKey\":\"platformSeriesId\",\"unifiedKey\":\"ctntIdPlatformSeriesId\",\"type\":\"string\"},\"state.content.identifiers.providerAssetId\":{\"quantumKey\":\"providerAssetId\",\"unifiedKey\":\"ctntIdProviderAssetId\",\"type\":\"string\"},\"state.content.identifiers.tmsGuideId\":{\"quantumKey\":\"tmsGuideId\",\"unifiedKey\":\"ctntIdTmsGuideId\",\"type\":\"string\"},\"state.content.identifiers.tmsProgramId\":{\"quantumKey\":\"tmsProgramId\",\"unifiedKey\":\"ctntIdTmsProgramId\",\"type\":\"string\"},\"state.content.identifiers.tmsSeriesConnectorId\":{\"quantumKey\":\"tmsSeriesConnectorId\",\"unifiedKey\":\"ctntIdTmsSeriesConnectorId\",\"type\":\"string\"},\"state.content.identifiers.tmsSeriesId\":{\"quantumKey\":\"tmsSeriesId\",\"unifiedKey\":\"ctntIdTmsSeriesId\",\"type\":\"string\"},\"state.content.programmer.linear.channelNumber\":{\"quantumKey\":\"channelNumber\",\"unifiedKey\":\"ctntPgmrLinearChnlNumber\",\"type\":\"string\"},\"state.content.purchaseId\":{\"quantumKey\":\"purchaseId\",\"unifiedKey\":\"ctntPurchaseId\",\"type\":\"string\"},\"state.content.rentalDurationHours\":{\"quantumKey\":\"rentalDurationHours\",\"unifiedKey\":\"ctntRntlDurHours\",\"type\":\"int\"},\"state.content.rentalExpirationDate\":{\"quantumKey\":\"rentalExpirationDate\",\"unifiedKey\":\"ctntRntlExpDate\",\"type\":\"long\"},\"state.content.stream.bookmarkPositionSec\":{\"quantumKey\":\"bookmarkPositionSec\",\"unifiedKey\":\"ctntStrmBkmrkPosSec\",\"type\":\"int\"},\"state.content.stream.cdvrType\":{\"quantumKey\":\"cdvrType\",\"unifiedKey\":\"cdvrType\",\"type\":\"string\"},\"state.content.stream.closedCaptioningCapable\":{\"quantumKey\":\"closedCaptioningCapable\",\"unifiedKey\":\"ctntStrmCCCapable\",\"type\":\"boolean\"},\"state.content.stream.contentUri\":{\"quantumKey\":\"contentUri\",\"unifiedKey\":\"ctntStrmCtntUri\",\"type\":\"string\"},\"state.content.stream.drmType\":{\"quantumKey\":\"drmType\",\"unifiedKey\":\"ctntStrmDrmType\",\"type\":\"string\"},\"state.content.stream.dvsCapable\":{\"quantumKey\":\"dvsCapable\",\"unifiedKey\":\"dvsCapable\",\"type\":\"boolean\"},\"state.content.stream.entitled\":{\"quantumKey\":\"entitled\",\"unifiedKey\":\"ctntStrmEntitled\",\"type\":\"boolean\"},\"state.content.stream.parentallyBlocked\":{\"quantumKey\":\"parentallyBlocked\",\"unifiedKey\":\"ctntStrmParntllyBlocked\",\"type\":\"boolean\"},\"state.content.stream.playbackId\":{\"quantumKey\":\"playbackId\",\"unifiedKey\":\"ctntStrmPlbkId\",\"type\":\"string\"},\"state.content.stream.playbackType\":{\"quantumKey\":\"playbackType\",\"unifiedKey\":\"ctntStrmPlbkType\",\"type\":\"string\"},\"state.content.stream.price\":{\"quantumKey\":\"price\",\"unifiedKey\":\"ctntStrmPrice\",\"type\":\"string\"},\"state.content.stream.programmerCallSign\":{\"quantumKey\":\"callSign\",\"unifiedKey\":\"ctntStrmPgmrCallSign\",\"type\":\"string\"},\"state.content.stream.programmerFavorited\":{\"quantumKey\":\"favorite\",\"unifiedKey\":\"ctntStrmPgmrFavorited\",\"type\":\"boolean\"},\"state.content.stream.purchaseType\":{\"quantumKey\":\"purchaseType\",\"unifiedKey\":\"ctntStrmPurchaseType\",\"type\":\"string\"},\"state.content.stream.recordingStartTimestamp\":{\"quantumKey\":\"recordingStartTimestamp\",\"unifiedKey\":\"ctntStrmRecStartTs\",\"type\":\"long\"},\"state.content.stream.recordingStopTimestamp\":{\"quantumKey\":\"recordingStopTimestamp\",\"unifiedKey\":\"ctntStrmRecStopTs\",\"type\":\"long\"},\"state.content.stream.sapCapable\":{\"quantumKey\":\"sapCapable\",\"unifiedKey\":\"ctntStrmSapCapable\",\"type\":\"boolean\"},\"state.content.stream.scrubbingCapability\":{\"quantumKey\":\"scrubbingCapability\",\"unifiedKey\":\"ctntStrmScrubbingCapability\",\"type\":\"string\"},\"state.content.stream.sourceMarket\":{\"quantumKey\":\"sourceMarket\",\"unifiedKey\":\"sourceMarket\",\"type\":\"string\"},\"state.content.stream.startOverCapable\":{\"quantumKey\":\"startOverCapable\",\"unifiedKey\":\"startOverCapable\",\"type\":\"boolean\"},\"state.content.stream.streamingFormat\":{\"quantumKey\":\"streamingFormat\",\"unifiedKey\":\"ctntStrmingFormat\",\"type\":\"string\"},\"state.playback.pauseLiveTvIsEnabled\":{\"quantumKey\":\"pauseLiveTvIsEnabled\",\"unifiedKey\":\"pauseLiveTvIsEnabled\",\"type\":\"boolean\"},\"state.playback.tuneType\":{\"quantumKey\":\"tuneType\",\"unifiedKey\":\"tuneType\",\"type\":\"string\"},\"state.view.currentPage.elements.elementIndex\":{\"quantumKey\":\"elementIndex\",\"unifiedKey\":\"currPageElemIndex\",\"type\":\"int\"},\"state.view.currentPage.elements.elementType\":{\"quantumKey\":\"elementType\",\"unifiedKey\":\"currPageElemType\",\"type\":\"string\"},\"state.view.currentPage.elements.standardizedName\":{\"quantumKey\":\"elementStandardizedName\",\"unifiedKey\":\"currPageElemStdName\",\"type\":\"string\"},\"state.view.currentPage.pageSection.index\":{\"quantumKey\":\"pageSectionIndex\",\"unifiedKey\":\"currPageSecIndex\",\"type\":\"int\"},\"state.view.currentPage.pageSection.name\":{\"quantumKey\":\"pageSectionName\",\"unifiedKey\":\"currPageSecName\",\"type\":\"string\"},\"state.view.currentPage.pageSubSection.index\":{\"quantumKey\":\"pageSubSectionIndex\",\"unifiedKey\":\"currPageSubsecIndex\",\"type\":\"int\"},\"state.view.currentPage.pageSubSection.name\":{\"quantumKey\":\"pageSubSectionName\",\"unifiedKey\":\"currPageSubsecName\",\"type\":\"string\"},\"state.view.playbackDisplayType\":{\"quantumKey\":\"playbackDisplayType\",\"unifiedKey\":\"playbackDisplayType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.device.playerDetails\":{\"quantumKey\":\"playerDetails\",\"unifiedKey\":\"devicePlayerDetails\",\"type\":\"string\"}},\"playbackStart\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.content.details.actualRuntime\":{\"quantumKey\":\"actualRuntime\",\"unifiedKey\":\"ctntDetailsActualRuntime\",\"type\":\"int\"},\"state.content.stream.audioCodec\":{\"quantumKey\":\"audioCodec\",\"unifiedKey\":\"audioCodec\",\"type\":\"string\"},\"state.content.stream.availableAudioTracks\":{\"quantumKey\":\"availableAudioTracks\",\"unifiedKey\":\"availableAudioTracks\",\"type\":\"string\"},\"state.content.stream.availableBitRates\":{\"quantumKey\":\"availableBitRates\",\"unifiedKey\":\"availableBitRates\",\"type\":\"string\"},\"state.content.stream.availableDrmTypes\":{\"quantumKey\":\"availableDrmTypes\",\"unifiedKey\":\"availableDrmTypes\",\"type\":\"string\"},\"state.content.stream.availableTextTracks\":{\"quantumKey\":\"availableTextTracks\",\"unifiedKey\":\"availableTextTracks\",\"type\":\"string\"},\"state.content.stream.cdnNode.node\":{\"quantumKey\":\"cdnNode\",\"unifiedKey\":\"cdnNode\",\"type\":\"string\"},\"state.content.stream.cdnNode.remoteNode\":{\"quantumKey\":\"cdnRemoteNode\",\"unifiedKey\":\"cdnRemoteNode\",\"type\":\"string\"},\"state.content.stream.cdnNode.requestId\":{\"quantumKey\":\"cdnReqID\",\"unifiedKey\":\"cdnReqID\",\"type\":\"string\"},\"state.content.stream.cdnNode.tcpStatus\":{\"quantumKey\":\"cdnTcpStatus\",\"unifiedKey\":\"cdnTcpStatus\",\"type\":\"string\"},\"state.content.stream.closedCaptioningCapable\":{\"quantumKey\":\"closedCaptioningCapable\",\"unifiedKey\":\"ctntStrmCCCapable\",\"type\":\"boolean\"},\"state.content.stream.dvsCapable\":{\"quantumKey\":\"dvsCapable\",\"unifiedKey\":\"dvsCapable\",\"type\":\"boolean\"},\"state.content.stream.isHDR\":{\"quantumKey\":\"streamIsHDR\",\"unifiedKey\":\"streamIsHDR\",\"type\":\"boolean\"},\"state.content.stream.numberOfAudioSources\":{\"quantumKey\":\"numberOfAudioSources\",\"unifiedKey\":\"ctntNmbrAudioSources\",\"type\":\"int\"},\"state.content.stream.outputFeedId\":{\"quantumKey\":\"outputFeedId\",\"unifiedKey\":\"outputFeedId\",\"type\":\"string\"},\"state.content.stream.sapCapable\":{\"quantumKey\":\"sapCapable\",\"unifiedKey\":\"ctntStrmSapCapable\",\"type\":\"boolean\"},\"state.content.stream.selectedVideoDecoder\":{\"quantumKey\":\"videoDecoder\",\"unifiedKey\":\"videoDecoder\",\"type\":\"string\"},\"state.content.stream.thumbnailsAvailable\":{\"quantumKey\":\"thumbnailsAvailable\",\"unifiedKey\":\"thumbnailsAvailable\",\"type\":\"array\",\"elementType\":\"string\"},\"state.content.stream.thumbnailsEnabled\":{\"quantumKey\":\"thumbnailsEnabled\",\"unifiedKey\":\"thumbnailsEnabled\",\"type\":\"boolean\"},\"state.content.stream.videoCodec\":{\"quantumKey\":\"videoCodec\",\"unifiedKey\":\"videoCodec\",\"type\":\"string\"},\"state.playback.bitRate.audioBitRateEstimateBps\":{\"quantumKey\":\"audioBitRateEstimateBps\",\"unifiedKey\":\"audioBitRateEstimateBps\",\"type\":\"int\"},\"state.playback.bitRate.bitRateEstimateBps\":{\"quantumKey\":\"bitRateEstimate\",\"unifiedKey\":\"bitRateEstimate\",\"type\":\"int\"},\"state.playback.bitRate.currentAudioBitRateBps\":{\"quantumKey\":\"currentAudioBitRateBps\",\"unifiedKey\":\"currentAudioBitRateBps\",\"type\":\"int\"},\"state.playback.bitRate.currentBitRateBps\":{\"quantumKey\":\"currentBitRateBps\",\"unifiedKey\":\"plbkBtRtCurrBtRtBps\",\"type\":\"int\"},\"state.playback.buffer.audioBufferRange\":{\"quantumKey\":\"audioBufferRange\",\"unifiedKey\":\"audioBufferRange\",\"type\":\"string\"},\"state.playback.buffer.bufferRange\":{\"quantumKey\":\"bufferRange\",\"unifiedKey\":\"bufferRange\",\"type\":\"string\"},\"state.playback.cacheStartPosition\":{\"quantumKey\":\"cacheStartPosition\",\"unifiedKey\":\"cacheStartPosition\",\"type\":\"long\"},\"state.playback.daiEnabled\":{\"quantumKey\":\"daiEnabled\",\"unifiedKey\":\"plbkDaiEnabled\",\"type\":\"boolean\"},\"state.playback.drmCached\":{\"quantumKey\":\"drmCached\",\"unifiedKey\":\"drmCached\",\"type\":\"boolean\"},\"state.playback.heartBeat.playPointTimestamp\":{\"quantumKey\":\"playPointTimestamp\",\"unifiedKey\":\"plbkHeartBeatPlayPointTs\",\"type\":\"long\"},\"state.playback.retryMethod\":{\"quantumKey\":\"playbackRetryMethod\",\"unifiedKey\":\"plbkRetryMethod\",\"type\":\"string\"},\"state.playback.videoPlayerSettings.profile\":{\"quantumKey\":\"videoPlayerSettingsProfile\",\"unifiedKey\":\"videoPlyrSetProfile\",\"type\":\"map\",\"elementType\":\"string\"},\"state.playback.videoPlayerSettings.profile.algorithm\":{\"quantumKey\":\"videoPlayerSettingsProfile.algorithm\",\"unifiedKey\":\"videoPlyrSetProfileAlg\",\"type\":\"string\"},\"state.playback.videoPlayerSettings.profile.drmSecurityLevel\":{\"quantumKey\":\"videoPlayerSettingsProfile.drmSecurityLevel\",\"unifiedKey\":\"videoPlyrSetProfileDrmSecurityLevel\",\"type\":\"string\"},\"state.playback.videoPlayerSettings.profile.profileName\":{\"quantumKey\":\"videoPlayerSettingsProfile.profileName\",\"unifiedKey\":\"videoPlyrSetProfileName\",\"type\":\"string\"},\"state.playback.videoPlayerSettings.profile.startingBitrate\":{\"quantumKey\":\"videoPlayerSettingsProfile.startingBitrate\",\"unifiedKey\":\"videoPlyrSetProfileStartBitrate\",\"type\":\"string\"},\"state.playback.videoPlayerSettings.recommendedBitrateBps\":{\"quantumKey\":\"recommendedBitrateBps\",\"unifiedKey\":\"videoPlyrSetProfileRcmdBps\",\"type\":\"int\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackStartAfterRetry\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.playback.bitRate.currentBitRateBps\":{\"quantumKey\":\"currentBitRateBps\",\"unifiedKey\":\"plbkBtRtCurrBtRtBps\",\"type\":\"int\"},\"state.playback.daiEnabled\":{\"quantumKey\":\"daiEnabled\",\"unifiedKey\":\"plbkDaiEnabled\",\"type\":\"boolean\"},\"state.playback.heartBeat.playPointTimestamp\":{\"quantumKey\":\"playPointTimestamp\",\"unifiedKey\":\"plbkHeartBeatPlayPointTs\",\"type\":\"long\"},\"state.playback.retryMethod\":{\"quantumKey\":\"playbackRetryMethod\",\"unifiedKey\":\"plbkRetryMethod\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackStop\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackStreamUriAcquired\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"state.content.stream.audioCodec\":{\"quantumKey\":\"audioCodec\",\"unifiedKey\":\"audioCodec\",\"type\":\"string\"},\"state.content.stream.contentUri\":{\"quantumKey\":\"contentUri\",\"unifiedKey\":\"ctntStrmCtntUri\",\"type\":\"string\"},\"state.content.stream.isHDR\":{\"quantumKey\":\"streamIsHDR\",\"unifiedKey\":\"streamIsHDR\",\"type\":\"boolean\"},\"state.content.stream.multiDrmFormat\":{\"quantumKey\":\"multiDrmFormat\",\"unifiedKey\":\"multiDrmFormat\",\"type\":\"string\"},\"state.content.stream.nielsenMetrics\":{\"quantumKey\":\"nielsenMetrics\",\"unifiedKey\":\"nielsenMetrics\",\"type\":\"array\",\"elementType\":\"string\"},\"state.content.stream.streamableLocations\":{\"quantumKey\":\"streamableLocations\",\"unifiedKey\":\"streamableLocations\",\"type\":\"array\",\"elementType\":\"string\"},\"state.content.stream.videoCodec\":{\"quantumKey\":\"videoCodec\",\"unifiedKey\":\"videoCodec\",\"type\":\"string\"},\"state.playback.daiEnabled\":{\"quantumKey\":\"daiEnabled\",\"unifiedKey\":\"plbkDaiEnabled\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackTrackChange\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"state.content.stream.audioCodec\":{\"quantumKey\":\"audioCodec\",\"unifiedKey\":\"audioCodec\",\"type\":\"string\"},\"state.content.stream.availableAudioTracks\":{\"quantumKey\":\"availableAudioTracks\",\"unifiedKey\":\"availableAudioTracks\",\"type\":\"string\"},\"state.content.stream.availableTextTracks\":{\"quantumKey\":\"availableTextTracks\",\"unifiedKey\":\"availableTextTracks\",\"type\":\"string\"},\"state.content.stream.recordingContentUriAcquired\":{\"quantumKey\":\"recordingContentUriAcquired\",\"unifiedKey\":\"recordingContentUriAcquired\",\"type\":\"string\"},\"state.playback.cacheStartPosition\":{\"quantumKey\":\"cacheStartPosition\",\"unifiedKey\":\"cacheStartPosition\",\"type\":\"long\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackTrickPlayRateChange\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredUsing\":{\"quantumKey\":\"triggeredUsing\",\"unifiedKey\":\"msgTriggeredUsing\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.playback.trickPlay.scrubSpeed\":{\"quantumKey\":\"scrubSpeed\",\"unifiedKey\":\"plbkTrickPlayScrubSpeed\",\"type\":\"string\"},\"state.playback.trickPlay.scrubType\":{\"quantumKey\":\"scrubType\",\"unifiedKey\":\"plbkTrickPlayScrubType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackTrickPlayStart\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"message.triggeredUsing\":{\"quantumKey\":\"triggeredUsing\",\"unifiedKey\":\"msgTriggeredUsing\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"state.playback.trickPlay.scrubSpeed\":{\"quantumKey\":\"scrubSpeed\",\"unifiedKey\":\"plbkTrickPlayScrubSpeed\",\"type\":\"string\"},\"state.playback.trickPlay.scrubStartPositionSec\":{\"quantumKey\":\"startPositionSec\",\"unifiedKey\":\"plbkTrickPlayScrubStartPosSec\",\"type\":\"int\"},\"state.playback.trickPlay.scrubType\":{\"quantumKey\":\"scrubType\",\"unifiedKey\":\"plbkTrickPlayScrubType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackTrickPlayStop\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"message.triggeredUsing\":{\"quantumKey\":\"triggeredUsing\",\"unifiedKey\":\"msgTriggeredUsing\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"state.playback.heartBeat.playPointTimestamp\":{\"quantumKey\":\"playPointTimestamp\",\"unifiedKey\":\"plbkHeartBeatPlayPointTs\",\"type\":\"long\"},\"state.playback.trickPlay.scrubEndPositionSec\":{\"quantumKey\":\"endPositionSec\",\"unifiedKey\":\"plbkTrickPlayScrubEndPosSec\",\"type\":\"int\"},\"state.playback.trickPlay.scrubType\":{\"quantumKey\":\"scrubType\",\"unifiedKey\":\"plbkTrickPlayScrubType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"playbackUnpause\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"message.triggeredUsing\":{\"quantumKey\":\"triggeredUsing\",\"unifiedKey\":\"msgTriggeredUsing\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"purchaseStart\":{\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.buyflow.offerId\":{\"quantumKey\":\"buyflowOfferId\",\"unifiedKey\":\"buyflowOfferId\",\"type\":\"string\"},\"message.feature.clientCart\":{\"quantumKey\":\"featureClientCart\",\"unifiedKey\":\"featureClientCart\",\"type\":\"array\",\"elementType\":\"object\"},\"message.feature.currentLineup\":{\"quantumKey\":\"featureCurrentLineup\",\"unifiedKey\":\"featureCurrentLineup\",\"type\":\"array\",\"elementType\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"purchaseStop\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.buyflow.offerId\":{\"quantumKey\":\"buyflowOfferId\",\"unifiedKey\":\"buyflowOfferId\",\"type\":\"string\"},\"message.feature.clientCart\":{\"quantumKey\":\"featureClientCart\",\"unifiedKey\":\"featureClientCart\",\"type\":\"array\",\"elementType\":\"object\"},\"message.feature.currentLineup\":{\"quantumKey\":\"featureCurrentLineup\",\"unifiedKey\":\"featureCurrentLineup\",\"type\":\"array\",\"elementType\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.billing.paymentAmountUsd\":{\"quantumKey\":\"paymentAmountUsd\",\"unifiedKey\":\"pmtAmount\",\"type\":\"double\"},\"operation.billing.paymentDate\":{\"quantumKey\":\"paymentDate\",\"unifiedKey\":\"pmtDate\",\"type\":\"string\"},\"operation.billing.paymentDueDate\":{\"quantumKey\":\"paymentDueDate\",\"unifiedKey\":\"pmtDueDate\",\"type\":\"string\"},\"operation.billing.paymentMethod\":{\"quantumKey\":\"paymentMethod\",\"unifiedKey\":\"pmtMethod\",\"type\":\"string\"},\"operation.billing.statementAge\":{\"quantumKey\":\"statementAge\",\"unifiedKey\":\"statementDate\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"requestToCancelRecording\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.recordingOptions\":{\"quantumKey\":\"recordingOptions\",\"unifiedKey\":\"opRecOptions\",\"type\":\"map\",\"elementType\":\"string\"},\"operation.recordingOptions.allowDuplicates\":{\"quantumKey\":\"recOpAllowDuplicates\",\"unifiedKey\":\"recOpAllowDuplicates\",\"type\":\"string\"},\"operation.recordingOptions.availableOOH\":{\"quantumKey\":\"recOpAvailableOOH\",\"unifiedKey\":\"recOpAvailableOOH\",\"type\":\"string\"},\"operation.recordingOptions.bookmark\":{\"quantumKey\":\"recOpBookmark\",\"unifiedKey\":\"recOpBookmark\",\"type\":\"string\"},\"operation.recordingOptions.callsign\":{\"quantumKey\":\"recOpCallsign\",\"unifiedKey\":\"recOpCallsign\",\"type\":\"string\"},\"operation.recordingOptions.cdvrSeriesRecording\":{\"quantumKey\":\"recOpCdvrSeriesRecording\",\"unifiedKey\":\"recOpCdvrSeriesRecording\",\"type\":\"string\"},\"operation.recordingOptions.cdvrState\":{\"quantumKey\":\"recOpCdvrState\",\"unifiedKey\":\"recOpCdvrState\",\"type\":\"string\"},\"operation.recordingOptions.channel\":{\"quantumKey\":\"recOpChannel\",\"unifiedKey\":\"recOpChannel\",\"type\":\"string\"},\"operation.recordingOptions.channelId\":{\"quantumKey\":\"recOpChannelId\",\"unifiedKey\":\"recOpChannelId\",\"type\":\"string\"},\"operation.recordingOptions.channelNumber\":{\"quantumKey\":\"recOpChannelNumber\",\"unifiedKey\":\"recOpChannelNumber\",\"type\":\"string\"},\"operation.recordingOptions.context\":{\"quantumKey\":\"recOpContext\",\"unifiedKey\":\"recOpContext\",\"type\":\"string\"},\"operation.recordingOptions.convertToSeries\":{\"quantumKey\":\"recOpConvertToSeries\",\"unifiedKey\":\"recOpConvertToSeries\",\"type\":\"string\"},\"operation.recordingOptions.deleteWhenSpaceIsNeeded\":{\"quantumKey\":\"recOpDeleteWhenSpaceIsNeeded\",\"unifiedKey\":\"recOpDeleteWhenSpaceIsNeeded\",\"type\":\"string\"},\"operation.recordingOptions.deliveryId\":{\"quantumKey\":\"recOpDeliveryId\",\"unifiedKey\":\"recOpDeliveryId\",\"type\":\"string\"},\"operation.recordingOptions.endTime\":{\"quantumKey\":\"recOpEndTime\",\"unifiedKey\":\"recOpEndTime\",\"type\":\"string\"},\"operation.recordingOptions.episodeNumber\":{\"quantumKey\":\"recOpEpisodeNumber\",\"unifiedKey\":\"recOpEpisodeNumber\",\"type\":\"string\"},\"operation.recordingOptions.episodeTitle\":{\"quantumKey\":\"recOpEpisodeTitle\",\"unifiedKey\":\"recOpEpisodeTitle\",\"type\":\"string\"},\"operation.recordingOptions.isEdit\":{\"quantumKey\":\"recOpIsEdit\",\"unifiedKey\":\"recOpIsEdit\",\"type\":\"string\"},\"operation.recordingOptions.keepUntil\":{\"quantumKey\":\"recOpKeepUntil\",\"unifiedKey\":\"recOpKeepUntil\",\"type\":\"string\"},\"operation.recordingOptions.newOnly\":{\"quantumKey\":\"recOpNewOnly\",\"unifiedKey\":\"recOpNewOnly\",\"type\":\"string\"},\"operation.recordingOptions.offSetEnd\":{\"quantumKey\":\"recOpOffSetEnd\",\"unifiedKey\":\"recOpOffSetEnd\",\"type\":\"string\"},\"operation.recordingOptions.offsetStart\":{\"quantumKey\":\"recOpOffsetStart\",\"unifiedKey\":\"recOpOffsetStart\",\"type\":\"string\"},\"operation.recordingOptions.playUrl\":{\"quantumKey\":\"recOpPlayUrl\",\"unifiedKey\":\"recOpPlayUrl\",\"type\":\"string\"},\"operation.recordingOptions.programId\":{\"quantumKey\":\"recOpProgId\",\"unifiedKey\":\"recOpProgId\",\"type\":\"string\"},\"operation.recordingOptions.recordOnlyNew\":{\"quantumKey\":\"recOpNew\",\"unifiedKey\":\"recOpNew\",\"type\":\"string\"},\"operation.recordingOptions.recordingId\":{\"quantumKey\":\"recOpRecordingId\",\"unifiedKey\":\"recOpRecordingId\",\"type\":\"string\"},\"operation.recordingOptions.recordingScheduleType\":{\"quantumKey\":\"recOpSchedType\",\"unifiedKey\":\"recOpSchedType\",\"type\":\"string\"},\"operation.recordingOptions.retentionExpiryTimeSec\":{\"quantumKey\":\"recOpRetentionExpiryTimeSec\",\"unifiedKey\":\"recOpRetentionExpiryTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.schedule\":{\"quantumKey\":\"recOpSchedule\",\"unifiedKey\":\"recOpSchedule\",\"type\":\"string\"},\"operation.recordingOptions.scheduleType\":{\"quantumKey\":\"recOpScheduleType\",\"unifiedKey\":\"recOpScheduleType\",\"type\":\"string\"},\"operation.recordingOptions.seasonNumber\":{\"quantumKey\":\"recOpSeasonNumber\",\"unifiedKey\":\"recOpSeasonNumber\",\"type\":\"string\"},\"operation.recordingOptions.seriesId\":{\"quantumKey\":\"recOpSeriesId\",\"unifiedKey\":\"recOpSeriesId\",\"type\":\"string\"},\"operation.recordingOptions.startAdjustMinutes\":{\"quantumKey\":\"recOpStartAdjustMinutes\",\"unifiedKey\":\"recOpStartAdjustMinutes\",\"type\":\"string\"},\"operation.recordingOptions.startTime\":{\"quantumKey\":\"recOpStartTime\",\"unifiedKey\":\"recOpStartTime\",\"type\":\"string\"},\"operation.recordingOptions.startTimeSec\":{\"quantumKey\":\"recOpStartTimeSec\",\"unifiedKey\":\"recOpStartTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.stopAdjustMinutes\":{\"quantumKey\":\"recOpStopAdjustMinutes\",\"unifiedKey\":\"recOpStopAdjustMinutes\",\"type\":\"string\"},\"operation.recordingOptions.stopTimeSec\":{\"quantumKey\":\"recOpStopTimeSec\",\"unifiedKey\":\"recOpStopTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.title\":{\"quantumKey\":\"recOpTitle\",\"unifiedKey\":\"recOpTitle\",\"type\":\"string\"},\"operation.recordingOptions.tmsGuideId\":{\"quantumKey\":\"recOpGuideId\",\"unifiedKey\":\"recOpGuideId\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"requestToDeleteRecording\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.recordingOptions\":{\"quantumKey\":\"recordingOptions\",\"unifiedKey\":\"opRecOptions\",\"type\":\"map\",\"elementType\":\"string\"},\"operation.recordingOptions.allowDuplicates\":{\"quantumKey\":\"recOpAllowDuplicates\",\"unifiedKey\":\"recOpAllowDuplicates\",\"type\":\"string\"},\"operation.recordingOptions.availableOOH\":{\"quantumKey\":\"recOpAvailableOOH\",\"unifiedKey\":\"recOpAvailableOOH\",\"type\":\"string\"},\"operation.recordingOptions.bookmark\":{\"quantumKey\":\"recOpBookmark\",\"unifiedKey\":\"recOpBookmark\",\"type\":\"string\"},\"operation.recordingOptions.callsign\":{\"quantumKey\":\"recOpCallsign\",\"unifiedKey\":\"recOpCallsign\",\"type\":\"string\"},\"operation.recordingOptions.cdvrSeriesRecording\":{\"quantumKey\":\"recOpCdvrSeriesRecording\",\"unifiedKey\":\"recOpCdvrSeriesRecording\",\"type\":\"string\"},\"operation.recordingOptions.cdvrState\":{\"quantumKey\":\"recOpCdvrState\",\"unifiedKey\":\"recOpCdvrState\",\"type\":\"string\"},\"operation.recordingOptions.channel\":{\"quantumKey\":\"recOpChannel\",\"unifiedKey\":\"recOpChannel\",\"type\":\"string\"},\"operation.recordingOptions.channelId\":{\"quantumKey\":\"recOpChannelId\",\"unifiedKey\":\"recOpChannelId\",\"type\":\"string\"},\"operation.recordingOptions.channelNumber\":{\"quantumKey\":\"recOpChannelNumber\",\"unifiedKey\":\"recOpChannelNumber\",\"type\":\"string\"},\"operation.recordingOptions.context\":{\"quantumKey\":\"recOpContext\",\"unifiedKey\":\"recOpContext\",\"type\":\"string\"},\"operation.recordingOptions.convertToSeries\":{\"quantumKey\":\"recOpConvertToSeries\",\"unifiedKey\":\"recOpConvertToSeries\",\"type\":\"string\"},\"operation.recordingOptions.deleteWhenSpaceIsNeeded\":{\"quantumKey\":\"recOpDeleteWhenSpaceIsNeeded\",\"unifiedKey\":\"recOpDeleteWhenSpaceIsNeeded\",\"type\":\"string\"},\"operation.recordingOptions.deliveryId\":{\"quantumKey\":\"recOpDeliveryId\",\"unifiedKey\":\"recOpDeliveryId\",\"type\":\"string\"},\"operation.recordingOptions.endTime\":{\"quantumKey\":\"recOpEndTime\",\"unifiedKey\":\"recOpEndTime\",\"type\":\"string\"},\"operation.recordingOptions.episodeNumber\":{\"quantumKey\":\"recOpEpisodeNumber\",\"unifiedKey\":\"recOpEpisodeNumber\",\"type\":\"string\"},\"operation.recordingOptions.episodeTitle\":{\"quantumKey\":\"recOpEpisodeTitle\",\"unifiedKey\":\"recOpEpisodeTitle\",\"type\":\"string\"},\"operation.recordingOptions.isEdit\":{\"quantumKey\":\"recOpIsEdit\",\"unifiedKey\":\"recOpIsEdit\",\"type\":\"string\"},\"operation.recordingOptions.keepUntil\":{\"quantumKey\":\"recOpKeepUntil\",\"unifiedKey\":\"recOpKeepUntil\",\"type\":\"string\"},\"operation.recordingOptions.newOnly\":{\"quantumKey\":\"recOpNewOnly\",\"unifiedKey\":\"recOpNewOnly\",\"type\":\"string\"},\"operation.recordingOptions.offSetEnd\":{\"quantumKey\":\"recOpOffSetEnd\",\"unifiedKey\":\"recOpOffSetEnd\",\"type\":\"string\"},\"operation.recordingOptions.offsetStart\":{\"quantumKey\":\"recOpOffsetStart\",\"unifiedKey\":\"recOpOffsetStart\",\"type\":\"string\"},\"operation.recordingOptions.playUrl\":{\"quantumKey\":\"recOpPlayUrl\",\"unifiedKey\":\"recOpPlayUrl\",\"type\":\"string\"},\"operation.recordingOptions.programId\":{\"quantumKey\":\"recOpProgId\",\"unifiedKey\":\"recOpProgId\",\"type\":\"string\"},\"operation.recordingOptions.recordOnlyNew\":{\"quantumKey\":\"recOpNew\",\"unifiedKey\":\"recOpNew\",\"type\":\"string\"},\"operation.recordingOptions.recordingId\":{\"quantumKey\":\"recOpRecordingId\",\"unifiedKey\":\"recOpRecordingId\",\"type\":\"string\"},\"operation.recordingOptions.recordingScheduleType\":{\"quantumKey\":\"recOpSchedType\",\"unifiedKey\":\"recOpSchedType\",\"type\":\"string\"},\"operation.recordingOptions.retentionExpiryTimeSec\":{\"quantumKey\":\"recOpRetentionExpiryTimeSec\",\"unifiedKey\":\"recOpRetentionExpiryTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.schedule\":{\"quantumKey\":\"recOpSchedule\",\"unifiedKey\":\"recOpSchedule\",\"type\":\"string\"},\"operation.recordingOptions.scheduleType\":{\"quantumKey\":\"recOpScheduleType\",\"unifiedKey\":\"recOpScheduleType\",\"type\":\"string\"},\"operation.recordingOptions.seasonNumber\":{\"quantumKey\":\"recOpSeasonNumber\",\"unifiedKey\":\"recOpSeasonNumber\",\"type\":\"string\"},\"operation.recordingOptions.seriesId\":{\"quantumKey\":\"recOpSeriesId\",\"unifiedKey\":\"recOpSeriesId\",\"type\":\"string\"},\"operation.recordingOptions.startAdjustMinutes\":{\"quantumKey\":\"recOpStartAdjustMinutes\",\"unifiedKey\":\"recOpStartAdjustMinutes\",\"type\":\"string\"},\"operation.recordingOptions.startTime\":{\"quantumKey\":\"recOpStartTime\",\"unifiedKey\":\"recOpStartTime\",\"type\":\"string\"},\"operation.recordingOptions.startTimeSec\":{\"quantumKey\":\"recOpStartTimeSec\",\"unifiedKey\":\"recOpStartTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.stopAdjustMinutes\":{\"quantumKey\":\"recOpStopAdjustMinutes\",\"unifiedKey\":\"recOpStopAdjustMinutes\",\"type\":\"string\"},\"operation.recordingOptions.stopTimeSec\":{\"quantumKey\":\"recOpStopTimeSec\",\"unifiedKey\":\"recOpStopTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.title\":{\"quantumKey\":\"recOpTitle\",\"unifiedKey\":\"recOpTitle\",\"type\":\"string\"},\"operation.recordingOptions.tmsGuideId\":{\"quantumKey\":\"recOpGuideId\",\"unifiedKey\":\"recOpGuideId\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"requestToEditRecording\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.recordingOptions\":{\"quantumKey\":\"recordingOptions\",\"unifiedKey\":\"opRecOptions\",\"type\":\"map\",\"elementType\":\"string\"},\"operation.recordingOptions.allowDuplicates\":{\"quantumKey\":\"recOpAllowDuplicates\",\"unifiedKey\":\"recOpAllowDuplicates\",\"type\":\"string\"},\"operation.recordingOptions.availableOOH\":{\"quantumKey\":\"recOpAvailableOOH\",\"unifiedKey\":\"recOpAvailableOOH\",\"type\":\"string\"},\"operation.recordingOptions.bookmark\":{\"quantumKey\":\"recOpBookmark\",\"unifiedKey\":\"recOpBookmark\",\"type\":\"string\"},\"operation.recordingOptions.callsign\":{\"quantumKey\":\"recOpCallsign\",\"unifiedKey\":\"recOpCallsign\",\"type\":\"string\"},\"operation.recordingOptions.cdvrSeriesRecording\":{\"quantumKey\":\"recOpCdvrSeriesRecording\",\"unifiedKey\":\"recOpCdvrSeriesRecording\",\"type\":\"string\"},\"operation.recordingOptions.cdvrState\":{\"quantumKey\":\"recOpCdvrState\",\"unifiedKey\":\"recOpCdvrState\",\"type\":\"string\"},\"operation.recordingOptions.channel\":{\"quantumKey\":\"recOpChannel\",\"unifiedKey\":\"recOpChannel\",\"type\":\"string\"},\"operation.recordingOptions.channelId\":{\"quantumKey\":\"recOpChannelId\",\"unifiedKey\":\"recOpChannelId\",\"type\":\"string\"},\"operation.recordingOptions.channelNumber\":{\"quantumKey\":\"recOpChannelNumber\",\"unifiedKey\":\"recOpChannelNumber\",\"type\":\"string\"},\"operation.recordingOptions.context\":{\"quantumKey\":\"recOpContext\",\"unifiedKey\":\"recOpContext\",\"type\":\"string\"},\"operation.recordingOptions.convertToSeries\":{\"quantumKey\":\"recOpConvertToSeries\",\"unifiedKey\":\"recOpConvertToSeries\",\"type\":\"string\"},\"operation.recordingOptions.deleteWhenSpaceIsNeeded\":{\"quantumKey\":\"recOpDeleteWhenSpaceIsNeeded\",\"unifiedKey\":\"recOpDeleteWhenSpaceIsNeeded\",\"type\":\"string\"},\"operation.recordingOptions.deliveryId\":{\"quantumKey\":\"recOpDeliveryId\",\"unifiedKey\":\"recOpDeliveryId\",\"type\":\"string\"},\"operation.recordingOptions.endTime\":{\"quantumKey\":\"recOpEndTime\",\"unifiedKey\":\"recOpEndTime\",\"type\":\"string\"},\"operation.recordingOptions.episodeNumber\":{\"quantumKey\":\"recOpEpisodeNumber\",\"unifiedKey\":\"recOpEpisodeNumber\",\"type\":\"string\"},\"operation.recordingOptions.episodeTitle\":{\"quantumKey\":\"recOpEpisodeTitle\",\"unifiedKey\":\"recOpEpisodeTitle\",\"type\":\"string\"},\"operation.recordingOptions.isEdit\":{\"quantumKey\":\"recOpIsEdit\",\"unifiedKey\":\"recOpIsEdit\",\"type\":\"string\"},\"operation.recordingOptions.keepUntil\":{\"quantumKey\":\"recOpKeepUntil\",\"unifiedKey\":\"recOpKeepUntil\",\"type\":\"string\"},\"operation.recordingOptions.newOnly\":{\"quantumKey\":\"recOpNewOnly\",\"unifiedKey\":\"recOpNewOnly\",\"type\":\"string\"},\"operation.recordingOptions.offSetEnd\":{\"quantumKey\":\"recOpOffSetEnd\",\"unifiedKey\":\"recOpOffSetEnd\",\"type\":\"string\"},\"operation.recordingOptions.offsetStart\":{\"quantumKey\":\"recOpOffsetStart\",\"unifiedKey\":\"recOpOffsetStart\",\"type\":\"string\"},\"operation.recordingOptions.playUrl\":{\"quantumKey\":\"recOpPlayUrl\",\"unifiedKey\":\"recOpPlayUrl\",\"type\":\"string\"},\"operation.recordingOptions.programId\":{\"quantumKey\":\"recOpProgId\",\"unifiedKey\":\"recOpProgId\",\"type\":\"string\"},\"operation.recordingOptions.recordOnlyNew\":{\"quantumKey\":\"recOpNew\",\"unifiedKey\":\"recOpNew\",\"type\":\"string\"},\"operation.recordingOptions.recordingId\":{\"quantumKey\":\"recOpRecordingId\",\"unifiedKey\":\"recOpRecordingId\",\"type\":\"string\"},\"operation.recordingOptions.recordingScheduleType\":{\"quantumKey\":\"recOpSchedType\",\"unifiedKey\":\"recOpSchedType\",\"type\":\"string\"},\"operation.recordingOptions.retentionExpiryTimeSec\":{\"quantumKey\":\"recOpRetentionExpiryTimeSec\",\"unifiedKey\":\"recOpRetentionExpiryTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.schedule\":{\"quantumKey\":\"recOpSchedule\",\"unifiedKey\":\"recOpSchedule\",\"type\":\"string\"},\"operation.recordingOptions.scheduleType\":{\"quantumKey\":\"recOpScheduleType\",\"unifiedKey\":\"recOpScheduleType\",\"type\":\"string\"},\"operation.recordingOptions.seasonNumber\":{\"quantumKey\":\"recOpSeasonNumber\",\"unifiedKey\":\"recOpSeasonNumber\",\"type\":\"string\"},\"operation.recordingOptions.seriesId\":{\"quantumKey\":\"recOpSeriesId\",\"unifiedKey\":\"recOpSeriesId\",\"type\":\"string\"},\"operation.recordingOptions.startAdjustMinutes\":{\"quantumKey\":\"recOpStartAdjustMinutes\",\"unifiedKey\":\"recOpStartAdjustMinutes\",\"type\":\"string\"},\"operation.recordingOptions.startTime\":{\"quantumKey\":\"recOpStartTime\",\"unifiedKey\":\"recOpStartTime\",\"type\":\"string\"},\"operation.recordingOptions.startTimeSec\":{\"quantumKey\":\"recOpStartTimeSec\",\"unifiedKey\":\"recOpStartTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.stopAdjustMinutes\":{\"quantumKey\":\"recOpStopAdjustMinutes\",\"unifiedKey\":\"recOpStopAdjustMinutes\",\"type\":\"string\"},\"operation.recordingOptions.stopTimeSec\":{\"quantumKey\":\"recOpStopTimeSec\",\"unifiedKey\":\"recOpStopTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.title\":{\"quantumKey\":\"recOpTitle\",\"unifiedKey\":\"recOpTitle\",\"type\":\"string\"},\"operation.recordingOptions.tmsGuideId\":{\"quantumKey\":\"recOpGuideId\",\"unifiedKey\":\"recOpGuideId\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"requestToRecord\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.recordingOptions\":{\"quantumKey\":\"recordingOptions\",\"unifiedKey\":\"opRecOptions\",\"type\":\"map\",\"elementType\":\"string\"},\"operation.recordingOptions.allowDuplicates\":{\"quantumKey\":\"recOpAllowDuplicates\",\"unifiedKey\":\"recOpAllowDuplicates\",\"type\":\"string\"},\"operation.recordingOptions.availableOOH\":{\"quantumKey\":\"recOpAvailableOOH\",\"unifiedKey\":\"recOpAvailableOOH\",\"type\":\"string\"},\"operation.recordingOptions.bookmark\":{\"quantumKey\":\"recOpBookmark\",\"unifiedKey\":\"recOpBookmark\",\"type\":\"string\"},\"operation.recordingOptions.callsign\":{\"quantumKey\":\"recOpCallsign\",\"unifiedKey\":\"recOpCallsign\",\"type\":\"string\"},\"operation.recordingOptions.cdvrSeriesRecording\":{\"quantumKey\":\"recOpCdvrSeriesRecording\",\"unifiedKey\":\"recOpCdvrSeriesRecording\",\"type\":\"string\"},\"operation.recordingOptions.cdvrState\":{\"quantumKey\":\"recOpCdvrState\",\"unifiedKey\":\"recOpCdvrState\",\"type\":\"string\"},\"operation.recordingOptions.channel\":{\"quantumKey\":\"recOpChannel\",\"unifiedKey\":\"recOpChannel\",\"type\":\"string\"},\"operation.recordingOptions.channelId\":{\"quantumKey\":\"recOpChannelId\",\"unifiedKey\":\"recOpChannelId\",\"type\":\"string\"},\"operation.recordingOptions.channelNumber\":{\"quantumKey\":\"recOpChannelNumber\",\"unifiedKey\":\"recOpChannelNumber\",\"type\":\"string\"},\"operation.recordingOptions.context\":{\"quantumKey\":\"recOpContext\",\"unifiedKey\":\"recOpContext\",\"type\":\"string\"},\"operation.recordingOptions.convertToSeries\":{\"quantumKey\":\"recOpConvertToSeries\",\"unifiedKey\":\"recOpConvertToSeries\",\"type\":\"string\"},\"operation.recordingOptions.deleteWhenSpaceIsNeeded\":{\"quantumKey\":\"recOpDeleteWhenSpaceIsNeeded\",\"unifiedKey\":\"recOpDeleteWhenSpaceIsNeeded\",\"type\":\"string\"},\"operation.recordingOptions.deliveryId\":{\"quantumKey\":\"recOpDeliveryId\",\"unifiedKey\":\"recOpDeliveryId\",\"type\":\"string\"},\"operation.recordingOptions.endTime\":{\"quantumKey\":\"recOpEndTime\",\"unifiedKey\":\"recOpEndTime\",\"type\":\"string\"},\"operation.recordingOptions.episodeNumber\":{\"quantumKey\":\"recOpEpisodeNumber\",\"unifiedKey\":\"recOpEpisodeNumber\",\"type\":\"string\"},\"operation.recordingOptions.episodeTitle\":{\"quantumKey\":\"recOpEpisodeTitle\",\"unifiedKey\":\"recOpEpisodeTitle\",\"type\":\"string\"},\"operation.recordingOptions.isEdit\":{\"quantumKey\":\"recOpIsEdit\",\"unifiedKey\":\"recOpIsEdit\",\"type\":\"string\"},\"operation.recordingOptions.keepUntil\":{\"quantumKey\":\"recOpKeepUntil\",\"unifiedKey\":\"recOpKeepUntil\",\"type\":\"string\"},\"operation.recordingOptions.newOnly\":{\"quantumKey\":\"recOpNewOnly\",\"unifiedKey\":\"recOpNewOnly\",\"type\":\"string\"},\"operation.recordingOptions.offSetEnd\":{\"quantumKey\":\"recOpOffSetEnd\",\"unifiedKey\":\"recOpOffSetEnd\",\"type\":\"string\"},\"operation.recordingOptions.offsetStart\":{\"quantumKey\":\"recOpOffsetStart\",\"unifiedKey\":\"recOpOffsetStart\",\"type\":\"string\"},\"operation.recordingOptions.playUrl\":{\"quantumKey\":\"recOpPlayUrl\",\"unifiedKey\":\"recOpPlayUrl\",\"type\":\"string\"},\"operation.recordingOptions.programId\":{\"quantumKey\":\"recOpProgId\",\"unifiedKey\":\"recOpProgId\",\"type\":\"string\"},\"operation.recordingOptions.recordOnlyNew\":{\"quantumKey\":\"recOpNew\",\"unifiedKey\":\"recOpNew\",\"type\":\"string\"},\"operation.recordingOptions.recordingId\":{\"quantumKey\":\"recOpRecordingId\",\"unifiedKey\":\"recOpRecordingId\",\"type\":\"string\"},\"operation.recordingOptions.recordingScheduleType\":{\"quantumKey\":\"recOpSchedType\",\"unifiedKey\":\"recOpSchedType\",\"type\":\"string\"},\"operation.recordingOptions.retentionExpiryTimeSec\":{\"quantumKey\":\"recOpRetentionExpiryTimeSec\",\"unifiedKey\":\"recOpRetentionExpiryTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.schedule\":{\"quantumKey\":\"recOpSchedule\",\"unifiedKey\":\"recOpSchedule\",\"type\":\"string\"},\"operation.recordingOptions.scheduleType\":{\"quantumKey\":\"recOpScheduleType\",\"unifiedKey\":\"recOpScheduleType\",\"type\":\"string\"},\"operation.recordingOptions.seasonNumber\":{\"quantumKey\":\"recOpSeasonNumber\",\"unifiedKey\":\"recOpSeasonNumber\",\"type\":\"string\"},\"operation.recordingOptions.seriesId\":{\"quantumKey\":\"recOpSeriesId\",\"unifiedKey\":\"recOpSeriesId\",\"type\":\"string\"},\"operation.recordingOptions.startAdjustMinutes\":{\"quantumKey\":\"recOpStartAdjustMinutes\",\"unifiedKey\":\"recOpStartAdjustMinutes\",\"type\":\"string\"},\"operation.recordingOptions.startTime\":{\"quantumKey\":\"recOpStartTime\",\"unifiedKey\":\"recOpStartTime\",\"type\":\"string\"},\"operation.recordingOptions.startTimeSec\":{\"quantumKey\":\"recOpStartTimeSec\",\"unifiedKey\":\"recOpStartTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.stopAdjustMinutes\":{\"quantumKey\":\"recOpStopAdjustMinutes\",\"unifiedKey\":\"recOpStopAdjustMinutes\",\"type\":\"string\"},\"operation.recordingOptions.stopTimeSec\":{\"quantumKey\":\"recOpStopTimeSec\",\"unifiedKey\":\"recOpStopTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.title\":{\"quantumKey\":\"recOpTitle\",\"unifiedKey\":\"recOpTitle\",\"type\":\"string\"},\"operation.recordingOptions.tmsGuideId\":{\"quantumKey\":\"recOpGuideId\",\"unifiedKey\":\"recOpGuideId\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"searchClosed\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"searched\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"message.triggeredUsing\":{\"quantumKey\":\"triggeredUsing\",\"unifiedKey\":\"msgTriggeredUsing\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.search.numberOfSearchResults\":{\"quantumKey\":\"numberOfSearchResults\",\"unifiedKey\":\"searchElem\",\"type\":\"int\"},\"state.search.queryId\":{\"quantumKey\":\"queryId\",\"unifiedKey\":\"searchQueryId\",\"type\":\"string\"},\"state.search.results\":{\"quantumKey\":\"results\",\"unifiedKey\":\"results\",\"type\":\"array\",\"elementType\":\"string\"},\"state.search.resultsMs\":{\"quantumKey\":\"resultsMs\",\"unifiedKey\":\"searchResultsMs\",\"type\":\"int\"},\"state.search.searchId\":{\"quantumKey\":\"searchId\",\"unifiedKey\":\"searchId\",\"type\":\"string\"},\"state.search.searchResults\":{\"quantumKey\":\"searchResults\",\"unifiedKey\":\"searchResults\",\"type\":\"array\",\"elementType\":\"object\"},\"state.search.searchType\":{\"quantumKey\":\"searchType\",\"unifiedKey\":\"searchType\",\"type\":\"string\"},\"state.search.text\":{\"quantumKey\":\"searchText\",\"unifiedKey\":\"searchText\",\"type\":\"string\"},\"state.userJourney.currentFeature.name\":{\"quantumKey\":\"userJourneyCurrentFeatureName\",\"unifiedKey\":\"userJourneyCurrentFeatureName\",\"type\":\"string\"},\"state.userJourney.featureFlagged\":{\"quantumKey\":\"userJourneyFeatureFlagged\",\"unifiedKey\":\"userJourneyFeatureFlagged\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"selectAction\":{\"message.category\":{\"quantumKey\":\"category\",\"unifiedKey\":\"msgCategory\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.buyflow.offerId\":{\"quantumKey\":\"buyflowOfferId\",\"unifiedKey\":\"buyflowOfferId\",\"type\":\"string\"},\"message.feature.clientCart\":{\"quantumKey\":\"featureClientCart\",\"unifiedKey\":\"featureClientCart\",\"type\":\"array\",\"elementType\":\"object\"},\"message.feature.currentLineup\":{\"quantumKey\":\"featureCurrentLineup\",\"unifiedKey\":\"featureCurrentLineup\",\"type\":\"array\",\"elementType\":\"string\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.feature.previousStep\":{\"quantumKey\":\"featurePreviousStep\",\"unifiedKey\":\"msgFeaturePrevStep\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"message.triggeredUsing\":{\"quantumKey\":\"triggeredUsing\",\"unifiedKey\":\"msgTriggeredUsing\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.billing.paymentAmountUsd\":{\"quantumKey\":\"paymentAmountUsd\",\"unifiedKey\":\"pmtAmount\",\"type\":\"double\"},\"operation.billing.paymentDate\":{\"quantumKey\":\"paymentDate\",\"unifiedKey\":\"pmtDate\",\"type\":\"string\"},\"operation.billing.paymentDueDate\":{\"quantumKey\":\"paymentDueDate\",\"unifiedKey\":\"pmtDueDate\",\"type\":\"string\"},\"operation.billing.paymentMethod\":{\"quantumKey\":\"paymentMethod\",\"unifiedKey\":\"pmtMethod\",\"type\":\"string\"},\"operation.billing.statementAge\":{\"quantumKey\":\"statementAge\",\"unifiedKey\":\"statementDate\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.outage.etr\":{\"quantumKey\":\"outageEtr\",\"unifiedKey\":\"outageEtr\",\"type\":\"boolean\"},\"operation.outage.pid\":{\"quantumKey\":\"outagePid\",\"unifiedKey\":\"outagePid\",\"type\":\"string\"},\"operation.phone.imei\":{\"quantumKey\":\"opPhoneImei\",\"unifiedKey\":\"opPhoneImei\",\"type\":\"string\"},\"operation.recordingOptions\":{\"quantumKey\":\"recordingOptions\",\"unifiedKey\":\"opRecOptions\",\"type\":\"map\",\"elementType\":\"string\"},\"operation.recordingOptions.allowDuplicates\":{\"quantumKey\":\"recOpAllowDuplicates\",\"unifiedKey\":\"recOpAllowDuplicates\",\"type\":\"string\"},\"operation.recordingOptions.availableOOH\":{\"quantumKey\":\"recOpAvailableOOH\",\"unifiedKey\":\"recOpAvailableOOH\",\"type\":\"string\"},\"operation.recordingOptions.bookmark\":{\"quantumKey\":\"recOpBookmark\",\"unifiedKey\":\"recOpBookmark\",\"type\":\"string\"},\"operation.recordingOptions.callsign\":{\"quantumKey\":\"recOpCallsign\",\"unifiedKey\":\"recOpCallsign\",\"type\":\"string\"},\"operation.recordingOptions.cdvrSeriesRecording\":{\"quantumKey\":\"recOpCdvrSeriesRecording\",\"unifiedKey\":\"recOpCdvrSeriesRecording\",\"type\":\"string\"},\"operation.recordingOptions.cdvrState\":{\"quantumKey\":\"recOpCdvrState\",\"unifiedKey\":\"recOpCdvrState\",\"type\":\"string\"},\"operation.recordingOptions.channel\":{\"quantumKey\":\"recOpChannel\",\"unifiedKey\":\"recOpChannel\",\"type\":\"string\"},\"operation.recordingOptions.channelId\":{\"quantumKey\":\"recOpChannelId\",\"unifiedKey\":\"recOpChannelId\",\"type\":\"string\"},\"operation.recordingOptions.channelNumber\":{\"quantumKey\":\"recOpChannelNumber\",\"unifiedKey\":\"recOpChannelNumber\",\"type\":\"string\"},\"operation.recordingOptions.context\":{\"quantumKey\":\"recOpContext\",\"unifiedKey\":\"recOpContext\",\"type\":\"string\"},\"operation.recordingOptions.convertToSeries\":{\"quantumKey\":\"recOpConvertToSeries\",\"unifiedKey\":\"recOpConvertToSeries\",\"type\":\"string\"},\"operation.recordingOptions.deleteWhenSpaceIsNeeded\":{\"quantumKey\":\"recOpDeleteWhenSpaceIsNeeded\",\"unifiedKey\":\"recOpDeleteWhenSpaceIsNeeded\",\"type\":\"string\"},\"operation.recordingOptions.deliveryId\":{\"quantumKey\":\"recOpDeliveryId\",\"unifiedKey\":\"recOpDeliveryId\",\"type\":\"string\"},\"operation.recordingOptions.endTime\":{\"quantumKey\":\"recOpEndTime\",\"unifiedKey\":\"recOpEndTime\",\"type\":\"string\"},\"operation.recordingOptions.episodeNumber\":{\"quantumKey\":\"recOpEpisodeNumber\",\"unifiedKey\":\"recOpEpisodeNumber\",\"type\":\"string\"},\"operation.recordingOptions.episodeTitle\":{\"quantumKey\":\"recOpEpisodeTitle\",\"unifiedKey\":\"recOpEpisodeTitle\",\"type\":\"string\"},\"operation.recordingOptions.isEdit\":{\"quantumKey\":\"recOpIsEdit\",\"unifiedKey\":\"recOpIsEdit\",\"type\":\"string\"},\"operation.recordingOptions.keepUntil\":{\"quantumKey\":\"recOpKeepUntil\",\"unifiedKey\":\"recOpKeepUntil\",\"type\":\"string\"},\"operation.recordingOptions.newOnly\":{\"quantumKey\":\"recOpNewOnly\",\"unifiedKey\":\"recOpNewOnly\",\"type\":\"string\"},\"operation.recordingOptions.offSetEnd\":{\"quantumKey\":\"recOpOffSetEnd\",\"unifiedKey\":\"recOpOffSetEnd\",\"type\":\"string\"},\"operation.recordingOptions.offsetStart\":{\"quantumKey\":\"recOpOffsetStart\",\"unifiedKey\":\"recOpOffsetStart\",\"type\":\"string\"},\"operation.recordingOptions.playUrl\":{\"quantumKey\":\"recOpPlayUrl\",\"unifiedKey\":\"recOpPlayUrl\",\"type\":\"string\"},\"operation.recordingOptions.programId\":{\"quantumKey\":\"recOpProgId\",\"unifiedKey\":\"recOpProgId\",\"type\":\"string\"},\"operation.recordingOptions.recordOnlyNew\":{\"quantumKey\":\"recOpNew\",\"unifiedKey\":\"recOpNew\",\"type\":\"string\"},\"operation.recordingOptions.recordingId\":{\"quantumKey\":\"recOpRecordingId\",\"unifiedKey\":\"recOpRecordingId\",\"type\":\"string\"},\"operation.recordingOptions.recordingScheduleType\":{\"quantumKey\":\"recOpSchedType\",\"unifiedKey\":\"recOpSchedType\",\"type\":\"string\"},\"operation.recordingOptions.retentionExpiryTimeSec\":{\"quantumKey\":\"recOpRetentionExpiryTimeSec\",\"unifiedKey\":\"recOpRetentionExpiryTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.schedule\":{\"quantumKey\":\"recOpSchedule\",\"unifiedKey\":\"recOpSchedule\",\"type\":\"string\"},\"operation.recordingOptions.scheduleType\":{\"quantumKey\":\"recOpScheduleType\",\"unifiedKey\":\"recOpScheduleType\",\"type\":\"string\"},\"operation.recordingOptions.seasonNumber\":{\"quantumKey\":\"recOpSeasonNumber\",\"unifiedKey\":\"recOpSeasonNumber\",\"type\":\"string\"},\"operation.recordingOptions.seriesId\":{\"quantumKey\":\"recOpSeriesId\",\"unifiedKey\":\"recOpSeriesId\",\"type\":\"string\"},\"operation.recordingOptions.startAdjustMinutes\":{\"quantumKey\":\"recOpStartAdjustMinutes\",\"unifiedKey\":\"recOpStartAdjustMinutes\",\"type\":\"string\"},\"operation.recordingOptions.startTime\":{\"quantumKey\":\"recOpStartTime\",\"unifiedKey\":\"recOpStartTime\",\"type\":\"string\"},\"operation.recordingOptions.startTimeSec\":{\"quantumKey\":\"recOpStartTimeSec\",\"unifiedKey\":\"recOpStartTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.stopAdjustMinutes\":{\"quantumKey\":\"recOpStopAdjustMinutes\",\"unifiedKey\":\"recOpStopAdjustMinutes\",\"type\":\"string\"},\"operation.recordingOptions.stopTimeSec\":{\"quantumKey\":\"recOpStopTimeSec\",\"unifiedKey\":\"recOpStopTimeSec\",\"type\":\"string\"},\"operation.recordingOptions.title\":{\"quantumKey\":\"recOpTitle\",\"unifiedKey\":\"recOpTitle\",\"type\":\"string\"},\"operation.recordingOptions.tmsGuideId\":{\"quantumKey\":\"recOpGuideId\",\"unifiedKey\":\"recOpGuideId\",\"type\":\"string\"},\"operation.settingsUpdates\":{\"quantumKey\":\"settingsUpdates\",\"unifiedKey\":\"opSettingsUpdates\",\"type\":\"map\",\"elementType\":\"string\"},\"operation.settingsUpdates.additionalContactMethod\":{\"quantumKey\":\"settingsUpdatesAdditionalContactMethod\",\"unifiedKey\":\"settingsUpdatesAdditionalContactMethod\",\"type\":\"string\"},\"operation.settingsUpdates.additionalContacts\":{\"quantumKey\":\"settingsUpdatesAdditionalContacts\",\"unifiedKey\":\"settingsUpdatesAdditionalContacts\",\"type\":\"string\"},\"operation.settingsUpdates.billingAddress\":{\"quantumKey\":\"settingsUpdatesBillingAddress\",\"unifiedKey\":\"settingsUpdatesBillingAddress\",\"type\":\"string\"},\"operation.settingsUpdates.deliveryMethod\":{\"quantumKey\":\"settingsUpdatesDeliveryMethod\",\"unifiedKey\":\"settingsUpdatesDeliveryMethod\",\"type\":\"string\"},\"operation.settingsUpdates.emailAddress\":{\"quantumKey\":\"settingsUpdatesEmailAddress\",\"unifiedKey\":\"settingsUpdatesEmailAddress\",\"type\":\"string\"},\"operation.settingsUpdates.enrollmentChange\":{\"quantumKey\":\"settingsUpdatesEnrollmentChange\",\"unifiedKey\":\"settingsUpdatesEnrollmentChange\",\"type\":\"string\"},\"operation.settingsUpdates.firstName\":{\"quantumKey\":\"settingsUpdatesFirstName\",\"unifiedKey\":\"settingsUpdatesFirstName\",\"type\":\"string\"},\"operation.settingsUpdates.lastName\":{\"quantumKey\":\"settingsUpdatesLastName\",\"unifiedKey\":\"settingsUpdatesLastName\",\"type\":\"string\"},\"operation.settingsUpdates.phoneNumber\":{\"quantumKey\":\"settingsUpdatesPhoneNumber\",\"unifiedKey\":\"settingsUpdatesPhoneNumber\",\"type\":\"string\"},\"operation.settingsUpdates.phoneType\":{\"quantumKey\":\"settingsUpdatesPhoneType\",\"unifiedKey\":\"settingsUpdatesPhoneType\",\"type\":\"string\"},\"operation.settingsUpdates.primaryContact\":{\"quantumKey\":\"settingsUpdatesPrimaryContact\",\"unifiedKey\":\"settingsUpdatesPrimaryContact\",\"type\":\"string\"},\"operation.settingsUpdates.primaryContactMethod\":{\"quantumKey\":\"settingsUpdatesPrimaryContactMethod\",\"unifiedKey\":\"settingsUpdatesPrimaryContactMethod\",\"type\":\"string\"},\"operation.toggleState\":{\"quantumKey\":\"toggleState\",\"unifiedKey\":\"opToggleState\",\"type\":\"boolean\"},\"operation.userEntry.accountNumber\":{\"quantumKey\":\"accountNumber\",\"unifiedKey\":\"opAccountNumber\",\"type\":\"long\"},\"operation.userEntry.email\":{\"quantumKey\":\"email\",\"unifiedKey\":\"opEmail\",\"type\":\"string\"},\"operation.userEntry.entryType\":{\"quantumKey\":\"entryType\",\"unifiedKey\":\"userName\",\"type\":\"string\"},\"operation.userEntry.phoneNumber\":{\"quantumKey\":\"phoneNumber\",\"unifiedKey\":\"opPhoneNumber\",\"type\":\"int\"},\"operation.userEntry.securityCode\":{\"quantumKey\":\"securityCode\",\"unifiedKey\":\"opSecurityCode\",\"type\":\"int\"},\"operation.userEntry.text\":{\"quantumKey\":\"entryText\",\"unifiedKey\":\"opUserText\",\"type\":\"string\"},\"operation.userEntry.zipcode\":{\"quantumKey\":\"zipcode\",\"unifiedKey\":\"opZipcode\",\"type\":\"int\"},\"operation.userPreferenceCategory\":{\"quantumKey\":\"userPreferenceCategory\",\"unifiedKey\":\"opUserPrefCat\",\"type\":\"string\"},\"operation.userPreferencesSelections\":{\"quantumKey\":\"userPreferencesSelections\",\"unifiedKey\":\"opUserPrefsSelections\",\"type\":\"array\",\"elementType\":\"string\"},\"state.content.contentClass\":{\"quantumKey\":\"contentClass\",\"unifiedKey\":\"ctntContentClass\",\"type\":\"string\"},\"state.content.contentFormat\":{\"quantumKey\":\"contentFormat\",\"unifiedKey\":\"ctntContentFormat\",\"type\":\"string\"},\"state.content.identifiers.dvrRecordingId\":{\"quantumKey\":\"dvrRecordingId\",\"unifiedKey\":\"ctntIdDvrRecordingId\",\"type\":\"string\"},\"state.content.identifiers.platformSeriesId\":{\"quantumKey\":\"platformSeriesId\",\"unifiedKey\":\"ctntIdPlatformSeriesId\",\"type\":\"string\"},\"state.content.identifiers.providerAssetId\":{\"quantumKey\":\"providerAssetId\",\"unifiedKey\":\"ctntIdProviderAssetId\",\"type\":\"string\"},\"state.content.identifiers.tmsGuideId\":{\"quantumKey\":\"tmsGuideId\",\"unifiedKey\":\"ctntIdTmsGuideId\",\"type\":\"string\"},\"state.content.identifiers.tmsProgramId\":{\"quantumKey\":\"tmsProgramId\",\"unifiedKey\":\"ctntIdTmsProgramId\",\"type\":\"string\"},\"state.content.identifiers.tmsSeriesId\":{\"quantumKey\":\"tmsSeriesId\",\"unifiedKey\":\"ctntIdTmsSeriesId\",\"type\":\"string\"},\"state.content.otaMissing\":{\"quantumKey\":\"otaMissing\",\"unifiedKey\":\"plbkOtaMissing\",\"type\":\"boolean\"},\"state.content.purchaseId\":{\"quantumKey\":\"purchaseId\",\"unifiedKey\":\"ctntPurchaseId\",\"type\":\"string\"},\"state.content.rentalDurationHours\":{\"quantumKey\":\"rentalDurationHours\",\"unifiedKey\":\"ctntRntlDurHours\",\"type\":\"int\"},\"state.content.rentalExpirationDate\":{\"quantumKey\":\"rentalExpirationDate\",\"unifiedKey\":\"ctntRntlExpDate\",\"type\":\"long\"},\"state.content.stream.bookmarkPositionSec\":{\"quantumKey\":\"bookmarkPositionSec\",\"unifiedKey\":\"ctntStrmBkmrkPosSec\",\"type\":\"int\"},\"state.content.stream.closedCaptioningCapable\":{\"quantumKey\":\"closedCaptioningCapable\",\"unifiedKey\":\"ctntStrmCCCapable\",\"type\":\"boolean\"},\"state.content.stream.drmType\":{\"quantumKey\":\"drmType\",\"unifiedKey\":\"ctntStrmDrmType\",\"type\":\"string\"},\"state.content.stream.entitled\":{\"quantumKey\":\"entitled\",\"unifiedKey\":\"ctntStrmEntitled\",\"type\":\"boolean\"},\"state.content.stream.parentallyBlocked\":{\"quantumKey\":\"parentallyBlocked\",\"unifiedKey\":\"ctntStrmParntllyBlocked\",\"type\":\"boolean\"},\"state.content.stream.playbackId\":{\"quantumKey\":\"playbackId\",\"unifiedKey\":\"ctntStrmPlbkId\",\"type\":\"string\"},\"state.content.stream.playbackType\":{\"quantumKey\":\"playbackType\",\"unifiedKey\":\"ctntStrmPlbkType\",\"type\":\"string\"},\"state.content.stream.price\":{\"quantumKey\":\"price\",\"unifiedKey\":\"ctntStrmPrice\",\"type\":\"string\"},\"state.content.stream.programmerCallSign\":{\"quantumKey\":\"callSign\",\"unifiedKey\":\"ctntStrmPgmrCallSign\",\"type\":\"string\"},\"state.content.stream.programmerFavorited\":{\"quantumKey\":\"favorite\",\"unifiedKey\":\"ctntStrmPgmrFavorited\",\"type\":\"boolean\"},\"state.content.stream.purchaseType\":{\"quantumKey\":\"purchaseType\",\"unifiedKey\":\"ctntStrmPurchaseType\",\"type\":\"string\"},\"state.content.stream.recordingStartTimestamp\":{\"quantumKey\":\"recordingStartTimestamp\",\"unifiedKey\":\"ctntStrmRecStartTs\",\"type\":\"long\"},\"state.content.stream.recordingStopTimestamp\":{\"quantumKey\":\"recordingStopTimestamp\",\"unifiedKey\":\"ctntStrmRecStopTs\",\"type\":\"long\"},\"state.content.stream.sapCapable\":{\"quantumKey\":\"sapCapable\",\"unifiedKey\":\"ctntStrmSapCapable\",\"type\":\"boolean\"},\"state.content.stream.scrubbingCapability\":{\"quantumKey\":\"scrubbingCapability\",\"unifiedKey\":\"ctntStrmScrubbingCapability\",\"type\":\"string\"},\"state.content.stream.streamingFormat\":{\"quantumKey\":\"streamingFormat\",\"unifiedKey\":\"ctntStrmingFormat\",\"type\":\"string\"},\"state.search.searchId\":{\"quantumKey\":\"searchId\",\"unifiedKey\":\"searchId\",\"type\":\"string\"},\"state.search.searchType\":{\"quantumKey\":\"searchType\",\"unifiedKey\":\"searchType\",\"type\":\"string\"},\"state.userJourney.currentFeature.name\":{\"quantumKey\":\"userJourneyCurrentFeatureName\",\"unifiedKey\":\"userJourneyCurrentFeatureName\",\"type\":\"string\"},\"state.userJourney.featureFlagged\":{\"quantumKey\":\"userJourneyFeatureFlagged\",\"unifiedKey\":\"userJourneyFeatureFlagged\",\"type\":\"boolean\"},\"state.view.currentPage.elements.elementIndex\":{\"quantumKey\":\"elementIndex\",\"unifiedKey\":\"currPageElemIndex\",\"type\":\"int\"},\"state.view.currentPage.elements.elementIntValue\":{\"quantumKey\":\"elementIntValue\",\"unifiedKey\":\"currPageElemIntValue\",\"type\":\"int\"},\"state.view.currentPage.elements.elementStringValue\":{\"quantumKey\":\"elementStringValue\",\"unifiedKey\":\"currPageElemStrValue\",\"type\":\"string\"},\"state.view.currentPage.elements.elementType\":{\"quantumKey\":\"elementType\",\"unifiedKey\":\"currPageElemType\",\"type\":\"string\"},\"state.view.currentPage.elements.elementUrl\":{\"quantumKey\":\"elementUrl\",\"unifiedKey\":\"currPageElemUrl\",\"type\":\"string\"},\"state.view.currentPage.elements.numberOfItems\":{\"quantumKey\":\"elementNumberOfItems\",\"unifiedKey\":\"currPageElemItemCnt\",\"type\":\"int\"},\"state.view.currentPage.elements.standardizedName\":{\"quantumKey\":\"elementStandardizedName\",\"unifiedKey\":\"currPageElemStdName\",\"type\":\"string\"},\"state.view.currentPage.elements.uiName\":{\"quantumKey\":\"elementUiName\",\"unifiedKey\":\"currPageElemUiName\",\"type\":\"string\"},\"state.view.currentPage.elements.xCoordinate\":{\"quantumKey\":\"elementXCoordinate\",\"unifiedKey\":\"elementXCoordinate\",\"type\":\"string\"},\"state.view.currentPage.elements.yCoordinate\":{\"quantumKey\":\"elementYCoordinate\",\"unifiedKey\":\"elementYCoordinate\",\"type\":\"string\"},\"state.view.currentPage.pageSection.index\":{\"quantumKey\":\"pageSectionIndex\",\"unifiedKey\":\"currPageSecIndex\",\"type\":\"int\"},\"state.view.currentPage.pageSection.name\":{\"quantumKey\":\"pageSectionName\",\"unifiedKey\":\"currPageSecName\",\"type\":\"string\"},\"state.view.currentPage.pageSection.numberOfItems\":{\"quantumKey\":\"pageSectionNumberOfItems\",\"unifiedKey\":\"currPageSecItemCnt\",\"type\":\"int\"},\"state.view.currentPage.pageSection.onSiteCampaignId\":{\"quantumKey\":\"onSiteCampaignId\",\"unifiedKey\":\"onSiteCampaignId\",\"type\":\"string\"},\"state.view.currentPage.pageSubSection.index\":{\"quantumKey\":\"pageSubSectionIndex\",\"unifiedKey\":\"currPageSubsecIndex\",\"type\":\"int\"},\"state.view.currentPage.pageSubSection.name\":{\"quantumKey\":\"pageSubSectionName\",\"unifiedKey\":\"currPageSubsecName\",\"type\":\"string\"},\"state.view.currentPage.pageSubSection.numberOfItems\":{\"quantumKey\":\"pageSubSectionNumberOfItems\",\"unifiedKey\":\"currPageSubsecItemCnt\",\"type\":\"int\"},\"state.view.currentPage.settings\":{\"quantumKey\":\"settings\",\"unifiedKey\":\"currPageSettings\",\"type\":\"map\",\"elementType\":\"string\"},\"state.view.currentPage.settings.adultTitles\":{\"quantumKey\":\"currPageSettingsAdultTitles\",\"unifiedKey\":\"currPageSettingsAdultTitles\",\"type\":\"string\"},\"state.view.currentPage.settings.autoplayEnabled\":{\"quantumKey\":\"settingsAutoplayEnabled\",\"unifiedKey\":\"currPageSettingsAutoplayEnabled\",\"type\":\"string\"},\"state.view.currentPage.settings.enabled\":{\"quantumKey\":\"currPageSettingsEnabled\",\"unifiedKey\":\"currPageSettingsEnabled\",\"type\":\"string\"},\"state.view.currentPage.settings.hdAutoTune\":{\"quantumKey\":\"currPageSettingsHdAutoTune\",\"unifiedKey\":\"currPageSettingsHdAutoTune\",\"type\":\"string\"},\"state.view.currentPage.settings.size\":{\"quantumKey\":\"currPageSettingsSize\",\"unifiedKey\":\"currPageSettingsSize\",\"type\":\"string\"},\"state.view.currentPage.settings.theme\":{\"quantumKey\":\"currPageSettingsTheme\",\"unifiedKey\":\"currPageSettingsTheme\",\"type\":\"string\"},\"state.view.currentPage.settings.youtube\":{\"quantumKey\":\"currPageSettingsYoutube\",\"unifiedKey\":\"currPageSettingsYoutube\",\"type\":\"string\"},\"state.view.currentPage.sortAndFilter.appliedFilters\":{\"quantumKey\":\"appliedFilters\",\"unifiedKey\":\"currPageAppliedFilters\",\"type\":\"array\",\"elementType\":\"string\"},\"state.view.currentPage.sortAndFilter.appliedSorts\":{\"quantumKey\":\"appliedSorts\",\"unifiedKey\":\"currPageAppliedSorts\",\"type\":\"array\",\"elementType\":\"string\"},\"visit.account.accountFeatures.navigationMuteAudio\":{\"quantumKey\":\"navigationMuteAudio\",\"unifiedKey\":\"navigationMuteAudio\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.features.backgroundAudioEnabled\":{\"quantumKey\":\"backgroundAudioEnabled\",\"unifiedKey\":\"backgroundAudioEnabled\",\"type\":\"string\"},\"visit.settings.appointmentNotificationsEnabled\":{\"quantumKey\":\"appointmentNotificationsEnabled\",\"unifiedKey\":\"appointmentNotificationsEnabled\",\"type\":\"string\"},\"visit.settings.billingNotificationsEnabled\":{\"quantumKey\":\"billingNotificationsEnabled\",\"unifiedKey\":\"billingNotificationsEnabled\",\"type\":\"string\"},\"visit.settings.outageNotificationsEnabled\":{\"quantumKey\":\"outageNotificationsEnabled\",\"unifiedKey\":\"outageNotificationsEnabled\",\"type\":\"string\"}},\"selectContent\":{\"message.category\":{\"quantumKey\":\"category\",\"unifiedKey\":\"msgCategory\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.buyflow.offerId\":{\"quantumKey\":\"buyflowOfferId\",\"unifiedKey\":\"buyflowOfferId\",\"type\":\"string\"},\"message.feature.clientCart\":{\"quantumKey\":\"featureClientCart\",\"unifiedKey\":\"featureClientCart\",\"type\":\"array\",\"elementType\":\"object\"},\"message.feature.currentLineup\":{\"quantumKey\":\"featureCurrentLineup\",\"unifiedKey\":\"featureCurrentLineup\",\"type\":\"array\",\"elementType\":\"string\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"message.triggeredUsing\":{\"quantumKey\":\"triggeredUsing\",\"unifiedKey\":\"msgTriggeredUsing\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.recordingOptions.bookmark\":{\"quantumKey\":\"recOpBookmark\",\"unifiedKey\":\"recOpBookmark\",\"type\":\"string\"},\"state.impression.campaignId\":{\"quantumKey\":\"impressionCampaignId\",\"unifiedKey\":\"impressionCampaignId\",\"type\":\"string\"},\"state.impression.id\":{\"quantumKey\":\"impressionId\",\"unifiedKey\":\"impressionId\",\"type\":\"string\"},\"state.search.queryId\":{\"quantumKey\":\"queryId\",\"unifiedKey\":\"searchQueryId\",\"type\":\"string\"},\"state.search.selectedResultFacet\":{\"quantumKey\":\"selectedResultFacet\",\"unifiedKey\":\"searchSelResultFacet\",\"type\":\"string\"},\"state.search.selectedResultName\":{\"quantumKey\":\"selectedResultName\",\"unifiedKey\":\"searchSelResultName\",\"type\":\"string\"},\"state.userJourney.currentFeature.name\":{\"quantumKey\":\"userJourneyCurrentFeatureName\",\"unifiedKey\":\"userJourneyCurrentFeatureName\",\"type\":\"string\"},\"state.userJourney.featureFlagged\":{\"quantumKey\":\"userJourneyFeatureFlagged\",\"unifiedKey\":\"userJourneyFeatureFlagged\",\"type\":\"boolean\"},\"state.view.content.identifiers.dvrRecordingId\":{\"quantumKey\":\"dvrRecordingId\",\"unifiedKey\":\"dvrRecordingId\",\"type\":\"string\"},\"state.view.content.identifiers.providerAssetId\":{\"quantumKey\":\"providerAssetId\",\"unifiedKey\":\"providerAssetId\",\"type\":\"string\"},\"state.view.content.identifiers.tmsGuideId\":{\"quantumKey\":\"tmsGuideId\",\"unifiedKey\":\"tmsGuideId\",\"type\":\"string\"},\"state.view.content.identifiers.tmsProgramId\":{\"quantumKey\":\"tmsProgramId\",\"unifiedKey\":\"tmsProgramId\",\"type\":\"string\"},\"state.view.content.identifiers.tmsSeriesId\":{\"quantumKey\":\"tmsSeriesId\",\"unifiedKey\":\"tmsSeriesId\",\"type\":\"string\"},\"state.view.content.stream.startTimestamp\":{\"quantumKey\":\"streamStartTimestamp\",\"unifiedKey\":\"streamStartTimestamp\",\"type\":\"long\"},\"state.view.currentPage.elements.elementIndex\":{\"quantumKey\":\"elementIndex\",\"unifiedKey\":\"currPageElemIndex\",\"type\":\"int\"},\"state.view.currentPage.elements.elementType\":{\"quantumKey\":\"elementType\",\"unifiedKey\":\"currPageElemType\",\"type\":\"string\"},\"state.view.currentPage.elements.numberOfItems\":{\"quantumKey\":\"elementNumberOfItems\",\"unifiedKey\":\"currPageElemItemCnt\",\"type\":\"int\"},\"state.view.currentPage.elements.standardizedName\":{\"quantumKey\":\"elementStandardizedName\",\"unifiedKey\":\"currPageElemStdName\",\"type\":\"string\"},\"state.view.currentPage.elements.uiName\":{\"quantumKey\":\"elementUiName\",\"unifiedKey\":\"currPageElemUiName\",\"type\":\"string\"},\"state.view.currentPage.pageSection.index\":{\"quantumKey\":\"pageSectionIndex\",\"unifiedKey\":\"currPageSecIndex\",\"type\":\"int\"},\"state.view.currentPage.pageSection.name\":{\"quantumKey\":\"pageSectionName\",\"unifiedKey\":\"currPageSecName\",\"type\":\"string\"},\"state.view.currentPage.pageSection.numberOfItems\":{\"quantumKey\":\"pageSectionNumberOfItems\",\"unifiedKey\":\"currPageSecItemCnt\",\"type\":\"int\"},\"state.view.currentPage.pageSubSection.index\":{\"quantumKey\":\"pageSubSectionIndex\",\"unifiedKey\":\"currPageSubsecIndex\",\"type\":\"int\"},\"state.view.currentPage.pageSubSection.name\":{\"quantumKey\":\"pageSubSectionName\",\"unifiedKey\":\"currPageSubsecName\",\"type\":\"string\"},\"state.view.currentPage.pageSubSection.numberOfItems\":{\"quantumKey\":\"pageSubSectionNumberOfItems\",\"unifiedKey\":\"currPageSubsecItemCnt\",\"type\":\"int\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"setAccessibilitySettings\":{\"visit.permissionSettings.tvProviderPermissionStatus\":{\"quantumKey\":\"tvProviderPermissionStatus\",\"unifiedKey\":\"tvProviderPermissionStatus\",\"type\":\"string\"},\"visit.device.settings.closedCaption\":{\"quantumKey\":\"closedCaptionSetting\",\"unifiedKey\":\"closedCaptionSetting\",\"type\":\"string\"},\"visit.device.settings.descriptiveVideoServices\":{\"quantumKey\":\"descriptiveVideoSetting\",\"unifiedKey\":\"descriptiveVideoSetting\",\"type\":\"string\"},\"visit.device.settings.greyscale\":{\"quantumKey\":\"greyscale\",\"unifiedKey\":\"greyscale\",\"type\":\"string\"},\"visit.device.settings.highContrast\":{\"quantumKey\":\"highContrastSetting\",\"unifiedKey\":\"highContrastSetting\",\"type\":\"string\"},\"visit.device.settings.invertColors\":{\"quantumKey\":\"invertColorsSetting\",\"unifiedKey\":\"invertColorsSetting\",\"type\":\"string\"},\"visit.device.settings.largeText\":{\"quantumKey\":\"largeTextSetting\",\"unifiedKey\":\"largeTextSetting\",\"type\":\"string\"},\"visit.device.settings.reduceMotion\":{\"quantumKey\":\"reduceMotion\",\"unifiedKey\":\"reduceMotion\",\"type\":\"string\"},\"visit.device.settings.secondaryAudioProgramming\":{\"quantumKey\":\"secondaryAudioProgramming\",\"unifiedKey\":\"secondaryAudioProgramming\",\"type\":\"string\"},\"visit.device.settings.services\":{\"quantumKey\":\"accessibilityServices\",\"unifiedKey\":\"accessibilityServices\",\"type\":\"string\"},\"visit.device.settings.talkBack\":{\"quantumKey\":\"talkBack\",\"unifiedKey\":\"talkBack\",\"type\":\"string\"},\"visit.device.settings.textSize\":{\"quantumKey\":\"textSize\",\"unifiedKey\":\"textSize\",\"type\":\"string\"},\"visit.device.settings.voiceover\":{\"quantumKey\":\"voiceoverSetting\",\"unifiedKey\":\"voiceoverSetting\",\"type\":\"string\"},\"visit.device.settings.zoom\":{\"quantumKey\":\"zoomSetting\",\"unifiedKey\":\"zoomSetting\",\"type\":\"string\"}},\"setAccountFeatures\":{\"visit.account.accountFeatures.accessibility\":{\"quantumKey\":\"accessibility\",\"unifiedKey\":\"accessibilityMode\",\"type\":\"boolean\"},\"visit.account.accountFeatures.appLaunchTakeover\":{\"quantumKey\":\"accountFeaturesAppLaunchTakeover\",\"unifiedKey\":\"accountFeaturesAppLaunchTakeover\",\"type\":\"boolean\"},\"visit.account.accountFeatures.boxless\":{\"quantumKey\":\"boxless\",\"unifiedKey\":\"accountFeaturesBoxless\",\"type\":\"boolean\"},\"visit.account.accountFeatures.cDvr\":{\"quantumKey\":\"cDvr\",\"unifiedKey\":\"accountFeaturesCdvr\",\"type\":\"boolean\"},\"visit.account.accountFeatures.forceTune\":{\"quantumKey\":\"accountFeaturesForceTune\",\"unifiedKey\":\"accountFeaturesForceTune\",\"type\":\"boolean\"},\"visit.account.accountFeatures.smb\":{\"quantumKey\":\"smb\",\"unifiedKey\":\"accountFeaturesSmb\",\"type\":\"boolean\"}},\"setAdBlockerInfo\":{\"visit.device.browser.adBlockerDetected\":{\"quantumKey\":\"adBlockerDetected\",\"unifiedKey\":\"adBlockerDetected\",\"type\":\"boolean\"},\"visit.device.browser.adBlockerEnabled\":{\"quantumKey\":\"adBlockerEnabled\",\"unifiedKey\":\"adBlockerEnabled\",\"type\":\"boolean\"}},\"setAppMode\":{\"visit.applicationDetails.appMode\":{\"quantumKey\":\"appMode\",\"unifiedKey\":\"appMode\",\"type\":\"string\"}},\"setAppModeExpanded\":{\"visit.applicationDetails.appModeExpanded\":{\"quantumKey\":\"appModeExpanded\",\"unifiedKey\":\"appModeExpanded\",\"type\":\"array\",\"elementType\":\"string\"}},\"setApplePrivateRelayIp\":{\"visit.connection.applePrivateRelayIp\":{\"quantumKey\":\"applePrivateRelayIp\",\"unifiedKey\":\"applePrivateRelayIp\",\"type\":\"string\"}},\"setApplicationName\":{\"visit.applicationDetails.applicationName\":{\"quantumKey\":\"applicationName\",\"unifiedKey\":\"appName\",\"type\":\"string\"}},\"setAudioBitRate\":{\"state.playback.bitRate.currentAudioBitRateBps\":{\"quantumKey\":\"currentAudioBitRateBps\",\"unifiedKey\":\"currentAudioBitRateBps\",\"type\":\"int\"}},\"setAutoAccessEnabled\":{\"visit.settings.autoAccessEnabled\":{\"quantumKey\":\"autoAccessEnabled\",\"unifiedKey\":\"autoAccessEnabled\",\"type\":\"string\"}},\"setBulkMduClass\":{\"visit.account.details.bulkMduClass\":{\"quantumKey\":\"bulkMduClass\",\"unifiedKey\":\"accountBulkMduClass\",\"type\":\"string\"}},\"setBuyflowPromotionFields\":{\"visit.promotion.buyflow.appPromoState\":{\"quantumKey\":\"appPromoState\",\"unifiedKey\":\"appPromoState\",\"type\":\"string\"},\"visit.promotion.buyflow.blacklistedFromFreePreview\":{\"quantumKey\":\"blacklistedFromFreePreview\",\"unifiedKey\":\"blacklistedFromFreePreview\",\"type\":\"boolean\"},\"visit.promotion.buyflow.blacklistedFromFreeTrial\":{\"quantumKey\":\"blacklistedFromFreeTrial\",\"unifiedKey\":\"blacklistedFromFreeTrial\",\"type\":\"boolean\"},\"visit.promotion.buyflow.eligible\":{\"quantumKey\":\"buyflowEligible\",\"unifiedKey\":\"buyflowEligible\",\"type\":\"boolean\"},\"visit.promotion.buyflow.householdFoundInMarketingFile\":{\"quantumKey\":\"householdFoundInMarketingFile\",\"unifiedKey\":\"householdFoundInMarketingFile\",\"type\":\"boolean\"},\"visit.promotion.buyflow.offerPriority\":{\"quantumKey\":\"offerPriority\",\"unifiedKey\":\"offerPriority\",\"type\":\"array\",\"elementType\":\"string\"},\"visit.promotion.buyflow.presentedOffers\":{\"quantumKey\":\"presentedOffers\",\"unifiedKey\":\"presentedOffers\",\"type\":\"array\",\"elementType\":\"string\"},\"visit.promotion.buyflow.requestedFreePreviewDisabled\":{\"quantumKey\":\"requestedFreePreviewDisabled\",\"unifiedKey\":\"requestedFreePreviewDisabled\",\"type\":\"boolean\"},\"visit.promotion.buyflow.requestedOfferId\":{\"quantumKey\":\"requestedOfferId\",\"unifiedKey\":\"requestedOfferId\",\"type\":\"string\"},\"visit.promotion.buyflow.requestedOfferIsReturned\":{\"quantumKey\":\"requestedOfferIsReturned\",\"unifiedKey\":\"requestedOfferIsReturned\",\"type\":\"boolean\"},\"visit.promotion.buyflow.requestedOfferMatchedTargeted\":{\"quantumKey\":\"requestedOfferMatchedTargeted\",\"unifiedKey\":\"requestedOfferMatchedTargeted\",\"type\":\"boolean\"},\"visit.promotion.buyflow.scenarioNumber\":{\"quantumKey\":\"scenarioNumber\",\"unifiedKey\":\"scenarioNumber\",\"type\":\"int\"},\"visit.promotion.buyflow.singleOfferReturned\":{\"quantumKey\":\"singleOfferReturned\",\"unifiedKey\":\"singleOfferReturned\",\"type\":\"string\"},\"visit.promotion.buyflow.targetedOfferFound\":{\"quantumKey\":\"targetedOfferFound\",\"unifiedKey\":\"targetedOfferFound\",\"type\":\"boolean\"}},\"setClientLocation\":{\"visit.location.clientLatitude\":{\"quantumKey\":\"clientLatitude\",\"unifiedKey\":\"clientLatitude\",\"type\":\"string\"},\"visit.location.clientLongitude\":{\"quantumKey\":\"clientLongitude\",\"unifiedKey\":\"clientLongitude\",\"type\":\"string\"}},\"setConfigFactors\":{\"visit.account.configurationFactors\":{\"quantumKey\":\"configurationFactors\",\"unifiedKey\":\"configurationFactors\",\"type\":\"string\"}},\"setDeviceLocation\":{\"visit.connection.deviceLocation\":{\"quantumKey\":\"connectionDeviceLocation\",\"unifiedKey\":\"connectionDeviceLocation\",\"type\":\"string\"}},\"setDevicePerformance\":{\"visit.device.performance.cpuUsagePercent\":{\"quantumKey\":\"cpuUsagePercent\",\"unifiedKey\":\"cpuUsagePercent\",\"type\":\"double\"},\"visit.device.performance.ramUsageMb\":{\"quantumKey\":\"ramUsageMb\",\"unifiedKey\":\"ramUsageMb\",\"type\":\"double\"}},\"setEntitlements\":{\"visit.account.entitlements\":{\"quantumKey\":\"entitlements\",\"unifiedKey\":\"accountEntitlements\",\"type\":\"string\"}},\"setExperimentConfigurations\":{\"visit.experimentUuids\":{\"quantumKey\":\"experimentUuids\",\"unifiedKey\":\"experimentUuids\",\"type\":\"array\",\"elementType\":\"string\"},\"visit.variantUuids\":{\"quantumKey\":\"variantUuids\",\"unifiedKey\":\"variantUuids\",\"type\":\"array\",\"elementType\":\"string\"}},\"setId3Tags\":{\"state.content.stream.id3Tags\":{\"quantumKey\":\"id3Tags\",\"unifiedKey\":\"id3Tags\",\"type\":\"boolean\"}},\"setLocationStatus\":{\"visit.permissionSettings.bleLocationStatus\":{\"quantumKey\":\"bleLocationStatus\",\"unifiedKey\":\"bleLocationStatus\",\"type\":\"string\"},\"visit.permissionSettings.gpsLocationStatus\":{\"quantumKey\":\"gpsLocationStatus\",\"unifiedKey\":\"gpsLocationStatus\",\"type\":\"string\"},\"visit.permissionSettings.locationStatus\":{\"quantumKey\":\"locationStatus\",\"unifiedKey\":\"locationStatus\",\"type\":\"string\"},\"visit.permissionSettings.networkLocationStatus\":{\"quantumKey\":\"networkLocationStatus\",\"unifiedKey\":\"networkLocationStatus\",\"type\":\"string\"}},\"setMaxVideoDetails\":{\"state.playback.maxVideoResolution\":{\"quantumKey\":\"maxVideoResolution\",\"unifiedKey\":\"maxVideoResolution\",\"type\":\"string\"}},\"setNetworkStatus\":{\"visit.connection.networkStatus\":{\"quantumKey\":\"networkStatus\",\"unifiedKey\":\"networkStatus\",\"type\":\"string\"}},\"setOtaChannels\":{\"visit.device.otaChannelMap\":{\"quantumKey\":\"otaChannelMap\",\"unifiedKey\":\"otaChannelMap\",\"type\":\"array\",\"elementType\":\"object\"}},\"setPackageInformation\":{\"visit.account.lineOfBusiness.internet.equipment\":{\"quantumKey\":\"accountInternetEquipment\",\"unifiedKey\":\"accountInternetEquipment\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.internet.packageName\":{\"quantumKey\":\"accountInternetPackageName\",\"unifiedKey\":\"accountInternetPackageName\",\"type\":\"string\"},\"visit.account.lineOfBusiness.internet.premiumOrAddOn\":{\"quantumKey\":\"accountInternetPremiumOrAddOn\",\"unifiedKey\":\"accountInternetPremiumOrAddOn\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.internet.productId\":{\"quantumKey\":\"accountInternetProductId\",\"unifiedKey\":\"accountInternetProductId\",\"type\":\"string\"},\"visit.account.lineOfBusiness.phone.equipment\":{\"quantumKey\":\"accountPhoneEquipment\",\"unifiedKey\":\"accountPhoneEquipment\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.phone.packageName\":{\"quantumKey\":\"accountPhonePackageName\",\"unifiedKey\":\"accountPhonePackageName\",\"type\":\"string\"},\"visit.account.lineOfBusiness.phone.premiumOrAddOn\":{\"quantumKey\":\"accountPhonePremiumOrAddOn\",\"unifiedKey\":\"accountPhonePremiumOrAddOn\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.phone.productId\":{\"quantumKey\":\"accountPhoneProductId\",\"unifiedKey\":\"accountPhoneProductId\",\"type\":\"string\"},\"visit.account.lineOfBusiness.tv.equipment\":{\"quantumKey\":\"accountTVEquipment\",\"unifiedKey\":\"accountTVEquipment\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.tv.packageName\":{\"quantumKey\":\"accountTVPackageName\",\"unifiedKey\":\"accountTVPackageName\",\"type\":\"string\"},\"visit.account.lineOfBusiness.tv.premiumOrAddOn\":{\"quantumKey\":\"accountTVPremiumOrAddOn\",\"unifiedKey\":\"accountTVPremiumOrAddOn\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.lineOfBusiness.tv.productId\":{\"quantumKey\":\"accountTVProductId\",\"unifiedKey\":\"accountTVProductId\",\"type\":\"string\"}},\"setPictureInPicture\":{\"state.view.pictureInPicture\":{\"quantumKey\":\"pictureInPicture\",\"unifiedKey\":\"pictureInPicture\",\"type\":\"boolean\"}},\"setPlaybackCapping\":{\"state.playback.capping\":{\"quantumKey\":\"playbackCapping\",\"unifiedKey\":\"playbackCapping\",\"type\":\"string\"}},\"setPlaybackPerformance\":{\"state.playback.performance.downloadLatencyMs\":{\"quantumKey\":\"playbackDownloadLatencyMs\",\"unifiedKey\":\"playbackDownloadLatencyMs\",\"type\":\"int\"},\"state.playback.performance.failedRequestCount\":{\"quantumKey\":\"playbackFailedRequestCount\",\"unifiedKey\":\"playbackFailedRequestCount\",\"type\":\"int\"},\"state.playback.performance.liveLatencySeconds\":{\"quantumKey\":\"playbackLiveLatencySeconds\",\"unifiedKey\":\"playbackLiveLatencySeconds\",\"type\":\"int\"}},\"setPlayerTestFields\":{\"state.content.stream.isHDR\":{\"quantumKey\":\"streamIsHDR\",\"unifiedKey\":\"streamIsHDR\",\"type\":\"boolean\"},\"state.playback.bitRate.audioBitRateEstimateBps\":{\"quantumKey\":\"audioBitRateEstimateBps\",\"unifiedKey\":\"audioBitRateEstimateBps\",\"type\":\"int\"},\"state.playback.bitRate.bitRateEstimateBps\":{\"quantumKey\":\"bitRateEstimate\",\"unifiedKey\":\"bitRateEstimate\",\"type\":\"int\"},\"state.playback.buffer.audioBufferRange\":{\"quantumKey\":\"audioBufferRange\",\"unifiedKey\":\"audioBufferRange\",\"type\":\"string\"},\"state.playback.buffer.bufferRange\":{\"quantumKey\":\"bufferRange\",\"unifiedKey\":\"bufferRange\",\"type\":\"string\"},\"state.playback.videoPlayerSettings.profile.drmSecurityLevel\":{\"quantumKey\":\"videoPlayerSettingsProfile.drmSecurityLevel\",\"unifiedKey\":\"videoPlyrSetProfileDrmSecurityLevel\",\"type\":\"string\"},\"state.playback.buffer.audioBufferLengthMs\":{\"quantumKey\":\"audioBufferLengthMs\",\"unifiedKey\":\"audioBufferLengthMs\",\"type\":\"int\"},\"state.playback.buffer.bufferLengthMs\":{\"quantumKey\":\"bufferLengthMs\",\"unifiedKey\":\"plbkBufferLengthMs\",\"type\":\"int\"},\"state.playback.frames.droppedFrames\":{\"quantumKey\":\"droppedFrames\",\"unifiedKey\":\"plbkDroppedFrames\",\"type\":\"int\"},\"state.playback.frames.frameRate\":{\"quantumKey\":\"frameRate\",\"unifiedKey\":\"plbkFrameRate\",\"type\":\"int\"}},\"setPowerState\":{\"visit.device.powerState\":{\"quantumKey\":\"powerState\",\"unifiedKey\":\"powerState\",\"type\":\"string\"}},\"setReferrerLink\":{\"visit.applicationDetails.referrerLink\":{\"quantumKey\":\"referrerLink\",\"unifiedKey\":\"appRefLink\",\"type\":\"string\"}},\"setReferrerLocation\":{\"visit.applicationDetails.referrerLocation\":{\"quantumKey\":\"referrerLocation\",\"unifiedKey\":\"appRefLocation\",\"type\":\"string\"}},\"setRemoteModel\":{\"visit.device.remoteModel\":{\"quantumKey\":\"remoteModel\",\"unifiedKey\":\"remoteModel\",\"type\":\"string\"}},\"setReplayLink\":{\"state.view.currentPage.replayLink\":{\"quantumKey\":\"replayLink\",\"unifiedKey\":\"replayLink\",\"type\":\"string\"}},\"setRequirementsHash\":{\"visit.analytics.requirementsHash\":{\"quantumKey\":\"analyticsHash\",\"unifiedKey\":\"analyticsHash\",\"type\":\"string\"}},\"setResolution\":{\"state.playback.videoResolution\":{\"quantumKey\":\"videoResolution\",\"unifiedKey\":\"videoResolution\",\"type\":\"string\"},\"state.playback.viewPortResolution\":{\"quantumKey\":\"viewPortResolution\",\"unifiedKey\":\"viewPortResolution\",\"type\":\"string\"}},\"setSecondaryPlaybackId\":{\"state.content.stream.secondaryPlaybackId\":{\"quantumKey\":\"secondaryPlaybackId\",\"unifiedKey\":\"secondaryPlaybackId\",\"type\":\"string\"}},\"setSegment\":{\"segmentUrl\":{\"quantumKey\":\"segmentUrl\",\"unifiedKey\":\"segmentUrl\",\"type\":\"string\"}},\"setSleepTimer\":{\"visit.applicationDetails.sleepTimer\":{\"quantumKey\":\"sleepTimer\",\"unifiedKey\":\"sleepTimer\",\"type\":\"int\"}},\"setSplitScreen\":{\"state.view.splitScreen\":{\"quantumKey\":\"splitScreen\",\"unifiedKey\":\"splitScreen\",\"type\":\"boolean\"}},\"setTimeZone\":{\"visit.account.timeZone\":{\"quantumKey\":\"timeZone\",\"unifiedKey\":\"accountTimeZone\",\"type\":\"string\"}},\"setTrafficOriginId\":{\"visit.isp.trafficOriginId\":{\"quantumKey\":\"trafficOriginId\",\"unifiedKey\":\"trafficOriginId\",\"type\":\"string\"}},\"setUserInteraction\":{\"visit.permissionSettings.userInteraction\":{\"quantumKey\":\"userInteraction\",\"unifiedKey\":\"userInteraction\",\"type\":\"string\"}},\"setVideoZone\":{\"visit.videoZone.division\":{\"quantumKey\":\"division\",\"unifiedKey\":\"videoZoneDivision\",\"type\":\"string\"},\"visit.videoZone.lineup\":{\"quantumKey\":\"lineup\",\"unifiedKey\":\"videoZoneLineup\",\"type\":\"string\"}},\"startSession\":{\"customer\":{\"quantumKey\":\"customer\",\"unifiedKey\":\"customer\",\"type\":\"string\"},\"domain\":{\"quantumKey\":\"domain\",\"unifiedKey\":\"domain\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"visit.accessibility\":{\"quantumKey\":\"accessibilitySettings\",\"unifiedKey\":\"accessibilitySettings\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.accountNumber\":{\"quantumKey\":\"accountNumber\",\"unifiedKey\":\"accountNumber\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.analytics.libraryInitTimeMs\":{\"quantumKey\":\"libraryInitTimeMs\",\"unifiedKey\":\"analyticsInitTimeMs\",\"type\":\"int\"},\"visit.analytics.libraryVersion\":{\"quantumKey\":\"libraryVersion\",\"unifiedKey\":\"analyticsLibVersion\",\"type\":\"string\"},\"visit.analytics.requirementsHash\":{\"quantumKey\":\"analyticsHash\",\"unifiedKey\":\"analyticsHash\",\"type\":\"string\"},\"visit.analytics.requirementsResponseTimeMs\":{\"quantumKey\":\"requirementsResponseTimeMs\",\"unifiedKey\":\"analyticsReqResponseTimeMs\",\"type\":\"int\"},\"visit.analytics.requirementsSource\":{\"quantumKey\":\"requirementsSource\",\"unifiedKey\":\"analyticsReqSource\",\"type\":\"string\"},\"visit.analytics.requirementsVersion\":{\"quantumKey\":\"requirementsVersion\",\"unifiedKey\":\"analyticsReqVersion\",\"type\":\"string\"},\"visit.applicationDetails.appDisplayDefinition\":{\"quantumKey\":\"appDisplayDefinition\",\"unifiedKey\":\"appDisplayDef\",\"type\":\"string\"},\"visit.applicationDetails.appVersion\":{\"quantumKey\":\"appVersion\",\"unifiedKey\":\"appVersion\",\"type\":\"string\"},\"visit.applicationDetails.applicationName\":{\"quantumKey\":\"applicationName\",\"unifiedKey\":\"appName\",\"type\":\"string\"},\"visit.applicationDetails.applicationType\":{\"quantumKey\":\"applicationType\",\"unifiedKey\":\"appType\",\"type\":\"string\"},\"visit.applicationDetails.buildTimestamp\":{\"quantumKey\":\"buildTimestamp\",\"unifiedKey\":\"buildTimestamp\",\"type\":\"long\"},\"visit.applicationDetails.campaign.campaignId\":{\"quantumKey\":\"campaignId\",\"unifiedKey\":\"campaignId\",\"type\":\"string\"},\"visit.applicationDetails.drmEnabled\":{\"quantumKey\":\"drmEnabled\",\"unifiedKey\":\"drmEnabled\",\"type\":\"boolean\"},\"visit.applicationDetails.environment\":{\"quantumKey\":\"environment\",\"unifiedKey\":\"appEnv\",\"type\":\"map\",\"elementType\":\"string\"},\"visit.applicationDetails.environment.environmentName\":{\"quantumKey\":\"environmentName\",\"unifiedKey\":\"appEnvName\",\"type\":\"string\"},\"visit.applicationDetails.packageVersion\":{\"quantumKey\":\"packageVersion\",\"unifiedKey\":\"packageVersion\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.appIdentifier\":{\"quantumKey\":\"appIdentifier\",\"unifiedKey\":\"appIdentifier\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.applicationName\":{\"quantumKey\":\"referrerAppName\",\"unifiedKey\":\"referrerAppName\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.applicationType\":{\"quantumKey\":\"referrerAppType\",\"unifiedKey\":\"referrerAppType\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.commonToken\":{\"quantumKey\":\"referrerAppCommonToken\",\"unifiedKey\":\"referrerAppCommonToken\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.connection.ipAddress\":{\"quantumKey\":\"referrerAppIpAddress\",\"unifiedKey\":\"referrerAppIpAddress\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.connection.port\":{\"quantumKey\":\"referrerAppConnectionPort\",\"unifiedKey\":\"referrerAppConnectionPort\",\"type\":\"int\"},\"visit.applicationDetails.referrerApp.connection.secure\":{\"quantumKey\":\"referrerAppConnectionSecure\",\"unifiedKey\":\"referrerAppConnectionSecure\",\"type\":\"boolean\"},\"visit.applicationDetails.referrerApp.connection.type\":{\"quantumKey\":\"referrerAppConnectionType\",\"unifiedKey\":\"referrerAppConnectionType\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.device.displayPPI\":{\"quantumKey\":\"referrerAppDeviceDisplayPPI\",\"unifiedKey\":\"referrerAppDeviceDisplayPPI\",\"type\":\"int\"},\"visit.applicationDetails.referrerApp.device.displaySize\":{\"quantumKey\":\"referrerAppDeviceDisplaySize\",\"unifiedKey\":\"referrerAppDeviceDisplaySize\",\"type\":\"double\"},\"visit.applicationDetails.referrerApp.device.id\":{\"quantumKey\":\"referrerAppDeviceId\",\"unifiedKey\":\"referrerAppDeviceId\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.device.operatingSystem\":{\"quantumKey\":\"referrerAppOperatingSystem\",\"unifiedKey\":\"referrerAppOperatingSystem\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.device.type\":{\"quantumKey\":\"referrerAppDeviceType\",\"unifiedKey\":\"referrerAppDeviceType\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.isActive\":{\"quantumKey\":\"referrerAppIsActive\",\"unifiedKey\":\"referrerAppIsActive\",\"type\":\"boolean\"},\"visit.applicationDetails.referrerApp.secondaryIdentifier\":{\"quantumKey\":\"referrerAppSecondaryIdentifier\",\"unifiedKey\":\"referrerAppSecondaryIdentifier\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.visitId\":{\"quantumKey\":\"referrerAppVisitId\",\"unifiedKey\":\"referrerAppVisitId\",\"type\":\"string\"},\"visit.applicationDetails.referrerLink\":{\"quantumKey\":\"referrerLink\",\"unifiedKey\":\"appRefLink\",\"type\":\"string\"},\"visit.applicationDetails.referrerLocation\":{\"quantumKey\":\"referrerLocation\",\"unifiedKey\":\"appRefLocation\",\"type\":\"string\"},\"visit.applicationDetails.technologyType\":{\"quantumKey\":\"technologyType\",\"unifiedKey\":\"techType\",\"type\":\"string\"},\"visit.connection.connectionType\":{\"quantumKey\":\"connectionType\",\"unifiedKey\":\"networkConnectType\",\"type\":\"string\"},\"visit.connection.networkCellCarrier\":{\"quantumKey\":\"networkCellCarrier\",\"unifiedKey\":\"networkCellCarrier\",\"type\":\"string\"},\"visit.connection.networkCellNetworkType\":{\"quantumKey\":\"networkCellNetworkType\",\"unifiedKey\":\"networkCellNetworkType\",\"type\":\"string\"},\"visit.connection.networkId\":{\"quantumKey\":\"connectionNetworkId\",\"unifiedKey\":\"connectionNetworkId\",\"type\":\"string\"},\"visit.device.androidDeviceId\":{\"quantumKey\":\"androidDeviceId\",\"unifiedKey\":\"androidDeviceId\",\"type\":\"string\"},\"visit.device.availableStorage\":{\"quantumKey\":\"availableStorage\",\"unifiedKey\":\"deviceAvailStorage\",\"type\":\"string\"},\"visit.device.controllerType\":{\"quantumKey\":\"controllerType\",\"unifiedKey\":\"controllerType\",\"type\":\"string\"},\"visit.device.deviceBuild\":{\"quantumKey\":\"deviceBuild\",\"unifiedKey\":\"deviceBuild\",\"type\":\"string\"},\"visit.device.deviceFormFactor\":{\"quantumKey\":\"formFactor\",\"unifiedKey\":\"deviceFormFactor\",\"type\":\"string\"},\"visit.device.deviceType\":{\"quantumKey\":\"deviceType\",\"unifiedKey\":\"deviceType\",\"type\":\"string\"},\"visit.device.displayRefreshRateHz\":{\"quantumKey\":\"displayRefreshRateHz\",\"unifiedKey\":\"displayRefreshRateHz\",\"type\":\"int\"},\"visit.device.linkedDevice.id\":{\"quantumKey\":\"linkedDeviceId\",\"unifiedKey\":\"deviceLinkedId\",\"type\":\"string\"},\"visit.device.linkedDevice.ipAddress\":{\"quantumKey\":\"linkedDeviceIpAddress\",\"unifiedKey\":\"deviceLinkedIp\",\"type\":\"string\"},\"visit.device.linkedDevice.name\":{\"quantumKey\":\"linkedDeviceName\",\"unifiedKey\":\"deviceLinkedName\",\"type\":\"string\"},\"visit.device.manufacturer\":{\"quantumKey\":\"manufacturer\",\"unifiedKey\":\"deviceManufacturer\",\"type\":\"string\"},\"visit.device.model\":{\"quantumKey\":\"deviceModel\",\"unifiedKey\":\"deviceModel\",\"type\":\"string\"},\"visit.device.operatingSystem\":{\"quantumKey\":\"operatingSystem\",\"unifiedKey\":\"deviceOperatingSystem\",\"type\":\"string\"},\"visit.device.secondaryUuid\":{\"quantumKey\":\"deviceSecondaryUUID\",\"unifiedKey\":\"deviceSecondaryUuid\",\"type\":\"string\"},\"visit.device.settings.notificationsEnabled\":{\"quantumKey\":\"notificationsEnabled\",\"unifiedKey\":\"notificationsEnabled\",\"type\":\"string\"},\"visit.device.usedStorage\":{\"quantumKey\":\"usedStorage\",\"unifiedKey\":\"deviceUsedStorage\",\"type\":\"string\"},\"visit.device.uuid\":{\"quantumKey\":\"deviceUUID\",\"unifiedKey\":\"deviceUuid\",\"type\":\"string\"},\"visit.device.vendorId\":{\"quantumKey\":\"vendorId\",\"unifiedKey\":\"deviceVendorIdMap\",\"type\":\"map\",\"elementType\":\"string\"},\"visit.device.vendorId.audienceManagerUuid\":{\"quantumKey\":\"audienceManagerUuid\",\"unifiedKey\":\"audienceManagerUuid\",\"type\":\"string\"},\"visit.device.vendorId.deviceVendorId\":{\"quantumKey\":\"otherDeviceVendorId\",\"unifiedKey\":\"otherDeviceVendorId\",\"type\":\"string\"},\"visit.device.vendorId.someId\":{\"quantumKey\":\"someId\",\"unifiedKey\":\"someId\",\"type\":\"string\"},\"visit.device.vendorId.vendorId\":{\"quantumKey\":\"vendorId.vendorId\",\"unifiedKey\":\"deviceVendorId\",\"type\":\"string\"},\"visit.externalAnalytics.sessionId\":{\"quantumKey\":\"externalAnalyticsSessionId\",\"unifiedKey\":\"externalAnalyticsSessionId\",\"type\":\"string\"},\"visit.externalApps\":{\"quantumKey\":\"externalApps\",\"unifiedKey\":\"externalApps\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.features.backgroundAudioEnabled\":{\"quantumKey\":\"backgroundAudioEnabled\",\"unifiedKey\":\"backgroundAudioEnabled\",\"type\":\"string\"},\"visit.inFocus\":{\"quantumKey\":\"inFocus\",\"unifiedKey\":\"inFocus\",\"type\":\"boolean\"},\"visit.login.userToken\":{\"quantumKey\":\"userToken\",\"unifiedKey\":\"userToken\",\"type\":\"string\"},\"visit.mirroring\":{\"quantumKey\":\"mirroring\",\"unifiedKey\":\"mirroring\",\"type\":\"boolean\"},\"visit.permissionSettings.bleLocationStatus\":{\"quantumKey\":\"bleLocationStatus\",\"unifiedKey\":\"bleLocationStatus\",\"type\":\"string\"},\"visit.permissionSettings.cookiesEnabled\":{\"quantumKey\":\"cookiesEnabled\",\"unifiedKey\":\"cookiesEnabled\",\"type\":\"string\"},\"visit.permissionSettings.gpsLocationStatus\":{\"quantumKey\":\"gpsLocationStatus\",\"unifiedKey\":\"gpsLocationStatus\",\"type\":\"string\"},\"visit.permissionSettings.limitAdTracking\":{\"quantumKey\":\"limitAdTracking\",\"unifiedKey\":\"limitAdTracking\",\"type\":\"string\"},\"visit.permissionSettings.locationStatus\":{\"quantumKey\":\"locationStatus\",\"unifiedKey\":\"locationStatus\",\"type\":\"string\"},\"visit.permissionSettings.networkLocationStatus\":{\"quantumKey\":\"networkLocationStatus\",\"unifiedKey\":\"networkLocationStatus\",\"type\":\"string\"},\"visit.previousVisitId\":{\"quantumKey\":\"previousVisitId\",\"unifiedKey\":\"prevVisitId\",\"type\":\"string\"},\"visit.privacy.gpcPersisted\":{\"quantumKey\":\"gpcPersisted\",\"unifiedKey\":\"gpcPersisted\",\"type\":\"boolean\"},\"visit.screenResolution\":{\"quantumKey\":\"screenResolution\",\"unifiedKey\":\"screenResolution\",\"type\":\"string\"},\"visit.settings\":{\"quantumKey\":\"settings\",\"unifiedKey\":\"settings\",\"type\":\"map\",\"elementType\":\"string\"},\"visit.settings.appliedConfigs\":{\"quantumKey\":\"appliedConfigs\",\"unifiedKey\":\"appliedConfigs\",\"type\":\"string\"},\"visit.settings.appointmentNotificationsEnabled\":{\"quantumKey\":\"appointmentNotificationsEnabled\",\"unifiedKey\":\"appointmentNotificationsEnabled\",\"type\":\"string\"},\"visit.settings.autoAccessEnabled\":{\"quantumKey\":\"autoAccessEnabled\",\"unifiedKey\":\"autoAccessEnabled\",\"type\":\"string\"},\"visit.settings.billingNotificationsEnabled\":{\"quantumKey\":\"billingNotificationsEnabled\",\"unifiedKey\":\"billingNotificationsEnabled\",\"type\":\"string\"},\"visit.settings.outageNotificationsEnabled\":{\"quantumKey\":\"outageNotificationsEnabled\",\"unifiedKey\":\"outageNotificationsEnabled\",\"type\":\"string\"},\"visit.settings.previousVisitQueuedMessageCount\":{\"quantumKey\":\"previousVisitQueuedMessageCount\",\"unifiedKey\":\"previousVisitQueuedMessageCount\",\"type\":\"string\"},\"visit.settings.previousVisitRejectedMessageCount\":{\"quantumKey\":\"previousVisitRejectedMessageCount\",\"unifiedKey\":\"previousVisitRejectedMessageCount\",\"type\":\"string\"},\"visit.settings.privateAppliedConfigs\":{\"quantumKey\":\"privateAppliedConfigs\",\"unifiedKey\":\"privateAppliedConfigs\",\"type\":\"string\"},\"visit.settings.reinitVersion\":{\"quantumKey\":\"reinitVersion\",\"unifiedKey\":\"reinitVersion\",\"type\":\"string\"},\"visit.talkingGuide\":{\"quantumKey\":\"talkingGuide\",\"unifiedKey\":\"talkingGuide\",\"type\":\"boolean\"},\"visit.thirdPartyAccess.requesterId\":{\"quantumKey\":\"requesterId\",\"unifiedKey\":\"thirdPtyAccRequesterId\",\"type\":\"string\"},\"visit.thirdPartyAccess.resourceId\":{\"quantumKey\":\"resourceId\",\"unifiedKey\":\"thirdPtyAccResourceId\",\"type\":\"string\"},\"visit.visitId\":{\"quantumKey\":\"visitId\",\"unifiedKey\":\"visitId\",\"type\":\"string\"}},\"subModalClose\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"state.view.subModal.currentModalName\":{\"quantumKey\":\"subModalName\",\"unifiedKey\":\"subModalName\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"subModalView\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.buyflow.offerId\":{\"quantumKey\":\"buyflowOfferId\",\"unifiedKey\":\"buyflowOfferId\",\"type\":\"string\"},\"message.feature.clientCart\":{\"quantumKey\":\"featureClientCart\",\"unifiedKey\":\"featureClientCart\",\"type\":\"array\",\"elementType\":\"object\"},\"message.feature.currentStep\":{\"quantumKey\":\"featureCurrentStep\",\"unifiedKey\":\"msgFeatureCurrStep\",\"type\":\"int\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.feature.numberOfSteps\":{\"quantumKey\":\"featureNumberOfSteps\",\"unifiedKey\":\"msgFeatureNbrOfSteps\",\"type\":\"int\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.view.subModal.currentModalLoadTimeMs\":{\"quantumKey\":\"subModalLoadTimeMs\",\"unifiedKey\":\"subModalLoadTimeMs\",\"type\":\"int\"},\"state.view.subModal.currentModalName\":{\"quantumKey\":\"subModalName\",\"unifiedKey\":\"subModalName\",\"type\":\"string\"},\"state.view.subModal.currentModalText\":{\"quantumKey\":\"subModalText\",\"unifiedKey\":\"subModalText\",\"type\":\"string\"},\"state.view.subModal.currentModalType\":{\"quantumKey\":\"subModalType\",\"unifiedKey\":\"subModalType\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"switchScreen\":{\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.triggeredBy\":{\"quantumKey\":\"triggeredBy\",\"unifiedKey\":\"msgTriggeredBy\",\"type\":\"string\"},\"message.triggeredUsing\":{\"quantumKey\":\"triggeredUsing\",\"unifiedKey\":\"msgTriggeredUsing\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"operation.switchScreenDirection\":{\"quantumKey\":\"switchScreenDirection\",\"unifiedKey\":\"opSwitchScreenDirection\",\"type\":\"string\"},\"operation.switchScreenId\":{\"quantumKey\":\"switchScreenId\",\"unifiedKey\":\"opSwitchScreenId\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.applicationName\":{\"quantumKey\":\"referrerAppName\",\"unifiedKey\":\"referrerAppName\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.applicationType\":{\"quantumKey\":\"referrerAppType\",\"unifiedKey\":\"referrerAppType\",\"type\":\"string\"},\"visit.applicationDetails.referrerApp.isActive\":{\"quantumKey\":\"referrerAppIsActive\",\"unifiedKey\":\"referrerAppIsActive\",\"type\":\"boolean\"},\"visit.applicationDetails.referrerApp.visitId\":{\"quantumKey\":\"referrerAppVisitId\",\"unifiedKey\":\"referrerAppVisitId\",\"type\":\"string\"},\"visit.chromecastEnabled\":{\"quantumKey\":\"chromecastEnabled\",\"unifiedKey\":\"chromecastEnabled\",\"type\":\"boolean\"},\"visit.device.linkedDevice.id\":{\"quantumKey\":\"linkedDeviceId\",\"unifiedKey\":\"deviceLinkedId\",\"type\":\"string\"},\"visit.mirroring\":{\"quantumKey\":\"mirroring\",\"unifiedKey\":\"mirroring\",\"type\":\"boolean\"}},\"systemMessage\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.os.methodName\":{\"quantumKey\":\"methodName\",\"unifiedKey\":\"methodName\",\"type\":\"string\"},\"operation.os.queryParameters\":{\"quantumKey\":\"osQueryParameters\",\"unifiedKey\":\"osQueryParameters\",\"type\":\"string\"},\"operation.os.responseText\":{\"quantumKey\":\"osResponseText\",\"unifiedKey\":\"osResponseText\",\"type\":\"string\"},\"operation.success\":{\"quantumKey\":\"success\",\"unifiedKey\":\"opSuccess\",\"type\":\"boolean\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"temporaryView\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"state.view.currentPage.appSection\":{\"quantumKey\":\"appSection\",\"unifiedKey\":\"currPageAppSection\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"userConfigSet\":{\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"state.view.currentPage.channelLineup.numberAvailableChannels\":{\"quantumKey\":\"numberAvailableChannels\",\"unifiedKey\":\"currPageChnlLineupNbrAvailChnls\",\"type\":\"int\"},\"state.view.currentPage.channelLineup.numberUnavailableChannels\":{\"quantumKey\":\"numberUnavailableChannels\",\"unifiedKey\":\"currPageChnlLineupNbrUnavailChnls\",\"type\":\"int\"},\"state.view.currentPage.channelLineup.otaMissingDelta\":{\"quantumKey\":\"otaMissingDelta\",\"unifiedKey\":\"otaMissingDelta\",\"type\":\"int\"},\"visit.accessibility\":{\"quantumKey\":\"accessibilitySettings\",\"unifiedKey\":\"accessibilitySettings\",\"type\":\"array\",\"elementType\":\"object\"},\"visit.account.accountFeatures.navigationMuteAudio\":{\"quantumKey\":\"navigationMuteAudio\",\"unifiedKey\":\"navigationMuteAudio\",\"type\":\"string\"},\"visit.account.accountGUID\":{\"quantumKey\":\"accountGUID\",\"unifiedKey\":\"accountGUID\",\"type\":\"string\"},\"visit.account.clientLocationNumber\":{\"quantumKey\":\"clientLocationNumber\",\"unifiedKey\":\"clientLocationNumber\",\"type\":\"string\"},\"visit.account.details.billingServices\":{\"quantumKey\":\"accountDetailsBillServices\",\"unifiedKey\":\"accountDetailsBillServices\",\"type\":\"string\"},\"visit.account.details.cpniCompliant\":{\"quantumKey\":\"cpniCompliant\",\"unifiedKey\":\"cpniCompliant\",\"type\":\"boolean\"},\"visit.account.identityGUID\":{\"quantumKey\":\"identityGUID\",\"unifiedKey\":\"identityGUID\",\"type\":\"string\"},\"visit.account.otaExperience\":{\"quantumKey\":\"otaExperience\",\"unifiedKey\":\"otaExperience\",\"type\":\"boolean\"},\"visit.account.tvProvider\":{\"quantumKey\":\"tvProvider\",\"unifiedKey\":\"tvProvider\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"},\"visit.connection.networkId\":{\"quantumKey\":\"connectionNetworkId\",\"unifiedKey\":\"connectionNetworkId\",\"type\":\"string\"},\"visit.device.linkedDevice.guideType\":{\"quantumKey\":\"guideType\",\"unifiedKey\":\"deviceGuideType\",\"type\":\"string\"},\"visit.device.settings.notificationsEnabled\":{\"quantumKey\":\"notificationsEnabled\",\"unifiedKey\":\"notificationsEnabled\",\"type\":\"string\"},\"visit.permissionSettings.cookiesEnabled\":{\"quantumKey\":\"cookiesEnabled\",\"unifiedKey\":\"cookiesEnabled\",\"type\":\"string\"},\"visit.permissionSettings.tvProviderPermissionStatus\":{\"quantumKey\":\"tvProviderPermissionStatus\",\"unifiedKey\":\"tvProviderPermissionStatus\",\"type\":\"string\"},\"visit.promotion.endDate\":{\"quantumKey\":\"promoEndDate\",\"unifiedKey\":\"promoEndDate\",\"type\":\"long\"},\"visit.promotion.offerId\":{\"quantumKey\":\"offerId\",\"unifiedKey\":\"offerId\",\"type\":\"string\"},\"visit.promotion.promoId\":{\"quantumKey\":\"promoId\",\"unifiedKey\":\"promoId\",\"type\":\"string\"},\"visit.promotion.promoType\":{\"quantumKey\":\"promoType\",\"unifiedKey\":\"promoType\",\"type\":\"string\"},\"visit.promotion.startDate\":{\"quantumKey\":\"promoStartDate\",\"unifiedKey\":\"promoStartDate\",\"type\":\"long\"}},\"userFeedback\":{\"message.context\":{\"quantumKey\":\"context\",\"unifiedKey\":\"msgContext\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension1\":{\"quantumKey\":\"msgFeatureDim1\",\"unifiedKey\":\"msgFeatureDim1\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension2\":{\"quantumKey\":\"msgFeatureDim2\",\"unifiedKey\":\"msgFeatureDim2\",\"type\":\"string\"},\"message.feature.dimensions.featureDimension3\":{\"quantumKey\":\"msgFeatureDim3\",\"unifiedKey\":\"msgFeatureDim3\",\"type\":\"string\"},\"message.feature.featureName\":{\"quantumKey\":\"featureName\",\"unifiedKey\":\"msgFeatureName\",\"type\":\"string\"},\"message.feature.featureStepName\":{\"quantumKey\":\"featureStepName\",\"unifiedKey\":\"msgFeatureStepName\",\"type\":\"string\"},\"message.feature.featureType\":{\"quantumKey\":\"featureType\",\"unifiedKey\":\"msgFeatureType\",\"type\":\"string\"},\"message.feature.ignoreContext\":{\"quantumKey\":\"ignoreContext\",\"unifiedKey\":\"ignoreContext\",\"type\":\"boolean\"},\"message.persistFeature\":{\"quantumKey\":\"persistFeature\",\"unifiedKey\":\"persistFeature\",\"type\":\"boolean\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.userEntry.category\":{\"quantumKey\":\"entryCategory\",\"unifiedKey\":\"opUserCat\",\"type\":\"string\"},\"operation.userEntry.entryType\":{\"quantumKey\":\"entryType\",\"unifiedKey\":\"userName\",\"type\":\"string\"},\"operation.userEntry.feedback\":{\"quantumKey\":\"userFeedback\",\"unifiedKey\":\"opUserFeedback\",\"type\":\"string\"},\"operation.userEntry.feedbackId\":{\"quantumKey\":\"feedbackId\",\"unifiedKey\":\"opFeedbackId\",\"type\":\"string\"},\"operation.userEntry.feedbackTarget\":{\"quantumKey\":\"feedbackTarget\",\"unifiedKey\":\"feedbackTarget\",\"type\":\"string\"},\"operation.userEntry.numeric\":{\"quantumKey\":\"entryNumeric\",\"unifiedKey\":\"opUserEntryNumeric\",\"type\":\"int\"},\"operation.userEntry.questionId\":{\"quantumKey\":\"questionId\",\"unifiedKey\":\"opQuestionId\",\"type\":\"int\"},\"operation.userEntry.questionType\":{\"quantumKey\":\"questionType\",\"unifiedKey\":\"questionType\",\"type\":\"string\"},\"operation.userEntry.strValue\":{\"quantumKey\":\"entryStrValue\",\"unifiedKey\":\"opUserEntryStrValue\",\"type\":\"string\"},\"operation.userEntry.surveyId\":{\"quantumKey\":\"surveyId\",\"unifiedKey\":\"opSurveyId\",\"type\":\"string\"},\"operation.userEntry.text\":{\"quantumKey\":\"entryText\",\"unifiedKey\":\"opUserText\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"webSocketActivity\":{\"application.api.apiCached\":{\"quantumKey\":\"apiCached\",\"unifiedKey\":\"appApiCached\",\"type\":\"boolean\"},\"application.api.apiClusterVersion\":{\"quantumKey\":\"apiClusterVersion\",\"unifiedKey\":\"apiClusterVersion\",\"type\":\"string\"},\"application.api.architecture\":{\"quantumKey\":\"apiArchitecture\",\"unifiedKey\":\"apiArchitecture\",\"type\":\"string\"},\"application.api.clientServiceResult\":{\"quantumKey\":\"clientServiceResult\",\"unifiedKey\":\"clientServiceResult\",\"type\":\"string\"},\"application.api.host\":{\"quantumKey\":\"host\",\"unifiedKey\":\"appApiHost\",\"type\":\"string\"},\"application.api.maxRetryCount\":{\"quantumKey\":\"maxRetryCount\",\"unifiedKey\":\"appApiMaxRetryCnt\",\"type\":\"int\"},\"application.api.path\":{\"quantumKey\":\"path\",\"unifiedKey\":\"appApiPath\",\"type\":\"string\"},\"application.api.queryParameters\":{\"quantumKey\":\"queryParameters\",\"unifiedKey\":\"appApiQueryParameters\",\"type\":\"string\"},\"application.api.reportedHeaders\":{\"quantumKey\":\"apiReportedHeaders\",\"unifiedKey\":\"apiReportedHeaders\",\"type\":\"string\"},\"application.api.responseCode\":{\"quantumKey\":\"responseCode\",\"unifiedKey\":\"appApiResponseCode\",\"type\":\"string\"},\"application.api.responseSize\":{\"quantumKey\":\"responseSize\",\"unifiedKey\":\"appApiResponseSize\",\"type\":\"int\"},\"application.api.responseText\":{\"quantumKey\":\"responseText\",\"unifiedKey\":\"appApiResponseText\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.api.responseTimeMs\":{\"quantumKey\":\"responseTimeMs\",\"unifiedKey\":\"appApiResponseTimeMs\",\"type\":\"int\"},\"application.api.retry\":{\"quantumKey\":\"retry\",\"unifiedKey\":\"appApiRetry\",\"type\":\"boolean\"},\"application.api.retryCount\":{\"quantumKey\":\"retryCount\",\"unifiedKey\":\"appApiRetryCnt\",\"type\":\"int\"},\"application.api.traceId\":{\"quantumKey\":\"traceId\",\"unifiedKey\":\"appApiTraceId\",\"type\":\"string\"},\"application.api.willRetry\":{\"quantumKey\":\"willRetry\",\"unifiedKey\":\"appApiWillRetry\",\"type\":\"boolean\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.operationType\":{\"quantumKey\":\"operationType\",\"unifiedKey\":\"opType\",\"type\":\"string\"},\"operation.outage.etr\":{\"quantumKey\":\"outageEtr\",\"unifiedKey\":\"outageEtr\",\"type\":\"boolean\"},\"operation.outage.pid\":{\"quantumKey\":\"outagePid\",\"unifiedKey\":\"outagePid\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"webSocketClose\":{\"application.api.apiCached\":{\"quantumKey\":\"apiCached\",\"unifiedKey\":\"appApiCached\",\"type\":\"boolean\"},\"application.api.apiClusterVersion\":{\"quantumKey\":\"apiClusterVersion\",\"unifiedKey\":\"apiClusterVersion\",\"type\":\"string\"},\"application.api.architecture\":{\"quantumKey\":\"apiArchitecture\",\"unifiedKey\":\"apiArchitecture\",\"type\":\"string\"},\"application.api.clientServiceResult\":{\"quantumKey\":\"clientServiceResult\",\"unifiedKey\":\"clientServiceResult\",\"type\":\"string\"},\"application.api.host\":{\"quantumKey\":\"host\",\"unifiedKey\":\"appApiHost\",\"type\":\"string\"},\"application.api.maxRetryCount\":{\"quantumKey\":\"maxRetryCount\",\"unifiedKey\":\"appApiMaxRetryCnt\",\"type\":\"int\"},\"application.api.path\":{\"quantumKey\":\"path\",\"unifiedKey\":\"appApiPath\",\"type\":\"string\"},\"application.api.queryParameters\":{\"quantumKey\":\"queryParameters\",\"unifiedKey\":\"appApiQueryParameters\",\"type\":\"string\"},\"application.api.reportedHeaders\":{\"quantumKey\":\"apiReportedHeaders\",\"unifiedKey\":\"apiReportedHeaders\",\"type\":\"string\"},\"application.api.responseCode\":{\"quantumKey\":\"responseCode\",\"unifiedKey\":\"appApiResponseCode\",\"type\":\"string\"},\"application.api.responseSize\":{\"quantumKey\":\"responseSize\",\"unifiedKey\":\"appApiResponseSize\",\"type\":\"int\"},\"application.api.responseText\":{\"quantumKey\":\"responseText\",\"unifiedKey\":\"appApiResponseText\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.api.responseTimeMs\":{\"quantumKey\":\"responseTimeMs\",\"unifiedKey\":\"appApiResponseTimeMs\",\"type\":\"int\"},\"application.api.retry\":{\"quantumKey\":\"retry\",\"unifiedKey\":\"appApiRetry\",\"type\":\"boolean\"},\"application.api.retryCount\":{\"quantumKey\":\"retryCount\",\"unifiedKey\":\"appApiRetryCnt\",\"type\":\"int\"},\"application.api.traceId\":{\"quantumKey\":\"traceId\",\"unifiedKey\":\"appApiTraceId\",\"type\":\"string\"},\"application.api.willRetry\":{\"quantumKey\":\"willRetry\",\"unifiedKey\":\"appApiWillRetry\",\"type\":\"boolean\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.outage.etr\":{\"quantumKey\":\"outageEtr\",\"unifiedKey\":\"outageEtr\",\"type\":\"boolean\"},\"operation.outage.pid\":{\"quantumKey\":\"outagePid\",\"unifiedKey\":\"outagePid\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"webSocketError\":{\"application.api.apiCached\":{\"quantumKey\":\"apiCached\",\"unifiedKey\":\"appApiCached\",\"type\":\"boolean\"},\"application.api.apiClusterVersion\":{\"quantumKey\":\"apiClusterVersion\",\"unifiedKey\":\"apiClusterVersion\",\"type\":\"string\"},\"application.api.architecture\":{\"quantumKey\":\"apiArchitecture\",\"unifiedKey\":\"apiArchitecture\",\"type\":\"string\"},\"application.api.clientServiceResult\":{\"quantumKey\":\"clientServiceResult\",\"unifiedKey\":\"clientServiceResult\",\"type\":\"string\"},\"application.api.host\":{\"quantumKey\":\"host\",\"unifiedKey\":\"appApiHost\",\"type\":\"string\"},\"application.api.maxRetryCount\":{\"quantumKey\":\"maxRetryCount\",\"unifiedKey\":\"appApiMaxRetryCnt\",\"type\":\"int\"},\"application.api.path\":{\"quantumKey\":\"path\",\"unifiedKey\":\"appApiPath\",\"type\":\"string\"},\"application.api.queryParameters\":{\"quantumKey\":\"queryParameters\",\"unifiedKey\":\"appApiQueryParameters\",\"type\":\"string\"},\"application.api.reportedHeaders\":{\"quantumKey\":\"apiReportedHeaders\",\"unifiedKey\":\"apiReportedHeaders\",\"type\":\"string\"},\"application.api.responseCode\":{\"quantumKey\":\"responseCode\",\"unifiedKey\":\"appApiResponseCode\",\"type\":\"string\"},\"application.api.responseSize\":{\"quantumKey\":\"responseSize\",\"unifiedKey\":\"appApiResponseSize\",\"type\":\"int\"},\"application.api.responseText\":{\"quantumKey\":\"responseText\",\"unifiedKey\":\"appApiResponseText\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.api.responseTimeMs\":{\"quantumKey\":\"responseTimeMs\",\"unifiedKey\":\"appApiResponseTimeMs\",\"type\":\"int\"},\"application.api.retry\":{\"quantumKey\":\"retry\",\"unifiedKey\":\"appApiRetry\",\"type\":\"boolean\"},\"application.api.retryCount\":{\"quantumKey\":\"retryCount\",\"unifiedKey\":\"appApiRetryCnt\",\"type\":\"int\"},\"application.api.traceId\":{\"quantumKey\":\"traceId\",\"unifiedKey\":\"appApiTraceId\",\"type\":\"string\"},\"application.api.willRetry\":{\"quantumKey\":\"willRetry\",\"unifiedKey\":\"appApiWillRetry\",\"type\":\"boolean\"},\"application.error.clientErrorCode\":{\"quantumKey\":\"clientErrorCode\",\"unifiedKey\":\"appClientErrorCode\",\"type\":\"string\"},\"application.error.errorCode\":{\"quantumKey\":\"errorCode\",\"unifiedKey\":\"appErrorCode\",\"type\":\"string\"},\"application.error.errorExtras\":{\"quantumKey\":\"errorExtras\",\"unifiedKey\":\"appErrorExtras\",\"type\":\"map\",\"elementType\":\"string\",\"blacklists\":[\"password\",\"sensitive\"]},\"application.error.errorExtras.nativeErrorCode\":{\"quantumKey\":\"nativeErrorCode\",\"unifiedKey\":\"nativeErrorCode\",\"type\":\"string\"},\"application.error.errorExtras.nativeErrorName\":{\"quantumKey\":\"nativeErrorName\",\"unifiedKey\":\"nativeErrorName\",\"type\":\"string\"},\"application.error.errorMessage\":{\"quantumKey\":\"errorMessage\",\"unifiedKey\":\"appErrorMessage\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.error.errorType\":{\"quantumKey\":\"errorType\",\"unifiedKey\":\"appErrorType\",\"type\":\"string\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.outage.etr\":{\"quantumKey\":\"outageEtr\",\"unifiedKey\":\"outageEtr\",\"type\":\"boolean\"},\"operation.outage.pid\":{\"quantumKey\":\"outagePid\",\"unifiedKey\":\"outagePid\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"webSocketHeartbeat\":{\"application.api.apiCached\":{\"quantumKey\":\"apiCached\",\"unifiedKey\":\"appApiCached\",\"type\":\"boolean\"},\"application.api.apiClusterVersion\":{\"quantumKey\":\"apiClusterVersion\",\"unifiedKey\":\"apiClusterVersion\",\"type\":\"string\"},\"application.api.architecture\":{\"quantumKey\":\"apiArchitecture\",\"unifiedKey\":\"apiArchitecture\",\"type\":\"string\"},\"application.api.clientServiceResult\":{\"quantumKey\":\"clientServiceResult\",\"unifiedKey\":\"clientServiceResult\",\"type\":\"string\"},\"application.api.host\":{\"quantumKey\":\"host\",\"unifiedKey\":\"appApiHost\",\"type\":\"string\"},\"application.api.maxRetryCount\":{\"quantumKey\":\"maxRetryCount\",\"unifiedKey\":\"appApiMaxRetryCnt\",\"type\":\"int\"},\"application.api.path\":{\"quantumKey\":\"path\",\"unifiedKey\":\"appApiPath\",\"type\":\"string\"},\"application.api.queryParameters\":{\"quantumKey\":\"queryParameters\",\"unifiedKey\":\"appApiQueryParameters\",\"type\":\"string\"},\"application.api.reportedHeaders\":{\"quantumKey\":\"apiReportedHeaders\",\"unifiedKey\":\"apiReportedHeaders\",\"type\":\"string\"},\"application.api.responseCode\":{\"quantumKey\":\"responseCode\",\"unifiedKey\":\"appApiResponseCode\",\"type\":\"string\"},\"application.api.responseSize\":{\"quantumKey\":\"responseSize\",\"unifiedKey\":\"appApiResponseSize\",\"type\":\"int\"},\"application.api.responseText\":{\"quantumKey\":\"responseText\",\"unifiedKey\":\"appApiResponseText\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.api.responseTimeMs\":{\"quantumKey\":\"responseTimeMs\",\"unifiedKey\":\"appApiResponseTimeMs\",\"type\":\"int\"},\"application.api.retry\":{\"quantumKey\":\"retry\",\"unifiedKey\":\"appApiRetry\",\"type\":\"boolean\"},\"application.api.retryCount\":{\"quantumKey\":\"retryCount\",\"unifiedKey\":\"appApiRetryCnt\",\"type\":\"int\"},\"application.api.traceId\":{\"quantumKey\":\"traceId\",\"unifiedKey\":\"appApiTraceId\",\"type\":\"string\"},\"application.api.willRetry\":{\"quantumKey\":\"willRetry\",\"unifiedKey\":\"appApiWillRetry\",\"type\":\"boolean\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.intValue\":{\"quantumKey\":\"operationIntValue\",\"unifiedKey\":\"operationIntValue\",\"type\":\"int\"},\"operation.outage.etr\":{\"quantumKey\":\"outageEtr\",\"unifiedKey\":\"outageEtr\",\"type\":\"boolean\"},\"operation.outage.pid\":{\"quantumKey\":\"outagePid\",\"unifiedKey\":\"outagePid\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}},\"webSocketOpen\":{\"application.api.apiCached\":{\"quantumKey\":\"apiCached\",\"unifiedKey\":\"appApiCached\",\"type\":\"boolean\"},\"application.api.apiClusterVersion\":{\"quantumKey\":\"apiClusterVersion\",\"unifiedKey\":\"apiClusterVersion\",\"type\":\"string\"},\"application.api.architecture\":{\"quantumKey\":\"apiArchitecture\",\"unifiedKey\":\"apiArchitecture\",\"type\":\"string\"},\"application.api.clientServiceResult\":{\"quantumKey\":\"clientServiceResult\",\"unifiedKey\":\"clientServiceResult\",\"type\":\"string\"},\"application.api.host\":{\"quantumKey\":\"host\",\"unifiedKey\":\"appApiHost\",\"type\":\"string\"},\"application.api.maxRetryCount\":{\"quantumKey\":\"maxRetryCount\",\"unifiedKey\":\"appApiMaxRetryCnt\",\"type\":\"int\"},\"application.api.path\":{\"quantumKey\":\"path\",\"unifiedKey\":\"appApiPath\",\"type\":\"string\"},\"application.api.queryParameters\":{\"quantumKey\":\"queryParameters\",\"unifiedKey\":\"appApiQueryParameters\",\"type\":\"string\"},\"application.api.reportedHeaders\":{\"quantumKey\":\"apiReportedHeaders\",\"unifiedKey\":\"apiReportedHeaders\",\"type\":\"string\"},\"application.api.responseCode\":{\"quantumKey\":\"responseCode\",\"unifiedKey\":\"appApiResponseCode\",\"type\":\"string\"},\"application.api.responseSize\":{\"quantumKey\":\"responseSize\",\"unifiedKey\":\"appApiResponseSize\",\"type\":\"int\"},\"application.api.responseText\":{\"quantumKey\":\"responseText\",\"unifiedKey\":\"appApiResponseText\",\"type\":\"string\",\"blacklists\":[\"password\"]},\"application.api.responseTimeMs\":{\"quantumKey\":\"responseTimeMs\",\"unifiedKey\":\"appApiResponseTimeMs\",\"type\":\"int\"},\"application.api.retry\":{\"quantumKey\":\"retry\",\"unifiedKey\":\"appApiRetry\",\"type\":\"boolean\"},\"application.api.retryCount\":{\"quantumKey\":\"retryCount\",\"unifiedKey\":\"appApiRetryCnt\",\"type\":\"int\"},\"application.api.traceId\":{\"quantumKey\":\"traceId\",\"unifiedKey\":\"appApiTraceId\",\"type\":\"string\"},\"application.api.willRetry\":{\"quantumKey\":\"willRetry\",\"unifiedKey\":\"appApiWillRetry\",\"type\":\"boolean\"},\"message.event.eventCaseDetails\":{\"quantumKey\":\"eventCaseDetails\",\"unifiedKey\":\"eventCaseDetails\",\"type\":\"string\"},\"message.event.eventGroup\":{\"quantumKey\":\"eventGroup\",\"unifiedKey\":\"eventGroup\",\"type\":\"string\"},\"message.event.eventLabel\":{\"quantumKey\":\"eventLabel\",\"unifiedKey\":\"eventLabel\",\"type\":\"string\"},\"message.event.eventSubGroup\":{\"quantumKey\":\"eventSubGroup\",\"unifiedKey\":\"eventSubGroup\",\"type\":\"string\"},\"message.eventCaseId\":{\"quantumKey\":\"eventCaseId\",\"unifiedKey\":\"eventCaseId\",\"type\":\"string\"},\"operation.additionalInformation\":{\"quantumKey\":\"additionalInformation\",\"unifiedKey\":\"linkAdditionalInfo\",\"type\":\"string\"},\"operation.outage.etr\":{\"quantumKey\":\"outageEtr\",\"unifiedKey\":\"outageEtr\",\"type\":\"boolean\"},\"operation.outage.pid\":{\"quantumKey\":\"outagePid\",\"unifiedKey\":\"outagePid\",\"type\":\"string\"},\"visit.additionalInformation\":{\"quantumKey\":\"visitAdditionalInformation\",\"unifiedKey\":\"visitAdditionalInformation\",\"type\":\"string\"}}},\"output\":{\"common\":[\"message\",\"operation.additionalInformation\",\"state.activeStates\",\"state.currentVideoPosition\",\"state.entryTimestamp\",\"state.entryVideoPosition\",\"state.job\",\"state.lifecycleState\",\"state.name\",\"state.previousLifecycleState\",\"state.previousState\",\"state.referrer\",\"state.support\",\"state.userJourney\",\"state.view.content\",\"state.view.currentPage.appSection\",\"state.view.currentPage.billing\",\"state.view.currentPage.campaign\",\"state.view.currentPage.channelLineup\",\"state.view.currentPage.childMarket\",\"state.view.currentPage.components\",\"state.view.currentPage.currentBalanceAmount\",\"state.view.currentPage.elements\",\"state.view.currentPage.mfeVersion\",\"state.view.currentPage.orders\",\"state.view.currentPage.pageDisplayType\",\"state.view.currentPage.pageId\",\"state.view.currentPage.pageName\",\"state.view.currentPage.pageSection\",\"state.view.currentPage.pageSequenceNumber\",\"state.view.currentPage.pageSubSection\",\"state.view.currentPage.pageTitle\",\"state.view.currentPage.pageType\",\"state.view.currentPage.pageUrl\",\"state.view.currentPage.pageViewType\",\"state.view.currentPage.parentMarket\",\"state.view.currentPage.pastDueAmount\",\"state.view.currentPage.renderDetails\",\"state.view.currentPage.replayLink\",\"state.view.currentPage.settings\",\"state.view.currentPage.sortAndFilter\",\"state.view.currentPage.temporaryViewedTimeMs\",\"state.view.currentPage.totalAmountDue\",\"state.view.currentPage.uiResponsiveBreakpoint\",\"state.view.currentPage.userJourney\",\"state.view.currentPage.userSubJourney\",\"state.view.device\",\"state.view.mirroring\",\"state.view.modal\",\"state.view.pictureInPicture\",\"state.view.playbackDisplayType\",\"state.view.previousPage\",\"state.view.splitScreen\",\"state.view.subModal\",\"state.view.userActivity\"],\"adBreakStart\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"adBreakStop\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"adStart\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"adStop\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"apiCall\":[\"application.api\",\"operation\"],\"applicationActivity\":[\"operation\"],\"applicationCrash\":[\"application.error\"],\"applicationPerformance\":[\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\"],\"assetDisplayed\":[\"operation\"],\"attemptRestart\":[\"operation.operationType\",\"state.content\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat.playPointTimestamp\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"batchApiCall\":[\"application.api.apiCached\",\"application.api.apiClusterVersion\",\"application.api.apis\",\"application.api.architecture\",\"application.api.clientServiceResult\",\"application.api.eventUid\",\"application.api.host\",\"application.api.httpVerb\",\"application.api.maxRetryCount\",\"application.api.path\",\"application.api.queryParameters\",\"application.api.reportedHeaders\",\"application.api.responseCode\",\"application.api.responseSize\",\"application.api.responseText\",\"application.api.responseTimeMs\",\"application.api.retry\",\"application.api.retryCount\",\"application.api.traceId\",\"application.api.transactionId\",\"application.api.websocketGuid\",\"application.api.willRetry\",\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\",\"state.content\"],\"bufferingStart\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"bufferingStop\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.bufferingTimeMs\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"checkAvailableChannels\":[],\"concurrencyChange\":[\"state.content\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.concurrency\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat.playPointTimestamp\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"connectionChange\":[\"operation.operationType\"],\"customEvent\":[\"custom\"],\"deeplinkStart\":[],\"deeplinkStop\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation.success\"],\"displayChange\":[\"operation.operationType\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"error\":[\"application.api\",\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"externalAppStateChange\":[],\"featureStart\":[\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\"],\"featureStop\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation\"],\"forcedLogin\":[\"operation.operationType\"],\"impressionStart\":[\"state.impression\"],\"impressionStop\":[\"state.impression\"],\"inVisitOauthRefresh\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation.operationType\",\"operation.success\"],\"loginStart\":[\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\"],\"loginStop\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation\"],\"logout\":[\"operation.operationType\"],\"modalClose\":[\"operation.operationType\"],\"modalView\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\"],\"pageView\":[\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\",\"state.view\"],\"pageViewInit\":[\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"pageViewPerformance\":[\"operation.operationType\",\"state.view\"],\"pinEntry\":[\"operation\"],\"playbackBitRateDownshift\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackBitRateUpshift\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackExitBeforeStart\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"state.content\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackFailure\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation.success\",\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackFailureBeforeRetry\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation.success\",\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackHeartbeat\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackPause\":[\"operation.operationType\",\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackSelect\":[\"operation.operationType\",\"state.content\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat.playPointTimestamp\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackStart\":[\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackStartAfterRetry\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackStop\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackStreamUriAcquired\":[\"operation.success\",\"state.content\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat.playPointTimestamp\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackTrackChange\":[\"operation.operationType\",\"operation.success\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackTrickPlayRateChange\":[\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.trickPlay\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackTrickPlayStart\":[\"operation.operationType\",\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.trickPlay\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackTrickPlayStop\":[\"operation.operationType\",\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.trickPlay\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"playbackUnpause\":[\"operation.operationType\",\"state.ad\",\"state.content\",\"state.playback.bitRate\",\"state.playback.buffer\",\"state.playback.cacheLength\",\"state.playback.cacheStartPosition\",\"state.playback.capping\",\"state.playback.daiEnabled\",\"state.playback.drmCached\",\"state.playback.frames\",\"state.playback.heartBeat\",\"state.playback.maxVideoResolution\",\"state.playback.pauseLiveTvIsEnabled\",\"state.playback.performance\",\"state.playback.playbackSelectedTimestamp\",\"state.playback.playbackStartedTimestamp\",\"state.playback.playerSessionId\",\"state.playback.retriedErrorCode\",\"state.playback.retryAttempts\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryTimeMs\",\"state.playback.segmentInfo\",\"state.playback.totalSessionRetries\",\"state.playback.tuneTimeMs\",\"state.playback.tuneType\",\"state.playback.uriObtainedMs\",\"state.playback.videoPlayerSettings\",\"state.playback.videoResolution\",\"state.playback.viewPortResolution\"],\"purchaseStart\":[],\"purchaseStop\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation\"],\"requestToCancelRecording\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation\"],\"requestToDeleteRecording\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation\"],\"requestToEditRecording\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation\"],\"requestToRecord\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation\"],\"searchClosed\":[\"operation.operationType\",\"state.search\"],\"searched\":[\"operation.operationType\",\"state.search\"],\"selectAction\":[\"operation\",\"state.content\",\"state.search\"],\"selectContent\":[\"operation.operationType\",\"operation.recordingOptions\",\"state.impression\",\"state.search\"],\"startSession\":[\"operation.operationType\"],\"subModalClose\":[\"operation.operationType\"],\"subModalView\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\"],\"switchScreen\":[\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation\"],\"systemMessage\":[\"operation\"],\"temporaryView\":[],\"userConfigSet\":[\"operation.operationType\"],\"userFeedback\":[\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\"],\"webSocketActivity\":[\"application.api.apiCached\",\"application.api.apiClusterVersion\",\"application.api.apis\",\"application.api.architecture\",\"application.api.clientServiceResult\",\"application.api.eventUid\",\"application.api.host\",\"application.api.httpVerb\",\"application.api.maxRetryCount\",\"application.api.path\",\"application.api.queryParameters\",\"application.api.reportedHeaders\",\"application.api.responseCode\",\"application.api.responseSize\",\"application.api.responseText\",\"application.api.responseTimeMs\",\"application.api.retry\",\"application.api.retryCount\",\"application.api.traceId\",\"application.api.transactionId\",\"application.api.websocketGuid\",\"application.api.willRetry\",\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\"],\"webSocketClose\":[\"application.api.apiCached\",\"application.api.apiClusterVersion\",\"application.api.apis\",\"application.api.architecture\",\"application.api.clientServiceResult\",\"application.api.eventUid\",\"application.api.host\",\"application.api.httpVerb\",\"application.api.maxRetryCount\",\"application.api.path\",\"application.api.queryParameters\",\"application.api.reportedHeaders\",\"application.api.responseCode\",\"application.api.responseSize\",\"application.api.responseText\",\"application.api.responseTimeMs\",\"application.api.retry\",\"application.api.retryCount\",\"application.api.traceId\",\"application.api.transactionId\",\"application.api.websocketGuid\",\"application.api.willRetry\",\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\"],\"webSocketError\":[\"application.api.apiCached\",\"application.api.apiClusterVersion\",\"application.api.apis\",\"application.api.architecture\",\"application.api.clientServiceResult\",\"application.api.eventUid\",\"application.api.host\",\"application.api.httpVerb\",\"application.api.maxRetryCount\",\"application.api.path\",\"application.api.queryParameters\",\"application.api.reportedHeaders\",\"application.api.responseCode\",\"application.api.responseSize\",\"application.api.responseText\",\"application.api.responseTimeMs\",\"application.api.retry\",\"application.api.retryCount\",\"application.api.traceId\",\"application.api.transactionId\",\"application.api.websocketGuid\",\"application.api.willRetry\",\"application.error.clientErrorCode\",\"application.error.errorCode\",\"application.error.errorExtras\",\"application.error.errorMessage\",\"application.error.errorType\",\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\"],\"webSocketHeartbeat\":[\"application.api.apiCached\",\"application.api.apiClusterVersion\",\"application.api.apis\",\"application.api.architecture\",\"application.api.clientServiceResult\",\"application.api.eventUid\",\"application.api.host\",\"application.api.httpVerb\",\"application.api.maxRetryCount\",\"application.api.path\",\"application.api.queryParameters\",\"application.api.reportedHeaders\",\"application.api.responseCode\",\"application.api.responseSize\",\"application.api.responseText\",\"application.api.responseTimeMs\",\"application.api.retry\",\"application.api.retryCount\",\"application.api.traceId\",\"application.api.transactionId\",\"application.api.websocketGuid\",\"application.api.willRetry\",\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\"],\"webSocketOpen\":[\"application.api.apiCached\",\"application.api.apiClusterVersion\",\"application.api.apis\",\"application.api.architecture\",\"application.api.clientServiceResult\",\"application.api.eventUid\",\"application.api.host\",\"application.api.httpVerb\",\"application.api.maxRetryCount\",\"application.api.path\",\"application.api.queryParameters\",\"application.api.reportedHeaders\",\"application.api.responseCode\",\"application.api.responseSize\",\"application.api.responseText\",\"application.api.responseTimeMs\",\"application.api.retry\",\"application.api.retryCount\",\"application.api.traceId\",\"application.api.transactionId\",\"application.api.websocketGuid\",\"application.api.willRetry\",\"operation.billing\",\"operation.device\",\"operation.intValue\",\"operation.nielsenLoadData\",\"operation.operationType\",\"operation.os\",\"operation.outage\",\"operation.phone\",\"operation.recordingOptions\",\"operation.settingsUpdates\",\"operation.switchScreenDirection\",\"operation.switchScreenId\",\"operation.toggleState\",\"operation.userEntry\",\"operation.userPreferenceCategory\",\"operation.userPreferencesSelections\"]},\"blacklists\":{\"password\":[\"\\\\\\\\?\\\"?password\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?Bearer\\\\\\\\?\\\"?\\\\s*:\"],\"sensitive\":[\"\\\\\\\\?\\\"?application.api.queryParameters\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?message.feature.accountNumber\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?oAuthToken\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.device.routerMacAddress\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.device.serialNumber\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.os.queryParameters\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.os.responseText\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.phone.imei\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.userEntry.accountNumber\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.userEntry.email\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.userEntry.feedbackId\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.userEntry.feedback\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.userEntry.phoneNumber\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.userEntry.securityCode\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.userEntry.text\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?operation.userEntry.zipcode\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?queryParameters\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?state.ad.deviceAdId\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?state.view.currentPage.components\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?state.view.currentPage.orders\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?state.view.currentPage.pageTitle\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?state.view.currentPage.pageUrl\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?state.view.device.serialNumber\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?state.view.previousPage.pageUrl\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.accountCompany\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.accountFranchise\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.accountGUID\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.accountNumber\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.accountSiteId\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.clientLocationNumber\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.identityGUID\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.mobileAccountNumber\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.soloLocationNumber\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.systemAgent\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.systemPrin\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.systemSys\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.account.trustedAuthId\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.applicationDetails.referrerApp.connection.ipAddress\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.applicationDetails.referrerApp.device.id\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.applicationDetails.referrerLink\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.device.androidDeviceId\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.device.crashId\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.device.linkedDevice.id\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.device.linkedDevice.ipAddress\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.device.secondaryUuid\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.device.uuid\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.device.vendorId.audienceManagerUuid\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.device.vendorId.deviceVendorId\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.device.vendorId.someId\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.device.vendorId.vendorId\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.device.vendorId\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.isp.trafficOriginId\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.location.clientLatitude\\\\\\\\?\\\"?\\\\s*:\",\"\\\\\\\\?\\\"?visit.location.clientLongitude\\\\\\\\?\\\"?\\\\s*:\"]},\"errorCodes\":{\"internal\":{\"generic\":\"AN-2000\",\"eventBeforeInit\":\"AN-2003\",\"rateLimit\":\"AN-2004\",\"badBitrate\":\"AN-2006\",\"noStreamId\":\"AN-2007\",\"maxConcurrentStreams\":\"AN-2008\",\"maxFieldSize\":\"AN-2009\",\"duplicatePageViewComplete\":\"AN-2010\",\"failedToResumeVisit\":\"AN-2011\",\"missingMaxCacheLengthSetting\":\"AN-2012\",\"unsupportedPauseDuringLinear\":\"AN-2013\",\"brokenPlayPointTimestamp\":\"AN-2014\",\"duplicatedSubModalView\":\"AN-2015\",\"missingImpressionStart\":\"AN-2016\",\"assetDisplayedMissingPageName\":\"AN-2017\",\"impressionStartMissingPageName\":\"AN-2018\",\"modalViewMissingPageName\":\"AN-2019\",\"selectionActionMissingPageName\":\"AN-2020\",\"selectionContentMissingPageName\":\"AN-2021\",\"userFeedbackMissingPageName\":\"AN-2022\",\"modalCloseMissingModalName\":\"AN-2023\",\"subModalViewMissingModalName\":\"AN-2024\",\"subCloseMissingOpenModalNames\":\"AN-2025\",\"duplicatePageView\":\"AN-2026\",\"duplicatePageViewInit\":\"AN-2027\"},\"state\":{\"playback\":{\"default\":\"AN-2500\"},\"ads\":{\"default\":\"AN-2600\"},\"login\":{\"default\":\"AN-2300\"},\"default\":\"AN-2100\"},\"recovery\":{\"recoveryBufferingStop\":\"AN-2701\",\"recoveryPlaybackExitBeforeStart\":\"AN-2702\",\"recoveryPlaybackStop\":\"AN-2704\",\"recoveryPlaybackTrickPlayStop\":\"AN-2705\",\"recoveryPlaybackUnpause\":\"AN-2706\"},\"application\":{\"generic\":\"AN-2800\",\"missingProgramData\":\"AN-2801\"}},\"persistenceRules\":{\"after\":{\"any\":[\"application\",\"operation\",\"state.playback.heartBeat\",\"state.playback.bitRate.currentBitRateBps\",\"state.playback.bitRate.contentElapsedAtCurrentBitRateMs\",\"state.playback.bitRate.previousBitRateBps\",\"state.playback.bitRate.contentElapsedAtPreviousBitRateMs\",\"state.playback.bitRate.currentAudioBitRateBps\",\"state.playback.bitRate.previousAudioBitRateBps\",\"state.playback.segmentInfo\",\"state.impression\",\"state.view.currentPage.navigation\",\"state.view.currentPage.elements\",\"state.view.currentPage.pageSection\",\"state.view.currentPage.pageSubSection\",\"state.userJourney.featureFlagged\",\"performance\",\"custom\",\"message\"],\"logout\":[\"visit.account\",\"visit.login\",\"visit.promotion\",\"visit.settings.privateAppliedConfigs\",\"visit.connection.deviceLocation\"],\"userConfigSet\":[\"visit.device.otaChannelMap\",\"visit.device.otaChannels\"],\"searchClosed\":[\"state.search\"],\"adBreakStop\":[\"state.ad\"],\"adStop\":[\"state.ad.id\",\"state.ad.title\",\"state.ad.number\",\"state.ad.campaign\",\"state.ad.startTimestamp\",\"state.ad.adDurationSec\",\"state.ad.adElapsedMs\",\"state.ad.adStoppedReason\",\"state.ad.deviceAdId\"],\"playbackTrickPlayStop\":[\"state.playback.trickPlay\"],\"deeplinkStop\":[\"state.referrer.instanceLink\",\"state.referrer.instanceLocation\"],\"modalClose\":[\"state.view.modal\"],\"playbackExitBeforeStart\":[\"state.content\",\"state.playback\",\"state.view.playbackDisplayType\"],\"playbackStart\":[\"state.playback.retryTimeMs\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryAttempts\",\"state.playback.retriedErrorCode\"],\"playbackStartAfterRetry\":[\"state.playback.retryTimeMs\",\"state.playback.retryCategory\",\"state.playback.retryMethod\",\"state.playback.retryAttempts\",\"state.playback.retriedErrorCode\"],\"playbackStop\":[\"state.ad\",\"state.content\",\"state.playback\",\"state.currentVideoPosition\",\"state.entryVideoPosition\",\"state.previousState.entryVideoPosition\",\"state.previousState.exitVideoPosition\",\"state.view.playbackDisplayType\"],\"playbackHeartbeat\":[\"state.playback.segmentInfo\"],\"bufferingStop\":[\"state.playback.bufferingTimeMs\"],\"playbackFailure\":[\"state.ad\",\"state.content\",\"state.playback\",\"state.currentVideoPosition\",\"state.entryVideoPosition\",\"state.previousState.entryVideoPosition\",\"state.previousState.exitVideoPosition\",\"state.view.playbackDisplayType\"],\"playbackFailureBeforeRetry\":[\"state.playback.retryTimeMs\",\"state.playback.retryMethod\"],\"selectContent\":[\"state.search.selectedResultName\",\"state.search.selectedResultFacet\"],\"pageView\":[\"state.view.userActivity\"]}},\"transitions\":{\"adBreakStart\":[{\"from\":[\"playing\"]}],\"adStart\":[{\"from\":[\"playing\"]}],\"adBreakStop\":[{\"from\":[\"playing\"]}],\"adStop\":[{\"from\":[\"playing\"]}],\"applicationActivity\":[{\"from\":[\"*\"]}],\"assetDisplayed\":[{\"from\":[\"*\"]}],\"apiCall\":[{\"from\":[\"*\"]}],\"applicationCrash\":[{\"from\":[\"*\"]}],\"applicationPerformance\":[{\"from\":[\"*\"]}],\"attemptRestart\":[{\"from\":[\"failed\"],\"action\":\"restarting\"}],\"bufferingStop\":[{\"from\":[\"buffering\"],\"action\":\"-buffering\"}],\"checkAvailableChannels\":[{\"from\":[\"*\"]}],\"batchApiCall\":[{\"from\":[\"*\"]}],\"bufferingStart\":[{\"from\":[\"playing\"],\"action\":\"+buffering\"}],\"concurrencyChange\":[{\"from\":[\"*\"]}],\"connectionChange\":[{\"from\":[\"*\"]}],\"customEvent\":[{\"from\":[\"*\"]}],\"deeplinkStart\":[{\"from\":[\"*\"]}],\"deeplinkStop\":[{\"from\":[\"*\"]}],\"displayChange\":[{\"from\":[\"*\"]}],\"externalAppStateChange\":[{\"from\":[\"*\"]}],\"featureStop\":[{\"from\":[\"*\"]}],\"error\":[{\"from\":[\"*\"]}],\"forcedLogin\":[{\"from\":[\"*\"]}],\"impressionStop\":[{\"from\":[\"*\"]}],\"inVisitOauthRefresh\":[{\"from\":[\"*\"]}],\"loginStart\":[{\"from\":[\"navigating\",\"appInitializing\"],\"action\":\"authenticating\"},{\"from\":[\"playing\",\"scrubbing\",\"buffering\",\"paused\"]}],\"impressionStart\":[{\"from\":[\"*\"]}],\"logout\":[{\"from\":[\"failed\",\"restarting\",\"initiating\"],\"action\":\"navigating\"},{\"from\":[\"*\"]}],\"modalClose\":[{\"from\":[\"*\"]}],\"loginStop\":[{\"from\":[\"authenticating\"],\"action\":\"navigating\"},{\"from\":[\"playing\",\"scrubbing\",\"buffering\",\"paused\"]}],\"modalView\":[{\"from\":[\"appInitializing\"],\"action\":\"navigating\"},{\"from\":[\"*\"]}],\"pageViewPerformance\":[{\"from\":[\"*\"]}],\"pageView\":[{\"from\":[\"*\"]}],\"pageViewInit\":[{\"from\":[\"appInitializing\"],\"action\":\"navigating\"},{\"from\":[\"*\"]}],\"pinEntry\":[{\"from\":[\"*\"]}],\"playbackBitRateDownshift\":[{\"from\":[\"playing\"]}],\"playbackBitRateUpshift\":[{\"from\":[\"playing\"]}],\"playbackExitBeforeStart\":[{\"from\":[\"initiating\",\"restarting\"],\"action\":\"navigating\"}],\"playbackHeartbeat\":[{\"from\":[\"playing\"],\"strict\":true,\"action\":\"playing\"}],\"playbackFailure\":[{\"from\":[\"playing\",\"initiating\",\"restarting\",\"DISABLED\"],\"action\":\"failed\"}],\"playbackFailureBeforeRetry\":[{\"from\":[\"playing\",\"initiating\",\"restarting\"],\"action\":\"failed\"},{\"from\":[\"DISABLED\"],\"action\":\"DISABLED\"}],\"playbackPause\":[{\"from\":[\"playing\"],\"action\":\"+paused\"}],\"playbackSelect\":[{\"from\":[\"initiating\",\"navigating\",\"failed\",\"DISABLED\",\"playing\",\"appInitializing\"],\"action\":\"initiating\"}],\"playbackStart\":[{\"from\":[\"initiating\",\"restarting\"],\"action\":\"playing\"}],\"playbackStartAfterRetry\":[{\"from\":[\"restarting\"],\"action\":\"playing\"}],\"playbackStop\":[{\"from\":[\"restarting\",\"playing\"],\"action\":\"navigating\"}],\"playbackStreamUriAcquired\":[{\"from\":[\"restarting\",\"initiating\"],\"action\":\"initiating\"}],\"playbackTrackChange\":[{\"from\":[\"playing\",\"initiating\"]}],\"playbackTrickPlayRateChange\":[{\"from\":[\"scrubbing\"]}],\"playbackTrickPlayStart\":[{\"from\":[\"playing\"],\"action\":\"+scrubbing\"}],\"playbackTrickPlayStop\":[{\"from\":[\"scrubbing\"],\"action\":\"-scrubbing\"}],\"purchaseStart\":[{\"from\":[\"*\"]}],\"playbackUnpause\":[{\"from\":[\"paused\"],\"action\":\"-paused\"}],\"purchaseStop\":[{\"from\":[\"*\"]}],\"requestToEditRecording\":[{\"from\":[\"*\"]}],\"requestToCancelRecording\":[{\"from\":[\"*\"]}],\"featureStart\":[{\"from\":[\"*\"]}],\"requestToDeleteRecording\":[{\"from\":[\"*\"]}],\"searchClosed\":[{\"from\":[\"*\"]}],\"requestToRecord\":[{\"from\":[\"*\"]}],\"searched\":[{\"from\":[\"*\"]}],\"selectAction\":[{\"from\":[\"*\"]}],\"selectContent\":[{\"from\":[\"*\"]}],\"startSession\":[{\"from\":[\"blank\"],\"action\":\"appInitializing\"}],\"subModalClose\":[{\"from\":[\"*\"]}],\"switchScreen\":[{\"from\":[\"*\"]}],\"temporaryView\":[{\"from\":[\"*\"]}],\"userConfigSet\":[{\"from\":[\"*\"]}],\"subModalView\":[{\"from\":[\"*\"]}],\"systemMessage\":[{\"from\":[\"*\"]}],\"userFeedback\":[{\"from\":[\"*\"]}],\"webSocketActivity\":[{\"from\":[\"*\"]}],\"webSocketClose\":[{\"from\":[\"*\"]}],\"webSocketError\":[{\"from\":[\"*\"]}],\"webSocketHeartbeat\":[{\"from\":[\"*\"]}],\"webSocketOpen\":[{\"from\":[\"*\"]}],\"pageViewCompleteAwaitingAction\":[{\"from\":[\"*\"]}],\"pageViewPartiallyRendered\":[{\"from\":[\"*\"]}]},\"legacyTransitions\":{\"adBreakStart\":{\"playing\":\"playing\"},\"adStart\":{\"playing\":\"playing\"},\"adBreakStop\":{\"playing\":\"playing\"},\"adStop\":{\"playing\":\"playing\"},\"applicationActivity\":{\"*\":\"*\"},\"assetDisplayed\":{\"*\":\"*\"},\"apiCall\":{\"*\":\"*\"},\"applicationCrash\":{\"*\":\"*\"},\"applicationPerformance\":{\"*\":\"*\"},\"attemptRestart\":{\"failed\":\"restarting\"},\"bufferingStop\":{\"buffering\":\"playing\"},\"checkAvailableChannels\":{\"*\":\"*\"},\"batchApiCall\":{\"*\":\"*\"},\"bufferingStart\":{\"playing\":\"buffering\"},\"concurrencyChange\":{\"*\":\"*\"},\"connectionChange\":{\"*\":\"*\"},\"customEvent\":{\"*\":\"*\"},\"deeplinkStart\":{\"*\":\"*\"},\"deeplinkStop\":{\"*\":\"*\"},\"displayChange\":{\"*\":\"*\"},\"externalAppStateChange\":{\"*\":\"*\"},\"featureStop\":{\"*\":\"*\"},\"error\":{\"*\":\"*\"},\"forcedLogin\":{\"*\":\"*\"},\"impressionStop\":{\"*\":\"*\"},\"inVisitOauthRefresh\":{\"*\":\"*\"},\"loginStart\":{\"navigating\":\"authenticating\",\"appInitializing\":\"authenticating\"},\"impressionStart\":{\"*\":\"*\"},\"logout\":{\"failed\":\"navigating\",\"restarting\":\"navigating\",\"initiating\":\"navigating\",\"*\":\"*\"},\"modalClose\":{\"*\":\"*\"},\"loginStop\":{\"authenticating\":\"navigating\"},\"modalView\":{\"appInitializing\":\"navigating\",\"*\":\"*\"},\"pageViewPerformance\":{\"*\":\"*\"},\"pageView\":{\"*\":\"*\"},\"pageViewInit\":{\"appInitializing\":\"navigating\",\"*\":\"*\"},\"pinEntry\":{\"*\":\"*\"},\"playbackBitRateDownshift\":{\"playing\":\"playing\",\"scrubbing\":\"scrubbing\",\"buffering\":\"buffering\",\"paused\":\"paused\"},\"playbackBitRateUpshift\":{\"playing\":\"playing\",\"scrubbing\":\"scrubbing\",\"buffering\":\"buffering\",\"paused\":\"paused\"},\"playbackExitBeforeStart\":{\"initiating\":\"navigating\",\"restarting\":\"navigating\"},\"playbackHeartbeat\":{\"playing\":\"playing\"},\"playbackFailure\":{\"playing\":\"failed\",\"initiating\":\"failed\",\"buffering\":\"failed\",\"paused\":\"failed\",\"scrubbing\":\"failed\",\"restarting\":\"failed\",\"DISABLED\":\"failed\"},\"playbackFailureBeforeRetry\":{\"playing\":\"failed\",\"initiating\":\"failed\",\"buffering\":\"failed\",\"paused\":\"failed\",\"scrubbing\":\"failed\",\"restarting\":\"failed\",\"DISABLED\":\"DISABLED\"},\"playbackPause\":{\"playing\":\"paused\"},\"playbackSelect\":{\"initiating\":\"initiating\",\"navigating\":\"initiating\",\"failed\":\"initiating\",\"restarting\":\"initiating\",\"DISABLED\":\"initiating\",\"playing\":\"initiating\",\"buffering\":\"initiating\",\"appInitializing\":\"initiating\"},\"playbackStart\":{\"initiating\":\"playing\",\"restarting\":\"playing\"},\"playbackStartAfterRetry\":{\"restarting\":\"playing\"},\"playbackStop\":{\"restarting\":\"navigating\",\"playing\":\"navigating\",\"buffering\":\"navigating\",\"paused\":\"navigating\"},\"playbackStreamUriAcquired\":{\"restarting\":\"initiating\",\"initiating\":\"initiating\"},\"playbackTrackChange\":{\"initiating\":\"initiating\",\"playing\":\"playing\",\"scrubbing\":\"scrubbing\",\"buffering\":\"buffering\",\"paused\":\"paused\"},\"playbackTrickPlayRateChange\":{\"scrubbing\":\"scrubbing\"},\"playbackTrickPlayStart\":{\"playing\":\"scrubbing\",\"paused\":\"scrubbing\",\"buffering\":\"scrubbing\"},\"playbackTrickPlayStop\":{\"scrubbing\":\"playing\"},\"purchaseStart\":{\"*\":\"*\"},\"playbackUnpause\":{\"paused\":\"playing\"},\"purchaseStop\":{\"*\":\"*\"},\"requestToEditRecording\":{\"*\":\"*\"},\"requestToCancelRecording\":{\"*\":\"*\"},\"featureStart\":{\"*\":\"*\"},\"requestToDeleteRecording\":{\"*\":\"*\"},\"searchClosed\":{\"*\":\"*\"},\"requestToRecord\":{\"*\":\"*\"},\"searched\":{\"*\":\"*\"},\"selectAction\":{\"*\":\"*\"},\"selectContent\":{\"*\":\"*\"},\"startSession\":{\"blank\":\"appInitializing\"},\"subModalClose\":{\"*\":\"*\"},\"switchScreen\":{\"*\":\"*\"},\"temporaryView\":{\"*\":\"*\"},\"userConfigSet\":{\"*\":\"*\"},\"subModalView\":{\"*\":\"*\"},\"systemMessage\":{\"*\":\"*\"},\"userFeedback\":{\"*\":\"*\"},\"webSocketActivity\":{\"*\":\"*\"},\"webSocketClose\":{\"*\":\"*\"},\"webSocketError\":{\"*\":\"*\"},\"webSocketHeartbeat\":{\"*\":\"*\"},\"webSocketOpen\":{\"*\":\"*\"},\"pageViewCompleteAwaitingAction\":{\"*\":\"*\"},\"pageViewPartiallyRendered\":{\"*\":\"*\"}}}");

/***/ }),

/***/ "./src/video/videoplayer/callbacks.js":
/*!********************************************!*\
  !*** ./src/video/videoplayer/callbacks.js ***!
  \********************************************/
/*! exports provided: onBeforeEvent, onAfterEvent, onBeforePlaybackSelect, onBeforePlaybackStreamUriAcquired, onBeforePlaybackStart, onAfterPlaybackStart, onBeforePlaybackStartAfterRetry, onBeforePlaybackStop, onBeforePlaybackExitBeforeStart, onBeforeBufferingStart, onBeforeBufferingStop, onBeforePlaybackPause, onBeforePlaybackUnpause, onBeforePlaybackTrickPlayStart, onBeforePlaybackTrickPlayRateChange, onBeforePlaybackTrickPlayStop, onBeforePlaybackBitRateChange, onBeforePlaybackFailure, onAfterPlaybackFailure, onBeforePlaybackFailureBeforeRetry, onBeforeAttemptRestart, onBeforePlaybackTrackChange, onBeforeTick */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeEvent", function() { return onBeforeEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterEvent", function() { return onAfterEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackSelect", function() { return onBeforePlaybackSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackStreamUriAcquired", function() { return onBeforePlaybackStreamUriAcquired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackStart", function() { return onBeforePlaybackStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterPlaybackStart", function() { return onAfterPlaybackStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackStartAfterRetry", function() { return onBeforePlaybackStartAfterRetry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackStop", function() { return onBeforePlaybackStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackExitBeforeStart", function() { return onBeforePlaybackExitBeforeStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeBufferingStart", function() { return onBeforeBufferingStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeBufferingStop", function() { return onBeforeBufferingStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackPause", function() { return onBeforePlaybackPause; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackUnpause", function() { return onBeforePlaybackUnpause; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackTrickPlayStart", function() { return onBeforePlaybackTrickPlayStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackTrickPlayRateChange", function() { return onBeforePlaybackTrickPlayRateChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackTrickPlayStop", function() { return onBeforePlaybackTrickPlayStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackBitRateChange", function() { return onBeforePlaybackBitRateChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackFailure", function() { return onBeforePlaybackFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAfterPlaybackFailure", function() { return onAfterPlaybackFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackFailureBeforeRetry", function() { return onBeforePlaybackFailureBeforeRetry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeAttemptRestart", function() { return onBeforeAttemptRestart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforePlaybackTrackChange", function() { return onBeforePlaybackTrackChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeTick", function() { return onBeforeTick; });
/* harmony import */ var video_videoplayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! video/videoplayer */ "./src/video/videoplayer/index.js");
// eslint-disable-next-line import/no-cycle

function onBeforeEvent(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.contentElapsedMs = 0;
  model.clockTimeElapsedMs = 0;
  model.retryTimeMs = undefined;
  if (event !== 'playbackBitRateChange') {
    model.contentElapsedAtCurrentBitRate = 0;
  }
  if (from === 'playing') {
    if (event !== 'tick') {
      model.contentElapsedAtCurrentBitRate = options.timestamp - model.lastHeartbeatEventTimestamp;
      model.calculateHeartbeat(options.timestamp);
    }
    if (model.playbackType === 'vod' || model.playbackType === 'dvr' || model.playbackType === 'sizzle' || model.playbackType === 'videoClip') {
      model.calculateCurrentVideoPosition(options.timestamp);
    }
  }
}
function onAfterEvent(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  if (event !== 'playbackBitRateChange') {
    delete model.previousBitRate;
    delete model.contentElapsedAtPreviousBitRate;
    delete model.previousAudioBitRateBps;
  }
  if (event !== 'tick' && event !== 'playbackSelect' && event !== 'playbackStreamUriAcquired' && event !== 'playbackStop' && event !== 'attemptRestart') {
    model.lastHeartbeatEventTimestamp = options.timestamp;
  }
  model.lastEventTimestamp = options.timestamp;
}
function onBeforePlaybackSelect(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var data = args.data,
    options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.playbackType = data.playbackType; // vod or linear

  if (model.playbackType === 'vod' || model.playbackType === 'dvr' || model.playbackType === 'sizzle' || model.playbackType === 'videoClip') {
    data.position !== undefined && (model.bookmarkPosition = data.position);
  }
  model.playbackSelectedTimestamp = options.timestamp;
}
function onBeforePlaybackStreamUriAcquired(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  var tuneTimeStamp = model.attemptRestartTimestamp !== 0 ? model.attemptRestartTimestamp : model.playbackSelectedTimestamp;
  model.uriObtainedMs = options.timestamp - tuneTimeStamp;
  if (model.playbackType === 'linear' && model.isPauseLinearInitiated) {
    model.calculatePlaybackCache(options.timestamp);
  }
}
function onBeforePlaybackStart(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var data = args.data,
    options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  if (model.playbackType === 'linear') {
    if (typeof data.playPointTimestamp !== 'undefined') {
      model.playPointTimestamp = data.playPointTimestamp;
    } else if (model.playPointTimestamp === 0) {
      model.playPointTimestamp = options.timestamp;
    }
  }
  if (model.playbackType === 'vod' || model.playbackType === 'dvr' || model.playbackType === 'sizzle' || model.playbackType === 'videoClip') {
    model.calculateCurrentVideoPosition(options.timestamp, model.bookmarkPosition);
  }
  delete model.bookmarkPosition;
  model.currentBitRate = data.bitrate;
  model.currentAudioBitRateBps = data.audioBitrate;
  model.tuneTimeMs = options.timestamp - model.playbackSelectedTimestamp;
  model.playbackStartedTimestamp = options.timestamp;
  if (model.attemptRestartTimestamp !== 0) {
    model.retryTimeMs = options.timestamp - model.attemptRestartTimestamp;
  }
  if (data.cacheStartPosition !== undefined) {
    model.cacheStartTimestamp = data.cacheStartPosition;
  }
  if (model.playbackType === 'linear' && model.isPauseLinearInitiated) {
    model.calculatePlaybackCache(options.timestamp);
  }
}
function onAfterPlaybackStart() {
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.attemptRestartTimestamp = 0;
}
function onBeforePlaybackStartAfterRetry(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var data = args.data,
    options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  if (model.playbackType === 'linear') {
    if (typeof data.playPointTimestamp !== 'undefined') {
      model.playPointTimestamp = data.playPointTimestamp;
    } else {
      model.playPointTimestamp = options.timestamp;
    }
  }
  model.currentBitRate = data.bitrate;
  if (model.attemptRestartTimestamp !== 0) {
    model.retryTimeMs = options.timestamp - model.attemptRestartTimestamp;
  }
}
function onBeforePlaybackStop() {
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.playbackStartedTimestamp = 0; // playback ended

  model.lastEventTimestamp = 0;
  model.lastHeartbeatEventTimestamp = 0;
}
function onBeforePlaybackExitBeforeStart() {
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.lastEventTimestamp = 0;
}
function onBeforeBufferingStart(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.bufferingTimestamp = options.timestamp;
}
function onBeforeBufferingStop(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.refreshHeartbeat(options.timestamp);
  model.lastBufferingTime = options.timestamp - model.bufferingTimestamp;
  model.bufferingTimestamp = 0;
}
function onBeforePlaybackPause(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.pauseTimestamp = options.timestamp;
}
function onBeforePlaybackUnpause(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.refreshHeartbeat(options.timestamp);
  model.pauseTimestamp = 0;
}
function onBeforePlaybackTrickPlayStart(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.trickPlayStartTimestamp = options.timestamp;
}
function onBeforePlaybackTrickPlayRateChange(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.trickPlayStartTimestamp = 0;
  model.refreshHeartbeat(options.timestamp);
}
function onBeforePlaybackTrickPlayStop(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var data = args.data,
    options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.refreshHeartbeat(options.timestamp);
  if (model.playbackType === 'linear') {
    if (typeof data.playPointTimestamp !== 'undefined') {
      model.playPointTimestamp = data.playPointTimestamp;
    } else if (model.playPointTimestamp === 0) {
      // In case it was saved for pause live session
      model.playPointTimestamp = options.timestamp;
    }
  }
  if (model.playbackType !== 'linear') {
    model.calculateCurrentVideoPosition(options.timestamp, data.contentPosition);
  }
  model.trickPlayStartTimestamp = 0;
}
function onBeforePlaybackBitRateChange(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var data = args.data,
    options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.contentElapsedAtPreviousBitRate = model.contentElapsedAtCurrentBitRate;
  model.contentElapsedAtCurrentBitRate = 0;
  model.previousBitRate = model.currentBitRate;
  model.previousAudioBitRateBps = model.currentAudioBitRateBps;
  model.currentBitRate = data.bitrate;
  model.currentAudioBitRateBps = data.audioBitrate;
  model.clockTimeElapsedMs = options.timestamp - model.lastHeartbeatEventTimestamp;
}
function onBeforePlaybackFailure(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.clockTimeElapsedMs = options.timestamp - model.lastHeartbeatEventTimestamp;
  if (model.attemptRestartTimestamp !== 0) {
    model.retryTimeMs = options.timestamp - model.attemptRestartTimestamp;
  }
}
function onAfterPlaybackFailure(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  // eslint-disable-line no-unused-vars
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.playbackStartedTimestamp = 0; // playback ended
}

function onBeforePlaybackFailureBeforeRetry(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.clockTimeElapsedMs = options.timestamp - model.lastHeartbeatEventTimestamp;
  if (model.attemptRestartTimestamp !== 0) {
    model.retryTimeMs = options.timestamp - model.attemptRestartTimestamp;
  }
}
function onBeforeAttemptRestart(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  model.contentElapsedAtCurrentBitRate = 0;
  model.attemptRestartTimestamp = options.timestamp;
}
function onBeforePlaybackTrackChange(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var data = args.data,
    options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;

  // NOTE: If it is the first pause live enabling event that triggers the playback cache growth
  if (model.isPauseLinearInitiated === false && data.isPauseLinearInitiated === true) {
    model.isPauseLinearInitiated = data.isPauseLinearInitiated;
    model.cacheStartTimestamp = data.cacheStartTimestamp !== undefined ? data.cacheStartTimestamp : options.timestamp;
    model.cacheLength = options.timestamp - model.cacheStartTimestamp;
  }
}
function onBeforeTick(event, from, into) {
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    data: {},
    options: {}
  };
  var options = args.options;
  var model = video_videoplayer__WEBPACK_IMPORTED_MODULE_0__["default"].model;
  if (model.bufferingTimestamp === 0 && model.pauseTimestamp === 0 && model.trickPlayStartTimestamp === 0 && model.playbackType === 'linear') {
    model.playPointTimestamp += options.timestamp - model.lastEventTimestamp;
  }
}

/***/ }),

/***/ "./src/video/videoplayer/index.js":
/*!****************************************!*\
  !*** ./src/video/videoplayer/index.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_utils_StateMachine__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core/utils/StateMachine */ "./src/core/utils/StateMachine.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./model */ "./src/video/videoplayer/model.js");
/* harmony import */ var _callbacks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./callbacks */ "./src/video/videoplayer/callbacks.js");
/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./transitions */ "./src/video/videoplayer/transitions.js");




// eslint-disable-next-line import/no-cycle


var VideoPlayer = /*#__PURE__*/function () {
  function VideoPlayer() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, VideoPlayer);
    this.model = new _model__WEBPACK_IMPORTED_MODULE_3__["default"]();
    this.sm = new core_utils_StateMachine__WEBPACK_IMPORTED_MODULE_2__["default"]({
      initial: 'blank',
      callbacks: _callbacks__WEBPACK_IMPORTED_MODULE_4__,
      transitions: _transitions__WEBPACK_IMPORTED_MODULE_5__["default"],
      name: 'VideoPlayer'
    });
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(VideoPlayer, [{
    key: "playbackSelect",
    value: function playbackSelect(timestamp, playbackType, position) {
      this.sm.trigger('playbackSelect', {
        data: {
          playbackType: playbackType,
          position: position
        },
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackStreamUriAcquired",
    value: function playbackStreamUriAcquired(timestamp) {
      this.sm.trigger('playbackStreamUriAcquired', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackStart",
    value: function playbackStart(timestamp, bitrate, playPointTimestamp, audioBitrate, cacheStartPosition) {
      this.sm.trigger('playbackStart', {
        data: {
          bitrate: bitrate,
          playPointTimestamp: playPointTimestamp,
          audioBitrate: audioBitrate,
          cacheStartPosition: cacheStartPosition
        },
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackStartAfterRetry",
    value: function playbackStartAfterRetry(timestamp, bitrate, playPointTimestamp) {
      this.sm.trigger('playbackStartAfterRetry', {
        data: {
          bitrate: bitrate,
          playPointTimestamp: playPointTimestamp
        },
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackStop",
    value: function playbackStop(timestamp) {
      this.sm.trigger('playbackStop', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackExitBeforeStart",
    value: function playbackExitBeforeStart(timestamp) {
      this.sm.trigger('playbackExitBeforeStart', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackHeartbeat",
    value: function playbackHeartbeat(timestamp) {
      this.sm.trigger('playbackHeartbeat', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "bufferingStart",
    value: function bufferingStart(timestamp) {
      this.sm.trigger('bufferingStart', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "bufferingStop",
    value: function bufferingStop(timestamp) {
      this.sm.trigger('bufferingStop', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackPause",
    value: function playbackPause(timestamp) {
      this.sm.trigger('playbackPause', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackUnpause",
    value: function playbackUnpause(timestamp) {
      this.sm.trigger('playbackUnpause', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackTrickPlayStart",
    value: function playbackTrickPlayStart(timestamp) {
      this.sm.trigger('playbackTrickPlayStart', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackTrickPlayRateChange",
    value: function playbackTrickPlayRateChange(timestamp) {
      this.sm.trigger('playbackTrickPlayRateChange', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackTrickPlayStop",
    value: function playbackTrickPlayStop(timestamp, contentPosition, playPointTimestamp) {
      this.sm.trigger('playbackTrickPlayStop', {
        data: {
          contentPosition: contentPosition,
          playPointTimestamp: playPointTimestamp
        },
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackFailure",
    value: function playbackFailure(timestamp) {
      this.sm.trigger('playbackFailure', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackFailureBeforeRetry",
    value: function playbackFailureBeforeRetry(timestamp) {
      this.sm.trigger('playbackFailureBeforeRetry', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "attemptRestart",
    value: function attemptRestart(timestamp) {
      this.sm.trigger('attemptRestart', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackBitRateChange",
    value: function playbackBitRateChange(timestamp, bitrate, audioBitrate) {
      this.sm.trigger('playbackBitRateChange', {
        data: {
          bitrate: bitrate,
          audioBitrate: audioBitrate
        },
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "playbackTrackChange",
    value: function playbackTrackChange(timestamp) {
      var isPauseLinearInitiated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var cacheStartTimestamp = arguments.length > 2 ? arguments[2] : undefined;
      this.sm.trigger('playbackTrackChange', {
        data: {
          isPauseLinearInitiated: isPauseLinearInitiated,
          cacheStartTimestamp: cacheStartTimestamp
        },
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "tick",
    value: function tick(timestamp) {
      this.sm.trigger('tick', {
        options: {
          timestamp: timestamp
        }
      });
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.model.playbackStartedTimestamp !== 0;
    }
  }, {
    key: "getVideoPlayerState",
    value: function getVideoPlayerState() {
      var data = {
        playbackType: this.model.playbackType,
        uriObtainedMs: this.model.uriObtainedMs,
        tuneTimeMs: this.model.tuneTimeMs,
        currentVideoPosition: this.model.currentVideoPosition,
        lastBufferingTime: this.model.lastBufferingTime,
        retryTimeMs: this.model.retryTimeMs,
        heartBeat: {
          contentElapsedMs: this.model.contentElapsedMs,
          clockTimeElapsedMs: this.model.clockTimeElapsedMs,
          playPointTimestamp: this.model.playPointTimestamp,
          runningTotalContentElapsedMs: this.model.runningTotalContentElapsedMs
        },
        bitRate: {
          currentBitRate: this.model.currentBitRate,
          previousBitRate: this.model.previousBitRate,
          contentElapsedAtCurrentBitRate: this.model.contentElapsedAtCurrentBitRate,
          contentElapsedAtPreviousBitRate: this.model.contentElapsedAtPreviousBitRate,
          currentAudioBitRateBps: this.model.currentAudioBitRateBps,
          previousAudioBitRateBps: this.model.previousAudioBitRateBps
        },
        cache: {
          isPauseLinearInitiated: this.model.isPauseLinearInitiated,
          cacheStartPosition: this.model.cacheStartTimestamp,
          cacheLength: this.model.cacheLength
        }
      };
      this.model.playbackType === 'linear' && delete data.currentVideoPosition;
      this.model.playbackType !== 'linear' && delete data.heartBeat.playPointTimestamp;
      return data;
    }
  }, {
    key: "reset",
    value: function reset() {
      // NOTE: If playbackCacheMaxLength is being set before playbackSelect
      // then playbackSelect will erase this value during video player reset
      var playbackCacheMaxLength = this.model.playbackCacheMaxLength;
      if (this.model.isPauseLinearInitiated) {
        var _this$model = this.model,
          isPauseLinearInitiated = _this$model.isPauseLinearInitiated,
          cacheStartTimestamp = _this$model.cacheStartTimestamp,
          cacheLength = _this$model.cacheLength,
          playPointTimestamp = _this$model.playPointTimestamp;
        this.model = new _model__WEBPACK_IMPORTED_MODULE_3__["default"]();
        this.model.isPauseLinearInitiated = isPauseLinearInitiated;
        this.model.cacheStartTimestamp = cacheStartTimestamp;
        this.model.cacheLength = cacheLength;
        this.model.playPointTimestamp = playPointTimestamp;
      } else {
        this.model = new _model__WEBPACK_IMPORTED_MODULE_3__["default"]();
      }
      this.model.playbackCacheMaxLength = playbackCacheMaxLength;
      this.sm.current = 'blank';
    }
  }, {
    key: "forceReset",
    value: function forceReset() {
      this.model = new _model__WEBPACK_IMPORTED_MODULE_3__["default"]();
      this.sm.current = 'blank';
    }
  }]);
  return VideoPlayer;
}();
/* harmony default export */ __webpack_exports__["default"] = (new VideoPlayer());

/***/ }),

/***/ "./src/video/videoplayer/model.js":
/*!****************************************!*\
  !*** ./src/video/videoplayer/model.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);


var PlayerModel = /*#__PURE__*/function () {
  function PlayerModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, PlayerModel);
    this.playbackType = undefined;
    this.uriObtainedMs = 0;
    this.tuneTimeMs = 0;
    this.lastBufferingTime = 0;
    this.retryTimeMs = undefined;

    // content
    this.currentVideoPosition = 0;
    this.contentElapsedMs = 0;
    this.clockTimeElapsedMs = 0;
    this.bookmarkPosition = 0;
    this.runningTotalContentElapsedMs = 0;

    // bitrate fields
    this.currentBitRate = 0;
    this.previousBitRate = undefined;
    this.contentElapsedAtCurrentBitRate = 0;
    this.contentElapsedAtPreviousBitRate = undefined;

    // audio bitrate fields
    this.currentAudioBitRateBps = 0;
    this.previousAudioBitRateBps = undefined;

    // timestamps
    this.playbackSelectedTimestamp = 0;
    this.playbackStartedTimestamp = 0;
    this.lastEventTimestamp = 0;
    this.lastHeartbeatEventTimestamp = 0;
    this.bufferingTimestamp = 0;
    this.playbackFailTimestamp = 0;
    this.playPointTimestamp = 0;
    this.attemptRestartTimestamp = 0;
    this.pauseTimestamp = 0;
    this.trickPlayStartTimestamp = 0;

    // pause live
    this.isPauseLinearInitiated = false;
    this.cacheStartTimestamp = 0;
    this.cacheLength = 0;
    this.playbackCacheMaxLength = 0;
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(PlayerModel, [{
    key: "refreshHeartbeat",
    value: function refreshHeartbeat(timestamp) {
      this.contentElapsedMs = 0;
      this.contentElapsedAtCurrentBitRate = 0;
      this.clockTimeElapsedMs = timestamp - this.lastHeartbeatEventTimestamp;
      if (this.playbackType === 'linear' && this.isPauseLinearInitiated) {
        this.calculatePlaybackCache(timestamp);
      }
    }

    // contentElapsedMs, clockTimeElapsedMs, runningTotalContentElapsedMs, playPointTimestamp
  }, {
    key: "calculateHeartbeat",
    value: function calculateHeartbeat(timestamp) {
      var contentElapsedSinceLastEventMs = timestamp - this.lastEventTimestamp;
      var contentElapsedSinceLastHeartbeatMs = timestamp - this.lastHeartbeatEventTimestamp;
      this.contentElapsedMs = contentElapsedSinceLastHeartbeatMs;
      this.runningTotalContentElapsedMs += this.contentElapsedMs;
      this.clockTimeElapsedMs = contentElapsedSinceLastHeartbeatMs;
      if (this.playbackType === 'linear' && this.bufferingTimestamp === 0) {
        this.playPointTimestamp = this.playPointTimestamp + contentElapsedSinceLastEventMs;
      }
      if (this.playbackType === 'linear' && this.isPauseLinearInitiated) {
        this.calculatePlaybackCache(timestamp);
      }
    }
  }, {
    key: "calculatePlaybackCache",
    value: function calculatePlaybackCache(timestamp) {
      this.cacheLength = timestamp - this.cacheStartTimestamp;
      if (this.cacheLength > this.playbackCacheMaxLength) {
        this.cacheStartTimestamp = timestamp - this.playbackCacheMaxLength;
      }
      this.cacheLength = Math.min(this.playbackCacheMaxLength, this.cacheLength);
    }

    // currentVideoPosition
  }, {
    key: "calculateCurrentVideoPosition",
    value: function calculateCurrentVideoPosition(timestamp, contentPosition) {
      if (typeof contentPosition !== 'undefined') {
        this.currentVideoPosition = contentPosition; // set from bookmark
      } else {
        this.currentVideoPosition = this.currentVideoPosition + Math.round((timestamp - this.lastEventTimestamp) / 1000);
      }
    }
  }]);
  return PlayerModel;
}();
/* harmony default export */ __webpack_exports__["default"] = (PlayerModel);

/***/ }),

/***/ "./src/video/videoplayer/transitions.js":
/*!**********************************************!*\
  !*** ./src/video/videoplayer/transitions.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/pick */ "./node_modules/lodash/pick.js");
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_pick__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var video_json_QuantumSpecTools_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! video/json/QuantumSpecTools.json */ "./src/video/json/QuantumSpecTools.json");
var video_json_QuantumSpecTools_json__WEBPACK_IMPORTED_MODULE_2___namespace = /*#__PURE__*/__webpack_require__.t(/*! video/json/QuantumSpecTools.json */ "./src/video/json/QuantumSpecTools.json", 1);


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var playerTransitions = lodash_pick__WEBPACK_IMPORTED_MODULE_1___default()(video_json_QuantumSpecTools_json__WEBPACK_IMPORTED_MODULE_2__["legacyTransitions"], ['playbackSelect', 'playbackStreamUriAcquired', 'playbackStart', 'playbackStartAfterRetry', 'playbackStop', 'playbackHeartbeat', 'bufferingStart', 'bufferingStop', 'playbackPause', 'playbackUnpause', 'playbackFailure', 'playbackFailureBeforeRetry', 'attemptRestart', 'playbackTrickPlayStart', 'playbackTrickPlayRateChange', 'playbackTrickPlayStop', 'playbackExitBeforeStart', 'playbackTrackChange']);
playerTransitions.playbackSelect = _objectSpread(_objectSpread({}, playerTransitions.playbackSelect), {}, {
  blank: 'initiating'
});
playerTransitions.tick = {
  '*': '*'
};
playerTransitions.playbackBitRateChange = video_json_QuantumSpecTools_json__WEBPACK_IMPORTED_MODULE_2__["legacyTransitions"].playbackBitRateUpshift;
/* harmony default export */ __webpack_exports__["default"] = (playerTransitions);

/***/ }),

/***/ 0:
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./src/index.js */"./src/index.js");


/***/ })

/******/ });
});
//# sourceMappingURL=analytics.js.map

/***/ }),

/***/ "./node_modules/lodash/_DataView.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_DataView.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "./node_modules/lodash/_Hash.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/_Hash.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(/*! ./_hashClear */ "./node_modules/lodash/_hashClear.js"),
    hashDelete = __webpack_require__(/*! ./_hashDelete */ "./node_modules/lodash/_hashDelete.js"),
    hashGet = __webpack_require__(/*! ./_hashGet */ "./node_modules/lodash/_hashGet.js"),
    hashHas = __webpack_require__(/*! ./_hashHas */ "./node_modules/lodash/_hashHas.js"),
    hashSet = __webpack_require__(/*! ./_hashSet */ "./node_modules/lodash/_hashSet.js");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "./node_modules/lodash/_ListCache.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_ListCache.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(/*! ./_listCacheClear */ "./node_modules/lodash/_listCacheClear.js"),
    listCacheDelete = __webpack_require__(/*! ./_listCacheDelete */ "./node_modules/lodash/_listCacheDelete.js"),
    listCacheGet = __webpack_require__(/*! ./_listCacheGet */ "./node_modules/lodash/_listCacheGet.js"),
    listCacheHas = __webpack_require__(/*! ./_listCacheHas */ "./node_modules/lodash/_listCacheHas.js"),
    listCacheSet = __webpack_require__(/*! ./_listCacheSet */ "./node_modules/lodash/_listCacheSet.js");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "./node_modules/lodash/_Map.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/_Map.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "./node_modules/lodash/_MapCache.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_MapCache.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(/*! ./_mapCacheClear */ "./node_modules/lodash/_mapCacheClear.js"),
    mapCacheDelete = __webpack_require__(/*! ./_mapCacheDelete */ "./node_modules/lodash/_mapCacheDelete.js"),
    mapCacheGet = __webpack_require__(/*! ./_mapCacheGet */ "./node_modules/lodash/_mapCacheGet.js"),
    mapCacheHas = __webpack_require__(/*! ./_mapCacheHas */ "./node_modules/lodash/_mapCacheHas.js"),
    mapCacheSet = __webpack_require__(/*! ./_mapCacheSet */ "./node_modules/lodash/_mapCacheSet.js");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "./node_modules/lodash/_Promise.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_Promise.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "./node_modules/lodash/_Set.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/_Set.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "./node_modules/lodash/_SetCache.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_SetCache.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(/*! ./_MapCache */ "./node_modules/lodash/_MapCache.js"),
    setCacheAdd = __webpack_require__(/*! ./_setCacheAdd */ "./node_modules/lodash/_setCacheAdd.js"),
    setCacheHas = __webpack_require__(/*! ./_setCacheHas */ "./node_modules/lodash/_setCacheHas.js");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "./node_modules/lodash/_Stack.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/_Stack.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(/*! ./_ListCache */ "./node_modules/lodash/_ListCache.js"),
    stackClear = __webpack_require__(/*! ./_stackClear */ "./node_modules/lodash/_stackClear.js"),
    stackDelete = __webpack_require__(/*! ./_stackDelete */ "./node_modules/lodash/_stackDelete.js"),
    stackGet = __webpack_require__(/*! ./_stackGet */ "./node_modules/lodash/_stackGet.js"),
    stackHas = __webpack_require__(/*! ./_stackHas */ "./node_modules/lodash/_stackHas.js"),
    stackSet = __webpack_require__(/*! ./_stackSet */ "./node_modules/lodash/_stackSet.js");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "./node_modules/lodash/_Symbol.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/_Symbol.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "./node_modules/lodash/_Uint8Array.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_Uint8Array.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "./node_modules/lodash/_WeakMap.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_WeakMap.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "./node_modules/lodash/_arrayEvery.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_arrayEvery.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),

/***/ "./node_modules/lodash/_arrayFilter.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_arrayFilter.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "./node_modules/lodash/_arrayLikeKeys.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_arrayLikeKeys.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(/*! ./_baseTimes */ "./node_modules/lodash/_baseTimes.js"),
    isArguments = __webpack_require__(/*! ./isArguments */ "./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__(/*! ./isBuffer */ "./node_modules/lodash/isBuffer.js"),
    isIndex = __webpack_require__(/*! ./_isIndex */ "./node_modules/lodash/_isIndex.js"),
    isTypedArray = __webpack_require__(/*! ./isTypedArray */ "./node_modules/lodash/isTypedArray.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "./node_modules/lodash/_arrayMap.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_arrayMap.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "./node_modules/lodash/_arrayPush.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_arrayPush.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "./node_modules/lodash/_arraySome.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_arraySome.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "./node_modules/lodash/_assocIndexOf.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_assocIndexOf.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(/*! ./eq */ "./node_modules/lodash/eq.js");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_baseEach.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseEach.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(/*! ./_baseForOwn */ "./node_modules/lodash/_baseForOwn.js"),
    createBaseEach = __webpack_require__(/*! ./_createBaseEach */ "./node_modules/lodash/_createBaseEach.js");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "./node_modules/lodash/_baseEvery.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseEvery.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(/*! ./_baseEach */ "./node_modules/lodash/_baseEach.js");

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),

/***/ "./node_modules/lodash/_baseFindIndex.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_baseFindIndex.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "./node_modules/lodash/_baseFor.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_baseFor.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(/*! ./_createBaseFor */ "./node_modules/lodash/_createBaseFor.js");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "./node_modules/lodash/_baseForOwn.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseForOwn.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(/*! ./_baseFor */ "./node_modules/lodash/_baseFor.js"),
    keys = __webpack_require__(/*! ./keys */ "./node_modules/lodash/keys.js");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ "./node_modules/lodash/_baseGet.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_baseGet.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(/*! ./_castPath */ "./node_modules/lodash/_castPath.js"),
    toKey = __webpack_require__(/*! ./_toKey */ "./node_modules/lodash/_toKey.js");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ "./node_modules/lodash/_baseGetAllKeys.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_baseGetAllKeys.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(/*! ./_arrayPush */ "./node_modules/lodash/_arrayPush.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseGetTag.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseGetTag.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__(/*! ./_getRawTag */ "./node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__(/*! ./_objectToString */ "./node_modules/lodash/_objectToString.js");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "./node_modules/lodash/_baseHasIn.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseHasIn.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "./node_modules/lodash/_baseIndexOf.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseIndexOf.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(/*! ./_baseFindIndex */ "./node_modules/lodash/_baseFindIndex.js"),
    baseIsNaN = __webpack_require__(/*! ./_baseIsNaN */ "./node_modules/lodash/_baseIsNaN.js"),
    strictIndexOf = __webpack_require__(/*! ./_strictIndexOf */ "./node_modules/lodash/_strictIndexOf.js");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_baseIsArguments.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_baseIsArguments.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqual.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseIsEqual.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(/*! ./_baseIsEqualDeep */ "./node_modules/lodash/_baseIsEqualDeep.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqualDeep.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_baseIsEqualDeep.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(/*! ./_Stack */ "./node_modules/lodash/_Stack.js"),
    equalArrays = __webpack_require__(/*! ./_equalArrays */ "./node_modules/lodash/_equalArrays.js"),
    equalByTag = __webpack_require__(/*! ./_equalByTag */ "./node_modules/lodash/_equalByTag.js"),
    equalObjects = __webpack_require__(/*! ./_equalObjects */ "./node_modules/lodash/_equalObjects.js"),
    getTag = __webpack_require__(/*! ./_getTag */ "./node_modules/lodash/_getTag.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__(/*! ./isBuffer */ "./node_modules/lodash/isBuffer.js"),
    isTypedArray = __webpack_require__(/*! ./isTypedArray */ "./node_modules/lodash/isTypedArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "./node_modules/lodash/_baseIsMatch.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseIsMatch.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(/*! ./_Stack */ "./node_modules/lodash/_Stack.js"),
    baseIsEqual = __webpack_require__(/*! ./_baseIsEqual */ "./node_modules/lodash/_baseIsEqual.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "./node_modules/lodash/_baseIsNaN.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseIsNaN.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "./node_modules/lodash/_baseIsNative.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseIsNative.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(/*! ./isFunction */ "./node_modules/lodash/isFunction.js"),
    isMasked = __webpack_require__(/*! ./_isMasked */ "./node_modules/lodash/_isMasked.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js"),
    toSource = __webpack_require__(/*! ./_toSource */ "./node_modules/lodash/_toSource.js");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "./node_modules/lodash/_baseIsTypedArray.js":
/*!**************************************************!*\
  !*** ./node_modules/lodash/_baseIsTypedArray.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isLength = __webpack_require__(/*! ./isLength */ "./node_modules/lodash/isLength.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "./node_modules/lodash/_baseIteratee.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseIteratee.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(/*! ./_baseMatches */ "./node_modules/lodash/_baseMatches.js"),
    baseMatchesProperty = __webpack_require__(/*! ./_baseMatchesProperty */ "./node_modules/lodash/_baseMatchesProperty.js"),
    identity = __webpack_require__(/*! ./identity */ "./node_modules/lodash/identity.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    property = __webpack_require__(/*! ./property */ "./node_modules/lodash/property.js");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "./node_modules/lodash/_baseKeys.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseKeys.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(/*! ./_isPrototype */ "./node_modules/lodash/_isPrototype.js"),
    nativeKeys = __webpack_require__(/*! ./_nativeKeys */ "./node_modules/lodash/_nativeKeys.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseMatches.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseMatches.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(/*! ./_baseIsMatch */ "./node_modules/lodash/_baseIsMatch.js"),
    getMatchData = __webpack_require__(/*! ./_getMatchData */ "./node_modules/lodash/_getMatchData.js"),
    matchesStrictComparable = __webpack_require__(/*! ./_matchesStrictComparable */ "./node_modules/lodash/_matchesStrictComparable.js");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "./node_modules/lodash/_baseMatchesProperty.js":
/*!*****************************************************!*\
  !*** ./node_modules/lodash/_baseMatchesProperty.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(/*! ./_baseIsEqual */ "./node_modules/lodash/_baseIsEqual.js"),
    get = __webpack_require__(/*! ./get */ "./node_modules/lodash/get.js"),
    hasIn = __webpack_require__(/*! ./hasIn */ "./node_modules/lodash/hasIn.js"),
    isKey = __webpack_require__(/*! ./_isKey */ "./node_modules/lodash/_isKey.js"),
    isStrictComparable = __webpack_require__(/*! ./_isStrictComparable */ "./node_modules/lodash/_isStrictComparable.js"),
    matchesStrictComparable = __webpack_require__(/*! ./_matchesStrictComparable */ "./node_modules/lodash/_matchesStrictComparable.js"),
    toKey = __webpack_require__(/*! ./_toKey */ "./node_modules/lodash/_toKey.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "./node_modules/lodash/_baseProperty.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseProperty.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "./node_modules/lodash/_basePropertyDeep.js":
/*!**************************************************!*\
  !*** ./node_modules/lodash/_basePropertyDeep.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(/*! ./_baseGet */ "./node_modules/lodash/_baseGet.js");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "./node_modules/lodash/_baseSome.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseSome.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(/*! ./_baseEach */ "./node_modules/lodash/_baseEach.js");

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),

/***/ "./node_modules/lodash/_baseTimes.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseTimes.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "./node_modules/lodash/_baseToString.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseToString.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js"),
    arrayMap = __webpack_require__(/*! ./_arrayMap */ "./node_modules/lodash/_arrayMap.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__(/*! ./isSymbol */ "./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ "./node_modules/lodash/_baseTrim.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseTrim.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(/*! ./_trimmedEndIndex */ "./node_modules/lodash/_trimmedEndIndex.js");

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ "./node_modules/lodash/_baseUnary.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseUnary.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "./node_modules/lodash/_cacheHas.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_cacheHas.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "./node_modules/lodash/_castPath.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_castPath.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isKey = __webpack_require__(/*! ./_isKey */ "./node_modules/lodash/_isKey.js"),
    stringToPath = __webpack_require__(/*! ./_stringToPath */ "./node_modules/lodash/_stringToPath.js"),
    toString = __webpack_require__(/*! ./toString */ "./node_modules/lodash/toString.js");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ "./node_modules/lodash/_coreJsData.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_coreJsData.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "./node_modules/lodash/_createBaseEach.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_createBaseEach.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(/*! ./isArrayLike */ "./node_modules/lodash/isArrayLike.js");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "./node_modules/lodash/_createBaseFor.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_createBaseFor.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "./node_modules/lodash/_equalArrays.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_equalArrays.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(/*! ./_SetCache */ "./node_modules/lodash/_SetCache.js"),
    arraySome = __webpack_require__(/*! ./_arraySome */ "./node_modules/lodash/_arraySome.js"),
    cacheHas = __webpack_require__(/*! ./_cacheHas */ "./node_modules/lodash/_cacheHas.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "./node_modules/lodash/_equalByTag.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_equalByTag.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js"),
    Uint8Array = __webpack_require__(/*! ./_Uint8Array */ "./node_modules/lodash/_Uint8Array.js"),
    eq = __webpack_require__(/*! ./eq */ "./node_modules/lodash/eq.js"),
    equalArrays = __webpack_require__(/*! ./_equalArrays */ "./node_modules/lodash/_equalArrays.js"),
    mapToArray = __webpack_require__(/*! ./_mapToArray */ "./node_modules/lodash/_mapToArray.js"),
    setToArray = __webpack_require__(/*! ./_setToArray */ "./node_modules/lodash/_setToArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "./node_modules/lodash/_equalObjects.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_equalObjects.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(/*! ./_getAllKeys */ "./node_modules/lodash/_getAllKeys.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "./node_modules/lodash/_freeGlobal.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_freeGlobal.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash/_getAllKeys.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_getAllKeys.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(/*! ./_baseGetAllKeys */ "./node_modules/lodash/_baseGetAllKeys.js"),
    getSymbols = __webpack_require__(/*! ./_getSymbols */ "./node_modules/lodash/_getSymbols.js"),
    keys = __webpack_require__(/*! ./keys */ "./node_modules/lodash/keys.js");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_getMapData.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_getMapData.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(/*! ./_isKeyable */ "./node_modules/lodash/_isKeyable.js");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "./node_modules/lodash/_getMatchData.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_getMatchData.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(/*! ./_isStrictComparable */ "./node_modules/lodash/_isStrictComparable.js"),
    keys = __webpack_require__(/*! ./keys */ "./node_modules/lodash/keys.js");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "./node_modules/lodash/_getNative.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_getNative.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(/*! ./_baseIsNative */ "./node_modules/lodash/_baseIsNative.js"),
    getValue = __webpack_require__(/*! ./_getValue */ "./node_modules/lodash/_getValue.js");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "./node_modules/lodash/_getRawTag.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_getRawTag.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "./node_modules/lodash/_getSymbols.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_getSymbols.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(/*! ./_arrayFilter */ "./node_modules/lodash/_arrayFilter.js"),
    stubArray = __webpack_require__(/*! ./stubArray */ "./node_modules/lodash/stubArray.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "./node_modules/lodash/_getTag.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/_getTag.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(/*! ./_DataView */ "./node_modules/lodash/_DataView.js"),
    Map = __webpack_require__(/*! ./_Map */ "./node_modules/lodash/_Map.js"),
    Promise = __webpack_require__(/*! ./_Promise */ "./node_modules/lodash/_Promise.js"),
    Set = __webpack_require__(/*! ./_Set */ "./node_modules/lodash/_Set.js"),
    WeakMap = __webpack_require__(/*! ./_WeakMap */ "./node_modules/lodash/_WeakMap.js"),
    baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    toSource = __webpack_require__(/*! ./_toSource */ "./node_modules/lodash/_toSource.js");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "./node_modules/lodash/_getValue.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_getValue.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "./node_modules/lodash/_hasPath.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_hasPath.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(/*! ./_castPath */ "./node_modules/lodash/_castPath.js"),
    isArguments = __webpack_require__(/*! ./isArguments */ "./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isIndex = __webpack_require__(/*! ./_isIndex */ "./node_modules/lodash/_isIndex.js"),
    isLength = __webpack_require__(/*! ./isLength */ "./node_modules/lodash/isLength.js"),
    toKey = __webpack_require__(/*! ./_toKey */ "./node_modules/lodash/_toKey.js");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "./node_modules/lodash/_hashClear.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_hashClear.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "./node_modules/lodash/_nativeCreate.js");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "./node_modules/lodash/_hashDelete.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_hashDelete.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "./node_modules/lodash/_hashGet.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_hashGet.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "./node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "./node_modules/lodash/_hashHas.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_hashHas.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "./node_modules/lodash/_nativeCreate.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "./node_modules/lodash/_hashSet.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_hashSet.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "./node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "./node_modules/lodash/_isIndex.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_isIndex.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "./node_modules/lodash/_isIterateeCall.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_isIterateeCall.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(/*! ./eq */ "./node_modules/lodash/eq.js"),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ "./node_modules/lodash/isArrayLike.js"),
    isIndex = __webpack_require__(/*! ./_isIndex */ "./node_modules/lodash/_isIndex.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "./node_modules/lodash/_isKey.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/_isKey.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__(/*! ./isSymbol */ "./node_modules/lodash/isSymbol.js");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ "./node_modules/lodash/_isKeyable.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_isKeyable.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "./node_modules/lodash/_isMasked.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_isMasked.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(/*! ./_coreJsData */ "./node_modules/lodash/_coreJsData.js");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "./node_modules/lodash/_isPrototype.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_isPrototype.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "./node_modules/lodash/_isStrictComparable.js":
/*!****************************************************!*\
  !*** ./node_modules/lodash/_isStrictComparable.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_listCacheClear.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_listCacheClear.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_listCacheDelete.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_listCacheDelete.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "./node_modules/lodash/_assocIndexOf.js");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_listCacheGet.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_listCacheGet.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "./node_modules/lodash/_assocIndexOf.js");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_listCacheHas.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_listCacheHas.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "./node_modules/lodash/_assocIndexOf.js");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_listCacheSet.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_listCacheSet.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "./node_modules/lodash/_assocIndexOf.js");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheClear.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_mapCacheClear.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(/*! ./_Hash */ "./node_modules/lodash/_Hash.js"),
    ListCache = __webpack_require__(/*! ./_ListCache */ "./node_modules/lodash/_ListCache.js"),
    Map = __webpack_require__(/*! ./_Map */ "./node_modules/lodash/_Map.js");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheDelete.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_mapCacheDelete.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "./node_modules/lodash/_getMapData.js");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheGet.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_mapCacheGet.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "./node_modules/lodash/_getMapData.js");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheHas.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_mapCacheHas.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "./node_modules/lodash/_getMapData.js");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheSet.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_mapCacheSet.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "./node_modules/lodash/_getMapData.js");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapToArray.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_mapToArray.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "./node_modules/lodash/_matchesStrictComparable.js":
/*!*********************************************************!*\
  !*** ./node_modules/lodash/_matchesStrictComparable.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_memoizeCapped.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_memoizeCapped.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(/*! ./memoize */ "./node_modules/lodash/memoize.js");

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ "./node_modules/lodash/_nativeCreate.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_nativeCreate.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "./node_modules/lodash/_nativeKeys.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_nativeKeys.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(/*! ./_overArg */ "./node_modules/lodash/_overArg.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "./node_modules/lodash/_nodeUtil.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_nodeUtil.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(/*! ./_freeGlobal */ "./node_modules/lodash/_freeGlobal.js");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/_objectToString.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_objectToString.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "./node_modules/lodash/_overArg.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_overArg.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "./node_modules/lodash/_root.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/_root.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(/*! ./_freeGlobal */ "./node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "./node_modules/lodash/_setCacheAdd.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_setCacheAdd.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "./node_modules/lodash/_setCacheHas.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_setCacheHas.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_setToArray.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_setToArray.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "./node_modules/lodash/_stackClear.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_stackClear.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(/*! ./_ListCache */ "./node_modules/lodash/_ListCache.js");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "./node_modules/lodash/_stackDelete.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_stackDelete.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "./node_modules/lodash/_stackGet.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_stackGet.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "./node_modules/lodash/_stackHas.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_stackHas.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "./node_modules/lodash/_stackSet.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_stackSet.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(/*! ./_ListCache */ "./node_modules/lodash/_ListCache.js"),
    Map = __webpack_require__(/*! ./_Map */ "./node_modules/lodash/_Map.js"),
    MapCache = __webpack_require__(/*! ./_MapCache */ "./node_modules/lodash/_MapCache.js");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "./node_modules/lodash/_strictIndexOf.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash/_strictIndexOf.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_stringToPath.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_stringToPath.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(/*! ./_memoizeCapped */ "./node_modules/lodash/_memoizeCapped.js");

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ "./node_modules/lodash/_toKey.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/_toKey.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(/*! ./isSymbol */ "./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ "./node_modules/lodash/_toSource.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_toSource.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "./node_modules/lodash/_trimmedEndIndex.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_trimmedEndIndex.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ "./node_modules/lodash/eq.js":
/*!***********************************!*\
  !*** ./node_modules/lodash/eq.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "./node_modules/lodash/every.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/every.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(/*! ./_arrayEvery */ "./node_modules/lodash/_arrayEvery.js"),
    baseEvery = __webpack_require__(/*! ./_baseEvery */ "./node_modules/lodash/_baseEvery.js"),
    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ "./node_modules/lodash/_baseIteratee.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isIterateeCall = __webpack_require__(/*! ./_isIterateeCall */ "./node_modules/lodash/_isIterateeCall.js");

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),

/***/ "./node_modules/lodash/first.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/first.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./head */ "./node_modules/lodash/head.js");


/***/ }),

/***/ "./node_modules/lodash/get.js":
/*!************************************!*\
  !*** ./node_modules/lodash/get.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(/*! ./_baseGet */ "./node_modules/lodash/_baseGet.js");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ "./node_modules/lodash/hasIn.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/hasIn.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(/*! ./_baseHasIn */ "./node_modules/lodash/_baseHasIn.js"),
    hasPath = __webpack_require__(/*! ./_hasPath */ "./node_modules/lodash/_hasPath.js");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "./node_modules/lodash/head.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/head.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),

/***/ "./node_modules/lodash/identity.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/identity.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "./node_modules/lodash/indexOf.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/indexOf.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(/*! ./_baseIndexOf */ "./node_modules/lodash/_baseIndexOf.js"),
    toInteger = __webpack_require__(/*! ./toInteger */ "./node_modules/lodash/toInteger.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseIndexOf(array, value, index);
}

module.exports = indexOf;


/***/ }),

/***/ "./node_modules/lodash/isArguments.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/isArguments.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(/*! ./_baseIsArguments */ "./node_modules/lodash/_baseIsArguments.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "./node_modules/lodash/isArray.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/isArray.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "./node_modules/lodash/isArrayLike.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/isArrayLike.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(/*! ./isFunction */ "./node_modules/lodash/isFunction.js"),
    isLength = __webpack_require__(/*! ./isLength */ "./node_modules/lodash/isLength.js");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "./node_modules/lodash/isBuffer.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isBuffer.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js"),
    stubFalse = __webpack_require__(/*! ./stubFalse */ "./node_modules/lodash/stubFalse.js");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/isEqual.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/isEqual.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(/*! ./_baseIsEqual */ "./node_modules/lodash/_baseIsEqual.js");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "./node_modules/lodash/isFunction.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/isFunction.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "./node_modules/lodash/isLength.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isLength.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "./node_modules/lodash/isObject.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isObject.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "./node_modules/lodash/isObjectLike.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/isObjectLike.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "./node_modules/lodash/isSymbol.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isSymbol.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "./node_modules/lodash/isTypedArray.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/isTypedArray.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(/*! ./_baseIsTypedArray */ "./node_modules/lodash/_baseIsTypedArray.js"),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ "./node_modules/lodash/_baseUnary.js"),
    nodeUtil = __webpack_require__(/*! ./_nodeUtil */ "./node_modules/lodash/_nodeUtil.js");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "./node_modules/lodash/keys.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/keys.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(/*! ./_arrayLikeKeys */ "./node_modules/lodash/_arrayLikeKeys.js"),
    baseKeys = __webpack_require__(/*! ./_baseKeys */ "./node_modules/lodash/_baseKeys.js"),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ "./node_modules/lodash/isArrayLike.js");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "./node_modules/lodash/memoize.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/memoize.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(/*! ./_MapCache */ "./node_modules/lodash/_MapCache.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ "./node_modules/lodash/property.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/property.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(/*! ./_baseProperty */ "./node_modules/lodash/_baseProperty.js"),
    basePropertyDeep = __webpack_require__(/*! ./_basePropertyDeep */ "./node_modules/lodash/_basePropertyDeep.js"),
    isKey = __webpack_require__(/*! ./_isKey */ "./node_modules/lodash/_isKey.js"),
    toKey = __webpack_require__(/*! ./_toKey */ "./node_modules/lodash/_toKey.js");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "./node_modules/lodash/some.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/some.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(/*! ./_arraySome */ "./node_modules/lodash/_arraySome.js"),
    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ "./node_modules/lodash/_baseIteratee.js"),
    baseSome = __webpack_require__(/*! ./_baseSome */ "./node_modules/lodash/_baseSome.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isIterateeCall = __webpack_require__(/*! ./_isIterateeCall */ "./node_modules/lodash/_isIterateeCall.js");

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),

/***/ "./node_modules/lodash/stubArray.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/stubArray.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "./node_modules/lodash/stubFalse.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/stubFalse.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "./node_modules/lodash/toFinite.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/toFinite.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(/*! ./toNumber */ "./node_modules/lodash/toNumber.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ "./node_modules/lodash/toInteger.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/toInteger.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(/*! ./toFinite */ "./node_modules/lodash/toFinite.js");

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ "./node_modules/lodash/toNumber.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/toNumber.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(/*! ./_baseTrim */ "./node_modules/lodash/_baseTrim.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js"),
    isSymbol = __webpack_require__(/*! ./isSymbol */ "./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "./node_modules/lodash/toString.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/toString.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(/*! ./_baseToString */ "./node_modules/lodash/_baseToString.js");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./src/base.js":
/*!*********************!*\
  !*** ./src/base.js ***!
  \*********************/
/*! exports provided: isValidEventCase, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidEventCase", function() { return isValidEventCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Base; });
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./utils/helpers */ "./src/utils/helpers.js");
/* harmony import */ var _utils_storage__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./utils/storage */ "./src/utils/storage.js");
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./utils/analytics */ "./src/utils/analytics.js");
/* harmony import */ var _utils_helixError__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./utils/helixError */ "./src/utils/helixError.js");
/* harmony import */ var _utils_extensionsService__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./utils/extensionsService */ "./src/utils/extensionsService.js");
/* harmony import */ var _utils_extensionsServiceV2__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./utils/extensionsServiceV2 */ "./src/utils/extensionsServiceV2.js");
/* harmony import */ var _utils_urlMapping__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./utils/urlMapping */ "./src/utils/urlMapping.js");
/* harmony import */ var _utils_mappings__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./utils/mappings */ "./src/utils/mappings.js");
/* harmony import */ var _utils_colors__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./utils/colors */ "./src/utils/colors.js");
/* harmony import */ var _utils_defaultData__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./utils/defaultData */ "./src/utils/defaultData.js");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./utils/constants */ "./src/utils/constants.js");











var _excluded = ["helixWarnings"],
  _excluded2 = ["helixWarnings"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }











var isValidEventCase = function isValidEventCase(eventCase, eventCaseIgnoreList) {
  var hasValidEC = !Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["isNil"])(eventCase) && !Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["isNil"])(eventCase.eventCaseId);
  if (hasValidEC && !Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["isNil"])(eventCaseIgnoreList) && eventCaseIgnoreList.includes(eventCase.eventCaseId)) {
    throw new Error("Track Error, event case on ignored list: ".concat(eventCase.eventType));
  }
  return hasValidEC;
};
var splitUrl = function splitUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var apiParams = {
    appApiHost: '',
    appApiPath: '',
    appApiQueryParameters: ''
  };
  if (!url) {
    return apiParams;
  }
  if (url.indexOf('http') !== 0) {
    apiParams.appApiPath = url;
    return apiParams;
  }
  var urlArray = url.split('?');
  apiParams.appApiQueryParameters = urlArray[1] || '';
  var urlPathSplit = urlArray[0].split('://');
  var urlPathWOHost = urlPathSplit[1] || '';
  apiParams.appApiHost = urlPathWOHost.substr(0, urlPathWOHost.indexOf('/'));
  apiParams.appApiPath = urlPathWOHost.substr(urlPathWOHost.indexOf('/'));
  return apiParams;
};
var QUANTUM_LIBRARY_METHODS = {
  GET: {
    flushedEvents: 'getFlushedEvents',
    visitId: 'getVisitId',
    currentState: 'getCurrentLibraryState',
    experimentConfigurations: 'getExperimentConfigurations'
  },
  SET: {
    features: 'setFeatures',
    ignoredEvents: 'addIgnoredEvents',
    flushedEvents: 'addFlushedEvents',
    endpoint: 'endpoint',
    requirementsHash: 'setRequirementsHash'
  },
  DEPRECATED_SETTERS: ['setFeatures', 'addIgnoredEvents', 'setEventFilters']
};
var HELIX_LIBRARY_METHODS = {
  GET: {},
  SET: {
    enableClicktale: 'setEnableClicktale'
  }
};
var Base = /*#__PURE__*/function (_Analytics) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(Base, _Analytics);
  var _super = _createSuper(Base);
  function Base() {
    var _this;
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, Base);
    _this = _super.call(this);
    _this.libInitStart = Date.now();
    _this.helixError = new _utils_helixError__WEBPACK_IMPORTED_MODULE_15__["default"](_this.track.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7___default()(_this)), _this.allSetToTrack.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7___default()(_this)), _this.config);
    // Check for and handle GPC
    if (_this.handleGlobalPrivacyControl()) {
      _this.log.info('GPC is enabled. Cookie set.');
    } else {
      _this.log.info('GPC is not enabled.');
    }
    _this.applyMaxEventsPerSecondSettingForE2E();
    return _this;
  }
  /**
   * Holds event types to disable from tracking
   * @param  {Array}  [disabledEvents=[]] Array of event types
   */
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(Base, [{
    key: "disabledEvents",
    get:
    /**
     * @return {Array} Event types to disable from tracking
     */
    function get() {
      return this._disabledEvents || [];
    }
    /**
     * Fetch parameter value from library settings
     * @param  {string} key parameter key
     * @return {any}        parameter value
     */,
    set: function set(disabledEvents) {
      this._disabledEvents = disabledEvents && Array.isArray(disabledEvents) ? disabledEvents : [];
    }
  }, {
    key: "get",
    value: function get(key) {
      var getters = _objectSpread(_objectSpread({}, QUANTUM_LIBRARY_METHODS.GET), HELIX_LIBRARY_METHODS.GET);
      var libraryGetterMethod = getters[key];

      // do not call analytics set function if it is a helix getter
      if (Object.keys(HELIX_LIBRARY_METHODS.GET).includes(key)) {
        return this[libraryGetterMethod]();
      }
      if (typeof this.analytics[libraryGetterMethod] === 'function') {
        return this.analytics[libraryGetterMethod]();
      }
      this.log.warn("".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].yellow, "GET: ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].cyan, " ").concat(key));
      return this.analytics.get(key);
    }
    /**
     * Get a list of available set methods.
     * @method getSetterNames
     * @returns {Array.<string>} Setter names
     */
  }, {
    key: "getSetter",
    value: function getSetter() {
      if (!this.setters) {
        var setters = _objectSpread(_objectSpread({}, QUANTUM_LIBRARY_METHODS.SET), HELIX_LIBRARY_METHODS.SET);
        var setterNames = this.analytics.getSetterNames() || [];
        setterNames.map(function (setterName) {
          // make compatible with previous versions as an array with
          // key: with out the word set and first letter lower case
          // value: with the actual quantum setter name
          var name = setterName.startsWith('set') ? "".concat(setterName.charAt(3).toLowerCase()).concat(setterName.substring(4)) : setterName;
          setters[name] = setterName;
        });
        this.setters = setters;
      }
      return this.setters;
    }

    /**
     * Set parameter value to library settings
     * @param {string} key   parameter key
     * @param {string} value parameter value
     */
  }, {
    key: "set",
    value: function set(key, value) {
      if (!key || Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["isNil"])(value)) {
        return;
      }
      if (key === 'enabled' && typeof value === 'boolean' && !value) {
        this.enableAnalytics = false;
      }
      if (key === 'endpoint') {
        this.endpoint = value;
      }
      var setters = this.getSetter();
      var librarySetterMethod = setters[key];
      this.log.debug("".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].yellow, "SET: ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].cyan, " ").concat(key, " ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].green, " value: ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].yellow).concat(JSON.stringify(value)), {
        value: value,
        settersList: setters
      });
      var DEPRECATED = QUANTUM_LIBRARY_METHODS.DEPRECATED_SETTERS;
      if (DEPRECATED.includes(key)) {
        this.log.warn("The method ".concat(key, " is deprecated and will be removed in future versions"));
      }

      // do not call analytics library if it is a helix setter
      if (Object.keys(HELIX_LIBRARY_METHODS.SET).includes(key)) {
        return this[librarySetterMethod](value);
      }
      // call analytics function if it is a quantum setter (apiMethod)
      if (typeof this.analytics[librarySetterMethod] === 'function') {
        if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default()(value) === 'object' && !Array.isArray(value)) {
          value = Object.fromEntries(Object.entries(value).map(function (_ref) {
            var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref, 2),
              k = _ref2[0],
              v = _ref2[1];
            return [_utils_mappings__WEBPACK_IMPORTED_MODULE_19__["keyMappings"][k] || k, v];
          }));
        }
        return this.analytics[librarySetterMethod](value); // eslint-disable-line consistent-return
      }

      try {
        // call analytics set function to update library settings
        this.analytics.set(key, value);
      } catch (e) {
        this.log.warn("".concat(key, " is not it the setter list"), setters);
      }
    }

    /**
     * @deprecated
     */
  }, {
    key: "useDefaultStorage",
    value: function useDefaultStorage() {
      this.enablePersistence();
    }

    /**
     * @deprecated
     */
  }, {
    key: "setStorage",
    value: function setStorage(clientStorage) {
      this.setCustomStorage(clientStorage);
    }

    /**
     * @deprecated
     */
  }, {
    key: "removeStorage",
    value: function removeStorage(clientStorage) {
      this.removeCustomStorage(clientStorage);
    }

    /**
     * Enable library state persistence (local storage by default).
     * @method enablePersistence
     */
  }, {
    key: "enablePersistence",
    value: function enablePersistence() {
      try {
        // window may exist but localStorage may not
        // some SamsungTV and when on Incognito
        if (typeof window !== 'undefined' && window.localStorage && this.persistence === null) {
          this.persistence = 'local';
          this.log.debug("Persistence:".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].white, " Local"));
        }
        this.analytics.enablePersistence();
      } catch (e) {
        this.log.error("enable Local Persistence:".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, " fail"), e);
        this.persistence = null;
      }
    }

    /**
     * Add a custom persistent storage object to the library.
     * @method setCustomStorage
     * @param {Object} storage - Object that provides persistence API
     * @throws {Error} Will throw an error in development mode if the storage API is not working
     */
  }, {
    key: "setCustomStorage",
    value: function setCustomStorage(clientStorage) {
      this.persistence = 'custom';
      this.log.info("enablePersistence:".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].white, " custom"));
      _utils_storage__WEBPACK_IMPORTED_MODULE_13__["default"].setCustomStorage(clientStorage);
      if (typeof this.analytics.setCustomStorage === 'function') {
        this.analytics.setCustomStorage(clientStorage);
      }
    }

    /**
     * Remove the custom persistent storage object from the library and revert to local storage.
     * @method removeCustomStorage
     */
  }, {
    key: "removeCustomStorage",
    value: function removeCustomStorage() {
      _utils_storage__WEBPACK_IMPORTED_MODULE_13__["default"].removeCustomStorage();
      if (typeof this.analytics.removeCustomStorage === 'function') {
        this.analytics.removeCustomStorage();
      }
      this.persistence = null;
    }
  }, {
    key: "resetStorage",
    value: function resetStorage() {
      _utils_storage__WEBPACK_IMPORTED_MODULE_13__["default"].resetStorage();
      if (typeof this.analytics.resetStorage === 'function') {
        this.analytics.resetStorage();
      }
    }

    /**
     * Restart any in-progress flow (e.g., tvod, stream2, etc.).
     * resets the transactionId without a `message.context` change
     * @method restartFlow
     */
  }, {
    key: "restartFlow",
    value: function restartFlow() {
      if (typeof this.analytics.restartFlow === 'function') {
        this.analytics.restartFlow();
      }
    }

    /**
     *  Clear storage object from library
     */
  }, {
    key: "clearStorage",
    value: function clearStorage() {
      this.log.info("clearStorage ");
      try {
        this.analytics.core.removeStoredState();
        Object(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["removeFromStorage"])('requirements');
        Object(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["removeFromStorage"])('deviceUUID');
        Object(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["removeFromStorage"])('initial-library-state');
        Object(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["removeFromStorage"])('library-first-launch');
      } catch (e) {
        this.log.error('Error while clearStorage ', JSON.stringify(e));
      }
    }

    /**
     * Force flush the message queue.
     * @method flush
     * @returns {Promise} Promise that resolves after all events are sent, regardless of success/fail state
     * @note Avoid waiting for the promise in blocking scenarios such as "oneRetry"
     */
  }, {
    key: "flush",
    value: function () {
      var _flush = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.log.warn("".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].yellow, "flush: ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].cyan, " called"));
              if (!(typeof this.analytics.flush === 'function')) {
                _context.next = 5;
                break;
              }
              _context.next = 4;
              return this.analytics.flush();
            case 4:
              return _context.abrupt("return", _context.sent);
            case 5:
              throw new Error('Flush function is not defined in Quantum library');
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function flush() {
        return _flush.apply(this, arguments);
      }
      return flush;
    }()
    /**
     * Turn off the library.
     * @method stop
     */
  }, {
    key: "stop",
    value: function stop() {
      this.enableAnalytics = false;
      this.log.warn("\uD83D\uDED1  ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "stop: ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].cyan, " called, Analytics are now disable"));
      if (typeof this.analytics.stop === 'function') {
        this.analytics.stop();
      }
    }

    /**
     * Tracks all the events using eventId.
     * if events are not loaded, pushes the event to trackViews(mappedValues.msgEventType, mappedValues.opType, eventId);
                self..
     * if events are loaded but startSession is not called,
     *       pushes events to queue until startSession is called.
     * @param  {string} [eventId=''] [description]
     * @param  {Object} [params={}]  [description]
     * @param  {Object} [options={}] [description]
     * @return {[type]}              [description]
     */
  }, {
    key: "track",
    value: function track() {
      var _options;
      var eventId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // PICA-5338
      if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["isNil"])(options)) options = {};
      if ((_options = options) !== null && _options !== void 0 && _options.messageQaIssues) {
        delete options.messageQaIssues;
      }
      var mappedValues, eid;
      var eventIdTrimmed = eventId.replace(/ /g, '');
      options['helixTrackStartTimestamp'] = Date.now();
      try {
        var _options2, _options3;
        if (this.config && !Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["isNil"])(this.config.enableAnalytics) && !this.config.enableAnalytics) {
          this.log.info("track -- Analytics have been disabled by config. Config: ".concat(JSON.stringify(this.config)));
          return;
        }
        var _urlMapping = Object(_utils_urlMapping__WEBPACK_IMPORTED_MODULE_18__["urlMapping"])(eventIdTrimmed, this.eventsLoaded, this.urlMappings, this.sortedUrlMappingKeys, this.checkValidOpts(options), params, this.log, this.helixError),
          eventCaseId = _urlMapping.eid,
          opts = _urlMapping.opts,
          paramsIn = _urlMapping.paramsIn;
        var eventType = (paramsIn === null || paramsIn === void 0 ? void 0 : paramsIn.msgEventType) || (params === null || params === void 0 ? void 0 : params.msgEventType) || ((_options2 = options) === null || _options2 === void 0 ? void 0 : _options2.msgEventType) || ((_options3 = options) === null || _options3 === void 0 ? void 0 : _options3.eventType);
        this.trackCalled = true;
        eid = eventCaseId;
        if (this.allSetToTrack(eventCaseId)) {
          if (eventType !== null && eventType !== void 0 && eventType.match(/pageViewInit/i) && eid.match(/pageView(?!Init)/i) // pageView is not followed by "init"
          ) {
            var pageViewInitEid = eid.replace(/pageView/i, 'pageViewInit');
            if (this.getEventCase(pageViewInitEid)) {
              eid = pageViewInitEid;
            }
          }
          var eventCase = this.getEventCase(eid);
          if (!isValidEventCase(eventCase, this.config.eventCaseIgnoreList)) {
            this.log.error("Invalid event case. ".concat(eid, " is not tracked. eventCase: ").concat(JSON.stringify(eventCase)));
            return;
          }

          // Do not track event if the event type is in disabled events array
          if (this.disabledEvents.indexOf(eventCase.eventType) > -1) {
            this.log.debug("  event type  disabled  ".concat(eventCase.eventType, "  not tracked. eventCase: ").concat(JSON.stringify(eventCase)));
            return;
          }
          var msgName = eventCase.eventType;
          if (typeof paramsIn.url === 'string' && paramsIn.url.trim().length > 0) {
            var urlDetails = splitUrl(paramsIn.url);
            Object.assign(paramsIn, urlDetails);
          }
          var _this$getMappedValues = this.getMappedValues(paramsIn, eventCase),
            helixWarnings = _this$getMappedValues.helixWarnings,
            _mappedValues = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default()(_this$getMappedValues, _excluded);
          mappedValues = _objectSpread({}, _mappedValues);
          mappedValues.eventCaseId = eid;
          Object.keys(eventCase).forEach(function (key) {
            if (!mappedValues[key]) {
              switch (key) {
                case 'referrerAppVisitId':
                  mappedValues[key] = Object(_utils_defaultData__WEBPACK_IMPORTED_MODULE_21__["getReferrerAppVisitId"])();
                  break;
                case 'referrerAppName':
                  mappedValues[key] = Object(_utils_defaultData__WEBPACK_IMPORTED_MODULE_21__["getReferrerAppName"])();
                  break;
                case 'referrerAppType':
                  mappedValues[key] = Object(_utils_defaultData__WEBPACK_IMPORTED_MODULE_21__["getReferrerAppType"])();
                  break;
                case 'referrerAppDeviceId':
                  mappedValues[key] = Object(_utils_defaultData__WEBPACK_IMPORTED_MODULE_21__["getReferrerAppDeviceId"])();
                  break;
                case 'referrerAppCommonToken':
                  mappedValues[key] = Object(_utils_defaultData__WEBPACK_IMPORTED_MODULE_21__["getReferrerAppCommonToken"])();
                  break;
                case 'appRefLink':
                  // the eventCase key is Unified we set the Quantum Key
                  mappedValues['referrerLink'] = Object(_utils_defaultData__WEBPACK_IMPORTED_MODULE_21__["getAppReferrer"])();
                  break;
                case 'uiResponsiveBreakpoint':
                  mappedValues[key] = Object(_utils_defaultData__WEBPACK_IMPORTED_MODULE_21__["getCurrentBreakpoint"])();
                  break;
              }
            }
          });
          mappedValues = Object.keys(mappedValues).filter(function (k) {
            return mappedValues[k] != null && mappedValues[k] !== '';
          }).reduce(function (a, k) {
            return _objectSpread(_objectSpread({}, a), {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()({}, k, mappedValues[k]));
          }, {});

          // if (paramsIn?.msgEventType) {
          //   helixWarnings.push(
          //     `⚠️ Deprecated ${COLOR.yellow}  ${COLOR.magenta}msgEventType  ${COLOR.green} on adHocData. \n ${COLOR.blue}${paramsIn?.msgEventType}  ${COLOR.cyan} Update to send as 'options:{ eventType: "${paramsIn?.msgEventType}"}' `
          //   );
          // }

          var sdkMethod = eventType || msgName;
          if (sdkMethod === 'pageView') {
            var errorCode = _utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorCodes"].INVALID_EVENT_TYPE;
            this.log.error("\uD83D\uDED1 ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "AN-").concat(errorCode, " (").concat(_utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorMessages"][errorCode], "):\nMissing the ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].cyan, " msgEventType ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].white, "on ").concat(sdkMethod, " Event, ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "make sure to pass one of:").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].blue, " [pageViewCompleted, pageViewPartiallyRendered, pageViewTimeout, pageViewTemporary, pageViewCompleteAwaitingAction]"));
            this.helixError.reportError(errorCode, this.config, "".concat(eventId, ": Missing the option \"eventType\" on pageView Event"));
          }
          if (typeof this.analytics[sdkMethod] === 'function') {
            if (sdkMethod === 'loginStop' || sdkMethod === 'inVisitOauthRefresh') {
              mappedValues.oAuthToken = paramsIn.accountOauthToken;
            }
            var beforeExtensionsTimestamp = Date.now();
            // remove this once V2 is stablish

            if (this.helixExtensionRules && this.helixExtensionRules.length > 0) {
              mappedValues = Object(_utils_extensionsServiceV2__WEBPACK_IMPORTED_MODULE_17__["processExtensions"])(mappedValues, this.helixExtensionRules, this.helixError, this.analytics);
            } else {
              mappedValues = Object(_utils_extensionsService__WEBPACK_IMPORTED_MODULE_16__["processExtensions"])(mappedValues, this.expressions, this.helixError);
            }
            opts['helixTimeInRules'] = Date.now() - beforeExtensionsTimestamp;
            // need it by batch API
            if (mappedValues && mappedValues.eventCaseId && mappedValues.eventCaseId !== eid) {
              var newEventCase = this.getEventCase(mappedValues.eventCaseId);
              sdkMethod = newEventCase.eventType;
            }
            if (!mappedValues.blockTrack) {
              if (sdkMethod === 'startSession' && this.get('currentState') !== 'blank') {
                throw new Error("Unexpected event startSession received in state ".concat(this.get('currentState')));
              }
              this.validateEID({
                decodedEID: eventCase,
                adHocDataIn: params,
                adHocDataOut: mappedValues,
                optionsOut: opts,
                optionsIn: options,
                eid: mappedValues.eventCaseId || eid,
                sdkMethod: sdkMethod,
                helixWarnings: helixWarnings
              });
              this.analytics[sdkMethod](mappedValues, opts);
            }
          }
        } else if (this.enableAnalytics) {
          if (this.eventsLoaded) {
            var _eventCase = this.getEventCase(eid);
            if (!isValidEventCase(_eventCase, this.config.eventCaseIgnoreList)) {
              var _errorCode = _utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorCodes"].INVALID_EID;
              this.log.error("\uD83D\uDED1 ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "AN-").concat(_errorCode, " (").concat(_utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorMessages"][_errorCode], "):\nCouldn't find ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].cyan).concat(eid, " ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].white, "in events, ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "make sure ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].cyan).concat(this.config.requirementsVersion).concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, " is the correct requirementsVersion."));
              this.helixError.reportError(_errorCode, this.config, eid);
              return;
            }
            var properties = _eventCase.properties;
            this.log.info("track: ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].white, "retrieved properties:"), properties);
            this.log.info('track: check if current event is startSession');
            if (_eventCase.eventType === 'startSession') {
              this.trackStartSession(eid, paramsIn, opts);
            } else {
              this.log.info("track: ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].white, "Events loaded, waiting for startSession. Added ").concat(eid, " to queue."));
              this.updateQueue(eid, paramsIn, opts);
            }
          } else {
            this.log.debug("track: ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].white, "events not loaded. Added ").concat(eid, " to queue."));
            this.updateQueue(eid, paramsIn, opts);
          }
        }
        try {
          this.backwardCompatible();
        } catch (e) {
          this.log.error("There was an error making the backwardCompatible call: ".concat(JSON.stringify(e), " "), e);
        }
      } catch (e) {
        var _e$message;
        if (e !== null && e !== void 0 && (_e$message = e.message) !== null && _e$message !== void 0 && _e$message.startsWith('Track Error, event case on ignored list')) {
          var _errorCode2 = _utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorCodes"].IGNORED_EVENT_TYPE;
          this.log.error("\uD83D\uDED1 ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "AN-").concat(_errorCode2, " (").concat(_utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorMessages"][_errorCode2], ")"), {
            mappedValues: mappedValues,
            error: e
          });
          this.helixError.reportError(_errorCode2, {}, e);
        } else {
          var _errorCode3 = _utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorCodes"].TRACK;
          var additionalMessage = "There was an error making the track call for ".concat(eid, ".");
          this.log.error("\uD83D\uDED1 ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "AN-").concat(_errorCode3, " (").concat(_utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorMessages"][_errorCode3], "):").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].white, "\n ").concat(additionalMessage), {
            mappedValues: mappedValues,
            error: e
          });
          this.helixError.reportError(_utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorCodes"].TRACK, mappedValues, additionalMessage);
        }
      }
    }

    /**
     * analytics init. sets all the setters from settings. Release queue once startSession is tracked.
     * @param  {string} [eventId=''] startSession eventId to map the values from.
     * @param  {Object} [params={}]  Dynamic values and settings
     * @param  {Object} [options={}] Optional arguments for startSession
     */
  }, {
    key: "trackStartSession",
    value: function trackStartSession() {
      var _options4,
        _this2 = this;
      var eventId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // PICA-5338
      if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["isNil"])(options)) options = {};
      if ((_options4 = options) !== null && _options4 !== void 0 && _options4.messageQaIssues) {
        delete options.messageQaIssues;
      }
      var eventIdTrimmed = eventId.replace(/ /g, '');
      options['helixTrackStartTimestamp'] = Date.now();
      if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["isNil"])(this.config.enableAnalytics) || !this.config.enableAnalytics || !this.enableAnalytics) {
        this.log.error("track -- ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "Analytics have been disabled"), this.config);
        return;
      }
      var eventCase = this.getEventCase(eventIdTrimmed);
      this.log.debug('getEventCase: ', eventCase);
      if (!isValidEventCase(eventCase, this.config.eventCaseIgnoreList)) {
        var errorCode = _utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorCodes"].INVALID_EID;
        var errorMessage = "\uD83D\uDED1 ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "AN-").concat(errorCode, " (").concat(_utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorMessages"][errorCode], "):").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].white, "\n startSession not triggered. Event case is not valid EID:").concat(eventId);
        this.log.error(errorMessage, {
          eventCase: eventCase,
          params: params,
          options: options,
          eventId: eventIdTrimmed
        });
        this.helixError.reportError(errorCode, this.config, eventId);
        return;
      }
      var properties = Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["removeNullEntries"])(eventCase);
      var mapValues = Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["deepMerge"])(this.config, params, properties, {
        libraryInitTimeMs: 0,
        analyticsReqResponseTimeMs: this.reqFetchStop - this.reqFetchStart || 0,
        analyticsReqSource: this.analyticsReqSource,
        analyticsReqVersion: this.config.requirementsVersion,
        analyticsLibVersion: Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["helixVersion"])()
      });
      if ((mapValues === null || mapValues === void 0 ? void 0 : mapValues.appEnvName) !== 'prod') {
        this.applyMaxEventsPerSecondSettingForE2E();
      }
      var domain = mapValues.domain,
        _mapValues$settings = mapValues.settings,
        settings = _mapValues$settings === void 0 ? {} : _mapValues$settings;
      this.setClientDomain(domain);
      var _settings$setters = settings.setters,
        setters = _settings$setters === void 0 ? {} : _settings$setters;
      // sdk expects settings object to contain value of strings.
      var settingsObj = _objectSpread(_objectSpread({}, settings), Object.keys(setters).reduce(function (obj, setter) {
        obj[setter] =
        // eslint-disable-line no-param-reassign
        typeof setters[setter] === 'string' ? setters[setter] : JSON.stringify(setters[setter]); // eslint-disable-line no-param-reassign
        return obj;
      }, {}));
      if (!Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["isNil"])(setters) && Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["isObject"])(setters) && !Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_12__["isEmpty"])(setters)) {
        this.disabledEvents = setters.disabledEvents || [];
        Object.keys(setters).forEach(function (s) {
          return _this2.set(s, setters[s]);
        });
      }
      // Pass all the settings to analytics
      mapValues.settings = settingsObj;
      // Get prefilled values
      var _this$getMappedValues2 = this.getMappedValues(mapValues, eventCase),
        helixWarnings = _this$getMappedValues2.helixWarnings,
        mappedValues = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default()(_this$getMappedValues2, _excluded2);

      // process rules on the mappedValues
      var beforeExtensionsTimestamp = Date.now();
      if (this.helixExtensionRules && this.helixExtensionRules.length > 0) {
        mappedValues = Object(_utils_extensionsServiceV2__WEBPACK_IMPORTED_MODULE_17__["processExtensions"])(mappedValues, this.helixExtensionRules, this.helixError, this.analytics);
      } else {
        // remove this once V2 is stablish
        mappedValues = Object(_utils_extensionsService__WEBPACK_IMPORTED_MODULE_16__["processExtensions"])(mappedValues, this.expressions, this.helixError);
      }
      options['helixTimeInRules'] = Date.now() - beforeExtensionsTimestamp;
      options['currentTabId'] = this.currentTabId;
      // Add eventId to the message
      mappedValues.eventCaseId = eventIdTrimmed;
      this.libInitStop = Date.now();
      mappedValues.libraryInitTimeMs = this.libInitStop - this.libInitStart || 0;
      // *** Add gpcPersisted to mappedValues ***
      mappedValues.gpcPersisted = !!Object(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["getCookie"])(_utils_constants__WEBPACK_IMPORTED_MODULE_22__["C"].GPCCookie);
      try {
        this.analytics.init(mappedValues, options);
        this.validateEID({
          decodedEID: eventCase,
          adHocDataIn: params,
          adHocDataOut: mappedValues,
          optionsOut: options,
          optionsIn: options,
          eid: eventIdTrimmed,
          sdkMethod: 'startSession',
          helixWarnings: helixWarnings
        });
        this.analyticsInitialized = true;
        this.releaseQueue();
      } catch (e) {
        var _errorCode4 = _utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorCodes"].INIT;
        var _errorMessage = "\uD83D\uDED1 ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "AN-").concat(_errorCode4, " (").concat(_utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorMessages"][_errorCode4], ")");
        this.log.error(_errorMessage, e);
        this.helixError.reportError(_errorCode4, mappedValues);
      }
    }

    /**
     * Return true if the event can be tracked else returns false
     * @param  {String} eventId eventId to track analytics
     * @return {Boolean}
     */
  }, {
    key: "allSetToTrack",
    value: function allSetToTrack(eventId) {
      if (!eventId) {
        this.log.info("allSetToTrack: ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "Invalid event id."));
        return false;
      }
      if (!this.enableAnalytics) {
        this.log.error("allSetToTrack: ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "Analytics is disabled."));
        return false;
      }
      if (this.analyticsInitialized && this.eventsLoaded && this.getEventCase(eventId)) {
        this.log.debug("allSetToTrack: ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].white, "Analytics tracked."));
        return true;
      }
      if (this.analyticsInitialized && this.eventsLoaded && !this.getEventCase(eventId)) {
        this.log.warn("allSetToTrack: ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "can't find EventCase: ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].cyan).concat(eventId));
        return false;
      }
      this.log.debug("allSetToTrack: ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "Not ready to track."));
      return false;
    }
  }, {
    key: "generateOverloadMethods",
    value: function generateOverloadMethods() {
      var _this3 = this;
      var sdkMethods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return sdkMethods.reduce(function (overloadedTrackCalls, sdkMethod) {
        return _objectSpread(_objectSpread({}, overloadedTrackCalls), {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()({}, sdkMethod, function (adHocData, options) {
          return _this3.trackOverload(sdkMethod, adHocData, options);
        }));
      }, {});
    }
  }, {
    key: "trackOverload",
    value: function trackOverload(sdkMethod, adHocData, options) {
      try {
        var mappedValues = Object(_utils_extensionsService__WEBPACK_IMPORTED_MODULE_16__["processExtensions"])(_objectSpread(_objectSpread({}, adHocData), {}, {
          sdkMethod: sdkMethod
        }), this.helixExtensionRules, this.helixError);
        if (mappedValues.blockTrack) {
          this.log.warn("trackOverload blocked: ".concat(sdkMethod));
          return;
        }
        return this.analytics[sdkMethod](mappedValues, options);
      } catch (err) {
        var errorCode = _utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorCodes"].METHOD_NOT_FOUND;
        this.log.error("\uD83D\uDED1 ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "AN-").concat(errorCode, " (").concat(_utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorMessages"][errorCode], ")"), err);
        this.helixError.reportError(errorCode, {}, err);
      }
    }

    /**
     * Return object with the Headers values use by Qube
     * @param  {String} userId supplied by the app to track analytics
     * @return {Object}
     */
  }, {
    key: "getQubeHeaders",
    value: function getQubeHeaders(userId) {
      var visitId = this.get('visitId');
      var traceId = Object(_utils_defaultData__WEBPACK_IMPORTED_MODULE_21__["generatedUUIDV4"])();
      var _this$config = this.config,
        appName = _this$config.appName,
        appType = _this$config.appType;
      var store = this.analytics.core.getStoredState({
        applicationName: appName,
        applicationType: appType
      });
      var appSessionId = '';
      var _store$state = store.state,
        state = _store$state === void 0 ? '{}' : _store$state;
      if (state) {
        var _JSON$parse = JSON.parse(state);
        var _JSON$parse$model = _JSON$parse.model;
        _JSON$parse$model = _JSON$parse$model === void 0 ? {} : _JSON$parse$model;
        var _JSON$parse$model$vis = _JSON$parse$model.visit;
        _JSON$parse$model$vis = _JSON$parse$model$vis === void 0 ? {} : _JSON$parse$model$vis;
        var _JSON$parse$model$vis2 = _JSON$parse$model$vis.appSessionId;
        appSessionId = _JSON$parse$model$vis2 === void 0 ? '' : _JSON$parse$model$vis2;
      }
      return {
        'x-visit-id': visitId,
        'x-user-id': userId,
        'x-app-session-id': appSessionId,
        'x-trace-id': traceId,
        'x-app-id': "".concat(appName, "@").concat(appType)
      };
    }
  }, {
    key: "backwardCompatible",
    value: function backwardCompatible() {
      var persistence = this.persistence;
      if (typeof window === 'undefined' || persistence !== 'local' && typeof window !== 'undefined') return;
      var storage = window.localStorage || {
        setItem: function setItem() {},
        getItem: function getItem() {}
      };
      var visitId = this.get('visitId');
      if (typeof window !== 'undefined' && (!window.QuantumVisitID || window.QuantumVisitID !== visitId)) {
        window.QuantumVisitID = visitId;
      }
      var libraryState = storage.getItem(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["STORAGE_KEYS"].LIBRARY_STATE);
      if (!libraryState && visitId) {
        storage.setItem(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["STORAGE_KEYS"].LIBRARY_STATE, JSON.stringify({
          model: {
            visit: {
              visitId: visitId
            }
          }
        }));
      } else if (visitId) {
        var currentLibraryState = JSON.parse(libraryState) || {};
        var _currentLibraryState$ = currentLibraryState.model,
          _currentLibraryState$2 = _currentLibraryState$ === void 0 ? {} : _currentLibraryState$,
          _currentLibraryState$3 = _currentLibraryState$2.visit,
          _currentLibraryState$4 = _currentLibraryState$3 === void 0 ? {} : _currentLibraryState$3,
          currentVisitId = _currentLibraryState$4.visitId;
        if (currentVisitId !== visitId) storage.setItem(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["STORAGE_KEYS"].LIBRARY_STATE, JSON.stringify({
          model: {
            visit: {
              visitId: visitId
            }
          }
        }));
      }
    }
  }, {
    key: "checkValidOpts",
    value: function checkValidOpts(opts) {
      var timestamp = opts.timestamp;
      if (timestamp) {
        var minDate = new Date('2025-01-26T00:00:00Z');
        var isStaleTimestamp = timestamp < minDate.getTime();
        var isWrongType = typeof timestamp !== 'number';
        if (isWrongType || isStaleTimestamp) {
          var errorCode = isWrongType ? _utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorCodes"].INVALID_TIMESTAMP : _utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorCodes"].STALE_TIMESTAMP;
          this.log.error("\uD83D\uDED1 ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].red, "AN-").concat(errorCode, " (").concat(_utils_helixError__WEBPACK_IMPORTED_MODULE_15__["ErrorMessages"][errorCode], "):").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_20__["default"].white, "\n Timestamp Provided: ").concat(timestamp));
          this.helixError.reportError(errorCode, {}, "".concat(timestamp));
          delete opts['timestamp'];
        }
      }
      return opts;
    }

    /**
     * Get the list of events that could be tracked in the current state.
     * @method getNextEvents
     * @returns {string} Current state
     */
  }, {
    key: "getNextEvents",
    value: function getNextEvents() {
      if (typeof this.analytics.getNextEvents === 'function') {
        return this.analytics.getNextEvents();
      }
    }

    /**
     * Check if an event can be tracked in the current state.
     * @method isValidEventForCurrentState
     * @param {string} eventName - Event name to check
     * @returns {boolean} Indicates if the event can be tracked in the current state
     */
  }, {
    key: "isValidForCurrentState",
    value: function isValidForCurrentState(eventName) {
      if (typeof this.analytics.isValidEventForCurrentState === 'function') {
        return this.analytics.isValidEventForCurrentState(eventName);
      }
    }

    /**
     * Checks for Global Privacy Control (GPC) signal and sets/updates a cookie if enabled.
     *
     * If GPC is enabled, this function sets a cookie named "PersistGPC" with an
     * expiration date of 14 months in the future. If the cookie already exists,
     * only the expiration date is updated. The cookie value stores the date
     * when the GPC signal was first detected.
     *
     * @returns {boolean} True if GPC is enabled, otherwise false.
     */
  }, {
    key: "handleGlobalPrivacyControl",
    value: function handleGlobalPrivacyControl() {
      if (typeof navigator !== 'undefined' && navigator.globalPrivacyControl) {
        this.log.info('Global Privacy Control (GPC) signal detected.');
        var expirationDate = new Date();
        expirationDate.setMonth(expirationDate.getMonth() + 14);
        if (Object(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["getCookie"])(_utils_constants__WEBPACK_IMPORTED_MODULE_22__["C"].GPCCookie)) {
          this.log.debug('PersistGPC cookie exists, updating expiration.');
          if (!Object(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["writeCookie"])(_utils_constants__WEBPACK_IMPORTED_MODULE_22__["C"].GPCCookie, Object(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["getCookie"])(_utils_constants__WEBPACK_IMPORTED_MODULE_22__["C"].GPCCookie), expirationDate)) {
            this.log.error('Failed to update PersistGPC cookie expiration.');
            return false;
          }
        } else {
          this.log.debug('PersistGPC cookie not found, setting cookie.');
          var today = new Date().toISOString().slice(0, 10); // Get date in YYYY-MM-DD format

          if (!Object(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["writeCookie"])(_utils_constants__WEBPACK_IMPORTED_MODULE_22__["C"].GPCCookie, today, expirationDate)) {
            this.log.error('Failed set PersistGPC cookie');
            return false;
          }
        }
        return true;
      }
      return false;
    }
    /**
     * Checks for a cookie named "maxEventsPerSecond" and sets its value to the analytics library
     * if the environment is not Production.
     * @method overtireSettingForE2E
     * @returns {void}
     */
  }, {
    key: "applyMaxEventsPerSecondSettingForE2E",
    value: function applyMaxEventsPerSecondSettingForE2E() {
      var maxEventsPerSecond = parseInt(Object(_utils_storage__WEBPACK_IMPORTED_MODULE_13__["getCookie"])(_utils_constants__WEBPACK_IMPORTED_MODULE_22__["C"].HelixMaxEventsPerSecond), 10);
      this.log.info('Max events per second: ' + maxEventsPerSecond);
      if (!isNaN(maxEventsPerSecond)) {
        if (!this.config.settings) {
          this.config.settings = {
            setters: {}
          };
        } else if (!this.config.settings.setters) {
          this.config.settings.setters = {};
        }
        this.config.settings.setters.maxEventsPerSecond = maxEventsPerSecond;
        this.log.info('applyMaxEventsPerSecondSettingForE2E detected, setting maxEventsPerSecond: ' + maxEventsPerSecond);
      }
    }
  }]);
  return Base;
}(_utils_analytics__WEBPACK_IMPORTED_MODULE_14__["default"]);


/***/ }),

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* eslint-disable */
var analytics = __webpack_require__(/*! ./video */ "./src/video.js")["default"];
/* harmony default export */ __webpack_exports__["default"] = (analytics);

/***/ }),

/***/ "./src/utils/Logger.js":
/*!*****************************!*\
  !*** ./src/utils/Logger.js ***!
  \*****************************/
/*! exports provided: LOG, levels, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOG", function() { return LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "levels", function() { return levels; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Logger_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Logger_tools */ "./src/utils/Logger_tools.js");



var LOG = {
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
  CRITICAL: 'critical'
};
var levels = {
  debug: 1,
  info: 10,
  warn: 20,
  error: 30,
  critical: 50
};
var Logger = /*#__PURE__*/function () {
  function Logger() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Logger);
    this._level = levels.critical;
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Logger, [{
    key: "setLevel",
    value: function setLevel(level) {
      if (level in levels) {
        this._level = levels[level];
      }
    }
  }, {
    key: "write",
    value: function write(props) {
      var _props$level = props.level,
        level = _props$level === void 0 ? LOG.INFO : _props$level,
        message = props.message,
        payload = props.payload,
        color = props.color;
      // eslint-disable-line class-methods-use-this
      if (!console) return;
      var consol = console;

      // Do not log in test environment
      if (!level || levels[level] < this._level) {
        return;
      }
      if (typeof consol[level] === 'function') {
        if (!payload || typeof payload === 'string' || payload === 'number') {
          consol[level].call(consol, "%c[Helix] %c".concat(message, "  %c").concat(payload || ''), 'color: gray;', 'color: silver;', "color: ".concat(color, ";"));
        } else {
          try {
            var ordered = {};
            // try sort out the objects
            var count = 0;
            Object.keys(payload).sort().forEach(function (key) {
              count++;
              ordered[key] = payload[key];
            });
            consol.groupCollapsed("%c[Helix] %c".concat(message, " %c- %c(").concat(count, ")"), 'color: gray;', 'color: silver;', "color: ".concat(color, ";"), 'color: white;');
            Object(_Logger_tools__WEBPACK_IMPORTED_MODULE_2__["default"])(ordered);
            consol.groupEnd();
          } catch (e) {
            consol.groupEnd();
            consol[level].call(payload);
            consol[level].call(e);
          }
        }
      } else if (typeof consol.log === 'function') {
        consol.log("[helix] (".concat(level.toUpperCase(), ") ").concat(message));
      }
    }
  }, {
    key: "debug",
    value: function debug(message) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.write({
        level: LOG.DEBUG,
        color: 'blue',
        message: message,
        payload: payload
      });
    }
  }, {
    key: "info",
    value: function info(message) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.write({
        level: LOG.INFO,
        color: 'green',
        message: message,
        payload: payload
      });
    }
  }, {
    key: "warn",
    value: function warn(message) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.write({
        level: LOG.WARN,
        color: 'orange',
        message: message,
        payload: payload
      });
    }
  }, {
    key: "error",
    value: function error(message) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.write({
        level: LOG.ERROR,
        color: 'red',
        message: message,
        payload: payload
      });
    }
  }, {
    key: "critical",
    value: function critical(message) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.write({
        level: LOG.CRITICAL,
        color: 'red',
        message: message,
        payload: payload
      });
    }
  }]);
  return Logger;
}();
/* harmony default export */ __webpack_exports__["default"] = (new Logger());

/***/ }),

/***/ "./src/utils/Logger_tools.js":
/*!***********************************!*\
  !*** ./src/utils/Logger_tools.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return loop; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);

function loop(data) {
  var propNames = Object.keys(data);
  if (propNames.length === 1) {
    getType(propNames[0], data[propNames[0]]);
  } else {
    propNames.forEach(function (name) {
      return getType(name, data[name]);
    });
  }
}
function getType(key, value) {
  var consol = console;
  var text = '';
  var type = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value);
  var dateType = Object.prototype.toString.call(value);
  switch (type) {
    case 'boolean':
      if (value === true) {
        text = "".concat(key, ": %c TRUE");
        consol.log(text, 'color: green; font-style: italic');
      } else if (value === false) {
        text = "".concat(key, ": %c FALSE");
        consol.log(text, 'color: red; font-style: italic');
      }
      break;
    case 'number':
      text = "".concat(key, ": %c ").concat(value);
      if (value > 0) consol.log(text, 'color: SaddleBrown');else consol.log(text, 'color: Tomato; font-style: italic');
      break;
    case 'string':
      text = "".concat(key, ": %c \"").concat(value, "\"");
      consol.log(text, 'color: light gray');
      break;
    case 'function':
      text = "%c".concat(key, "()");
      consol.log(text, 'color: DarkCyan');
      break;
    case 'undefined':
      text = "".concat(key, ": %c UNDEFINED");
      consol.log(text, 'color: Chocolate; font-style: italic');
      break;
    case 'null':
      text = "".concat(key, ": %c NULL");
      consol.log(text, 'color: Brown; font-style: italic');
      break;

    // objects are a special case
    case 'object':
      logObject(dateType, text, key, value);
      break;
    default:
      consol.log('*TYPE: ', type);
      consol.log(key, ':', value);
  }
}
function logObject(dateType, text, key, value) {
  var consol = console;
  if (dateType === '[object Date]') {
    text = "".concat(key, ": %c ").concat(value.toLocaleString(), " (date)");
    consol.log(text, 'color: DarkGreen');
    return;
  } else if (value === null) {
    text = "".concat(key, ": %c NULL");
    consol.log(text, 'color: Brown; font-style: italic');
    return;
  } else if ('_isAMomentObject' in value) {
    text = "".concat(key, ": %c ").concat(value.format('lll'), " (moment)");
    consol.log(text, 'color: ForestGreen');
    return;
  } else if (Object.keys(value).length === 0) {
    text = "".concat(key, ": %c ").concat(JSON.stringify(value));
    consol.log(text, 'color: DeepPink');
    return;
  }

  // check how deep the object is,  very deep nested objects will
  // will make the the browser slow down
  var deepen = deep(value);
  var unordered = value;
  var ordered = {};
  // try sort out the objects
  Object.keys(unordered).sort().forEach(function (key) {
    ordered[key] = unordered[key];
  });
  if (deepen > 0 && deepen < 20) {
    // Not an array just go 2 levels deep
    consol.groupCollapsed("".concat(key, " [").concat(Object.keys(value).length, "]"));
    var properties = Object.getOwnPropertyNames(ordered);
    properties.forEach(function (prop) {
      return getType(prop, value[prop]);
    });
  } else {
    consol.groupCollapsed("".concat(key, " (x)"));
    consol.log(value);
    consol.groupEnd();
    return;
  }
  consol.groupEnd();
}
function deep(data) {
  // browser will crash if circular references exist
  try {
    JSON.stringify(data);
  } catch (error) {
    // discard key if value cannot be deduped
    return 20;
  }
  return Object.keys(data).length;
}

/***/ }),

/***/ "./src/utils/analytics.js":
/*!********************************!*\
  !*** ./src/utils/analytics.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Analytics; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./events */ "./src/utils/events.js");
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./storage */ "./src/utils/storage.js");
/* harmony import */ var _defaultData__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./defaultData */ "./src/utils/defaultData.js");
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./colors */ "./src/utils/colors.js");
/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Logger */ "./src/utils/Logger.js");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./helpers */ "./src/utils/helpers.js");
/* harmony import */ var _uuid__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./uuid */ "./src/utils/uuid.js");
/* harmony import */ var _utils_helixError__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../utils/helixError */ "./src/utils/helixError.js");










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var PENDING_EVENTS_KEY = 'pendingEventsQueue';
// also check if custom storage exists - if it does use in memory
var LOCAL_STORAGE = typeof self !== 'undefined' ? self.localStorage : null;
var Analytics = /*#__PURE__*/function (_Events) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Analytics, _Events);
  var _super = _createSuper(Analytics);
  function Analytics() {
    var _this;
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, Analytics);
    _this = _super.call(this);
    _this.persistence = null;
    _this.endpoint = null;
    _this.config = {};
    _this.customConfig = {};
    _this.pendingEventsQueue = [];
    _this.pendingStartSessionParams = null;
    _this.isReleasingQueue = false;
    _this.initialMaxEventsPerSecond = 20;
    _this.helixError = new _utils_helixError__WEBPACK_IMPORTED_MODULE_18__["default"](_this.track.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this)), _this.allSetToTrack.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this)), _this.config);
    return _this;
  }

  /**
   * Override this method from tracker class
   */
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(Analytics, [{
    key: "track",
    value: function track() {
      this.log.debug('this is an abstract method. Override it in child');
    }

    /**
     * Override this method from tracker class
     */
  }, {
    key: "allSetToTrack",
    value: function allSetToTrack() {
      this.log.debug('this is an abstract method. Override it in child');
    }

    /**
     * Tracks all the events using eventId.
     *  Steps:
     *    Clears Helix Queue if Analytics has been Initialized
     *    Flushes the Library (to get a clean state)
     *    Does a track
     *    Immediately flushes it and sends a Promise back.
     * @param  {string} [eventId=''] [description]
     * @param  {Object} [params={}]  [description]
     * @param  {Object} [options={}] [description]
     * @return {[type]}              [description]
     */
  }, {
    key: "trackAndFlush",
    value: function () {
      var _trackAndFlush = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee() {
        var eventId,
          params,
          options,
          _args = arguments;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              eventId = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
              params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              if (this.analyticsInitialized) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", Promise.reject('Analytics not initialized: Cannot flush without analytics.'));
            case 5:
              this.releaseQueue();
              _context.next = 8;
              return this.flush();
            case 8:
              _context.next = 10;
              return this.track(eventId, params, options);
            case 10:
              return _context.abrupt("return", this.flush());
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function trackAndFlush() {
        return _trackAndFlush.apply(this, arguments);
      }
      return trackAndFlush;
    }()
    /**
     * Read currentTabId from session storage
     * If it already exists, remove it from storage and pass to quantum
     * If it does not exist, generate new tabId and store in memory
     *   - When the beforeunload event occurs, write the stored tabId to session storage
     * @return {void}
     */
  }, {
    key: "setupTabId",
    value: function setupTabId() {
      var _this2 = this;
      if (typeof window !== 'undefined') {
        var tabIdKey = 'currentTabId';
        var savedId = Object(_storage__WEBPACK_IMPORTED_MODULE_12__["fetchFromSessionStorage"])(tabIdKey);
        this.log.debug('Resume session; Saved Tab ID: ', savedId);
        if (savedId) {
          Object(_storage__WEBPACK_IMPORTED_MODULE_12__["removeFromSessionStorage"])(tabIdKey);
          this.currentTabId = savedId;
        } else {
          this.currentTabId = Object(_uuid__WEBPACK_IMPORTED_MODULE_17__["default"])();
        }
        window.addEventListener('unload', function () {
          Object(_storage__WEBPACK_IMPORTED_MODULE_12__["writeToSessionStorage"])(tabIdKey, _this2.currentTabId);
          _this2.log.debug('Saved TabID on unload Event Listener: ', _this2.currentTabId);
        });
        window.addEventListener('beforeunload', function () {
          Object(_storage__WEBPACK_IMPORTED_MODULE_12__["writeToSessionStorage"])(tabIdKey, _this2.currentTabId);
          _this2.log.debug('Saved TabID on beforeunload Event Listener: ', _this2.currentTabId);
        });
      }
    }

    /**
     * Save config data to storage so it can be
     * used for helix errors in the event that initialization fails.
     * Also need to reset the fallback visitId so this does not persist accross visits
     * @param  {Object} [config={}] Inital config
     * @Return {void}
     */
  }, {
    key: "setupInitialLibraryState",
    value: function setupInitialLibraryState(config) {
      Object(_storage__WEBPACK_IMPORTED_MODULE_12__["writeToStorage"])(_storage__WEBPACK_IMPORTED_MODULE_12__["STORAGE_KEYS"].INITIAL_LIBRARY_STATE, _objectSpread(_objectSpread({}, config), {}, {
        fallbackVisitId: ''
      }));
    }

    /**
     * Asynchronously initializes viper. If required fields are not passed,
     * analytics will be disabled.
     * calls a method to fetch events when all required fields are passed.
     * @param  {Object} [config={}] Inital config. This will persist and will be added to startSession
     * @Return {Promise}
     */
  }, {
    key: "init",
    value: function () {
      var _init = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee2() {
        var config,
          requirementsVersion,
          analyticsReqVersion,
          errorMessage,
          errorResponse,
          _errorMessage,
          consoleMessage,
          _consoleMessage,
          _args2 = arguments;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              config = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              requirementsVersion = config.requirementsVersion, analyticsReqVersion = config.analyticsReqVersion; // Copy the unified key analyticsReqVersion to requirementsVersion if provided
              if (analyticsReqVersion) {
                requirementsVersion = analyticsReqVersion;
              }
              if (!(Object(_helpers__WEBPACK_IMPORTED_MODULE_16__["isEmpty"])(requirementsVersion) && Object(_helpers__WEBPACK_IMPORTED_MODULE_16__["isEmpty"])(analyticsReqVersion) || Object(_helpers__WEBPACK_IMPORTED_MODULE_16__["isNil"])(requirementsVersion) && Object(_helpers__WEBPACK_IMPORTED_MODULE_16__["isNil"])(requirementsVersion))) {
                _context2.next = 8;
                break;
              }
              errorMessage = "There was an error initializing Helix: Missing requirements version";
              this.log.error(errorMessage);
              this.helixError.reportError(_utils_helixError__WEBPACK_IMPORTED_MODULE_18__["ErrorCodes"].INVALID_REQUIREMENTS, config, errorMessage);
              throw new Error(errorMessage);
            case 8:
              // Ensure requirementsVersion is a string
              config.requirementsVersion = String(requirementsVersion);
              _context2.prev = 9;
              this.setupTabId();
              this.setupInitialLibraryState(config);
              this.config = _objectSpread(_objectSpread({}, config), this.getDefaultConfig(config));
              this.log.info('💈 Initializing....', {
                config: config,
                enrichedConfig: this.config
              });

              // Fetch events
              _context2.next = 16;
              return this.fetchEvents(this.config);
            case 16:
              _context2.next = 23;
              break;
            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](9);
              errorResponse = _context2.t0 && _context2.t0.responseText ? _context2.t0.responseText : _context2.t0;
              _errorMessage = "There was an error initializing Helix: ".concat(errorResponse);
              if (_errorMessage.includes('Missing requirements version')) {
                consoleMessage = "\uD83D\uDED1 ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].red, "AN-").concat(_utils_helixError__WEBPACK_IMPORTED_MODULE_18__["ErrorCodes"].INVALID_REQUIREMENTS, ":").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white, " ").concat(errorResponse);
                this.log.error(consoleMessage);
                this.helixError.reportError(_utils_helixError__WEBPACK_IMPORTED_MODULE_18__["ErrorCodes"].INVALID_REQUIREMENTS, this.config, _errorMessage);
              } else {
                _consoleMessage = "\uD83D\uDED1 ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].red, "AN-").concat(_utils_helixError__WEBPACK_IMPORTED_MODULE_18__["ErrorCodes"].INIT, " (There was an error initializing Helix):").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white, " ").concat(errorResponse);
                this.log.error(_consoleMessage);
                this.helixError.reportError(_utils_helixError__WEBPACK_IMPORTED_MODULE_18__["ErrorCodes"].INIT, this.config, _errorMessage);
              }
            case 23:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[9, 18]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
    /**
     * if events are more than one hour old, they will be ignored
     * @param  {Number} timestamp the value from the message.timestamp field
     * @return  {Boolean} true if the message was generated more than an hour ago
     */
  }, {
    key: "isExpiredPendingEvent",
    value: function isExpiredPendingEvent(timestamp) {
      var expireDate = Date.now() - 1000 * 60 * 60; // 1 hour TTL
      return timestamp < expireDate;
    }

    /**
     * Store the queued events that have not been tracked yet
     * @param   {[type]} [pendingEvent={}] array of pending events
     * @return  {void}
     */
  }, {
    key: "setPendingEventsToStorage",
    value: function setPendingEventsToStorage(pendingEvents) {
      try {
        LOCAL_STORAGE.setItem(PENDING_EVENTS_KEY, JSON.stringify(pendingEvents));
      } catch (error) {
        this.log.warn("".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].yellow, "Unable to add pending events to localStorage. Storing in memory..."), error);
        this.pendingEventsQueue = pendingEvents;
      }
    }

    /**
     * Get the queued events from localStorage that have not been tracked yet
     * if events are more than one hour old, they will be ignored
     * @return  {[type]} [pendingEvent={}] array of untracked events
     */
  }, {
    key: "getPendingEventsFromStorage",
    value: function getPendingEventsFromStorage() {
      var _this3 = this;
      try {
        var pendingEventsFromStorage = JSON.parse(LOCAL_STORAGE.getItem(PENDING_EVENTS_KEY) || '[]');
        var unexpiredPendingEvents = pendingEventsFromStorage.filter(function (event) {
          var _event$params$;
          var timestamp = ((_event$params$ = event.params[1]) === null || _event$params$ === void 0 ? void 0 : _event$params$.helixTrackStartTimestamp) || Date.now();
          return !_this3.isExpiredPendingEvent(timestamp);
        });
        if (pendingEventsFromStorage.length !== unexpiredPendingEvents.length) {
          this.setPendingEventsToStorage(unexpiredPendingEvents);
        }
        return unexpiredPendingEvents;
      } catch (error) {
        this.log.warn("".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].yellow, "Unable to get pending events from localStorage. Retrieving events stored in memory..."), error);
        return this.pendingEventsQueue;
      }
    }

    /**
     * Get the queued events that have not been tracked yet
     * if localStorage does not exist on the device, the events are stored in memory
     * if events in localStorage are more than one hour old, they will be ignored
     * @return  {[type]} [event={}] array of events in the queue
     */
  }, {
    key: "getPendingEventsQueue",
    value: function getPendingEventsQueue() {
      if (!LOCAL_STORAGE) {
        return this.pendingEventsQueue;
      }
      return this.getPendingEventsFromStorage();
    }

    /**
     * Queue the events until library is ready to track..
     * if startSession is asked to push to queue, it is stored separately.
     * @param  {[type]} [eventId=''] eventId used to track analytics
     * @param  {[type]} rest    rest of the arguments passed along with the eventId
     */
  }, {
    key: "updateQueue",
    value: function updateQueue() {
      var eventId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!this.enableAnalytics) {
        return;
      }
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      if (eventId.indexOf('startSession') > -1) {
        this.pendingStartSessionParams = {
          id: eventId,
          params: rest
        };
      } else {
        if (LOCAL_STORAGE) {
          var eventsFromStorage = this.getPendingEventsFromStorage();
          var updatedEvents = [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(eventsFromStorage), [{
            id: eventId,
            params: rest
          }]);
          this.setPendingEventsToStorage(updatedEvents);
        } else {
          this.pendingEventsQueue.push({
            id: eventId,
            params: rest
          });
        }
        this.log.info("Adding to ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].yellow, "queue").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green, "..."), {
          pendingEventsQueue: this.getPendingEventsQueue()
        });
      }
    }

    /**
     * Loops thorough every object in the queue and calls the track method with arguments.
     * Empty queue once all pending events are tracked
     * Increase the maxEventsPerSecond if less the current queue size
     * @return {[type]} [description]
     */
  }, {
    key: "releaseQueue",
    value: function () {
      var _releaseQueue = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee3() {
        var _this4 = this;
        var pendingEventsQueue, queueSize, maxEventsPerSecond, tempMaxEventsPerSecond, newMaxEventsPerSecond;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              pendingEventsQueue = this.getPendingEventsQueue();
              queueSize = pendingEventsQueue.length || 0;
              if (!(queueSize === 0 || !this.analytics)) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              maxEventsPerSecond = this.analytics.get('maxEventsPerSecond');
              this.log.info("Releasing ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].yellow).concat(queueSize).concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green, " queue events..."), pendingEventsQueue);
              tempMaxEventsPerSecond = queueSize < 100 ? queueSize + 5 : 100;
              if (maxEventsPerSecond < queueSize) {
                this.log.info("".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].red, "\u26A0\uFE0F Increasing ").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green, "maxEventsPerSecond during release Queue from ").concat(maxEventsPerSecond, " to ").concat(tempMaxEventsPerSecond));
                this.analytics.set('maxEventsPerSecond', tempMaxEventsPerSecond);
              }
              if (!this.isReleasingQueue) {
                _context3.next = 10;
                break;
              }
              return _context3.abrupt("return");
            case 10:
              this.isReleasingQueue = true;
              pendingEventsQueue.forEach(function (e) {
                return _this4.track.apply(_this4, [e.id].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(e.params)));
              });
              this.emptyQueue();
              this.isReleasingQueue = false;

              // check if maxEventsPerSecond setting is changed during the execution of this function
              newMaxEventsPerSecond = this.analytics.get('maxEventsPerSecond');
              if (this.analytics.get('maxEventsPerSecond') === tempMaxEventsPerSecond) {
                this.log.info("Resetting maxEventsPerSecond post releaseQueue to previous value: ".concat(maxEventsPerSecond));
                this.analytics.set('maxEventsPerSecond', maxEventsPerSecond);
              } else if (newMaxEventsPerSecond > maxEventsPerSecond) {
                this.log.info("Resetting maxEventsPerSecond post releaseQueue to updated value: ".concat(newMaxEventsPerSecond));
                this.analytics.set('maxEventsPerSecond', newMaxEventsPerSecond);
              }
              _context3.next = 18;
              return this.analytics.flush();
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function releaseQueue() {
        return _releaseQueue.apply(this, arguments);
      }
      return releaseQueue;
    }()
    /**
     * Reset the queue array.
     */
  }, {
    key: "emptyQueue",
    value: function emptyQueue() {
      if (LOCAL_STORAGE) {
        this.setPendingEventsToStorage([]);
      }
      this.pendingEventsQueue = [];
    }
  }, {
    key: "getDefaultConfig",
    value: function getDefaultConfig(config) {
      try {
        var noFetchDefaultData = config.noFetchDefaultData;
        var configuration = noFetchDefaultData ? config : Object(_defaultData__WEBPACK_IMPORTED_MODULE_13__["default"])(config);
        var domain = configuration.domain,
          appEnvName = configuration.appEnvName,
          _configuration$settin = configuration.settings,
          settings = _configuration$settin === void 0 ? {} : _configuration$settin;
        var logLevel = configuration.logLevel || settings.logLevel || _Logger__WEBPACK_IMPORTED_MODULE_15__["LOG"].ERROR;
        // on Prod set level to error only
        var setLogLevel = appEnvName === _defaultData__WEBPACK_IMPORTED_MODULE_13__["ENV"].PROD ? _Logger__WEBPACK_IMPORTED_MODULE_15__["LOG"].CRITICAL : logLevel;
        configuration.logLevel = setLogLevel;
        // set the log level if passed 'logLevel' in settings
        if (this.log) this.log.setLevel(setLogLevel);
        // Update the library log level as well based on the settings.
        if (this.analytics && this.analytics.log) this.analytics.log.setLevel(setLogLevel);
        // auto select the local storage if developer fails to choose persistence
        if (typeof window !== 'undefined' && this.persistence === null && !noFetchDefaultData) {
          this.log.debug("Auto set Persistence");
          this.enablePersistence();
        }
        if (!this.endpoint && domain && appEnvName) {
          var endpoint = Object(_defaultData__WEBPACK_IMPORTED_MODULE_13__["getCollectorEndpoint"])(domain, appEnvName);
          this.log.debug("Setting collector endpoint: ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white).concat(domain, " ").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].BgGreen).concat(appEnvName), {
            domain: domain,
            appEnvName: appEnvName,
            endpoint: endpoint
          });
          this.set('endpoint', endpoint);
        }
        return configuration;
      } catch (e) {
        return _objectSpread({
          customer: 'Charter',
          appType: 'Web',
          msgTriggeredBy: 'user',
          logLevel: _Logger__WEBPACK_IMPORTED_MODULE_15__["LOG"].ERROR
        }, config);
      }
    }
  }, {
    key: "validateEID",
    value: function validateEID(data) {
      try {
        var _data$decodedEID = data.decodedEID,
          decodedEID = _data$decodedEID === void 0 ? {} : _data$decodedEID,
          adHocDataIn = data.adHocDataIn,
          adHocDataOut = data.adHocDataOut,
          _data$optionsOut = data.optionsOut,
          optionsOut = _data$optionsOut === void 0 ? [] : _data$optionsOut,
          optionsIn = data.optionsIn,
          eid = data.eid,
          sdkMethod = data.sdkMethod,
          _data$helixWarnings = data.helixWarnings,
          helixWarnings = _data$helixWarnings === void 0 ? [] : _data$helixWarnings;
        var overwrite = JSON.parse(LOCAL_STORAGE ? LOCAL_STORAGE.getItem(_storage__WEBPACK_IMPORTED_MODULE_12__["STORAGE_KEYS"].DEBUGGER) : '{}') || {};
        if (!Object(_helpers__WEBPACK_IMPORTED_MODULE_16__["isEmpty"])(overwrite)) this.changeLogLevel(overwrite);
        var _this$config$logLevel = this.config.logLevel,
          logLevel = _this$config$logLevel === void 0 ? _Logger__WEBPACK_IMPORTED_MODULE_15__["LOG"].ERROR : _this$config$logLevel;
        if (logLevel === _Logger__WEBPACK_IMPORTED_MODULE_15__["LOG"].INFO || logLevel === _Logger__WEBPACK_IMPORTED_MODULE_15__["LOG"].DEBUG || logLevel === _Logger__WEBPACK_IMPORTED_MODULE_15__["LOG"].WARN) {
          var preFilled = Object(_helpers__WEBPACK_IMPORTED_MODULE_16__["removeNullEntries"])(decodedEID);
          for (var _i = 0, _Object$entries = Object.entries(adHocDataIn); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];
            var validValue = decodedEID[key] || null;
            var stringifiedValue = Object(_helpers__WEBPACK_IMPORTED_MODULE_16__["stringify"])(value);
            var stringifiedNewValue = Object(_helpers__WEBPACK_IMPORTED_MODULE_16__["stringify"])(validValue);
            if (key in decodedEID && stringifiedNewValue != stringifiedValue && validValue) {
              helixWarnings.push("\u26A0\uFE0F adHocData ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].yellow, " pre-filled value change | ").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green, "property: ").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].magenta).concat(key, " ").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green, " value: ").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].red).concat(stringifiedValue, " ").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green, "newValue: ").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].cyan).concat(stringifiedNewValue).concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green, " EID:").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].cyan, " ").concat(eid));
            }
          }
          var eidColor = helixWarnings.length ? _colors__WEBPACK_IMPORTED_MODULE_14__["default"].yellow : _colors__WEBPACK_IMPORTED_MODULE_14__["default"].green;
          var warningMessage = helixWarnings.length ? "".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].red, "(").concat(helixWarnings.length, " ").concat(helixWarnings.length === 1 ? 'warning' : 'warnings', ")") : '';
          this.log.warn("\uD83C\uDF10 Tracked:".concat(eidColor, " ").concat(eid, " ").concat(warningMessage, " | ").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].cyan, " ").concat(sdkMethod), {
            decoded_EID: decodedEID,
            preFilled: preFilled,
            adHocDataIn: adHocDataIn,
            adHocDataOut: adHocDataOut,
            optionsOut: optionsOut,
            optionsIn: optionsIn,
            helixWarnings: helixWarnings
          });
        }
      } catch (e) {
        this.log.warn('Error validating properties', e);
      }
    }

    /**
     * Changes the configuration of Quantum at run time.
     *  Steps:
     *    Pass the values via the cfg_XXX.json file
     * @param  {Object} [data={}]  [any valid configuration property and forceLogInfo to change the log level ]
      */
  }, {
    key: "resetConfiguration",
    value: function resetConfiguration(data) {
      var _this5 = this;
      try {
        Object.keys(data).map(function (key) {
          if (['enableAnalytics', 'configCheckHeartbeatSeconds'].includes(key) && data[key] !== _this5.customConfig[key]) {
            // skip these they are handle else where
            _this5.customConfig[key] = data[key];
          } else if (data[key] !== _this5.customConfig[key]) {
            _this5.log.info("\uD83D\uDECE\uFE0F  Resetting configuration ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green).concat(key, ": ").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].cyan).concat(data[key]));
            _this5.set(key, data[key]);
          }
          _this5.customConfig[key] = data[key];
        });
      } catch (e) {
        this.log.critical('Error', e);
      }
    }

    /**
     * Changes the log level of Quantum at run time.
     *  Steps:
     *    Pass the values via local storage under "library-debugger
     *    Pass the values via the cfg_XXX.json file
     *    Called on every track call
      * @param  {Object} [data={}]  [any valid configuration property and forceLogInfo to change the log level ]
      */
  }, {
    key: "changeLogLevel",
    value: function changeLogLevel(data) {
      var _data$forceLogInfo = data.forceLogInfo,
        forceLogInfo = _data$forceLogInfo === void 0 ? false : _data$forceLogInfo;
      var setLogLevel = _Logger__WEBPACK_IMPORTED_MODULE_15__["levels"][forceLogInfo] ? forceLogInfo : _Logger__WEBPACK_IMPORTED_MODULE_15__["LOG"].INFO;
      try {
        if (forceLogInfo && this.config.logLevel !== setLogLevel) {
          this.config.logLevel = setLogLevel;
          // set the log level if passed 'logLevel' in settings
          if (this.log) this.log.setLevel(setLogLevel);
          // Update the library log level as well based on the settings.
          if (this.analytics && this.analytics.log) this.analytics.log.setLevel(setLogLevel);
          this.log.info("\uD83D\uDECE\uFE0F  Overtiring ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green, " LogLevel: ").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].cyan).concat(setLogLevel, "  "));
        }
      } catch (e) {
        this.log.critical('Error', e);
      }
    }
  }]);
  return Analytics;
}(_events__WEBPACK_IMPORTED_MODULE_11__["default"]);


/***/ }),

/***/ "./src/utils/colors.js":
/*!*****************************!*\
  !*** ./src/utils/colors.js ***!
  \*****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  black: '\x1b[30m',
  red: '\x1b[31m',
  green: '\x1b[32m',
  yellow: '\x1b[33m',
  blue: '\x1b[34m',
  magenta: '\x1b[35m',
  cyan: '\x1b[36m',
  white: '\x1b[37m',
  Reset: '\x1b[0m',
  BgBlack: '\x1b[40m',
  BgRed: '\x1b[41m',
  BgGreen: '\x1b[42m',
  BgYellow: '\x1b[43m',
  BgBlue: '\x1b[44m',
  BgMagenta: '\x1b[45m',
  BgCyan: '\x1b[46m',
  BgWhite: '\x1b[47m'
});

/***/ }),

/***/ "./src/utils/constants.js":
/*!********************************!*\
  !*** ./src/utils/constants.js ***!
  \********************************/
/*! exports provided: C */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return C; });
var C = Object.freeze({
  GPCCookie: 'PersistGPC',
  HelixMaxEventsPerSecond: 'HelixMaxEventsPerSecond'
});

/***/ }),

/***/ "./src/utils/defaultData.js":
/*!**********************************!*\
  !*** ./src/utils/defaultData.js ***!
  \**********************************/
/*! exports provided: DOMAIN, ENV, COLLECTOR_URL, state, getUAParser, getDevice, getOS, getFormFactor, getDeviceOperatingSystem, getDeviceType, generatedUUIDV4, getQueryParam, getAppReferrer, getEnvironmentByUrl, getCollectorEnvironment, getCollectorEndpoint, getCurrentBrowserWidth, getCurrentBreakpoint, getCampaignId, getReferrerAppVisitId, getReferrerAppName, getReferrerAppType, getReferrerAppDeviceId, getReferrerAppCommonToken, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMAIN", function() { return DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENV", function() { return ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLLECTOR_URL", function() { return COLLECTOR_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUAParser", function() { return getUAParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDevice", function() { return getDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOS", function() { return getOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFormFactor", function() { return getFormFactor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDeviceOperatingSystem", function() { return getDeviceOperatingSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDeviceType", function() { return getDeviceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generatedUUIDV4", function() { return generatedUUIDV4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryParam", function() { return getQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAppReferrer", function() { return getAppReferrer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEnvironmentByUrl", function() { return getEnvironmentByUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCollectorEnvironment", function() { return getCollectorEnvironment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCollectorEndpoint", function() { return getCollectorEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentBrowserWidth", function() { return getCurrentBrowserWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentBreakpoint", function() { return getCurrentBreakpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCampaignId", function() { return getCampaignId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReferrerAppVisitId", function() { return getReferrerAppVisitId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReferrerAppName", function() { return getReferrerAppName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReferrerAppType", function() { return getReferrerAppType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReferrerAppDeviceId", function() { return getReferrerAppDeviceId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReferrerAppCommonToken", function() { return getReferrerAppCommonToken; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _uaParser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./uaParser */ "./src/utils/uaParser.js");
/* harmony import */ var _uuid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./uuid */ "./src/utils/uuid.js");
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./storage */ "./src/utils/storage.js");
/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Logger */ "./src/utils/Logger.js");

var _DOMAIN$PORTALS, _DOMAIN$VIDEO, _DOMAIN$INTERNAL, _Object$freeze;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var DOMAIN = Object.freeze({
  PORTALS: 'portals',
  VIDEO: 'video',
  INTERNAL: 'internal_apps'
});
var ENV = Object.freeze({
  PROD: 'prod',
  STAGING: 'staging',
  LOCAL: 'local'
});
var COLLECTOR_URL = Object.freeze((_Object$freeze = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_Object$freeze, DOMAIN.PORTALS, (_DOMAIN$PORTALS = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_DOMAIN$PORTALS, ENV.PROD, 'https://sspp-ingest.pi.spectrum.net/topics/sspp?bulk=true'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_DOMAIN$PORTALS, ENV.STAGING, 'https://sspp-ingest.pi-charter.net/topics/sspp?bulk=true'), _DOMAIN$PORTALS)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_Object$freeze, DOMAIN.VIDEO, (_DOMAIN$VIDEO = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_DOMAIN$VIDEO, ENV.PROD, 'https://collector.pi.spectrum.net/api/collector?bulk=true'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_DOMAIN$VIDEO, ENV.STAGING, 'https://collector.pi-charter.net/api/collector?bulk=true'), _DOMAIN$VIDEO)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_Object$freeze, DOMAIN.INTERNAL, (_DOMAIN$INTERNAL = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_DOMAIN$INTERNAL, ENV.PROD, 'https://collector.pi.spectrum.net/topics/internal_quantum?bulk=true'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_DOMAIN$INTERNAL, ENV.STAGING, 'https://collector.pi-charter.net/topics/internal_quantum?bulk=true'), _DOMAIN$INTERNAL)), _Object$freeze));
var state = {
  agentParser: new _uaParser__WEBPACK_IMPORTED_MODULE_1__["default"](),
  config: {
    breakpoint: [3840, 2560, 1920, 1600, 1440, 1280, 960, 728, 600, 320]
  }
};
var getUAParser = function getUAParser() {
  return state.agentParser;
};
var getDevice = function getDevice() {
  return getUAParser().getDevice();
};
var getOS = function getOS() {
  return getUAParser().getOS();
};
var getFormFactor = function getFormFactor() {
  var detectedType = getDevice().type;
  switch (detectedType) {
    case 'mobile':
      return 'phone';
    case 'tablet':
      return 'tablet';
    default:
      return 'pc';
  }
};
var getDeviceOperatingSystem = function getDeviceOperatingSystem() {
  return "".concat(getOS().name, " ").concat(getOS().version);
};
var getDeviceType = function getDeviceType() {
  var detectedType = getDevice().type;
  var detectedOS = getOS().name;
  if (detectedOS === 'iOS') {
    if (detectedType === 'mobile') return 'iPhone';
    if (detectedType === 'tablet') return 'iPad';
    return 'iPod touch';
  }
  if (detectedOS === 'Android') {
    if (detectedType === 'mobile') return 'androidPhone';
    if (detectedType === 'tablet') return 'androidTablet';
    return 'androidPhone';
  }
  return 'webBrowser';
};
var getStorageValue = function getStorageValue(key) {
  return Object(_storage__WEBPACK_IMPORTED_MODULE_3__["fetchFromStorage"])(key);
};
var setStorageValue = function setStorageValue(key, value) {
  return Object(_storage__WEBPACK_IMPORTED_MODULE_3__["writeToStorage"])(key, value);
};
var generatedUUIDV4 = _uuid__WEBPACK_IMPORTED_MODULE_2__["default"];
var getDeviceUUIDV4 = function getDeviceUUIDV4() {
  var deviceIdKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'deviceUUID';
  if (getStorageValue(deviceIdKey)) {
    return getStorageValue(deviceIdKey);
  }
  var newUUIDV4 = Object(_uuid__WEBPACK_IMPORTED_MODULE_2__["default"])();
  setStorageValue(deviceIdKey, newUUIDV4);
  return newUUIDV4;
};
var getUUIDV4 = function getUUIDV4() {
  var deviceIdKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'deviceUUID';
  return getDeviceUUIDV4(deviceIdKey);
};
var getQueryParam = function getQueryParam(key) {
  var _window$location;
  var searchParams = typeof window !== 'undefined' ? ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.search) || '' : '';
  return new URLSearchParams(searchParams).get(key);
};
var getAppReferrer = function getAppReferrer() {
  var _document;
  var appReferrerParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['referrer', 'ref', 'src', 'url', 'from'];
  return appReferrerParams.map(getQueryParam).find(Boolean) || ((_document = document) === null || _document === void 0 ? void 0 : _document.referrer);
};
var getEnvironmentByUrl = function getEnvironmentByUrl() {
  var _window$location2;
  var host = typeof window !== 'undefined' ? ((_window$location2 = window.location) === null || _window$location2 === void 0 ? void 0 : _window$location2.host) || '' : '';
  if (host.includes('localhost')) return ENV.LOCAL;
  var stagingEnvironments = ['engnew', 'engprod', 'dev-', 'dev2-', 'mock-', 'qa-', 'stage-', 'development.', 'ci1-', 'engr', '.blue', 'pilot'];
  stagingEnvironments.forEach(function (env) {
    if (host.includes(env)) return ENV.STAGING;
  });
  return ENV.PROD;
};

// The collector endpoints are only split by prod and staging,
// so "local" will use the "staging" endpoint
var getCollectorEnvironment = function getCollectorEnvironment(env) {
  var environment = env || getEnvironmentByUrl();
  return environment === ENV.LOCAL ? ENV.STAGING : environment;
};
var getCollectorEndpoint = function getCollectorEndpoint() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var environment = arguments.length > 1 ? arguments[1] : undefined;
  var env = getCollectorEnvironment(environment);
  var _domain = domain || "video" || DOMAIN.VIDEO; // eslint-disable-line
  return COLLECTOR_URL[_domain][env];
};
var getScreenResolution = function getScreenResolution() {
  var _screen = typeof screen === 'undefined' ? {} : screen;
  return _screen.width + 'x' + _screen.height;
};
var getCurrentBrowserWidth = function getCurrentBrowserWidth() {
  return typeof window !== 'undefined' ? window.innerWidth : undefined;
};
var getCurrentBreakpoint = function getCurrentBreakpoint() {
  var _state$config;
  var width = getCurrentBrowserWidth();
  var breakpoints = (state === null || state === void 0 ? void 0 : (_state$config = state.config) === null || _state$config === void 0 ? void 0 : _state$config.breakpoint) || [];
  return breakpoints.find(function (value) {
    return value < width;
  });
};
var getCampaignId = function getCampaignId() {
  try {
    var _window$location3;
    var searchParams = typeof window !== 'undefined' ? ((_window$location3 = window.location) === null || _window$location3 === void 0 ? void 0 : _window$location3.search) || '' : '';
    var urlParams = new URLSearchParams(searchParams);
    return urlParams.get('cid') || urlParams.get('cmp') || '';
  } catch (err) {
    return '';
  }
};
var getReferrerAppVisitId = function getReferrerAppVisitId() {
  try {
    var _window$location4;
    var searchParams = typeof window !== 'undefined' ? ((_window$location4 = window.location) === null || _window$location4 === void 0 ? void 0 : _window$location4.search) || '' : '';
    var urlParams = new URLSearchParams(searchParams);
    if (urlParams.get('visitId')) return urlParams.get('visitId');
    if (urlParams.get('exVisitID')) return urlParams.get('exVisitID');
    return '';
  } catch (err) {
    return '';
  }
};
var getReferrerAppName = function getReferrerAppName() {
  try {
    var _window$location5;
    var searchParams = typeof window !== 'undefined' ? ((_window$location5 = window.location) === null || _window$location5 === void 0 ? void 0 : _window$location5.search) || '' : '';
    var urlParams = new URLSearchParams(searchParams);
    if (urlParams.get('referrerAppName')) return urlParams.get('referrerAppName');
    return '';
  } catch (err) {
    return '';
  }
};
var getReferrerAppType = function getReferrerAppType() {
  try {
    var _window$location6;
    var searchParams = typeof window !== 'undefined' ? ((_window$location6 = window.location) === null || _window$location6 === void 0 ? void 0 : _window$location6.search) || '' : '';
    var urlParams = new URLSearchParams(searchParams);
    if (urlParams.get('referrerAppType')) return urlParams.get('referrerAppType');
    return '';
  } catch (err) {
    return '';
  }
};
var getReferrerAppDeviceId = function getReferrerAppDeviceId() {
  try {
    var _window$location7;
    var searchParams = typeof window !== 'undefined' ? ((_window$location7 = window.location) === null || _window$location7 === void 0 ? void 0 : _window$location7.search) || '' : '';
    var urlParams = new URLSearchParams(searchParams);
    if (urlParams.get('referrerAppDeviceId')) return urlParams.get('referrerAppDeviceId');
    return '';
  } catch (err) {
    return '';
  }
};
var getReferrerAppCommonToken = function getReferrerAppCommonToken() {
  try {
    var _window$location8;
    var searchParams = typeof window !== 'undefined' ? ((_window$location8 = window.location) === null || _window$location8 === void 0 ? void 0 : _window$location8.search) || '' : '';
    var urlParams = new URLSearchParams(searchParams);
    if (urlParams.get('referrerAppCommonToken')) return urlParams.get('referrerAppCommonToken');
    return '';
  } catch (err) {
    return '';
  }
};
var fetchDefaultData = function fetchDefaultData() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  try {
    if (typeof window === 'undefined') return _objectSpread({
      customer: 'Charter',
      appType: 'Web',
      msgTriggeredBy: 'user',
      logLevel: _Logger__WEBPACK_IMPORTED_MODULE_4__["LOG"].ERROR
    }, config);
    var data = _objectSpread({
      customer: 'Charter',
      appType: 'Web',
      msgTriggeredBy: 'user',
      logLevel: _Logger__WEBPACK_IMPORTED_MODULE_4__["LOG"].ERROR,
      appRefLink: getAppReferrer(),
      appEnvName: getEnvironmentByUrl(),
      deviceFormFactor: getFormFactor(),
      deviceOperatingSystem: getDeviceOperatingSystem(),
      deviceUuid: getUUIDV4(),
      deviceType: getDeviceType(),
      uiResponsiveBreakpoint: getCurrentBreakpoint(),
      screenResolution: getScreenResolution(),
      campaignId: getCampaignId(),
      referrerAppVisitId: getReferrerAppVisitId(),
      referrerAppName: getReferrerAppName(),
      referrerAppType: getReferrerAppType(),
      referrerAppDeviceId: getReferrerAppDeviceId(),
      referrerAppCommonToken: getReferrerAppCommonToken()
    }, config);
    var removeEmpty = Object.keys(data).filter(function (k) {
      return data[k] != null;
    }).reduce(function (a, k) {
      return _objectSpread(_objectSpread({}, a), {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, k, data[k]));
    }, {});
    return removeEmpty;
  } catch (e) {
    return _objectSpread({
      customer: 'Charter',
      appType: 'Web',
      msgTriggeredBy: 'user',
      logLevel: _Logger__WEBPACK_IMPORTED_MODULE_4__["LOG"].ERROR
    }, config);
  }
};
/* harmony default export */ __webpack_exports__["default"] = (fetchDefaultData);

/***/ }),

/***/ "./src/utils/events.js":
/*!*****************************!*\
  !*** ./src/utils/events.js ***!
  \*****************************/
/*! exports provided: fetchFromS3OrError, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchFromS3OrError", function() { return fetchFromS3OrError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Events; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _charter_helix_extensions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @charter/helix-extensions */ "./node_modules/@charter/helix-extensions/dist/index.js");
/* harmony import */ var _charter_helix_extensions__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_charter_helix_extensions__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./storage */ "./src/utils/storage.js");
/* harmony import */ var _httpServices__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./httpServices */ "./src/utils/httpServices.js");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./helpers */ "./src/utils/helpers.js");
/* harmony import */ var _mappings__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mappings */ "./src/utils/mappings.js");
/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Logger */ "./src/utils/Logger.js");
/* harmony import */ var _urlMapping__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./urlMapping */ "./src/utils/urlMapping.js");
/* harmony import */ var _helixError__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./helixError */ "./src/utils/helixError.js");
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./colors */ "./src/utils/colors.js");





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











/**
 * Get from S3 or throw a FETCH_FILE error
 * @param  {Object} data The connection info
 * @return {Promise}     resolves with the result, otherwise errors
 */
var fetchFromS3OrError = /*#__PURE__*/function () {
  var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee(config, helixError) {
    var result, errorCode;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return Object(_httpServices__WEBPACK_IMPORTED_MODULE_8__["fetchS3"])(config, 11, 1000);
        case 3:
          result = _context.sent;
          return _context.abrupt("return", result);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          'Errror ';
          errorCode = Object.values(_helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorCodes"]).includes(_context.t0) ? _context.t0 : _helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorCodes"].FETCH_CONFIG_FILE;
          _Logger__WEBPACK_IMPORTED_MODULE_11__["default"].error("\uD83D\uDED1 ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].red, "AN-").concat(errorCode, " (").concat(_helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorMessages"][errorCode], "):").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white, " Failed to fetch from S3\n Please ensure you have the correct requirementsVersion, applicationName, and applicationType."));
          helixError.reportError(errorCode, config, _context.t0);
          return _context.abrupt("return", null);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return function fetchFromS3OrError(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var Events = /*#__PURE__*/function () {
  function Events() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Events);
    this.log = _Logger__WEBPACK_IMPORTED_MODULE_11__["default"];
    this.enableAnalytics = true;
    this.analyticsInitialized = false;
    this.events = {};
    this.eventCases = {};
    this.mappings = {};
    this.extensions = {};
    this.helixExtensionRules = [];
    this.config = {};
    this.helixError = new _helixError__WEBPACK_IMPORTED_MODULE_13__["default"](this.track.bind(this), this.allSetToTrack.bind(this), this.config);
  }

  /**
   * Override this method in Base class
   */
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Events, [{
    key: "track",
    value: function track() {
      this.log.debug('this is an abstract method. Override it in child');
    }

    /**
     * Override this method in Base class
     */
  }, {
    key: "allSetToTrack",
    value: function allSetToTrack() {
      this.log.debug('this is an abstract method. Override it in child');
    }

    /**
     * Override this method in Base class
     */
  }, {
    key: "set",
    value: function set() {
      this.log.debug('this is an abstract method. Override it in child');
    }

    /**
     * Override this method in analytics class
     */
  }, {
    key: "getPendingEventsQueue",
    value: function getPendingEventsQueue() {
      this.log.debug('this is an abstract method. Override it in child');
    }

    /**
     * Clear the pending events when analytics is disabled
     * @param  {Boolean} [value=true] false to disable analytics. true to enable
     */
  }, {
    key: "enableAnalytics",
    get:
    /**
     * @return {Boolean} Wheter analytics is enabled or not
     */
    function get() {
      return this._enableAnalytics;
    }

    /**
     * if events is not an empty object, assign events to memory variable and set eventsLoaded to true
     * if startSession is in queue then trigger the startSession.
     * @param  {Object} [events] events object
     */,
    set: function set(value) {
      var val = value || value === false ? value : true;
      this._enableAnalytics = val;
      if (!val && this.getPendingEventsQueue().length) {
        this.emptyQueue();
      }
    }

    /**
     * Checks if events are loaded and tracker manager is initialized with events
     * @return {boolean} true if events loaded
     */
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "eventsLoaded",
    get: function get() {
      return !Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["isEmpty"])(this.eventCases);
    }
  }, {
    key: "events",
    set: function set(json) {
      if (Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["isEmpty"])(json)) {
        return;
      }
      this.log.debug('calling tracker manager init');
      this.hydrateEventCases(json);
      this.hydrateMappings(json);
      var pendingStartSession = this.pendingStartSessionParams;
      if (!this.reqFetchStop) {
        this.reqFetchStop = Date.now();
      }
      if (pendingStartSession) {
        this.log.info('Set events: Tracking start session.');
        this.trackStartSession.apply(this, [pendingStartSession.id].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(pendingStartSession.params)));
      }
    }

    /**
     * hydrate Events from the requirements file
     * add properties to the event cases from the event types
     *
     eventTypes: {
      applicationPerformance: {
        "opType": null,
        "eventCaseId": null,
       },
      ...
     eventCases:{
    "SPECTRUM_applicationPerformance_appInit_toPreAuth": {
    	"opType": "appInit_toPreAuth",
    	"eventType": "applicationPerformance"
        "eventCaseId": SPECTRUM_applicationPerformance_appInit_toPreAuth
    },
      ...}
      */
  }, {
    key: "hydrateEventCases",
    value: function hydrateEventCases(json) {
      var eventTypes = json.eventTypes,
        eventCases = json.eventCases;
      var hydratedEventCases = {};
      for (var eventCaseKey in eventCases) {
        var eventCase = eventCases[eventCaseKey];
        var eventType = eventTypes[eventCase.eventType];
        hydratedEventCases[eventCaseKey] = _objectSpread(_objectSpread(_objectSpread({}, eventType), eventCase), {}, {
          eventCaseId: eventCaseKey
        });
      }
      this.eventCases = hydratedEventCases;
    }
    /**
     * Load the Quantum and Unified key mappings
     */
  }, {
    key: "hydrateMappings",
    value: function hydrateMappings(json) {
      var eventTypes = json.eventTypes;
      var mappings = this.mappings;
      for (var eventType in eventTypes) {
        for (var unifiedKey in eventTypes[eventType]) {
          mappings[unifiedKey] = _mappings__WEBPACK_IMPORTED_MODULE_10__["keyMappings"][unifiedKey] || unifiedKey;
        }
      }
      this.mappings = mappings;
      return this.mappings;
    }
    /**
     * Override this from tracker class
     */
  }, {
    key: "trackStartSession",
    value: function trackStartSession() {
      this.analyticsInitialized = true;
    }
  }, {
    key: "getEventCase",
    value: function getEventCase(eventCaseId) {
      var generic = "generic_".concat(eventCaseId, "_").concat(Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["lowercase"])(this.getClientDomain(this.config)));
      return this.eventCases[generic] || this.eventCases[eventCaseId] || null;
    }

    /**
     * Merges the input mapValues(adHoc in) and eventCase properties, and maps the properties based on defined mappings.
     * @param  {Object} mapValues Input values to be mapped
     * @param  {Object} eventCase Event data
     * @return {Object} Parameters with mapped keys and merged values, along with any warnings
     */
  }, {
    key: "getMappedValues",
    value: function getMappedValues(mapValues, eventCase) {
      var _this = this;
      var mergedValues = _objectSpread(_objectSpread({}, mapValues), eventCase);
      return Object.keys(mergedValues).reduce(function (mappedValues, unifiedKey) {
        var _ref2;
        var prefilledValue = eventCase && !Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["isNil"])(eventCase[unifiedKey]) ? eventCase[unifiedKey] : null;
        var value = (_ref2 = prefilledValue !== null && prefilledValue !== void 0 ? prefilledValue : mapValues[unifiedKey]) !== null && _ref2 !== void 0 ? _ref2 : null; // replace the value with the pre-filled value if it exists
        var key = _this.mappings[unifiedKey] || unifiedKey; // replace the Unified key  with the Quantum Key if they differ
        // only populate values that are in the event case and is not empty
        if (unifiedKey in eventCase && !Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["isNil"])(value) && !Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["isEmpty"])(value)) {
          mappedValues[key] = value;
        } else if (!(unifiedKey in eventCase) && !(unifiedKey in _this.config) && unifiedKey !== 'msgEventType') {
          var warningMessage = ["".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white, "\u26A0\uFE0F adHocData"), "".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].yellow, "discarded property |"), "".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green, "property:").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].magenta, " ").concat(unifiedKey), "".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green, " value:").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white).concat(mapValues[unifiedKey])].join(' ');
          mappedValues.helixWarnings.push(warningMessage);
        }
        return mappedValues;
      }, {
        helixWarnings: []
      });
    }

    /**
     * Compares the hash of the local and remote specs file.
     * Returns true if updated specs should be fetched from remote.
     */
  }, {
    key: "fetchEvents",
    value:
    /**
     * Fetch events from storage, S3 and local in relevant phases.
     * Disable analytics if failed to fetch events.
     * @param  {Object}  config config passed to init. Used to fetch events
     */
    function () {
      var _fetchEvents = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee2(config) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.eventsLoaded) {
                _context2.next = 8;
                break;
              }
              this.reqFetchStart = Date.now();
              _context2.next = 4;
              return this.fetchConfigFromS3(config);
            case 4:
              this.log.debug("fetched config, fetching from storage. eventsLoaded: ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white).concat(this.eventsLoaded));
              this.fetchFromStorage(config);
              this.log.debug("fetchFromStorage eventsLoaded: ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white).concat(this.eventsLoaded));
              this.reqFetchStop = Date.now();
            case 8:
              if (!this.eventsLoaded) {
                this.enableAnalytics = false;
                this.log.error('Cannot get events from remote or local. Analytics have been disabled!');
              }
              this.fetchEventsComplete();
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchEvents(_x3) {
        return _fetchEvents.apply(this, arguments);
      }
      return fetchEvents;
    }()
    /**
     * Override this method from inheriting class
     */
  }, {
    key: "fetchEventsComplete",
    value: function fetchEventsComplete() {
      this.config.fetchEventsCompleted = true;
    }

    /**
     * If this.events is not empty object, return true. Stop further processing.
     * Fetch events from storage, if the requirementsVersion is same as the one from config,
     *      assign events, mappings and return true.
     * If the value is Nil or not an object or if requirementsVersion does not match from config,
     *      return false.
     * @param  {Object} [config=this.config] config passed to init.
     * @return {Boolean}
     */
  }, {
    key: "fetchFromStorage",
    value: function fetchFromStorage(config) {
      if (this.eventsLoaded) {
        return true;
      }
      var value = Object(_storage__WEBPACK_IMPORTED_MODULE_7__["fetchFromStorage"])(_storage__WEBPACK_IMPORTED_MODULE_7__["STORAGE_KEYS"].REQUIREMENTS);
      if (!Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["isNil"])(value) && Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["isObject"])(value) && value.requirementsVersion === config.requirementsVersion) {
        var data = value.data || {};
        this.log.debug("RequirementsVersion fetch from storage: ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].cyan, " SUCCESS"));
        return this.setData(data, 'local');
      }
      return false;
    }

    /**
     * load the requirements data to memory
     * @method setData
     * @param  {Object} [src] Object with the requirements and the source local or remote
     */
  }, {
    key: "setData",
    value: function setData(data, src) {
      if (Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["validRequirementsResponse"])(data)) {
        var _data$extensions;
        this.analyticsReqSource = src;
        this.urlMappings = data['url-mappings'];
        this.sortedUrlMappingKeys = Object(_urlMapping__WEBPACK_IMPORTED_MODULE_12__["getSortedUrlMappingKeys"])(data['url-mappings']);
        var extensions = data.extensions;
        this.extensions = extensions;
        if (extensions && data.extensions.rules) {
          var _extensions$rules = extensions.rules,
            rules = _extensions$rules === void 0 ? [] : _extensions$rules;
          var size = rules.length || 0;
          this.log.info("\uD83D\uDCD6 Found ".concat(size, " legacy extension rules "), rules);
          this.expressions = data.extensions.rules;
        }
        if (extensions && data !== null && data !== void 0 && (_data$extensions = data.extensions) !== null && _data$extensions !== void 0 && _data$extensions.helixExtensionRules) {
          var _data$extensions$heli = data.extensions.helixExtensionRules,
            helixExtensionRules = _data$extensions$heli === void 0 ? [] : _data$extensions$heli;
          var _size = helixExtensionRules.length || 0;
          this.log.info("\uD83D\uDCD6 Found ".concat(_size, " V2 helix extension rules "));
          this.helixExtensionRules = helixExtensionRules;
        }
        this.events = data;
        this.log.debug("Using events from ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white).concat(src));
        var _data$metadata = data.metadata,
          _data$metadata2 = _data$metadata === void 0 ? {} : _data$metadata,
          domain = _data$metadata2.domain;
        this.setClientDomain(domain);
        return true;
      }
      return false;
    }

    /**
     * Given a set of String Array of Rules. Process Expressions
     * @param {String[]} rules - arry list of rul;es
     * @return {String} New object of key:value pairs
     */
  }, {
    key: "expressions",
    get:
    /**
     * @return {any} Expressions processed from String Array of Rules
     */
    function get() {
      return this._expressions;
    },
    set: function set(rules) {
      var _this2 = this;
      if (rules) {
        this.log.debug('Found rules to parse');
        var expressions = [];
        rules.map(function (rule) {
          try {
            var exp = new _charter_helix_extensions__WEBPACK_IMPORTED_MODULE_6__["Expression"]();
            exp.parse(rule);
            if (exp) expressions.push(exp);
          } catch (e) {
            _this2.log.info('🛑 Invalid rule found', {
              e: e,
              rule: rule
            });
            _this2.helixError.reportError(_helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorCodes"].PARSE_RULES, _this2.config, e);
          }
        });
        this._expressions = expressions;
        this.log.debug('Rules parsed into Expressions');
      }
    }
  }, {
    key: "fetchConfigFromS3",
    value: function () {
      var _fetchConfigFromS = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee3(config) {
        var _this3 = this;
        var clonedConfig, result, json, errorCode;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              clonedConfig = Object.assign({}, config, {
                requirementsVersion: "cfg_".concat(config === null || config === void 0 ? void 0 : config.requirementsVersion)
              });
              _context3.next = 3;
              return fetchFromS3OrError(clonedConfig, this.helixError);
            case 3:
              result = _context3.sent;
              if (!result) {
                _context3.next = 27;
                break;
              }
              _context3.prev = 5;
              json = JSON.parse(result);
              this.resetConfiguration(json.config);
              clonedConfig.specsHash = json.specsHash;
              Object.assign(clonedConfig, json.config);
              delete clonedConfig.requirementsVersion; // prevent overwriting original requirements version
              this.config = Object.assign({}, config, clonedConfig);
              if (!Events.shouldFetchSpecs(this.config)) {
                _context3.next = 17;
                break;
              }
              this.log.info("".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].green, "fetching from S3"));
              _context3.next = 16;
              return this.fetchFromS3(this.config, true);
            case 16:
              this.log.info("fetchFromS3. eventsLoaded:".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white, " ").concat(this.eventsLoaded));
            case 17:
              this.set('requirementsHash', {
                analyticsHash: this.config.specsHash
              });
              if (this.config && this.config.configCheckHeartbeatSeconds) {
                setTimeout(function () {
                  return (
                    // Timeout should be heartbeat or 10 minutes (600 seconds) by default
                    _this3.fetchConfigFromS3(_this3.config)
                  );
                }, this.config.configCheckHeartbeatSeconds * 1000 || 600000);
              }
              this.log.info("fetchConfigFromS3. eventsLoaded: ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white).concat(this.eventsLoaded));
              _context3.next = 27;
              break;
            case 22:
              _context3.prev = 22;
              _context3.t0 = _context3["catch"](5);
              errorCode = _helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorCodes"].PARSE_CONFIG;
              this.log.error("\uD83D\uDED1 ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].red, "AN-").concat(errorCode, " (").concat(_helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorMessages"][errorCode], "):").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white, "\n ").concat(_context3.t0));
              this.helixError.reportError(errorCode, config, _context3.t0);
            case 27:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[5, 22]]);
      }));
      function fetchConfigFromS3(_x4) {
        return _fetchConfigFromS.apply(this, arguments);
      }
      return fetchConfigFromS3;
    }()
    /**
     * If this.events is not empty object, return true. Stop further processing.
     * Fetch events from S3, if the response is valid, assign events, mappings and return true.
     * If the data is not valid, return false.
     * If XHR failed, return false.
     * @param  {Object} [config] config passed to init.
     * @return {Boolean}
     */
  }, {
    key: "fetchFromS3",
    value: function () {
      var _fetchFromS = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee4(config, force) {
        var result, json, errorCode, additionalMessage, valueToStore, _errorCode;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.log.debug("Events fetchFromS3. eventsLoaded: ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white).concat(this.eventsLoaded));
              if (!(this.eventsLoaded && !force)) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              _context4.next = 5;
              return fetchFromS3OrError(config, this.helixError);
            case 5:
              result = _context4.sent;
              if (result) {
                try {
                  json = JSON.parse(result);
                  if (!Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["validRequirementsResponse"])(json)) {
                    errorCode = _helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorCodes"].INVALID_SPEC_FILE;
                    additionalMessage = 'Failed to load data from S3: Invalid data.';
                    this.log.error("\uD83D\uDED1 ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].red, "AN-").concat(errorCode, " (").concat(_helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorMessages"][errorCode], "):").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white, "\n ").concat(additionalMessage));
                    this.helixError.reportError(errorCode, config, additionalMessage);
                  }
                  this.analyticsReqSource = 'remote';
                  this.setData(json, 'remote');
                  valueToStore = JSON.stringify({
                    requirementsVersion: config.requirementsVersion,
                    data: json,
                    specsHash: config.specsHash ? config.specsHash : 0
                  });
                  Object(_storage__WEBPACK_IMPORTED_MODULE_7__["writeToStorage"])(_storage__WEBPACK_IMPORTED_MODULE_7__["STORAGE_KEYS"].REQUIREMENTS, valueToStore);
                  this.log.debug("Using events from S3. eventsLoaded: ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white).concat(this.eventsLoaded));
                } catch (err) {
                  _errorCode = _helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorCodes"].PARSE_SPEC;
                  this.log.error("\uD83D\uDED1 ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].red, "AN-").concat(_errorCode, " fetchFromS3 (").concat(_helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorMessages"][_errorCode], "):").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white, "\n ").concat(err));
                  this.helixError.reportError(_errorCode, config, err);
                }
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchFromS3(_x5, _x6) {
        return _fetchFromS.apply(this, arguments);
      }
      return fetchFromS3;
    }()
    /**
     * If this.events is not empty object, return true. Stop further processing.
     * Fetch events from URL, if the response is valid, assign events, mappings and return true.
     * If the data is not valid, return false.
     * If XHR failed, return false.
     * @param  {Object} [config=this.config] config passed to init.
     * @return {Boolean}
     */
  }, {
    key: "fetchFromLocal",
    value: function () {
      var _fetchFromLocal = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee5() {
        var config,
          json,
          errorCode,
          additionalMessage,
          _args5 = arguments;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              config = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : this.config;
              if (!this.eventsLoaded) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return", true);
            case 3:
              _context5.prev = 3;
              _context5.next = 6;
              return Object(_httpServices__WEBPACK_IMPORTED_MODULE_8__["fetchFromUrl"])(config.defaultEvents);
            case 6:
              json = _context5.sent;
              if (!Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["validRequirementsResponse"])(json)) {
                errorCode = _helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorCodes"].INVALID_SPEC_FILE;
                additionalMessage = 'Failed to load data from LocalStorage: Invalid data';
                this.log.error("\uD83D\uDED1 ".concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].red, "AN-").concat(errorCode, " (").concat(_helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorMessages"][errorCode], "):").concat(_colors__WEBPACK_IMPORTED_MODULE_14__["default"].white, "\n ").concat(additionalMessage));
                this.helixError.reportError(errorCode, config, additionalMessage);
              }
              this.events = json;
              this.log.debug('using events from local.');
              return _context5.abrupt("return", true);
            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5["catch"](3);
              this.log.error("Failed to load events from local: ".concat(_context5.t0));
              return _context5.abrupt("return", false);
            case 17:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[3, 13]]);
      }));
      function fetchFromLocal() {
        return _fetchFromLocal.apply(this, arguments);
      }
      return fetchFromLocal;
    }()
    /**
     * Set the domain of the application
     * @method   setClientDomain
     * @param {string} domain - client domain
     */
  }, {
    key: "setClientDomain",
    value: function setClientDomain(domain) {
      if (!Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["isNil"])(domain) && !Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["isEmpty"])(domain)) {
        this.config.domain = domain;
      }
    }

    /**
     * Get the domain of the application
     * @method getClientDomain
     * @returns {config} domain of the client
     */
  }, {
    key: "getClientDomain",
    value: function getClientDomain(config) {
      var _this$config;
      if (this !== null && this !== void 0 && (_this$config = this.config) !== null && _this$config !== void 0 && _this$config.domain) return this.config.domain;
      var conf = !Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["isNil"])(config) && !Object(_helpers__WEBPACK_IMPORTED_MODULE_9__["isEmpty"])(config) ? config : this.config;
      return Object(_helixError__WEBPACK_IMPORTED_MODULE_13__["getDomain"])(conf);
    }
  }], [{
    key: "shouldFetchSpecs",
    value: function shouldFetchSpecs(config) {
      var specsHash = config.specsHash,
        requirementsVersion = config.requirementsVersion;
      var ls = Object(_storage__WEBPACK_IMPORTED_MODULE_7__["fetchFromStorage"])(_storage__WEBPACK_IMPORTED_MODULE_7__["STORAGE_KEYS"].REQUIREMENTS);
      if (!ls) {
        // no local storage. Must fetch specs from remote
        return true;
      } else if (specsHash !== ls.specsHash) {
        // does local match remote hash? If not, fetch remote.
        return true;
      } else if (requirementsVersion && requirementsVersion !== (ls === null || ls === void 0 ? void 0 : ls.requirementsVersion)) {
        this.helixError.reportError(_helixError__WEBPACK_IMPORTED_MODULE_13__["ErrorCodes"].SPECS_VERSION_MISMATCH, config, 'requirements version requested does not match local storage version');
        // fetch remote.
        return true;
      }
      return false;
    }
  }]);
  return Events;
}();


/***/ }),

/***/ "./src/utils/extensionComparator.js":
/*!******************************************!*\
  !*** ./src/utils/extensionComparator.js ***!
  \******************************************/
/*! exports provided: eqComparator, notEqComparator, substringComparator, notSubstringComparator, hasElementComparator, notHasElementComparator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eqComparator", function() { return eqComparator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notEqComparator", function() { return notEqComparator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "substringComparator", function() { return substringComparator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notSubstringComparator", function() { return notSubstringComparator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasElementComparator", function() { return hasElementComparator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notHasElementComparator", function() { return notHasElementComparator; });
/* harmony import */ var lodash_indexOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/indexOf */ "./node_modules/lodash/indexOf.js");
/* harmony import */ var lodash_indexOf__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_indexOf__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/isEqual */ "./node_modules/lodash/isEqual.js");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Compares if the value of a field is equal to the condition value.
 * @param {string} field - The field to compare.
 * @param {*} conditionValue - The value to compare against.
 * @param {string} source - The source of the data ('client' or 'sdk').
 * @param {Object} context - The context containing adHocData and quantumAnalytics.
 * @returns {boolean} True if the field value equals the condition value, otherwise false.
 */
function eqComparator(field, conditionValue, source, context) {
  if (source === 'client') {
    var unifiedKey = context.quantumAnalytics.getQuantumKeyForPath(field, context.adHocData.eventType);
    if (unifiedKey === undefined) {
      // NOTE: A field is not supported on the current event type
      return false;
    }
    return lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default()(context.adHocData[unifiedKey], conditionValue);
  } else if (source === 'sdk') {
    return lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default()(context.quantumAnalytics.getValueForPath(field), conditionValue);
  } else {
    throw new Error("\uD83D\uDCCF NOT SUPPORTED SOURCE: [ ".concat(JSON.stringify(source), " ]"));
  }
}

/**
 * Compares if the value of a field is not equal to the condition value.
 * @param {string} field - The field to compare.
 * @param {*} conditionValue - The value to compare against.
 * @param {string} source - The source of the data ('client' or 'sdk').
 * @param {Object} context - The context containing adHocData and quantumAnalytics.
 * @returns {boolean} True if the field value does not equal the condition value, otherwise false.
 */
function notEqComparator(field, conditionValue, source, context) {
  return !eqComparator(field, conditionValue, source, context);
}

/**
 * Checks if the value of a field contains the condition value as a substring.
 * @param {string} field - The field to compare.
 * @param {string} conditionValue - The substring to check for.
 * @param {string} source - The source of the data ('client' or 'sdk').
 * @param {Object} context - The context containing adHocData and quantumAnalytics.
 * @returns {boolean} True if the field value contains the condition value, otherwise false.
 */
function substringComparator(field, conditionValue, source, context) {
  if (source === 'client') {
    var unifiedKey = context.quantumAnalytics.getQuantumKeyForPath(field, context.adHocData.eventType);
    if (unifiedKey === undefined) {
      // NOTE: A field is not supported on the current event type
      return false;
    }
    var fieldValue = context.adHocData[unifiedKey];
    if (fieldValue === undefined) fieldValue = '';
    return fieldValue.includes(conditionValue);
  } else if (source === 'sdk') {
    return context.quantumAnalytics.getValueForPath(field).includes(conditionValue);
  } else {
    throw new Error("\uD83D\uDCCF NOT SUPPORTED SOURCE: [ ".concat(JSON.stringify(source), " ]"));
  }
}

/**
 * Checks if the value of a field does not contain the condition value as a substring.
 * @param {string} field - The field to compare.
 * @param {string} conditionValue - The substring to check for.
 * @param {string} source - The source of the data ('client' or 'sdk').
 * @param {Object} context - The context containing adHocData and quantumAnalytics.
 * @returns {boolean} True if the field value does not contain the condition value, otherwise false.
 */
function notSubstringComparator(field, conditionValue, source, context) {
  return !substringComparator(field, conditionValue, source, context);
}

/**
 * Checks if the value of a field contains the condition value as an element.
 * @param {string} field - The field to compare.
 * @param {*} conditionValue - The element to check for.
 * @param {string} source - The source of the data ('client' or 'sdk').
 * @param {Object} context - The context containing adHocData and quantumAnalytics.
 * @returns {boolean} True if the field value contains the condition value, otherwise false.
 */
function hasElementComparator(field, conditionValue, source, context) {
  if (source === 'client') {
    var unifiedKey = context.quantumAnalytics.getQuantumKeyForPath(field, context.adHocData.eventType);
    if (unifiedKey === undefined) {
      // NOTE: A field is not supported on the current event type
      return false;
    }
    var fieldValue = context.adHocData[unifiedKey];
    if (!Array.isArray(fieldValue)) {
      return false; // Ensure the field value is an array
    }

    return lodash_indexOf__WEBPACK_IMPORTED_MODULE_0___default()(fieldValue, conditionValue) > -1;
  } else if (source === 'sdk') {
    var _fieldValue = context.quantumAnalytics.getValueForPath(field);
    if (!Array.isArray(_fieldValue)) {
      return false; // Ensure the field value is an array
    }

    return lodash_indexOf__WEBPACK_IMPORTED_MODULE_0___default()(_fieldValue, conditionValue) > -1;
  } else {
    throw new Error("\uD83D\uDCCF NOT SUPPORTED SOURCE: [ ".concat(JSON.stringify(source), " ]"));
  }
}

/**
 * Checks if the value of a field does not contain the condition value as an element.
 * @param {string} field - The field to compare.
 * @param {*} conditionValue - The element to check for.
 * @param {string} source - The source of the data ('client' or 'sdk').
 * @param {Object} context - The context containing adHocData and quantumAnalytics.
 * @returns {boolean} True if the field value does not contain the condition value, otherwise false.
 */
function notHasElementComparator(field, conditionValue, source, context) {
  return !hasElementComparator(field, conditionValue, source, context);
}

/***/ }),

/***/ "./src/utils/extensionsService.js":
/*!****************************************!*\
  !*** ./src/utils/extensionsService.js ***!
  \****************************************/
/*! exports provided: processExtensions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processExtensions", function() { return processExtensions; });
/* harmony import */ var _charter_helix_extensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @charter/helix-extensions */ "./node_modules/@charter/helix-extensions/dist/index.js");
/* harmony import */ var _charter_helix_extensions__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_charter_helix_extensions__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helixError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helixError */ "./src/utils/helixError.js");
/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Logger */ "./src/utils/Logger.js");
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./colors */ "./src/utils/colors.js");




/**
 * Given a map of values, processes any extensions assigned to this platform.
 * @param mappedValues
 * @return {any} New object of key:value pairs
 */
var processExtensions = function processExtensions(mappedValues, expressions, helixError) {
  // expressions && log.info(`Process Extensions:`, { mappedValues, expressions });

  var dataMap = Object.assign({}, mappedValues);
  var blockTrack = false;
  if (expressions) {
    // Load all mapped values into a Context object for processing by the Extensions class.
    var context = new _charter_helix_extensions__WEBPACK_IMPORTED_MODULE_0__["Context"]();
    try {
      Object.keys(mappedValues).forEach(function (key) {
        context.setValue(new _charter_helix_extensions__WEBPACK_IMPORTED_MODULE_0__["Operand"](key, _charter_helix_extensions__WEBPACK_IMPORTED_MODULE_0__["OperandType"].Data), mappedValues[key]);
      });
      blockTrack = expressions.some(function (expr) {
        return !expr.eval(context);
      });
      if (!blockTrack) {
        dataMap = context.dataVar;
      } else {
        _Logger__WEBPACK_IMPORTED_MODULE_2__["default"].warn("\uD83D\uDED1 - Ext Rules: ".concat(_colors__WEBPACK_IMPORTED_MODULE_3__["default"].red, "blockTrack:").concat(_colors__WEBPACK_IMPORTED_MODULE_3__["default"].green), blockTrack);
      }
      if (JSON.stringify(mappedValues) !== JSON.stringify(context.dataVar)) {
        try {
          Object.keys(context.dataVar).map(function (key) {
            var newValue = context.dataVar[key];
            var value = mappedValues[key] ? mappedValues[key] : '';
            if (newValue != value) {
              _Logger__WEBPACK_IMPORTED_MODULE_2__["default"].warn("\uD83C\uDFAF - Ext Rules: ".concat(_colors__WEBPACK_IMPORTED_MODULE_3__["default"].yellow, " update adHocData | ").concat(_colors__WEBPACK_IMPORTED_MODULE_3__["default"].green, "property: ").concat(_colors__WEBPACK_IMPORTED_MODULE_3__["default"].magenta).concat(key, " ").concat(_colors__WEBPACK_IMPORTED_MODULE_3__["default"].green, "newValue: ").concat(_colors__WEBPACK_IMPORTED_MODULE_3__["default"].cyan).concat(newValue, " ").concat(_colors__WEBPACK_IMPORTED_MODULE_3__["default"].green, "oldValue: ").concat(_colors__WEBPACK_IMPORTED_MODULE_3__["default"].cyan).concat(value));
            }
          });
        } catch (e) {
          _Logger__WEBPACK_IMPORTED_MODULE_2__["default"].error('🎯 - Ext Rules:  error', e);
        }
      }
    } catch (err) {
      var errorCode = _helixError__WEBPACK_IMPORTED_MODULE_1__["ErrorCodes"].PARSE_RULES;
      var additionalMessage = "Ext Rules: There was an error evaluating Helix expressions: ".concat(err);
      _Logger__WEBPACK_IMPORTED_MODULE_2__["default"].error("\uD83D\uDED1 ".concat(_colors__WEBPACK_IMPORTED_MODULE_3__["default"].red, "AN-").concat(errorCode, " (").concat(_helixError__WEBPACK_IMPORTED_MODULE_1__["ErrorMessages"][errorCode], "):").concat(_colors__WEBPACK_IMPORTED_MODULE_3__["default"].white, "\n ").concat(additionalMessage));
      helixError.reportError(_helixError__WEBPACK_IMPORTED_MODULE_1__["ErrorCodes"].PARSE_RULES, context.dataVar, additionalMessage);
    }
  }
  dataMap.blockTrack = blockTrack;
  return dataMap;
};

/***/ }),

/***/ "./src/utils/extensionsServiceV2.js":
/*!******************************************!*\
  !*** ./src/utils/extensionsServiceV2.js ***!
  \******************************************/
/*! exports provided: processExtensions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processExtensions", function() { return processExtensions; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helixError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helixError */ "./src/utils/helixError.js");
/* harmony import */ var _extensionComparator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./extensionComparator */ "./src/utils/extensionComparator.js");
/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Logger */ "./src/utils/Logger.js");
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./colors */ "./src/utils/colors.js");
/* harmony import */ var lodash_every__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lodash/every */ "./node_modules/lodash/every.js");
/* harmony import */ var lodash_every__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_every__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_some__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lodash/some */ "./node_modules/lodash/some.js");
/* harmony import */ var lodash_some__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_some__WEBPACK_IMPORTED_MODULE_6__);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var helixExtensionsComparators = {
  eq: _extensionComparator__WEBPACK_IMPORTED_MODULE_2__["eqComparator"],
  notEq: _extensionComparator__WEBPACK_IMPORTED_MODULE_2__["notEqComparator"],
  substring: _extensionComparator__WEBPACK_IMPORTED_MODULE_2__["substringComparator"],
  notSubstring: _extensionComparator__WEBPACK_IMPORTED_MODULE_2__["notSubstringComparator"],
  hasElement: _extensionComparator__WEBPACK_IMPORTED_MODULE_2__["hasElementComparator"],
  notHasElement: _extensionComparator__WEBPACK_IMPORTED_MODULE_2__["notHasElementComparator"]
};

/**
 * Processes extensions assigned to this platform based on the provided rules.
 * @param {Object} adHocData - The ad hoc data for the current event.
 * @param {Array} helixExtensionRules - The rules to process extensions.
 * @param {Object} helixError - The error handler for reporting issues.
 * @param {Object} analytics - The analytics object for accessing quantum keys and values.
 * @returns {Object|boolean} The processed event data or false if an error occurs.
 */
var processExtensions = function processExtensions() {
  var adHocData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var helixExtensionRules = arguments.length > 1 ? arguments[1] : undefined;
  var helixError = arguments.length > 2 ? arguments[2] : undefined;
  var analytics = arguments.length > 3 ? arguments[3] : undefined;
  var eventDataProcessed = _objectSpread({
    blockTrack: false
  }, adHocData);
  var eventCaseId = adHocData.eventCaseId,
    eventType = adHocData.eventType;
  if (helixExtensionRules && helixExtensionRules.length > 0) {
    var context = {
      adHocData: adHocData,
      quantumAnalytics: analytics
    };
    try {
      helixExtensionRules.forEach(function (rule) {
        var ifClause = rule["if"],
          thenClause = rule.then;
        if (evaluateRule(ifClause, context)) {
          thenClause.forEach(function (decision) {
            var field = analytics.getQuantumKeyForPath(decision.field, eventType);
            if (decision.action === 'block') {
              _Logger__WEBPACK_IMPORTED_MODULE_3__["default"].warn("\uD83D\uDCCF ".concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].red, "BLOCKED ").concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].Reset, "event case: ").concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].yellow).concat(eventCaseId || eventType).concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].Reset, " due to the RULE: ").concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].blue).concat(JSON.stringify(ifClause)).concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].Reset));
              eventDataProcessed.blockTrack = true;
              return false;
            } else if (decision.action === 'set') {
              _Logger__WEBPACK_IMPORTED_MODULE_3__["default"].info("\uD83D\uDCCF Set: ".concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].green).concat(decision.field).concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].Reset, " with value: ").concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].yellow).concat(decision.value).concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].Reset, " due to the RULE: ").concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].blue).concat(JSON.stringify(ifClause)).concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].Reset));
              eventDataProcessed[field] = decision.value;
            } else if (decision.action === 'replace') {
              var regex = new RegExp(decision.match, '');
              var newValue = eventDataProcessed[field].replace(regex, decision.value);
              _Logger__WEBPACK_IMPORTED_MODULE_3__["default"].info("\uD83D\uDCCF Replace: ".concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].green).concat(decision.field).concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].Reset, " with value: ").concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].yellow).concat(newValue).concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].Reset, " due to the RULE: ").concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].blue).concat(JSON.stringify(ifClause)).concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].Reset));
              eventDataProcessed[field] = newValue;
            }
          });
        }
      });
    } catch (err) {
      var errorCode = _helixError__WEBPACK_IMPORTED_MODULE_1__["ErrorCodes"].PARSE_RULES;
      var additionalMessage = "V2 Ext Rules: There was an error evaluating Helix expressions: ".concat(err.message);
      _Logger__WEBPACK_IMPORTED_MODULE_3__["default"].error("\uD83D\uDCCF \uD83D\uDED1 ".concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].red, "AN-").concat(errorCode, " (").concat(_helixError__WEBPACK_IMPORTED_MODULE_1__["ErrorMessages"][errorCode], "):").concat(_colors__WEBPACK_IMPORTED_MODULE_4__["default"].white, "\n ").concat(additionalMessage), adHocData);
      helixError.reportError(_helixError__WEBPACK_IMPORTED_MODULE_1__["ErrorCodes"].PARSE_RULES, additionalMessage);
      return false;
    }
  }
  return eventDataProcessed;
};

/**
 * Handles a single condition by evaluating it using the appropriate comparator.
 * @param {Object} condition - The condition to evaluate.
 * @param {Object} context - The context containing adHocData and quantumAnalytics.
 * @returns {boolean} The result of the condition evaluation.
 * @throws {Error} If the comparator is unknown.
 */
function handleCondition(condition, context) {
  var comparator = helixExtensionsComparators[condition.comparator];
  if (!comparator) {
    throw new Error("UNKNOWN COMPARATOR: [ ".concat(JSON.stringify(condition.comparator), " ]"));
  }
  return comparator(condition.field, condition.value, condition.source, context);
}

/**
 * Simplifies a rule clause by evaluating relational expressions or nested conditions.
 * @param {Object} value - The current condition or rule clause.
 * @param {number} index - The index of the current condition in the array.
 * @param {Array} arr - The array of conditions.
 * @param {Object} context - The context containing adHocData and quantumAnalytics.
 * @returns {boolean} The result of the clause evaluation.
 */
function simplifyRuleClause(value, index, arr, context) {
  var isRelationalExpression = !value.operator && !value.conditions;
  if (isRelationalExpression) {
    // NOTE: The bottom of a deeply nested condition is reached. Evaluating condition
    return handleCondition(value, context);
  }

  // NOTE: Proceeding with unwrapping a deeply nested condition
  return evaluateRule(value, context);
}

/**
 * Evaluates a rule by processing its conditions based on the operator ('and' or 'or').
 * @param {Object} rule - The rule to evaluate.
 * @param {Object} context - The context containing adHocData and quantumAnalytics.
 * @returns {boolean} The result of the rule evaluation.
 * @throws {Error} If the operator is not supported.
 */
function evaluateRule(rule, context) {
  if (rule.operator === 'and') {
    return lodash_every__WEBPACK_IMPORTED_MODULE_5___default()(rule.conditions, function (value, index, arr) {
      return simplifyRuleClause(value, index, arr, context);
    });
  } else if (rule.operator === 'or') {
    return lodash_some__WEBPACK_IMPORTED_MODULE_6___default()(rule.conditions, function (value, index, arr) {
      return simplifyRuleClause(value, index, arr, context);
    });
  } else {
    throw new Error("\uD83D\uDCCF NOT SUPPORTED OPERATOR: [ ".concat(JSON.stringify(rule.operator), " ]"));
  }
}

/***/ }),

/***/ "./src/utils/helixError.js":
/*!*********************************!*\
  !*** ./src/utils/helixError.js ***!
  \*********************************/
/*! exports provided: HelixErrorData, ErrorAnalyticsImpact, ErrorCodes, ErrorMessages, writeBaseFieldsToStorage, getDomain, getFallbackVisitId, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HelixErrorData", function() { return HelixErrorData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorAnalyticsImpact", function() { return ErrorAnalyticsImpact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorCodes", function() { return ErrorCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorMessages", function() { return ErrorMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeBaseFieldsToStorage", function() { return writeBaseFieldsToStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDomain", function() { return getDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFallbackVisitId", function() { return getFallbackVisitId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HelixError; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Logger */ "./src/utils/Logger.js");
/* harmony import */ var _httpServices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./httpServices */ "./src/utils/httpServices.js");
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./storage */ "./src/utils/storage.js");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/helpers */ "./src/utils/helpers.js");
/* harmony import */ var _utils_defaultData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/defaultData */ "./src/utils/defaultData.js");
/* harmony import */ var _utils_uuid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../utils/uuid */ "./src/utils/uuid.js");



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var HelixErrorData = Object.freeze({
  EID_PORTALS: 'generic_error_portals',
  EID_VIDEO: 'generic_error_video',
  EID_INTERNAL_APPS: 'generic_error_internal_apps',
  EVENT_TYPE: 'error',
  ERROR_TYPE: 'analytics'
});
var ErrorAnalyticsImpact = Object.freeze({
  WARNING: 'warning',
  ERROR: 'error',
  CRITICAL: 'critical'
});
var ErrorCodes = Object.freeze({
  STALE_TIMESTAMP: '0088',
  // HELIX FAILURES (10XX)
  INVALID_EID: '1001',
  TRACK: '1002',
  INIT: '1003',
  INVALID_EVENT_TYPE: '1004',
  SPECS_VERSION_MISMATCH: '1005',
  IGNORED_EVENT_TYPE: '1010',
  INVALID_REQUIREMENTS: '1012',
  INVALID_TIMESTAMP: '1050',
  // HELIX EXTENSIONS FILE ERRORS (11XX)
  PARSE_RULES: '1100',
  EVAL_RULES: '1105',
  METHOD_NOT_FOUND: '1106',
  FETCH_CONFIG_FILE: '1110',
  RE_FETCH_CONFIG_FILE: '1111',
  PARSE_CONFIG_FILE: '1112',
  FETCH_SPECS_FILE: '1114',
  RE_FETCH_SPECS_FILE: '1115',
  PARSE_SPECS_FILE: '1116'
});
var ErrorMessages = Object.freeze({
  '0088': 'Timestamp is too far in the past',
  // HELIX FAILURES (10XX)

  '1001': 'Invalid EID',
  '1002': 'Track Error',
  '1003': 'Error calling Quantum init in start session',
  '1004': 'Unsupported event type',
  '1005': 'Local storage requirements version mismatch',
  '1010': 'Event type on ignore list, not allowed to be called by the client',
  '1012': 'Invalid analytics requirements version',
  '1050': 'Invalid timestamp - not an integer',
  // HELIX EXTENSIONS FILE ERRORS (11XX)
  '1100': 'Error parsing Helix Extension Rules',
  '1105': 'Error evaluating a Rule',
  '1106': 'Quantum method not found',
  '1110': 'Failed to fetch config file',
  '1111': 'Failed to re-fetch config file',
  '1112': 'Failed to parse config file',
  '1114': 'Failed to fetch specs file',
  '1115': 'Failed to re-fetch specs file',
  '1116': 'Failed to parse specs file'
});
var writeBaseFieldsToStorage = function writeBaseFieldsToStorage() {
  var visitInformation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var visitId = visitInformation.visitId,
    applicationName = visitInformation.applicationName,
    applicationType = visitInformation.applicationType,
    requirementsVersion = visitInformation.requirementsVersion,
    libraryVersion = visitInformation.libraryVersion,
    appVersion = visitInformation.appVersion,
    deviceUuid = visitInformation.deviceUuid,
    deviceFormFactor = visitInformation.deviceFormFactor,
    deviceType = visitInformation.deviceType,
    deviceModel = visitInformation.deviceModel,
    deviceOperatingSystem = visitInformation.deviceOperatingSystem,
    appEnvName = visitInformation.appEnvName;
  Object(_storage__WEBPACK_IMPORTED_MODULE_5__["writeToStorage"])(_storage__WEBPACK_IMPORTED_MODULE_5__["STORAGE_KEYS"].INITIAL_LIBRARY_STATE, {
    fallbackVisitId: visitId,
    model: {
      visit: {
        visitId: visitId,
        applicationDetails: {
          applicationName: applicationName,
          applicationType: applicationType,
          appVersion: appVersion,
          environment: {
            environmentName: appEnvName
          }
        },
        analytics: {
          requirementsVersion: requirementsVersion,
          libraryVersion: libraryVersion
        }
      }
    },
    device: {
      deviceFormFactor: deviceFormFactor,
      deviceType: deviceType,
      model: deviceModel,
      operatingSystem: deviceOperatingSystem,
      uuid: deviceUuid
    }
  });
};
var getDomain = function getDomain(config) {
  var _ref = Object(_storage__WEBPACK_IMPORTED_MODULE_5__["fetchFromStorage"])(_storage__WEBPACK_IMPORTED_MODULE_5__["STORAGE_KEYS"].INITIAL_LIBRARY_STATE) || {},
    domainFromStorage = _ref.domain;
  var _ref2 = Object(_storage__WEBPACK_IMPORTED_MODULE_5__["fetchFromStorage"])(_storage__WEBPACK_IMPORTED_MODULE_5__["STORAGE_KEYS"].REQUIREMENTS) || {},
    _ref2$data = _ref2.data,
    _ref2$data2 = _ref2$data === void 0 ? {
      metadata: {}
    } : _ref2$data,
    domainFromRequirements = _ref2$data2.metadata.domain;
  return config.domain || domainFromRequirements || domainFromStorage || "video" || _utils_defaultData__WEBPACK_IMPORTED_MODULE_7__["DOMAIN"].VIDEO;
};

/**
 * If an error occurs before the library has been initialized, we need to use a fallback visitId
 * @param  {string} eid   Event case ID
 * @param  {Object} error The data for error event
 * @return {void}
 */
var getFallbackVisitId = function getFallbackVisitId(domain) {
  try {
    // check if a fallback visitId is already available, otherwise create new one
    var libraryState = Object(_storage__WEBPACK_IMPORTED_MODULE_5__["fetchFromStorage"])(_storage__WEBPACK_IMPORTED_MODULE_5__["STORAGE_KEYS"].INITIAL_LIBRARY_STATE);
    if (!(libraryState !== null && libraryState !== void 0 && libraryState.fallbackVisitId)) {
      var fallbackVisitId = Object(_utils_uuid__WEBPACK_IMPORTED_MODULE_8__["generateVisitId"])(domain);
      Object(_storage__WEBPACK_IMPORTED_MODULE_5__["writeToStorage"])(_storage__WEBPACK_IMPORTED_MODULE_5__["STORAGE_KEYS"].INITIAL_LIBRARY_STATE, _objectSpread(_objectSpread({}, libraryState), {}, {
        fallbackVisitId: fallbackVisitId
      }));
      return fallbackVisitId;
    }
    return libraryState.fallbackVisitId;
  } catch (err) {
    // should never get here
    _Logger__WEBPACK_IMPORTED_MODULE_3__["default"].error("Unable to generate visit ID with new format: ".concat(err));
    return Object(_utils_uuid__WEBPACK_IMPORTED_MODULE_8__["generateVisitId"])(domain);
  }
};
var HelixError = /*#__PURE__*/function () {
  function HelixError(onTrackCallback, onAllSetToTrackCallback) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, HelixError);
    this.track = onTrackCallback;
    this.allSetToTrack = onAllSetToTrackCallback;
    this.errorEID = '';
    this.config = config;
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(HelixError, [{
    key: "generateErrorObject",
    value: function generateErrorObject(data, fallbackDomain) {
      var appName = data.appName,
        appType = data.appType,
        appVersion = data.appVersion,
        appVenonaVersion = data.appVenonaVersion,
        deviceFormFactor = data.deviceFormFactor,
        deviceType = data.deviceType,
        deviceModel = data.deviceModel,
        deviceOperatingSystem = data.deviceOperatingSystem,
        deviceUuid = data.deviceUuid,
        visitId = data.visitId,
        customer = data.customer,
        domain = data.domain,
        appErrorCode = data.appErrorCode,
        appErrorMessage = data.appErrorMessage,
        appErrorType = data.appErrorType,
        category = data.category,
        eventCaseId = data.eventCaseId,
        msgEventType = data.msgEventType,
        sequenceNumber = data.sequenceNumber,
        analytics = data.analytics,
        appEnvName = data.appEnvName;
      return {
        domain: domain || fallbackDomain,
        customer: customer || 'Charter',
        visit: {
          analytics: analytics || {
            libraryVersion: "4.38.0"
          },
          visitId: visitId,
          applicationDetails: {
            venonaVersion: appVenonaVersion || 'n/a',
            appVersion: appVersion || '1.0',
            applicationName: appName || 'HelixErrors',
            applicationType: appType || 'Web',
            environment: {
              environmentName: appEnvName || 'prod'
            }
          },
          device: {
            deviceFormFactor: deviceFormFactor || 'pc',
            deviceType: deviceType,
            model: deviceModel,
            operatingSystem: deviceOperatingSystem,
            uuid: deviceUuid || Object(_utils_uuid__WEBPACK_IMPORTED_MODULE_8__["generateVisitId"])(domain || fallbackDomain)
          }
        },
        messages: [{
          application: {
            error: {
              errorCode: appErrorCode,
              errorMessage: appErrorMessage,
              errorType: appErrorType
            }
          },
          operation: {
            success: false
          },
          message: {
            category: category || HelixErrorData.EVENT_TYPE,
            eventCaseId: eventCaseId,
            name: msgEventType,
            sequenceNumber: sequenceNumber || 0,
            timestamp: Date.now(),
            triggeredBy: 'analytics'
          }
        }]
      };
    }

    /**
     * Track error, or post to collector if helix is still initializing or if EID is invalid
     * @param  {string} eid   Event case ID
     * @param  {Object} error The data for error event
     * @return {void}
     */
  }, {
    key: "reportError",
    value: function reportError(errorCode) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var errorMessage = arguments.length > 2 ? arguments[2] : undefined;
      var errorData = _objectSpread({}, data);
      if (!this.errorEID) {
        this.errorEID = this.getErrorEID();
      }
      var error = this.compileErrorByCode(errorCode, errorData, errorMessage);
      return this.allSetToTrack && this.allSetToTrack(this.errorEID) ? this.track(this.errorEID, error) : this.postHelixError(error);
    }
  }, {
    key: "getErrorEID",
    value: function getErrorEID() {
      var domain = getDomain(this.config);
      var domainUpperCase = (domain === null || domain === void 0 ? void 0 : domain.toUpperCase()) || '';
      var _errorEID = "EID_".concat(domainUpperCase);
      return !HelixErrorData[_errorEID] ? HelixErrorData.EVENT_TYPE : HelixErrorData[_errorEID];
    }

    /**
     * Generate Analytics Error event based on error code
     * @param {String} errorCode       Helix Error Code for error event (e.g. 2000)
     * @param  {Object} errorData      Optional additional data for error event
     * @param {String} errorMsg        Optional error message
     * @return {Object}                Formatted helix error event
     */
  }, {
    key: "compileErrorByCode",
    value: function compileErrorByCode(errorCode) {
      var errorData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var message = arguments.length > 2 ? arguments[2] : undefined;
      var errorMessage = this.getErrorMessage(errorCode, message);
      switch (errorCode) {
        case ErrorCodes.INVALID_EID:
          return this.generateAN1001(errorData, message);
        case ErrorCodes.FETCH_CONFIG_FILE:
          return this.generateAN1110(errorData, errorMessage);
        case ErrorCodes.FETCH_SPECS_FILE:
          return this.generateAN1112(errorData, errorMessage);
        case ErrorCodes.RE_FETCH_CONFIG_FILE:
          return this.generateAN1114(errorData, errorMessage);
        case ErrorCodes.RE_FETCH_SPECS_FILE:
          return this.generateAN1115(errorData, errorMessage);
        case ErrorCodes.PARSE_SPECS_FILE:
          return this.generateAN1116(errorData, errorMessage);
        case ErrorCodes.PARSE_CONFIG_FILE:
          return this.generateAN1111(errorData, errorMessage);
        default:
          return this.generateHelixError(errorCode, errorData, errorMessage);
      }
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage(errorCode, additionalMessage) {
      var messagePrefix = ErrorMessages[errorCode] || 'UNDEFINED';
      return ErrorMessages[errorCode] && additionalMessage ? "".concat(messagePrefix, ": ").concat(additionalMessage) : messagePrefix;
    }

    /**
     * Generate Analytics Error events
     * AN1110 - Failed to fetch config file
     * @param  {Object} data The data for error event
     * @return {Object}      Formatted helix error event
     */
  }, {
    key: "generateAN1110",
    value: function generateAN1110() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var errorMessage = arguments.length > 1 ? arguments[1] : undefined;
      var _data$appVersion = data.appVersion,
        appVersion = _data$appVersion === void 0 ? '' : _data$appVersion,
        _data$appName = data.appName,
        appName = _data$appName === void 0 ? '' : _data$appName,
        _data$appType = data.appType,
        appType = _data$appType === void 0 ? '' : _data$appType,
        _data$appEnvName = data.appEnvName,
        appEnvName = _data$appEnvName === void 0 ? '' : _data$appEnvName,
        requirementsVersion = data.requirementsVersion;
      var appErrorMessage = "".concat(errorMessage, ". Failed to fetch configuration file: ").concat(appName, "@").concat(appType, "/").concat(requirementsVersion, ".json ENV: ").concat(appEnvName, " appVersion: ").concat(appVersion, ". Analytics have been disabled!");
      return this.generateHelixError(ErrorCodes.FETCH_CONFIG_FILE, data, appErrorMessage, ErrorAnalyticsImpact.CRITICAL);
    }

    /**
     * Generate Analytics Error events
     * AN1111 - Failed to parse config file
     * @param  {Object} data The data for error event
     * @return {Object}      Formatted helix error event
     */
  }, {
    key: "generateAN1111",
    value: function generateAN1111() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var errorMessage = arguments.length > 1 ? arguments[1] : undefined;
      var _data$appVersion2 = data.appVersion,
        appVersion = _data$appVersion2 === void 0 ? '' : _data$appVersion2,
        _data$appName2 = data.appName,
        appName = _data$appName2 === void 0 ? '' : _data$appName2,
        _data$appType2 = data.appType,
        appType = _data$appType2 === void 0 ? '' : _data$appType2,
        _data$appEnvName2 = data.appEnvName,
        appEnvName = _data$appEnvName2 === void 0 ? '' : _data$appEnvName2,
        requirementsVersion = data.requirementsVersion;
      var appErrorMessage = "".concat(errorMessage, ".\tFailed to re-fetch configuration: ").concat(appName, "@").concat(appType, "/").concat(requirementsVersion, ".json ENV: ").concat(appEnvName, " appVersion: ").concat(appVersion, ". Analytics have been disabled!");
      return this.generateHelixError(ErrorCodes.PARSE_CONFIG_FILE, data, appErrorMessage, ErrorAnalyticsImpact.WARNING);
    }

    /**
     * Generate Analytics Error events
     * AN1112- Failed to fetch specs file
     * @param  {Object} data The data for error event
     * @return {Object}      Formatted helix error event
     */
  }, {
    key: "generateAN1112",
    value: function generateAN1112() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var errorMessage = arguments.length > 1 ? arguments[1] : undefined;
      var _data$appVersion3 = data.appVersion,
        appVersion = _data$appVersion3 === void 0 ? '' : _data$appVersion3,
        _data$appName3 = data.appName,
        appName = _data$appName3 === void 0 ? '' : _data$appName3,
        _data$appType3 = data.appType,
        appType = _data$appType3 === void 0 ? '' : _data$appType3,
        _data$appEnvName3 = data.appEnvName,
        appEnvName = _data$appEnvName3 === void 0 ? '' : _data$appEnvName3,
        requirementsVersion = data.requirementsVersion;
      var appErrorMessage = "".concat(errorMessage, ". Failed to parse the configuration file: ").concat(appName, "@").concat(appType, "/").concat(requirementsVersion, ".json ENV: ").concat(appEnvName, " appVersion: ").concat(appVersion, ".");
      return this.generateHelixError(ErrorCodes.FETCH_SPECS_FILE, data, appErrorMessage, ErrorAnalyticsImpact.CRITICAL);
    }

    /**
     * Generate Analytics Error events
     * AN1114- Failed to re-fetch config file
     * @param  {Object} data The data for error event
     * @return {Object}      Formatted helix error event
     */
  }, {
    key: "generateAN1114",
    value: function generateAN1114() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var errorMessage = arguments.length > 1 ? arguments[1] : undefined;
      var _data$appVersion4 = data.appVersion,
        appVersion = _data$appVersion4 === void 0 ? '' : _data$appVersion4,
        _data$appName4 = data.appName,
        appName = _data$appName4 === void 0 ? '' : _data$appName4,
        _data$appType4 = data.appType,
        appType = _data$appType4 === void 0 ? '' : _data$appType4,
        _data$appEnvName4 = data.appEnvName,
        appEnvName = _data$appEnvName4 === void 0 ? '' : _data$appEnvName4,
        requirementsVersion = data.requirementsVersion;
      var appErrorMessage = "".concat(errorMessage, ". Failed to fetch requirements version file: ").concat(appName, "@").concat(appType, "/").concat(requirementsVersion, ".json ENV: ").concat(appEnvName, " appVersion: ").concat(appVersion, ".");
      return this.generateHelixError(ErrorCodes.RE_FETCH_CONFIG_FILE, data, appErrorMessage, ErrorAnalyticsImpact.CRITICAL);
    }

    /**
     * Generate Analytics Error events
     * AN1115- Failed to fetch specs file
     * @param  {Object} data The data for error event
     * @return {Object}      Formatted helix error event
     */
  }, {
    key: "generateAN1115",
    value: function generateAN1115() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var errorMessage = arguments.length > 1 ? arguments[1] : undefined;
      var _data$appVersion5 = data.appVersion,
        appVersion = _data$appVersion5 === void 0 ? '' : _data$appVersion5,
        _data$appName5 = data.appName,
        appName = _data$appName5 === void 0 ? '' : _data$appName5,
        _data$appType5 = data.appType,
        appType = _data$appType5 === void 0 ? '' : _data$appType5,
        _data$appEnvName5 = data.appEnvName,
        appEnvName = _data$appEnvName5 === void 0 ? '' : _data$appEnvName5,
        requirementsVersion = data.requirementsVersion;
      var appErrorMessage = "".concat(errorMessage, ". Failed to re-fetch requirements version file: ").concat(appName, "@").concat(appType, "/").concat(requirementsVersion, ".json ENV: ").concat(appEnvName, " appVersion: ").concat(appVersion, ".");
      return this.generateHelixError(ErrorCodes.RE_FETCH_SPECS_FILE, data, appErrorMessage, ErrorAnalyticsImpact.WARNING);
    }

    /**
     * Generate Analytics Error events
     * AN1116- Failed to parse specs file
     * @param  {Object} data The data for error event
     * @return {Object}      Formatted helix error event
     */
  }, {
    key: "generateAN1116",
    value: function generateAN1116() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var errorMessage = arguments.length > 1 ? arguments[1] : undefined;
      var _data$appVersion6 = data.appVersion,
        appVersion = _data$appVersion6 === void 0 ? '' : _data$appVersion6,
        _data$appName6 = data.appName,
        appName = _data$appName6 === void 0 ? '' : _data$appName6,
        _data$appType6 = data.appType,
        appType = _data$appType6 === void 0 ? '' : _data$appType6,
        _data$appEnvName6 = data.appEnvName,
        appEnvName = _data$appEnvName6 === void 0 ? '' : _data$appEnvName6,
        requirementsVersion = data.requirementsVersion;
      var appErrorMessage = "".concat(errorMessage, ". Failed to parse the requirements version file: ").concat(appName, "@").concat(appType, "/").concat(requirementsVersion, ".json ENV: ").concat(appEnvName, " appVersion: ").concat(appVersion, ".");
      return this.generateHelixError(ErrorCodes.PARSE_SPECS_FILE, data, appErrorMessage, ErrorAnalyticsImpact.CRITICAL);
    }

    /**
     * Generate Analytics Error events
     * AN1001 - No Event Id Found
     * @param  {String} eid The event case ID provided by the client
     * @return {Object}           Formatted helix error event
     */
  }, {
    key: "generateAN1001",
    value: function generateAN1001() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var eid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var errorMap = {
        eventCaseId: Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_6__["isEmpty"])(eid) ? 'Missing Event Case, called track with empty string' : eid,
        errorCategory: 'analytics'
      };
      var appErrorMessage = "Invalid EID:".concat(eid);
      var params = _objectSpread(_objectSpread({}, data), {}, {
        appClientErrorCode: "AN-".concat(ErrorCodes.INVALID_EID),
        appErrorExtras: errorMap
      });
      return this.generateHelixError(ErrorCodes.INVALID_EID, params, appErrorMessage, ErrorAnalyticsImpact.CRITICAL);
    }

    /**
     * Generate Analytics Error event based on error code
     * @param {String} errorCode       Helix Error Code for error event (e.g. 2000)
     * @param  {Object} errorData      Optional additional data for error event
     * @param {String} errorMsg        Optional error message
     * @return {Object}                Formatted helix error event
     */
  }, {
    key: "generateHelixError",
    value: function generateHelixError() {
      var errorCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UNDEFINED';
      var errorData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var errorMsg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'UNDEFINED';
      var analyticsImpact = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ErrorAnalyticsImpact.ERROR;
      return Object.assign(errorData, {
        msgEventType: HelixErrorData.EVENT_TYPE,
        eventCaseId: this.errorEID,
        appErrorCode: "AN-".concat(errorCode),
        appErrorMessage: "".concat(errorMsg),
        appErrorType: HelixErrorData.ERROR_TYPE,
        errorAnalyticsImpact: analyticsImpact
      });
    }

    /**
     * Report Analytics Error events directly to the collector.
     * @param  {Object} data The data for error event
     * @return {Promise}     resolves with the result, otherwise errors
     */
  }, {
    key: "postHelixError",
    value: function postHelixError(data) {
      // if no visitId, use fallback visitId and write basic application fields
      // to storage so the quantum chrome extension can still load the visit
      var domain = getDomain(this.config);
      var fallbackVisitId = getFallbackVisitId(domain);
      var errorData = _objectSpread(_objectSpread({}, data), {}, {
        sequenceNumber: 0,
        visitId: fallbackVisitId
      });
      if (errorData.visitId === fallbackVisitId) {
        writeBaseFieldsToStorage(errorData);
      }
      var error = this.generateErrorObject(errorData, domain);
      return Object(_httpServices__WEBPACK_IMPORTED_MODULE_4__["postToCollector"])(error, domain);
    }
  }]);
  return HelixError;
}();


/***/ }),

/***/ "./src/utils/helpers.js":
/*!******************************!*\
  !*** ./src/utils/helpers.js ***!
  \******************************/
/*! exports provided: removeNullEntries, isObject, isEmpty, isNil, mergeList, typeCast, deepMerge, helixVersion, validRequirementsResponse, validateResponse, stringify, trimAndTruncate, lowercase, includesLower */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeNullEntries", function() { return removeNullEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNil", function() { return isNil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeList", function() { return mergeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "typeCast", function() { return typeCast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepMerge", function() { return deepMerge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "helixVersion", function() { return helixVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validRequirementsResponse", function() { return validRequirementsResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateResponse", function() { return validateResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stringify", function() { return stringify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trimAndTruncate", function() { return trimAndTruncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lowercase", function() { return lowercase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includesLower", function() { return includesLower; });
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Logger */ "./src/utils/Logger.js");





/**
 * Removed empty and null values from object
 * @param  {Any}  value
 * @return {Boolean}
 */

var removeNullEntries = function removeNullEntries(obj) {
  var cleanedObj = {};
  for (var key in obj) {
    if (!(isNil(obj[key]) || isEmpty(obj[key]))) {
      cleanedObj[key] = obj[key];
    }
  }
  return cleanedObj;
};
/**
 * Check if the value is object.
 * @param  {Any}  value
 * @return {Boolean}
 */
var isObject = function isObject(value) {
  return value !== null && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(value) === 'object' && !Array.isArray(value);
};

/**
 * Returns true if the given value is its type's empty value; false otherwise.
 * @param  {Any}  value
 * @return {Boolean}
 */
var isEmpty = function isEmpty(value) {
  if (isObject(value)) {
    return Object.keys(value).length === 0;
  }
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (typeof value === 'string') {
    return !value;
  }
  return false;
};

/**
 * checks if value is null or undefined
 * @param  {Any}  value
 * @return {Boolean}
 */
var isNil = function isNil(value) {
  if (value === null || typeof value === 'undefined') {
    return true;
  }
  return false;
};

/**
 * Accepts an array of objects and combines the array into a single object
 * containing all of the properties contained within the array of objects.
 * [{foo: val1}, {bar: val2}] becomes {foo: val1, bar: val2}
 * @param dataList
 */
var mergeList = function mergeList(dataList) {
  var mergedData = {};
  try {
    if (dataList && dataList.length > 0) {
      var _dataList = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(dataList, 1);
      mergedData = _dataList[0];
      for (var x = 1; x < dataList.length; x += 1) {
        mergedData = Object.assign(mergedData, dataList[x]);
      }
    }
  } catch (err) {
    _Logger__WEBPACK_IMPORTED_MODULE_3__["default"].error(JSON.stringify(err));
  }
  return mergedData;
};

/**
 * Convert given value to asked type
 * @param  {string} value Value to convert
 * @param  {string} type  Type to which value should be converted
 * @return {*}       [description]
 */
var typeCast = function typeCast(value, type) {
  if (isNil(value)) {
    return null;
  }
  switch (type) {
    case 'boolean':
    case 'bool':
      return value === 'true';
    case 'int':
    case 'long':
    case 'double':
    case 'number':
      return Number(value);
    default:
      return value;
  }
};

/**
 * deep merge objects and return new object
 * if any argument is not an object, it will ignore it.
 * @param  {Object} rest Objects to merge into one
 * @return {Object}      deeply merged objects
 */
var deepMerge = function deepMerge() {
  for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
    rest[_key] = arguments[_key];
  }
  return rest.reduce(function (obj, r) {
    var rVal = r;
    if (Array.isArray(rVal)) {
      rVal = mergeList(rVal);
    }
    if (!isObject(rVal)) {
      return obj;
    }
    Object.keys(rVal).forEach(function (key) {
      var prevVal = obj[key];
      var currVal = rVal[key];
      /* eslint-disable no-param-reassign */
      if (Array.isArray(prevVal) && Array.isArray(currVal)) {
        var _obj$key;
        obj[key] = (_obj$key = obj[key]).concat.apply(_obj$key, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(currVal));
      } else if (isObject(prevVal) && isObject(currVal)) {
        obj[key] = deepMerge(prevVal, currVal);
      } else {
        obj[key] = isNil(currVal) ? prevVal : currVal;
      }
      /* eslint-enable */
    });

    return obj;
  }, {});
};

/**
 * Given an encoded json file, return the decoded version.
 */

var helixVersion = function helixVersion() {
  return "4.38.0" || false;
};

/**
 * Validate the response received from service.
 * @param  {Object} data Data received from service. Either from S3 or from local url
 * @return {Boolean}     true if the response received from service is valid. else false
 */

var validRequirementsResponse = function validRequirementsResponse(data) {
  if (isNil(data) || isNil(data.eventCases) || isNil(data.eventTypes)) {
    return false;
  }
  return !(isEmpty(data.eventCases) || isEmpty(data.eventTypes));
};
var validateResponse = function validateResponse(response, url) {
  var data = typeof response === 'string' ? JSON.parse(response) : response;
  var isConfigFile = url.includes('cfg_');
  if (isEmpty(data)) {
    return false;
  }
  if (!isConfigFile) {
    return validRequirementsResponse(data);
  }
  if (isNil(data === null || data === void 0 ? void 0 : data.config) || isNil(data === null || data === void 0 ? void 0 : data.specsHash)) {
    return false;
  }
  return true;
};

/**
 * converts value to a string
 * @param  {Any}  value
 * @return {String}
 */
var stringify = function stringify(value) {
  if (value === undefined) {
    return 'undefined';
  }
  if (value === null) {
    return 'null';
  }
  if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(value) === 'object') {
    return JSON.stringify(value);
  }
  return typeof value === 'string' ? value : value.toString();
};

/**
 * removes extra whitespace from string and truncates if
 * the string is longer than the specified maxLength
 * @param  {String}  value
 * @param {Number}  maxLength
 * @return {String}
 */
var trimAndTruncate = function trimAndTruncate() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var maxLength = arguments.length > 1 ? arguments[1] : undefined;
  if (typeof value === 'string') {
    var trimmedValue = value.trim();
    return typeof maxLength === 'undefined' ? trimmedValue : trimmedValue.slice(0, maxLength).trim();
  }
};

/**
 * converts the string to lowercase
 * @param  {String}  value
 * @return {String}
 */
var lowercase = function lowercase() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.toLowerCase();
};

/**
 * Converts the string and substring to lowercase and checks
 * that the substring is included in the string
 * e.g. a string of 'test' and substring of 'ST' will return true
 * @param  {String}  value
 * @return {Boolean}
 */
var includesLower = function includesLower(substring, str) {
  return typeof str === 'string' ? lowercase(str).includes(lowercase(substring)) : false;
};

/***/ }),

/***/ "./src/utils/httpServices.js":
/*!***********************************!*\
  !*** ./src/utils/httpServices.js ***!
  \***********************************/
/*! exports provided: fetchNative, fetchXHR, httpRequest, fetchS3, postToCollector, fetchFromUrl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchNative", function() { return fetchNative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchXHR", function() { return fetchXHR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "httpRequest", function() { return httpRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchS3", function() { return fetchS3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postToCollector", function() { return postToCollector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchFromUrl", function() { return fetchFromUrl; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Logger */ "./src/utils/Logger.js");
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./storage */ "./src/utils/storage.js");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./helpers */ "./src/utils/helpers.js");
/* harmony import */ var _defaultData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./defaultData */ "./src/utils/defaultData.js");
/* harmony import */ var _helixError__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./helixError */ "./src/utils/helixError.js");




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var XHR_TIMEOUT = 3000;
var ENCODER_VERSION = 'v3';
var S3_BASE_URL = 'https://cdn.pi.spectrum.net';
var METHODS = {
  GET: 'GET',
  POST: 'POST'
};
var fetchNative = /*#__PURE__*/function () {
  var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee(method, url) {
    var config,
      data,
      body,
      options,
      response,
      status,
      ok,
      json,
      _error$response,
      _args = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          config = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          data = _args.length > 3 ? _args[3] : undefined;
          _context.prev = 2;
          body = data ? {
            body: JSON.stringify(data)
          } : {};
          options = _objectSpread({
            method: method,
            mode: 'cors',
            // no-cors, *cors, same-origin
            cache: 'no-cache',
            // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'omit',
            // include, *same-origin, omit
            headers: method !== 'GET' ? {
              'Content-Type': config.contentType || 'application/json'
            } : {},
            redirect: 'follow',
            // manual, *follow, error
            referrerPolicy: 'no-referrer'
          }, body);
          _context.next = 7;
          return fetch(url, options);
        case 7:
          response = _context.sent;
          status = response.status, ok = response.ok;
          if (ok) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", {
            response: {},
            status: status
          });
        case 11:
          _context.next = 13;
          return response.json();
        case 13:
          json = _context.sent;
          return _context.abrupt("return", {
            response: JSON.stringify(json),
            status: status
          });
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", {
            error: _context.t0,
            status: _context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status
          });
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 17]]);
  }));
  return function fetchNative(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchXHR = function fetchXHR(method, url) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = arguments.length > 3 ? arguments[3] : undefined;
  return new Promise(function (resolve, reject) {
    var xhttp = new XMLHttpRequest();
    /* eslint-disable func-names */
    xhttp.onreadystatechange = function () {
      if (xhttp.readyState === 4) {
        if (xhttp.status >= 400) {
          reject({
            error: xhttp,
            status: xhttp === null || xhttp === void 0 ? void 0 : xhttp.status
          });
        }
        resolve({
          response: xhttp.responseText,
          status: xhttp === null || xhttp === void 0 ? void 0 : xhttp.status
        });
      }
    };
    /* eslint-enable */
    if (!config.username || !config.password) {
      xhttp.open(method, url, true);
    } else {
      xhttp.open(method, url, true, config.username, config.password);
    }
    if (config.contentType) {
      xhttp.setRequestHeader('Content-Type', config.contentType);
    }
    xhttp.timeout = XHR_TIMEOUT;
    xhttp.send(JSON.stringify(data));
  });
};
var httpRequest = /*#__PURE__*/function () {
  var _ref2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee2(method, url) {
    var config,
      data,
      _args2 = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          config = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          data = _args2.length > 3 ? _args2[3] : undefined;
          if (!(typeof window !== 'undefined' && typeof window.fetch !== 'undefined')) {
            _context2.next = 8;
            break;
          }
          _context2.next = 5;
          return fetchNative(method, url, config, data);
        case 5:
          _context2.t0 = _context2.sent;
          _context2.next = 11;
          break;
        case 8:
          _context2.next = 10;
          return fetchXHR(method, url, config, data);
        case 10:
          _context2.t0 = _context2.sent;
        case 11:
          return _context2.abrupt("return", _context2.t0);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function httpRequest(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Get data from S3 bucket.
 * @param  {Object}  config config passed to init
 * @return {Promise}        Retry if download fails, back of each time,
 *                          first try 100ms later, second 200ms and so on
 *                          Return null if response is invalid or call failed.
 *                          Else return data object and store the object to storage.
 */
var fetchS3 = /*#__PURE__*/function () {
  var _ref3 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee4(config) {
    var maxRetries,
      delay,
      setRetryTimeout,
      _setRetryTimeout,
      _config$s3BaseUri,
      s3BaseUri,
      appType,
      appName,
      requirementsVersion,
      specsHash,
      fetchEventsCompleted,
      url,
      isConfig,
      retries,
      _yield$httpRequest,
      response,
      status,
      errorMessage,
      skipRetry,
      afterLastAttempt,
      _args4 = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _setRetryTimeout = function _setRetryTimeout3() {
            _setRetryTimeout = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee3(retries, reason) {
              return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _Logger__WEBPACK_IMPORTED_MODULE_4__["default"].error("".concat(retries, " - S3 download fail, going to retry"), reason);
                    return _context3.abrupt("return", new Promise(function (resolve) {
                      return setTimeout(resolve, retries * delay);
                    }));
                  case 2:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return _setRetryTimeout.apply(this, arguments);
          };
          setRetryTimeout = function _setRetryTimeout2(_x6, _x7) {
            return _setRetryTimeout.apply(this, arguments);
          };
          maxRetries = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 11;
          delay = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : 1000;
          _config$s3BaseUri = config.s3BaseUri, s3BaseUri = _config$s3BaseUri === void 0 ? S3_BASE_URL : _config$s3BaseUri, appType = config.appType, appName = config.appName, requirementsVersion = config.requirementsVersion, specsHash = config.specsHash, fetchEventsCompleted = config.fetchEventsCompleted;
          url = "".concat(s3BaseUri, "/").concat(appName, "/").concat(appType, "/").concat(ENCODER_VERSION, "/").concat(requirementsVersion, ".json");
          isConfig = requirementsVersion.includes('cfg_');
          _Logger__WEBPACK_IMPORTED_MODULE_4__["default"].info("\uD83D\uDD17 Fetching S3 from url: ".concat(url));
          retries = 0;
        case 9:
          if (!(retries < maxRetries)) {
            _context4.next = 56;
            break;
          }
          _context4.prev = 10;
          _context4.next = 13;
          return httpRequest(METHODS.GET, url, config);
        case 13:
          _yield$httpRequest = _context4.sent;
          response = _yield$httpRequest.response;
          status = _yield$httpRequest.status;
          if (!(status >= 400)) {
            _context4.next = 31;
            break;
          }
          _Logger__WEBPACK_IMPORTED_MODULE_4__["default"].error("\uD83D\uDD17 Fail Fetching S3 with status: ".concat(status));
          if (!(isConfig && !specsHash)) {
            _context4.next = 22;
            break;
          }
          throw _helixError__WEBPACK_IMPORTED_MODULE_8__["ErrorCodes"].FETCH_CONFIG_FILE;
        case 22:
          if (!(isConfig && specsHash)) {
            _context4.next = 26;
            break;
          }
          throw _helixError__WEBPACK_IMPORTED_MODULE_8__["ErrorCodes"].RE_FETCH_CONFIG_FILE;
        case 26:
          if (!fetchEventsCompleted) {
            _context4.next = 30;
            break;
          }
          throw _helixError__WEBPACK_IMPORTED_MODULE_8__["ErrorCodes"].RE_FETCH_CONFIG_FILE;
        case 30:
          throw _helixError__WEBPACK_IMPORTED_MODULE_8__["ErrorCodes"].FETCH_SPECS_FILE;
        case 31:
          if (!Object(_helpers__WEBPACK_IMPORTED_MODULE_6__["validateResponse"])(response, url)) {
            _context4.next = 35;
            break;
          }
          return _context4.abrupt("return", response);
        case 35:
          if (!isConfig) {
            _context4.next = 39;
            break;
          }
          throw _helixError__WEBPACK_IMPORTED_MODULE_8__["ErrorCodes"].PARSE_CONFIG_FILE;
        case 39:
          throw _helixError__WEBPACK_IMPORTED_MODULE_8__["ErrorCodes"].PARSE_SPECS_FILE;
        case 40:
          _context4.next = 53;
          break;
        case 42:
          _context4.prev = 42;
          _context4.t0 = _context4["catch"](10);
          errorMessage = (_helixError__WEBPACK_IMPORTED_MODULE_8__["ErrorMessages"] === null || _helixError__WEBPACK_IMPORTED_MODULE_8__["ErrorMessages"] === void 0 ? void 0 : _helixError__WEBPACK_IMPORTED_MODULE_8__["ErrorMessages"][_context4.t0]) || _helixError__WEBPACK_IMPORTED_MODULE_8__["ErrorMessages"][_helixError__WEBPACK_IMPORTED_MODULE_8__["ErrorCodes"].FETCH_FILE];
          _Logger__WEBPACK_IMPORTED_MODULE_4__["default"].debug("Error: ".concat(errorMessage), {
            e: _context4.t0
          });
          skipRetry = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(_context4.t0) === 'object' && _context4.t0.status && _context4.t0.status >= 400 && _context4.t0.status < 500;
          afterLastAttempt = skipRetry || retries + 1 === maxRetries;
          if (afterLastAttempt) {
            _context4.next = 51;
            break;
          }
          _context4.next = 51;
          return setRetryTimeout(retries + 1, errorMessage);
        case 51:
          if (!afterLastAttempt) {
            _context4.next = 53;
            break;
          }
          throw _context4.t0;
        case 53:
          retries++;
          _context4.next = 9;
          break;
        case 56:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[10, 42]]);
  }));
  return function fetchS3(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Post message directly to collector
 * @param data
 * @param domain String "portals" | "video" | "internal_apps" | ""
 * @returns {Promise<*>}
 */
var postToCollector = /*#__PURE__*/function () {
  var _ref4 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee5(data, domain) {
    var fallbackCollectorUrl, _ref5, _ref5$settings, _ref5$settings2, _ref5$settings2$endpo, endpoint, response;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          fallbackCollectorUrl = Object(_defaultData__WEBPACK_IMPORTED_MODULE_7__["getCollectorEndpoint"])(domain);
          _ref5 = Object(_storage__WEBPACK_IMPORTED_MODULE_5__["fetchFromStorage"])('library-state') || {}, _ref5$settings = _ref5.settings, _ref5$settings2 = _ref5$settings === void 0 ? {} : _ref5$settings, _ref5$settings2$endpo = _ref5$settings2.endpoint, endpoint = _ref5$settings2$endpo === void 0 ? fallbackCollectorUrl : _ref5$settings2$endpo;
          _context5.prev = 2;
          _context5.next = 5;
          return httpRequest(METHODS.POST, endpoint, {
            contentType: 'application/json'
          }, data);
        case 5:
          response = _context5.sent;
          return _context5.abrupt("return", response.response);
        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5["catch"](2);
          _Logger__WEBPACK_IMPORTED_MODULE_4__["default"].error("Failed to post to collector: ".concat(JSON.stringify(_context5.t0)));
          return _context5.abrupt("return", null);
        case 13:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[2, 9]]);
  }));
  return function postToCollector(_x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Fetch the data from url provided
 * @param  {String}  url URL to fetch the data from
 * @return {Promise}     Return null if response is invalid or call failed. Else return data object
 */
var fetchFromUrl = /*#__PURE__*/function () {
  var _ref6 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee6(url) {
    var response;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return httpRequest(METHODS.GET, url);
        case 3:
          response = _context6.sent;
          return _context6.abrupt("return", response.response);
        case 7:
          _context6.prev = 7;
          _context6.t0 = _context6["catch"](0);
          _Logger__WEBPACK_IMPORTED_MODULE_4__["default"].error("Failed to fetch from url: ".concat(url, " Error: ").concat(JSON.stringify(_context6.t0)));
          return _context6.abrupt("return", null);
        case 11:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 7]]);
  }));
  return function fetchFromUrl(_x10) {
    return _ref6.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./src/utils/mappings.js":
/*!*******************************!*\
  !*** ./src/utils/mappings.js ***!
  \*******************************/
/*! exports provided: keyMappings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyMappings", function() { return keyMappings; });
var keyMappings = {
  linkAdditionalInfo: 'additionalInformation',
  opSuccess: 'success',
  appApiResponseCode: 'responseCode',
  appApiResponseText: 'responseText',
  appApiResponseTimeMs: 'responseTimeMs',
  appApiResponseSize: 'responseSize',
  appApiHost: 'host',
  appApiPath: 'path',
  appApiHttpVerb: 'httpVerb',
  appApiCached: 'apiCached',
  appApiQueryParameters: 'queryParameters',
  appApiTraceId: 'traceId',
  appApiRetry: 'retry',
  appApiWillRetry: 'willRetry',
  appApiRetryCnt: 'retryCount',
  appApiMaxRetryCnt: 'maxRetryCount',
  appRefLink: 'referrerLink',
  currPageSecName: 'pageSectionName',
  currPageElemStrValue: 'elementStringValue',
  currPageElemUrl: 'elementUrl',
  msgTriggeredBy: 'triggeredBy',
  msgTriggeredUsing: 'triggeredUsing',
  opType: 'operationType',
  appErrorCode: 'errorCode',
  appClientErrorCode: 'clientErrorCode',
  appErrorMessage: 'errorMessage',
  appErrorExtras: 'errorExtras',
  currPageComponents: 'components',
  msgFeatureStepName: 'featureStepName',
  networkConnectType: 'connectionType',
  codeFileName: 'fileName',
  codeFnName: 'functionName',
  codeLineNbr: 'lineNumber',
  techType: 'technologyType',
  appErrorType: 'errorType',
  accessibilityMode: 'accessibility',
  msgFeatureName: 'featureName',
  msgFeatureType: 'featureType',
  msgContext: 'context',
  msgFeatureCurrStep: 'featureCurrentStep',
  msgFeatureNbrOfSteps: 'featureNumberOfSteps',
  msgFeatureTransactionId: 'transactionId',
  opUserPrefsSelections: 'userPreferencesSelections',
  pmtAmount: 'paymentAmountUsd',
  pmtDate: 'paymentDate',
  pmtDueDate: 'paymentDueDate',
  statementDate: 'statementAge',
  pmtMethod: 'paymentMethod',
  loginCompletedTs: 'oAuthExpirationTimestamp',
  appRefLocation: 'referrerLocation',
  opUserText: 'entryText',
  loginAttemptId: 'authAttemptId',
  accountOauthToken: 'oAuthToken',
  accountTokenType: 'tokenType',
  msgFeaturePrevStep: 'featurePreviousStep',
  modalLoadTimeMs: 'loadTimeMs',
  currPagePmtMethod: 'paymentMethod',
  totalAmtDue: 'totalAmountDue',
  pastDueAmt: 'pastDueAmount',
  currentBalAmt: 'currentBalanceAmount',
  currPageAppSection: 'appSection',
  currPageAppliedSorts: 'appliedSorts',
  currPageAppliedFilters: 'appliedFilters',
  currPageSecItemCnt: 'pageSectionNumberOfItems',
  pageSecAllDisplayed: 'sectionAllDisplayed',
  pageSubSecAllDisplayed: 'subSectionAllDisplayed',
  currPageName: 'pageName',
  currPageTitle: 'pageTitle',
  currPageId: 'pageId',
  currPagePageType: 'pageType',
  currPagePageViewType: 'pageViewType',
  currPagePageDisplayType: 'pageDisplayType',
  currPageIsLazyLoad: 'isLazyLoad',
  msgCategory: 'category',
  searchElem: 'numberOfSearchResults',
  searchResultsMs: 'resultsMs',
  searchQueryId: 'queryId',
  currPageSecIndex: 'pageSectionIndex',
  currPageSubsecName: 'pageSubSectionName',
  currPageSubsecIndex: 'pageSubSectionIndex',
  currPageSubsecItemCnt: 'pageSubSectionNumberOfItems',
  currPageElemStdName: 'elementStandardizedName',
  currPageElemUiName: 'elementUiName',
  currPageElemItemCnt: 'elementNumberOfItems',
  currPageElemType: 'elementType',
  currPageElemIndex: 'elementIndex',
  currPageElemIntValue: 'elementIntValue',
  userName: 'entryType',
  opToggleState: 'toggleState',
  opUserEntryStrValue: 'entryStrValue',
  opZipcode: 'zipcode',
  opPhoneNumber: 'phoneNumber',
  opEmail: 'email',
  opAccountNumber: 'accountNumber',
  opSecurityCode: 'securityCode',
  opUserPrefCat: 'userPreferenceCategory',
  opSettingsUpdates: 'settingsUpdates',
  appName: 'applicationName',
  appType: 'applicationType',
  appEnv: 'environment',
  appEnvName: 'environmentName',
  prevVisitId: 'previousVisitId',
  appDisplayDef: 'appDisplayDefinition',
  deviceVendorIdMap: 'vendorId',
  deviceVendorId: 'vendorId.vendorId',
  deviceFormFactor: 'formFactor',
  deviceManufacturer: 'manufacturer',
  deviceOperatingSystem: 'operatingSystem',
  deviceUuid: 'deviceUUID',
  deviceSecondaryUuid: 'deviceSecondaryUUID',
  deviceAvailStorage: 'availableStorage',
  deviceUsedStorage: 'usedStorage',
  thirdPtyAccRequesterId: 'requesterId',
  thirdPtyAccResourceId: 'resourceId',
  analyticsLibVersion: 'libraryVersion',
  analyticsReqVersion: 'requirementsVersion',
  analyticsInitTimeMs: 'libraryInitTimeMs',
  analyticsReqResponseTimeMs: 'requirementsResponseTimeMs',
  analyticsReqSource: 'requirementsSource',
  accountBulkMduClass: 'bulkMduClass',
  accountTimeZone: 'timeZone',
  accountEntitlements: 'entitlements',
  opUserFeedback: 'userFeedback',
  opUserCat: 'entryCategory',
  opUserEntryNumeric: 'entryNumeric',
  opSurveyId: 'surveyId',
  opQuestionId: 'questionId',
  opFeedbackId: 'feedbackId',
  adNbr: 'adNumber',
  adDeviceAdId: 'deviceAdId',
  adDurSec: 'adDurationSec',
  currPageChnlLineupNbrAvailChnls: 'numberAvailableChannels',
  currPageChnlLineupNbrUnavailChnls: 'numberUnavailableChannels',
  plbkConcurrencyEvent: 'concurrencyEvent',
  plbkConcurrencyBlocked: 'concurrencyBlocked',
  plbkConcurrencyAegisCount: 'concurrencyAegisCount',
  plbkConcurrencyToken: 'concurrencyToken',
  plbkConcurrencyPolicyMaxAegisLimit: 'concurrencyPolicyMaxAegisLimit',
  plbkConcurrencyPolicyType: 'concurrencyPolicyType',
  plbkConcurrencyPolicyName: 'concurrencyPolicyName',
  plbkConcurrencyPolicyNetworkIds: 'concurrencyPolicyNetworkIds',
  plbkConcurrencyPolicyContentTypes: 'concurrencyPolicyContentTypes',
  currPageCampaignId: 'pageViewCampaignId',
  opUserPinType: 'pinType',
  plbkBtRtCurrBtRtBps: 'currentBitRateBps',
  videoPlyrSetProfileDrmSecurityLevel: 'videoPlayerSettingsProfile.drmSecurityLevel',
  plbkRetryAttempts: 'playbackRetryAttempts',
  plbkRetryMethod: 'playbackRetryMethod',
  devicePlayerDetails: 'playerDetails',
  ctntDetailsRuntime: 'runtime',
  ctntContentClass: 'contentClass',
  ctntContentFormat: 'contentFormat',
  ctntIdDvrRecordingId: 'dvrRecordingId',
  ctntIdProviderAssetId: 'providerAssetId',
  ctntIdTmsGuideId: 'tmsGuideId',
  ctntIdPlatformSeriesId: 'platformSeriesId',
  ctntIdTmsSeriesId: 'tmsSeriesId',
  ctntIdTmsSeriesConnectorId: 'tmsSeriesConnectorId',
  ctntIdTmsProgramId: 'tmsProgramId',
  ctntPurchaseId: 'purchaseId',
  ctntRntlDurHours: 'rentalDurationHours',
  ctntRntlExpDate: 'rentalExpirationDate',
  ctntDetailsExpirationDate: 'expirationDate',
  ctntStrmPlbkType: 'playbackType',
  ctntStrmingFormat: 'streamingFormat',
  ctntStrmDrmType: 'drmType',
  ctntStrmScrubbingCapability: 'scrubbingCapability',
  ctntStrmCCCapable: 'closedCaptioningCapable',
  ctntStrmSapCapable: 'sapCapable',
  ctntStrmBkmrkPosSec: 'bookmarkPositionSec',
  ctntStrmEntitled: 'entitled',
  ctntStrmParntllyBlocked: 'parentallyBlocked',
  ctntStrmPlbkId: 'playbackId',
  ctntStrmPurchaseType: 'purchaseType',
  ctntStrmPrice: 'price',
  ctntStrmRecStartTs: 'recordingStartTimestamp',
  ctntStrmRecStopTs: 'recordingStopTimestamp',
  ctntStrmPgmrCallSign: 'callSign',
  ctntStrmPgmrFavorited: 'favorite',
  ctntPgmrLinearChnlNumber: 'channelNumber',
  ctntDetailsTitle: 'contentDetailsTitle',
  ctntDetailsActualRuntime: 'actualRuntime',
  ctntNmbrAudioSources: 'numberOfAudioSources',
  plbkDroppedFrames: 'droppedFrames',
  plbkFrameRate: 'frameRate',
  plbkBufferLengthMs: 'bufferLengthMs',
  plbkDaiEnabled: 'daiEnabled',
  plbkHeartBeatPlayPointTs: 'playPointTimestamp',
  videoPlyrSetProfile: 'videoPlayerSettingsProfile',
  videoPlyrSetProfileName: 'videoPlayerSettingsProfile.profileName',
  videoPlyrSetProfileAlg: 'videoPlayerSettingsProfile.algorithm',
  videoPlyrSetProfileStartBitrate: 'videoPlayerSettingsProfile.startingBitrate',
  videoPlyrSetProfileRcmdBps: 'recommendedBitrateBps',
  ctntStrmCtntUri: 'contentUri',
  plbkTrickPlayScrubType: 'scrubType',
  plbkTrickPlayScrubSpeed: 'scrubSpeed',
  plbkTrickPlayScrubStartPosSec: 'startPositionSec',
  plbkTrickPlayScrubEndPosSec: 'endPositionSec',
  opRecOptions: 'recordingOptions',
  searchSelResultName: 'selectedResultName',
  searchSelResultFacet: 'selectedResultFacet',
  plbkOtaMissing: 'otaMissing',
  opSwitchScreenDirection: 'switchScreenDirection',
  opSwitchScreenId: 'switchScreenId',
  accountFeaturesBoxless: 'boxless',
  accountFeaturesCdvr: 'cDvr',
  accountFeaturesSmb: 'smb',
  deviceGuideType: 'guideType',
  videoZoneDivision: 'division',
  videoZoneLineup: 'lineup',
  accountDetailsBillStatus: 'billingStatus',
  accountDetailsAutoPayStatus: 'autoPayStatus',
  amountDueSource: 'billingAmountDueSource',
  accountDetailsStatementMethod: 'statementMethod',
  accountDetailsApptScheduled: 'appointmentScheduled',
  accountDetailsMso: 'mso',
  accountSystemSys: 'systemSys',
  accountSystemPrin: 'systemPrin',
  accountSystemAgent: 'systemAgent',
  pageViewAdditionalInfo: 'currentPageAdditionalInfo',
  currPageElemSelOptions: 'selectedOptions',
  currPageUrl: 'pageUrl',
  deviceLinkedName: 'linkedDeviceName',
  deviceLinkedId: 'linkedDeviceId',
  currPageSettings: 'settings',
  currPageSettingsAutoplayEnabled: 'settingsAutoplayEnabled',
  deviceLinkedIp: 'linkedDeviceIpAddress'
};

/***/ }),

/***/ "./src/utils/storage.js":
/*!******************************!*\
  !*** ./src/utils/storage.js ***!
  \******************************/
/*! exports provided: default, fetchFromStorage, writeToStorage, removeFromStorage, STORAGE_KEYS, writeToSessionStorage, fetchFromSessionStorage, removeFromSessionStorage, getCookie, writeCookie */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchFromStorage", function() { return fetchFromStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeToStorage", function() { return writeToStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFromStorage", function() { return removeFromStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORAGE_KEYS", function() { return STORAGE_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeToSessionStorage", function() { return writeToSessionStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchFromSessionStorage", function() { return fetchFromSessionStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFromSessionStorage", function() { return removeFromSessionStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCookie", function() { return getCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeCookie", function() { return writeCookie; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);

var storage = {
  /**
   * @return {Object} storage being used
   */
  getStorage: function getStorage() {
    var ls = typeof self !== 'undefined' ? self.localStorage : null;
    return this._storage === null ? null : this._storage || ls;
  },
  /**
   * implement your own storage
   * @param {Object} clientStorage Storage object to use to store values.
   */
  setCustomStorage: function setCustomStorage(newStorage) {
    if (typeof newStorage === 'function' && !newStorage.get('library-debugger')) {
      newStorage.setItem('library-debugger', JSON.stringify({
        forceLogInfo: false
      }));
    }
    this._storage = newStorage;
  },
  /**
   * reset storage to its default (localStorage)
   */
  resetStorage: function resetStorage() {
    this._storage = typeof self !== 'undefined' ? self.localStorage : null;
  },
  removeCustomStorage: function removeCustomStorage() {
    this._storage = null;
  }
};
/* harmony default export */ __webpack_exports__["default"] = (storage);

/**
 * fetch value from storage.
 * @param  {String} key Name of the key used to store the value
 * @return {Any}        Parse and return if the value is JSON.
 */
var fetchFromStorage = function fetchFromStorage(key) {
  // stop if storage is not defined or key is falsy.
  if (!storage.getStorage() || !key) {
    return;
  }
  var value = storage.getStorage().getItem(key);
  if (!value) {
    return;
  }
  try {
    return JSON.parse(value); // eslint-disable-line consistent-return
  } catch (e) {
    return value; // eslint-disable-line consistent-return
  }
};

/**
 * write data to storage
 * @param  {String} key   Key to store with
 * @param  {String} value    Value to store
 */
var writeToStorage = function writeToStorage(key, value) {
  // stop if storage is not defined or if value or key is not defined.
  if (!storage.getStorage() || !value || !key) {
    return;
  }
  var val = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value) === 'object' ? JSON.stringify(value) : value;
  storage.getStorage().setItem(key, val);
};

/**
 * Remove data from storage.
 * @param  {String} key Key used to store the data.
 */
var removeFromStorage = function removeFromStorage(key) {
  // stop if storage is not defined.
  if (!storage.getStorage()) {
    return;
  }
  try {
    storage.getStorage().removeItem(key);
  } catch (e) {
    try {
      storage.getStorage().reset(key);
    } catch (e) {
      return;
    }
  }
};

/**
 * keys used for storage should be defined here
 * @type {Object}
 */
var STORAGE_KEYS = {
  REQUIREMENTS: 'requirements',
  LIBRARY_STATE: 'library-state',
  INITIAL_LIBRARY_STATE: 'initial-library-state',
  DEBUGGER: 'library-debugger'
};

// @TODO: Refactor custom storage to be a class and remove below code
// https://gitlab.spectrumflow.net/product-intelligence/quantum-js-helix/-/issues/14

/**
 * write data to storage
 * @param  {String} key   Key to store with
 * @param  {String} value    Value to store
 */
var writeToSessionStorage = function writeToSessionStorage(key, value) {
  // stop if storage is not defined or key is falsy.
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined' || !key) return;
  try {
    var val = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value) === 'object' ? JSON.stringify(value) : value;
    sessionStorage.setItem(key, val);
  } catch (e) {
    return;
  }
};
var fetchFromSessionStorage = function fetchFromSessionStorage(key) {
  // stop if storage is not defined or key is falsy.
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined' || !key) return;
  var value = sessionStorage.getItem(key);
  if (!value) {
    return;
  }
  try {
    return JSON.parse(value); // eslint-disable-line consistent-return
  } catch (e) {
    return value; // eslint-disable-line consistent-return
  }
};

var removeFromSessionStorage = function removeFromSessionStorage(key) {
  // stop if storage is not defined or key is falsy.
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined' || !key) return;
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    return;
  }
};

/**
 * Gets the top-level domain from the current location for setting cookies.
 *
 * @returns {string} The cookie domain, or an empty string if it can't be determined.
 */

function getCookieDomain() {
  if (typeof window === 'undefined') return '';
  try {
    var _window, _window$location;
    var match = (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname.match(/[^.]*\.[^.]*$/)[0];
    return match || ''; // Return empty string  if no match is found
  } catch (err) {
    var _window2, _window2$location;
    return (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.hostname;
  }
}

/**
 * Retrieves the value of a cookie.
 *
 * @param {string} name - The name of the cookie.
 * @returns {string|undefined} The cookie value, or undefined if the cookie is not found.
 */

var getCookie = function getCookie(name) {
  if (typeof document === 'undefined') return;
  var cookieValue = document.cookie.split('; ').find(function (row) {
    return row.startsWith(name + '=');
  });
  return cookieValue ? decodeURIComponent(cookieValue.split('=')[1]) : undefined; // Use decodeURIComponent to handle special characters
};

/**
 * Writes a cookie with an optional expiration date.
 *
 * @param {string} name - The name of the cookie.
 * @param {string} value - The value to set for the cookie.
 * @param {Date} [expires] - Optional expiration date for the cookie.
 */
var writeCookie = function writeCookie(name, value, expires) {
  if (typeof document === 'undefined') return false;
  var domain = getCookieDomain();
  var cookieString = "".concat(name, "=").concat(encodeURIComponent(value), ";domain=.").concat(domain, ";SameSite=Strict;path=/");
  if (expires) {
    cookieString += ";expires=".concat(expires.toUTCString());
  }
  document.cookie = cookieString;
  return true;
};

/***/ }),

/***/ "./src/utils/uaParser.js":
/*!*******************************!*\
  !*** ./src/utils/uaParser.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UAParser; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helpers */ "./src/utils/helpers.js");



/* eslint-disable no-useless-escape */


/**
 * NOTE: This is a fork of the ua-parser-js npm package that removes all unused functionality and refactored code to align with this repository
 * The purpose for doing this is to remove the ua-parser-js dependency and have more control and security

 * UAParser.js v0.7.31
 * MIT License
 * Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data
 * Source : https://github.com/faisalman/ua-parser-js
 */

//////////////
// Constants
/////////////
var EMPTY = '',
  UNKNOWN = '?',
  FUNC_TYPE = 'function',
  UNDEF_TYPE = 'undefined',
  OBJ_TYPE = 'object',
  STR_TYPE = 'string',
  MODEL = 'model',
  NAME = 'name',
  TYPE = 'type',
  VERSION = 'version',
  ARCHITECTURE = 'architecture',
  CONSOLE = 'console',
  MOBILE = 'mobile',
  TABLET = 'tablet',
  SMARTTV = 'smarttv',
  WEARABLE = 'wearable',
  EMBEDDED = 'embedded',
  UA_MAX_LENGTH = 275;
var APPLE = 'Apple',
  BLACKBERRY = 'BlackBerry',
  BROWSER = 'Browser',
  CHROME = 'Chrome',
  EDGE = 'Edge',
  FIREFOX = 'Firefox',
  OPERA = 'Opera',
  FACEBOOK = 'Facebook';

///////////////
// Map helper
//////////////
function rgxMapper(ua, arrays) {
  var i = 0,
    j,
    k,
    p,
    q,
    matches,
    match;

  // loop through all regexes maps
  while (i < arrays.length && !matches) {
    var regex = arrays[i],
      // even sequence (0,2,4,..)
      props = arrays[i + 1]; // odd sequence (1,3,5,..)
    j = k = 0;

    // try matching uastring with regexes
    while (j < regex.length && !matches) {
      matches = regex[j++].exec(ua);
      if (matches) {
        for (p = 0; p < props.length; p++) {
          match = matches[++k];
          q = props[p];
          // check if given property is actually array
          if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(q) === OBJ_TYPE && q.length > 0) {
            if (q.length === 2) {
              if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(q[1]) == FUNC_TYPE) {
                // assign modified match
                this[q[0]] = q[1].call(this, match);
              } else {
                // assign given value, ignore regex match
                this[q[0]] = q[1];
              }
            } else if (q.length === 3) {
              // check whether function or regex
              if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                // call function (usually string mapper)
                this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
              } else {
                // sanitize match using given regex
                this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
              }
            } else if (q.length === 4) {
              this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
            }
          } else {
            this[q] = match ? match : undefined;
          }
        }
      }
    }
    i += 2;
  }
}
function strMapper(str, map) {
  for (var i in map) {
    // check if current value is array
    if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(map[i]) === OBJ_TYPE && map[i].length > 0) {
      for (var j = 0; j < map[i].length; j++) {
        if (Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["includesLower"])(map[i][j], str)) {
          return i === UNKNOWN ? undefined : i;
        }
      }
    } else if (Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["includesLower"])(map[i], str)) {
      return i === UNKNOWN ? undefined : i;
    }
  }
  return str;
}

///////////////
// String map
//////////////

// Safari < 3.0
var oldSafariMap = {
  '1.0': '/8',
  '1.2': '/1',
  '1.3': '/3',
  '2.0': '/412',
  '2.0.2': '/416',
  '2.0.3': '/417',
  '2.0.4': '/419',
  '?': '/'
};
var windowsVersionMap = {
  ME: '4.90',
  'NT 3.11': 'NT3.51',
  'NT 4.0': 'NT4.0',
  '2000': 'NT 5.0',
  XP: ['NT 5.1', 'NT 5.2'],
  Vista: 'NT 6.0',
  '7': 'NT 6.1',
  '8': 'NT 6.2',
  '8.1': 'NT 6.3',
  '10': ['NT 6.4', 'NT 10.0'],
  RT: 'ARM'
};

//////////////
// Regex map
/////////////

var regexes = {
  browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
  ], [VERSION, [NAME, 'Chrome']], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
  ], [VERSION, [NAME, 'Edge']], [
  // Presto based
  /(opera mini)\/([-\w\.]+)/i,
  // Opera Mini
  /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
  // Opera Mobi/Tablet
  /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
  ], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
  ], [VERSION, [NAME, OPERA + ' Mini']], [/\bopr\/([\w\.]+)/i // Opera Webkit
  ], [VERSION, [NAME, OPERA]], [
  // Mixed
  /(kindle)\/([\w\.]+)/i,
  // Kindle
  /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
  // Lunascape/Maxthon/Netfront/Jasmine/Blazer
  // Trident based
  /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
  // Avant/IEMobile/SlimBrowser
  /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
  // Baidu Browser
  /(?:ms|\()(ie) ([\w\.]+)/i,
  // Internet Explorer

  // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
  /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
  // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
  /(weibo)__([\d\.]+)/i // Weibo
  ], [NAME, VERSION], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
  ], [VERSION, [NAME, 'UC' + BROWSER]], [/\bqbcore\/([\w\.]+)/i // WeChat Desktop for Windows Built-in Browser
  ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [/micromessenger\/([\w\.]+)/i // WeChat
  ], [VERSION, [NAME, 'WeChat']], [/konqueror\/([\w\.]+)/i // Konqueror
  ], [VERSION, [NAME, 'Konqueror']], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
  ], [VERSION, [NAME, 'IE']], [/yabrowser\/([\w\.]+)/i // Yandex
  ], [VERSION, [NAME, 'Yandex']], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
  ], [[NAME, /(.+)/, '$1 Secure ' + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i // Firefox Focus
  ], [VERSION, [NAME, FIREFOX + ' Focus']], [/\bopt\/([\w\.]+)/i // Opera Touch
  ], [VERSION, [NAME, OPERA + ' Touch']], [/coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
  ], [VERSION, [NAME, 'Coc Coc']], [/dolfin\/([\w\.]+)/i // Dolphin
  ], [VERSION, [NAME, 'Dolphin']], [/coast\/([\w\.]+)/i // Opera Coast
  ], [VERSION, [NAME, OPERA + ' Coast']], [/miuibrowser\/([\w\.]+)/i // MIUI Browser
  ], [VERSION, [NAME, 'MIUI ' + BROWSER]], [/fxios\/([-\w\.]+)/i // Firefox for iOS
  ], [VERSION, [NAME, FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i // 360
  ], [[NAME, '360 ' + BROWSER]], [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [
  // Oculus/Samsung/Sailfish Browser
  /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
  ], [[NAME, /_/g, ' '], VERSION], [/(electron)\/([\w\.]+) safari/i,
  // Electron-based App
  /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
  // Tesla
  /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
  ], [NAME, VERSION], [/(metasr)[\/ ]?([\w\.]+)/i,
  // SouGouBrowser
  /(lbbrowser)/i // LieBao Browser
  ], [NAME], [
  // WebView
  /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
  ], [[NAME, FACEBOOK], VERSION], [/safari (line)\/([\w\.]+)/i,
  // Line App for iOS
  /\b(line)\/([\w\.]+)\/iab/i,
  // Line App for Android
  /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
  ], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
  ], [VERSION, [NAME, 'GSA']], [/headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
  ], [VERSION, [NAME, CHROME + ' Headless']], [/ wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
  ], [[NAME, CHROME + ' WebView'], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
  ], [VERSION, [NAME, 'Android ' + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
  ], [NAME, VERSION], [/version\/([\w\.]+) .*mobile\/\w+ (safari)/i // Mobile Safari
  ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
  ], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
  ], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [
  // Gecko based
  /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
  ], [[NAME, 'Netscape'], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
  ], [VERSION, [NAME, FIREFOX + ' Reality']], [/ekiohf.+(flow)\/([\w\.]+)/i,
  // Flow
  /(swiftfox)/i,
  // Swiftfox
  /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
  // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
  /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
  // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
  /(firefox)\/([\w\.]+)/i,
  // Other Firefox-based
  /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
  // Mozilla

  // Other
  /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
  // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
  /(links) \(([\w\.]+)/i // Links
  ], [NAME, VERSION]],
  cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
  ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
  ], [[ARCHITECTURE, _helpers__WEBPACK_IMPORTED_MODULE_3__["lowercase"]]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
  ], [[ARCHITECTURE, 'ia32']], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
  ], [[ARCHITECTURE, 'arm64']], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
  ], [[ARCHITECTURE, 'armhf']], [
  // PocketPC mistakenly identified as PowerPC
  /windows (ce|mobile); ppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
  ], [[ARCHITECTURE, /ower/, EMPTY, _helpers__WEBPACK_IMPORTED_MODULE_3__["lowercase"]]], [/(sun4\w)[;\)]/i // SPARC
  ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
  // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
  ], [[ARCHITECTURE, _helpers__WEBPACK_IMPORTED_MODULE_3__["lowercase"]]]],
  device: [[
  //////////////////////////
  // MOBILES & TABLETS
  // Ordered by popularity
  /////////////////////////

  // Samsung
  /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [TYPE, MOBILE]], [
  // Apple
  /\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
  ], [MODEL, [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i,
  // iPad
  /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [TYPE, TABLET]], [
  // Huawei
  /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [MODEL, [TYPE, MOBILE]], [
  // Xiaomi
  /\b(poco[\w ]+)(?: bui|\))/i,
  // Xiaomi POCO
  /\b; (\w+) build\/hm\1/i,
  // Xiaomi Hongmi 'numeric' models
  /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
  // Xiaomi Hongmi
  /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
  // Xiaomi Redmi
  /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
  ], [[MODEL, /_/g, ' '], [TYPE, MOBILE]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
  ], [[MODEL, /_/g, ' '], [TYPE, TABLET]], [
  // OPPO
  /; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [TYPE, MOBILE]], [
  // Vivo
  /vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [TYPE, MOBILE]], [
  // Realme
  /\b(rmx[12]\d{3})(?: bui|;|\))/i], [MODEL, [TYPE, MOBILE]], [
  // Motorola
  /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [TYPE, TABLET]], [
  // LG
  /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [TYPE, MOBILE]], [
  // Lenovo
  /(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [TYPE, TABLET]], [
  // Nokia
  /(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, ' '], [TYPE, MOBILE]], [
  // Google
  /(pixel c)\b/i // Google Pixel C
  ], [MODEL, [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
  ], [MODEL, [TYPE, MOBILE]], [
  // Sony
  /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
  // OnePlus
  / (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [TYPE, MOBILE]], [
  // Amazon
  /(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i,
  // Kindle Fire without Silk
  /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
  ], [MODEL, [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
  ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [TYPE, MOBILE]], [
  // BlackBerry
  /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
  ], [MODEL, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i // BlackBerry 10
  ], [MODEL, [TYPE, MOBILE]], [
  // Asus
  /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [TYPE, MOBILE]], [
  // HTC
  /(nexus 9)/i // HTC Nexus 9
  ], [MODEL, [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
  // HTC

  // ZTE
  /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
  ], [[MODEL, /_/g, ' '], [TYPE, MOBILE]], [
  // Acer
  /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [TYPE, TABLET]], [
  // Meizu
  /droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [TYPE, MOBILE]], [
  // Sharp
  /\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [TYPE, MOBILE]], [
  // MIXED
  /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
  // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
  /(hp) ([\w ]+\w)/i,
  // HP iPAQ
  /(asus)-?(\w+)/i,
  // Asus
  /(microsoft); (lumia[\w ]+)/i,
  // Microsoft Lumia
  /(lenovo)[-_ ]?([-\w]+)/i,
  // Lenovo
  /(jolla)/i,
  // Jolla
  /(oppo) ?([\w ]+) bui/i // OPPO
  ], [MODEL, [TYPE, MOBILE]], [/(archos) (gamepad2?)/i,
  // Archos
  /(hp).+(touchpad(?!.+tablet)|tablet)/i,
  // HP TouchPad
  /(kindle)\/([\w\.]+)/i,
  // Kindle
  /(nook)[\w ]+build\/(\w+)/i,
  // Nook
  /(dell) (strea[kpr\d ]*[\dko])/i,
  // Dell Streak
  /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
  // Le Pan Tablets
  /(trinity)[- ]*(t\d{3}) bui/i,
  // Trinity Tablets
  /(gigaset)[- ]+(q\w{1,9}) bui/i,
  // Gigaset Tablets
  /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
  ], [MODEL, [TYPE, TABLET]], [/(surface duo)/i // Surface Duo
  ], [MODEL, [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
  ], [MODEL, [TYPE, MOBILE]], [/(u304aa)/i // AT&T
  ], [MODEL, [TYPE, MOBILE]], [/\bsie-(\w*)/i // Siemens
  ], [MODEL, [TYPE, MOBILE]], [/\b(rct\w+) b/i // RCA Tablets
  ], [MODEL, [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
  ], [MODEL, [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
  ], [MODEL, [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
  ], [MODEL, [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [TYPE, TABLET]], [/\b(k88) b/i // ZTE K Series Tablet
  ], [MODEL, [TYPE, TABLET]], [/\b(nx\d{3}j) b/i // ZTE Nubia
  ], [MODEL, [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
  ], [MODEL, [TYPE, MOBILE]], [/\b(zur\d{3}) b/i // Swiss ZUR Tablet
  ], [MODEL, [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i // Zeki Tablets
  ], [MODEL, [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
  ], [MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i // Insignia Tablets
  ], [MODEL, [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
  ], [MODEL, [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
  ], [MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
  ], [MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i // Essential PH-1
  ], [MODEL, [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
  ], [MODEL, [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
  ], [MODEL, [TYPE, TABLET]], [/\btu_(1491) b/i // Rotor Tablets
  ], [MODEL, [TYPE, TABLET]], [/(shield[\w ]+) b/i // Nvidia Shield Tablets
  ], [MODEL, [TYPE, TABLET]], [/(sprint) (\w+)/i // Sprint Phones
  ], [MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
  ], [[MODEL, /\./g, ' '], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
  ], [MODEL, [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [TYPE, MOBILE]], [
  ///////////////////
  // CONSOLES
  ///////////////////

  /(ouya)/i,
  // Ouya
  /(nintendo) ([wids3utch]+)/i // Nintendo
  ], [MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i // Nvidia
  ], [MODEL, [TYPE, CONSOLE]], [/(playstation [345portablevi]+)/i // Playstation
  ], [MODEL, [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
  ], [MODEL, [TYPE, CONSOLE]], [
  ///////////////////
  // SMARTTVS
  ///////////////////

  /smart-tv.+(samsung)/i // Samsung
  ], [[TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
  ], [[TYPE, SMARTTV]], [/(apple) ?tv/i // Apple TV
  ], [[MODEL, APPLE + ' TV'], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
  ], [[MODEL, CHROME + 'cast'], [TYPE, SMARTTV]], [/droid.+aft(\w)( bui|\))/i // Fire TV
  ], [MODEL, [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
  ], [MODEL, [TYPE, SMARTTV]], [/(bravia[\w- ]+) bui/i // Sony
  ], [MODEL, [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
  // Roku
  /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
  ], [[MODEL, _helpers__WEBPACK_IMPORTED_MODULE_3__["trimAndTruncate"]], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
  ], [[TYPE, SMARTTV]], [
  ///////////////////
  // WEARABLES
  ///////////////////

  /((pebble))app/i // Pebble
  ], [MODEL, [TYPE, WEARABLE]], [/droid.+; (glass) \d/i // Google Glass
  ], [MODEL, [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [TYPE, WEARABLE]], [/(quest( 2)?)/i // Oculus Quest
  ], [MODEL, [TYPE, WEARABLE]], [
  ///////////////////
  // EMBEDDED
  ///////////////////

  /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
  ], [[TYPE, EMBEDDED]], [
  ////////////////////
  // MIXED (GENERIC)
  ///////////////////

  /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
  ], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
  ], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
  ], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
  ], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
  ], [MODEL]],
  engine: [[/windows.+ edge\/([\w\.]+)/i // EdgeHTML
  ], [VERSION, [NAME, EDGE + 'HTML']], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
  ], [VERSION, [NAME, 'Blink']], [/(presto)\/([\w\.]+)/i,
  // Presto
  /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
  // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
  /ekioh(flow)\/([\w\.]+)/i,
  // Flow
  /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
  // KHTML/Tasman/Links
  /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
  ], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
  ], [VERSION, NAME]],
  os: [[
  // Windows
  /microsoft (windows) (vista|xp)/i // Windows (iTunes)
  ], [NAME, VERSION], [/(windows) nt 6\.2; (arm)/i,
  // Windows RT
  /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
  // Windows Phone
  /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [
  // iOS/macOS
  /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
  // iOS
  /cfnetwork\/.+darwin/i], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
  ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
  // Mobile OSes
  /droid ([\w\.]+)\b.+(android[- ]x86)/i // Android-x86
  ], [VERSION, NAME], [
  // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
  /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i,
  // Blackberry
  /(tizen|kaios)[\/ ]([\w\.]+)/i,
  // Tizen/KaiOS
  /\((series40);/i // Series 40
  ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
  ], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
  ], [VERSION, [NAME, 'Symbian']], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
  ], [VERSION, [NAME, FIREFOX + ' OS']], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
  ], [VERSION, [NAME, 'webOS']], [
  // Google Chromecast
  /crkey\/([\d\.]+)/i // Google Chromecast
  ], [VERSION, [NAME, CHROME + 'cast']], [/(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
  ], [[NAME, 'Chromium OS'], VERSION], [
  // Console
  /(nintendo|playstation) ([wids345portablevuch]+)/i,
  // Nintendo/Playstation
  /(xbox); +xbox ([^\);]+)/i,
  // Microsoft Xbox (360, One, X, S, Series X, Series S)

  // Other
  /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
  // Joli/Palm
  /(mint)[\/\(\) ]?(\w*)/i,
  // Mint
  /(mageia|vectorlinux)[; ]/i,
  // Mageia/VectorLinux
  /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
  // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
  /(hurd|linux) ?([\w\.]*)/i,
  // Hurd/Linux
  /(gnu) ?([\w\.]*)/i,
  // GNU
  /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
  // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
  /(haiku) (\w+)/i // Haiku
  ], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i // Solaris
  ], [[NAME, 'Solaris'], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
  // Solaris
  /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
  // AIX
  /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
  // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
  /(unix) ?([\w\.]*)/i // UNIX
  ], [NAME, VERSION]]
};

/////////////////
// Constructor
////////////////
var UAParser = /*#__PURE__*/function () {
  function UAParser(ua) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, UAParser);
    this.ua = ua;
    var _ua = ua || ((typeof window === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(window)) !== UNDEF_TYPE && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
    this.setUA(_ua);
    this._rgxmap = regexes;
    return this;
  }
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(UAParser, [{
    key: "getDevice",
    value: function getDevice() {
      var _device = {};
      _device[MODEL] = undefined;
      _device[TYPE] = undefined;
      rgxMapper.call(_device, this.ua, this._rgxmap.device);
      return _device;
    }
  }, {
    key: "getOS",
    value: function getOS() {
      var _os = {};
      _os[NAME] = undefined;
      _os[VERSION] = undefined;
      rgxMapper.call(_os, this.ua, this._rgxmap.os);
      return _os;
    }
  }, {
    key: "setUA",
    value: function setUA(ua) {
      this.ua = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(ua) === STR_TYPE && ua.length > UA_MAX_LENGTH ? Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["trimAndTruncate"])(ua, UA_MAX_LENGTH) : ua;
      return this;
    }
  }]);
  return UAParser;
}();


/***/ }),

/***/ "./src/utils/urlMapping.js":
/*!*********************************!*\
  !*** ./src/utils/urlMapping.js ***!
  \*********************************/
/*! exports provided: getSortedUrlMappingKeys, urlMapping */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSortedUrlMappingKeys", function() { return getSortedUrlMappingKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "urlMapping", function() { return urlMapping; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_first__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/first */ "./node_modules/lodash/first.js");
/* harmony import */ var lodash_first__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_first__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/colors */ "./src/utils/colors.js");
/* harmony import */ var _utils_helixError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/helixError */ "./src/utils/helixError.js");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }



/**
 * @param {Object} urlMappings Object containing the url-mappings from the requirements file
 * (i.e '/' for homeAuth and homeUnauth EIDs)
 * @returns {Array<string>} array of urlMapping patterns (string) that are sorted based on the "i" key
 * in the urlMappings object. If the objects don't contain an "i" key, then no sorting is necessary
 */
var getSortedUrlMappingKeys = function getSortedUrlMappingKeys(urlMappings) {
  var _urlMappings$_first;
  var urlMappingKeys = Object.keys(urlMappings);
  var shouldSortKeys = ((_urlMappings$_first = urlMappings[lodash_first__WEBPACK_IMPORTED_MODULE_1___default()(urlMappingKeys)]) === null || _urlMappings$_first === void 0 ? void 0 : _urlMappings$_first.i) !== undefined;
  return !shouldSortKeys ? urlMappingKeys : urlMappingKeys.sort(function (a, b) {
    if (urlMappings[a].i < urlMappings[b].i) return -1;
    if (urlMappings[a].i > urlMappings[b].i) return 1;
    return 0;
  });
};

/**
 * Accepts a String url that will then be compared to a collection of regex expressions
 * in the requirements file.  The first string that returns true for a regex find operation
 * will be returned.  If a match is not found for a given URL then an 'Analytics_Generic_Error'
 * will be tracked with an error code of 'ANALYTICS-1100'.
 * @param {String} url Url that should match to a single event case id
 * @param {Object} optionsIn Object containing a keyword to allow for use of duplicate URL's
 * @param {Object} urlMappings Object containing the url-mappings from the requirements file
 * @param {Array<string>} sortedUrlMappingKeys Array containing the regex patterns for each url-mapping,
 * sorted based on the "i" (index) key for each mapping in the requirements file
 * @returns {Object} Event case that best matches the passed in URL
 */
var fetchEidByUrl = function fetchEidByUrl(url, optionsIn) {
  var urlMappings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var sortedUrlMappingKeys = arguments.length > 3 ? arguments[3] : undefined;
  var log = arguments.length > 4 ? arguments[4] : undefined;
  var helixError = arguments.length > 5 ? arguments[5] : undefined;
  var options = optionsIn || {};
  var _options$keyword = options.keyword,
    keyword = _options$keyword === void 0 ? '' : _options$keyword;
  var result = null;
  var start = Date.now();
  try {
    var sortedUrlMappings = sortedUrlMappingKeys !== null && sortedUrlMappingKeys !== void 0 && sortedUrlMappingKeys.length ? sortedUrlMappingKeys : getSortedUrlMappingKeys(urlMappings);
    var _iterator = _createForOfIteratorHelper(sortedUrlMappings),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        // eslint-disable-line no-restricted-syntax
        var re = new RegExp(key);
        if (re.test(url)) {
          log.info("fetchEidByUrl -- key: ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_2__["default"].white, " ").concat(key, ", ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_2__["default"].green, " value: ").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_2__["default"].cyan, " ").concat(JSON.stringify(urlMappings[key])), {
            result: result,
            options: options
          });
          result = Object.assign({}, urlMappings[key]); // clone to avoid mutation
          if (result.keywords) {
            var pos = result.keywords.indexOf(keyword);
            result.eid = result.eid[pos === -1 ? 0 : pos];
          }
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (!result) {
      var errorCode = _utils_helixError__WEBPACK_IMPORTED_MODULE_3__["ErrorCodes"].INVALID_EID;
      var additionalMessage = "urlMapping. No Event Case for URL: ".concat(url);
      log.error("\uD83D\uDED1 ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_2__["default"].red, "AN-").concat(errorCode, " (").concat(_utils_helixError__WEBPACK_IMPORTED_MODULE_3__["ErrorMessages"][errorCode], "):").concat(_utils_colors__WEBPACK_IMPORTED_MODULE_2__["default"].white, "\n ").concat(additionalMessage));
      helixError.reportError(errorCode, {}, additionalMessage);
    }
  } catch (err) {
    log.error("trackByUrl warning: ".concat(err), err);
    log.error(err);
  }
  log.debug("Time to process url regex tests: ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_2__["default"].white).concat(Date.now() - start, "ms"));
  return result;
};
var urlMapping = function urlMapping(eventCaseId, eventsLoaded, urlMappings, sortedUrlMappingKeys, options, params, log, helixError) {
  var eid = eventCaseId;
  var opts = _objectSpread({}, options);
  var paramsIn = _objectSpread({}, params);
  var eventType = (paramsIn === null || paramsIn === void 0 ? void 0 : paramsIn.msgEventType) || (options === null || options === void 0 ? void 0 : options.msgEventType) || (options === null || options === void 0 ? void 0 : options.eventType);
  if (opts.fetchByUrl) {
    log.info("urlMapping check Track path: ".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_2__["default"].white).concat(eid), {
      eventsLoaded: eventsLoaded,
      opts: opts,
      paramsIn: paramsIn,
      urlMappings: urlMappings
    });
  }
  if (eventsLoaded && opts.fetchByUrl) {
    if (eventType === 'pageViewInit') {
      if (opts.useCleanUrl) {
        // removing PII data from URL
        paramsIn.currPageUrl = opts.useCleanUrl;
      } else {
        var _window$location;
        paramsIn.currPageUrl = eid || typeof window !== 'undefined' && ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.href);
      }
    }
    var obj = fetchEidByUrl(eid, opts, urlMappings, sortedUrlMappingKeys, log, helixError);
    if (!obj) return {
      eid: null,
      opts: {},
      paramsIn: {}
    };
    eid = obj.eid;
    log.info("urlMapping - fetchByUrl:".concat(_utils_colors__WEBPACK_IMPORTED_MODULE_2__["default"].white, " ").concat(eid));
    if (eventType === 'pageViewCompleted' && obj.pcSupported) {
      paramsIn.msgEventType = 'pageViewPartiallyRendered';
    }
    opts.fetchByUrl = false;
  }
  return {
    eid: eid,
    opts: opts,
    paramsIn: paramsIn
  };
};

/***/ }),

/***/ "./src/utils/uuid.js":
/*!***************************!*\
  !*** ./src/utils/uuid.js ***!
  \***************************/
/*! exports provided: default, generateVisitId */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return uuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateVisitId", function() { return generateVisitId; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);

/* eslint-disable no-bitwise */
function uuid() {
  var d = new Date().getTime();
  var id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return id;
}
var domainKey = {
  video: 'V',
  internal_apps: 'I',
  portals: 'P'
};

// {YYYYMMDDHHMM}{DOMAIN}-{UUID}
// 202207121129I-296a4548-6eff-4bb6-be53-b3a7a61c49
function generateVisitId(domain) {
  var _Date$toISOString$mat = new Date().toISOString().match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/),
    _Date$toISOString$mat2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_Date$toISOString$mat, 6),
    year = _Date$toISOString$mat2[1],
    month = _Date$toISOString$mat2[2],
    day = _Date$toISOString$mat2[3],
    hour = _Date$toISOString$mat2[4],
    minute = _Date$toISOString$mat2[5];
  var timestamp = "".concat(year).concat(month).concat(day).concat(hour).concat(minute);
  return "".concat(timestamp).concat(domainKey[domain] || 'X', "-").concat(uuid());
}

/***/ }),

/***/ "./src/video.js":
/*!**********************!*\
  !*** ./src/video.js ***!
  \**********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./base */ "./src/base.js");






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var analytics = __webpack_require__(/*! @charter/quantum/build/video/analytics */ "./node_modules/@charter/quantum/build/video/analytics.js"); // eslint-disable-line import/no-dynamic-require
var Video = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default()(Video, _Base);
  var _super = _createSuper(Video);
  function Video() {
    var _this;
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Video);
    _this = _super.call(this);
    /**
     * Assigns video-based library
     * @type {video}
     */
    _this.domain = 'video';
    _this.analytics = analytics;
    return _this;
  }

  /**
   * This function should only be used by users who know what they're doing.
   * It bypasses Helix completely and provides direct access to the Quantum client.
   * @return {Object} Fetch the underlying Quantum library.
   *
   */
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Video, [{
    key: "quantum",
    get: function get() {
      var sdkMethods = Object.keys(analytics.core.eventInput) || [];
      // restartFlow - OVP needs this method Quantum that is not part of the core
      sdkMethods.push('restartFlow');
      return _objectSpread(_objectSpread({}, this.analytics), this.generateOverloadMethods(sdkMethods));
    }
  }]);
  return Video;
}(_base__WEBPACK_IMPORTED_MODULE_6__["default"]);
/* harmony default export */ __webpack_exports__["default"] = (new Video());

/***/ })

/******/ });
});
//# sourceMappingURL=index.js.map